export const ModelMap = {
  ColumnLabelMap: {
    User: {
      USER_ID: '用户序号(userId)',
      LOGIN: '登入名(login)',
      CHINESE_NAME: '中文名 (chineseName)',
      ENGLISH_NAME: '英文名(englishName)',
      PASSWORD: '密码(password)',
      EMAIL: '电子邮箱(email)',
      PHONE: '电话(phone)',
      CELL: '手机(cell)',
      FAX: '传真(fax)',
      ACTIVE: '激活(active)',
      EXPIRATION: '密码有效期(expirationDate)',
      DEFAULT_OFFICE_ID: '默认分公司(defaultOfficeId)',
      DEFAULT_DEP_ID: '默认部门(defaultDepId)',
      NET_CODE: '网管代码(netCode)',
      MANAGER: '上级主管(manager)',
      TYPE: '用户类型(type)',
      PORTRAIT: '头像(portrait)',
      EXTERNAL_USER: '是否外部用户(externalUser)',
      PARTNER_UUID: '外部用户所属合作伙伴UUID(partnerUUID)',
      USER_CODE: '用户代码(userCode)',
      FIRST_LOGIN_DATE: '首次登陆时间(firstLoginDate)',
      User: '用户(User)'
    },
    Privilege: {
      PRIVILEGE_ID: '权限序号(privilegeId)',
      NAME: '权限名(name)',
      CATEGORY: '权限类(category)',
      SHAPE: '权限型(shape)',
      POINT: '权限点(point)',
      DESCRIPTION: '权限描述(description)',
      ORDER_INDEX: '顺序号(orderIndex)',
      Privilege: '权限(Privilege)'
    },
    Role: {
      ROLE_ID: '角色序号(roleId)',
      NAME: '角色名(name)',
      SYSTEM_DEFINED: '固定角色(systemDefined)',
      DESCRIPTION: '角色描述(description)',
      ROLE_SCOPE: '角色范围(roleScope)',
      Role: '角色(Role)'
    },
    Office: {
      OFFICE_ID: '分公司序号(officeId)',
      CODE: '公司代码(code)',
      CHINESE_NAME: '分公司中文名(chineseName)',
      ENGLISH_NAME: '分公司英文名(englishName)',
      CITY_NAME: '城市名(cityName)',
      CHINESE_ADDRESS: '中文地址(chineseAddress)',
      SEA_ADDRESS_LINE1: '海运提单地址(seaAddressLine1)',
      SEA_ADDRESS_LINE2: '海运提单地址(seaAddressLine2)',
      SEA_ADDRESS_LINE3: '海运提单地址(seaAddressLine3)',
      SEA_ADDRESS_LINE4: '海运提单地址(seaAddressLine4)',
      SEA_ADDRESS_LINE5: '海运提单地址(seaAddressLine5)',
      SEA_ADDRESS_LINE6: '海运提单地址(seaAddressLine6)',
      AIR_ADDRESS_LINE1: '空运提单地址(airAddressLine1)',
      AIR_ADDRESS_LINE2: '空运提单地址(airAddressLine2)',
      AIR_ADDRESS_LINE3: '空运提单地址(airAddressLine3)',
      AIR_ADDRESS_LINE4: '空运提单地址(airAddressLine4)',
      AIR_ADDRESS_LINE5: '空运提单地址(airAddressLine5)',
      AIR_ADDRESS_LINE6: '空运提单地址(airAddressLine6)',
      ZIP_CODE: '邮政编码(zipCode)',
      PHONE: '电话(phone)',
      FAX: '传真(fax)',
      EMAIL: '电子邮箱(email)',
      CURRENCY: '当地币种',
      AIRPORT: '默认空港(airport)',
      SEAPORT: '默认海港(seaport)',
      RMB_ACCOUNT: '人民币账号(rmbAccount)',
      USD_ACCOUNT: '美元帐号(usdAccount)',
      TAX_ACCOUNT: '纳税人识别号(taxAccount)',
      OVERSEA_ADDRESS: '海外帐单地址(overseaAddress)',
      LOCAL_ADDRESS: '国内帐单地址(localAddress)',
      EDICODE: '海外EDI代码(EDICode)',
      TAX_RATE: '税率(taxRate)',
      INVOICE_TAX_RATE: '开票税率(invoiceTaxRate)',
      CLEAR_EMAIL: '结算邮箱(clearEmail)',
      SAJT_INVOICE_SERVICE: '税务系统接口服务地址(SajtInvoiceService)',
      INVOICE_TITLE: '发票抬头(invoiceTitle)',
      INVOICE_ADDRESS: '发票地址(invoiceAddress)',
      AGREE_TENANT_BOOKING: '同意接受外部委托(agreeTenantBooking)',
      USERNAME_EI: '电子发票平台编码(userNameEi)',
      PASSWORD_EI: '电子发票密码(passWordEi)',
      TAXPAYERID_EI: '电子发票纳税人识别号(taxPayerIdEi)',
      AUTHORIZATION_CODE_EI: '电子发票纳税人授权码(authorizationCodeEi)',
      INVOICE_SERVICE_EI: '电子发票服务请求地址(invoiceServiceEi)',
      COMPANY_UUID: '关联合作伙伴(companyUuid)',
      Office: '公司/分公司(Office)'
    },
    BankAccount: {
      ACCOUNT_ID: '账号序号(accoundId)',
      DESCRIPTION: '备注(description)',
      ACCOUNT_NO: '帐号(accountNo)',
      CURRENCY: '币种(currency)',
      BANK_CHINESE_NAME: '银行中文名(bankChineseName)',
      BANK_ENGLISH_NAME: '银行英文名(bankEnglishName)',
      BANK_ENGLISH_ADDRESS: '银行英文地址(bankEnglishAddress)',
      SWIFT_CODE: 'swiftCode',
      CODE: '账号代码(code)',
      SHORT_NAME: '账号简称(shortName)',
      BANK_ADDRESS: '银行中文地址(bankAddress)',
      BankAccount: '公司银行帐户(BankAccount)'
    },
    MailSubscribe: {
      SUBSCRIBER_ID: '订阅人ID(subscriberId)',
      SUBSCRIBER_NAME: '订阅人名(subscriberName)',
      CATEGORY: '订阅类(category)',
      SHAPE: '订阅型(shape)',
      POINT: '订阅点(point)',
      REMARKS: '备注(remarks)',
      MAIL: '邮箱(mail)',
      NAME: '名称(name)',
      ACTIVE: '是否有效(active)',
      MailSubscribe: '订阅(MailSubscribe)'
    },
    Department: {
      DEPARTMENT_ID: '部门序号(departmentId)',
      CODE: '部门代码(code)',
      CHINESE_NAME: '部门中文名称(chineseName)',
      ENGLISH_NAME: '部门英文名称(englishName)',
      DESCRIPTION: '备注(description)',
      JOB_NO_PREFIX: '工作号编码信息(JobNoPrefix)',
      Department: '部门(Department)'
    },
    TenantInitState: {
      NODE_CODE: '节点代码(nodeCode)',
      STATE: '状态(state)',
      TenantInitState: 'Tenant初始化状态(TenantInitState)'
    },
    TenantInitScriptState: {
      SCRIPT_CODE: '脚本代码(scriptCode)',
      EXECUTE_STATE: '执行状态(executeState)',
      EXECUTE_LOG: '执行日志(executeLog)',
      TenantInitScriptState: 'Tenant初始化脚本状态(TenantInitScriptState)'
    },
    Delegation: {
      ID: '序号(id)',
      DELEGATOR: '授权人(delegator)',
      DELEGATEE: '被授权人(delegatee)',
      START_TIME: '起始日期(startTime)',
      END_TIME: '结束日期(endTime)',
      ACTIVE: '是否有效(active)',
      REMARKS: '备注(remarks)',
      Delegation: '授权委托(Delegation)'
    },
    Menu: {
      MENU_ID: '菜单Id(menuId)',
      CODE: '菜单代码(code)',
      CHINESELABEL: '中文名称(chineseLabel)',
      ENGLISHLABEL: '英文名称(englishLabel)',
      ICON: '(图标)icon',
      ACTIVE_ICON: 'activeIcon',
      ACTIONS: 'actions',
      ORDERINDEX: 'orderIndex',
      PARENT_ID: 'parentId',
      TYPE: 'type',
      URL: '(web地址)url',
      Menu: '系统菜单(Menu)'
    },
    InitalData: {
      SEA_PORT: '海港(seaPort)',
      AIR_PORT: '空港(airPort)',
      CHARGE_ITEM: '收费项目(chargeItem)',
      CODE_MODULE: '海关商品编码(codeModule)',
      COUNTRY: '国家(Country)',
      REGION: '航线(region)',
      ACCESS_MANAGEMENT: '权限管理(accessManagement)',
      CONFIG: '基本配置(config)',
      NETWORK: '网络(network)',
      CURRENCY: '币种(currency)',
      EQTYPE: '箱种(eQType)',
      PACKING: '包装(packing)',
      PLATFORM: '提单类型(platForm)',
      CARGOTYPE: '货物类型(cargoType)',
      INCOTERM: '贸易条款(incoTerm)',
      SHIPPINGTERM: '运输条款(shippingTerm)',
      PRICEAIRSERVICE: '空运运费服务项目(priceAirService)',
      CUSTOMERTYPE: '客户类型(customerType)',
      BLMODE: '提单方式(blMode)',
      CUTOMJOBTYPE: '自定义业务类型(cutomJobType)',
      TRANSMITFILETYPE: '文件流转类型(transmitFileType)',
      TRADETERM: '贸易方式(tradeTerm)',
      PORTGROUP: '关联港口(portGroup)',
      OTHERCHARGEITEM: '空运运单杂费(otherChargeItem)',
      COPY_TENANT_ID: '复制平台ID(copyTenantId)',
      DOCUMENTCATEGORY: '文件管理类型(documentCategory)',
      InitalData: '初始化数据(initalData)'
    },
    SubscribePortPush: {
      CUSTOMER_ID: '客户Id(customerId)',
      SubscribePortPush: '客户订阅推送服务列表(SubscribePortPush)'
    },
    SubscribePortPushRule: {
      NAME: '名称(name)',
      PROPERTY: '属性(property)',
      EXPRESSION: '表达式(expression)',
      SubscribePortPushRule: '数据推送规则表(SubscribePortPushRule)'
    },
    Region: {
      CODE: '代码(code)',
      NAME: '区域名(name)',
      NAME_ENGLISH: '区域英文名(nameEnglish)',
      Region: '区域(Region)'
    },
    Country: {
      SERIAL_NUMBER: '序号(serialNumber)',
      INTERCHANGE_CODE: '交换码(interchangeCode)',
      ISO_CODE: 'ISO代码(isoCode)',
      CODE: '代码(code)',
      NAME: '国名(name)',
      CHINESE_NAME: '国家中文名(chineseName)',
      CONTINENT: '洲(continent)',
      Country: '国家(Country)'
    },
    AdministrativeDivision: {
      DIVISION_TYPE: '行政区划(divisionType)',
      PARENT_ID: '上级Id(parentId)',
      CODE: '代码(code)',
      NAME: '区划名(name)',
      ENGLISH_NAME: '区划英文名(englishName)',
      AdministrativeDivision: '行政区划(AdministrativeDivision)'
    },
    Currency: {
      SERIAL_NUMBER: '序号(serialNumber)',
      INTERCHANGE_CODE: '交换码(interchangeCode)',
      ISO_CODE: 'ISO代码(isoCode)',
      CODE: '货币代码(code)',
      NAME: '货币名称(name)',
      LOCAL_NAME: '货币本地化名称(localName)',
      DEFAULT_FRACTION_DIGITS: '默认小数位数(defaultFractionDigits)',
      SYMBOL: '货币符号(symbol)',
      REMARKS: '备注(remarks)',
      Currency: '币种(Currency)'
    },
    AirPort: {
      SERIAL_NUMBER: '序号(serialNumber)',
      INTERCHANGE_CODE: '交换码(interchangeCode)',
      ISO_CODE: 'ISO代码(isoCode)',
      CODE: '港口代码(code)',
      ENGLISH_NAME: '港口英文名称(englishName)',
      CHINESE_NAME: '港口中文名称(chineseName)',
      COUNTRY_CODE: '国家代码(countryCode)',
      REGION: '航线/区域(region)',
      AirPort: '空港(AirPort)'
    },
    SeaPort: {
      SERIAL_NUMBER: '序号(serialNumber)',
      INTERCHANGE_CODE: '交换码(interchangeCode)',
      ISO_CODE: 'ISO代码(isoCode)',
      CODE: '港口代码(code)',
      ENGLISH_NAME: '港口英文名称(englishName)',
      CHINESE_NAME: '港口中文名称(chineseName)',
      COUNTRY_CODE: '国家代码(countryCode)',
      REGION: '航线/区域(region)',
      BASE_PORT: '基本港(basePort)',
      REQUIREMENT: '目的港要求(requirement)',
      CITY_NAME: '城市名称(cityName)',
      CITY_CODE: '城市代码(cityCode)',
      SeaPort: '海港(SeaPort)'
    },
    Packing: {
      SERIAL_NUMBER: '序号(serialNumber)',
      INTERCHANGE_CODE: '交换码(interchangeCode)',
      ISO_CODE: 'ISO代码(isoCode)',
      CODE: '代码(code)',
      NAME: '名称(name)',
      CHINESE_NAME: '中文名称(chineseName)',
      POSITION: '位置(position)',
      EDICODE: 'EDI代码(ediCode)',
      PACK_TYPE: '包装类型(packType)',
      Packing: '包装(Packing)'
    },
    Rate: {
      BASE_CUURENCY: 'currency1',
      CURRENCY: 'currency2',
      RATE: 'rate',
      MONTH: 'validadate1',
      Rate: '汇率(Rate)'
    },
    EQType: {
      CODE: '代码(code)',
      NAME: '名称(name)',
      LOCAL_NAME: '箱型本地化名称(localName)',
      REMARK: '备注(remark)',
      EQType: '箱型(EQType)'
    },
    ChargeItem: {
      SERIAL_NUMBER: '序号(serialNumber)',
      INTERCHANGE_CODE: '交换码(interchangeCode)',
      ISO_CODE: 'ISO代码(isoCode)',
      BRANCH_ID: '分公司(branchId)',
      ITEM_ID: '费用项目Id(itemId)',
      CHARGECODE: '费用代码(chargeCode)',
      EN_NAME: '费用英文名(enName)',
      ZH_NAME: '费用中文名(zhName)',
      MEASURE: '费用计费方式(measure)',
      COMMISSION: '是否佣金(commission)',
      ADVANCE: '是否垫付(advance)',
      FOROTHERS: '其它业务使用(forOthers)',
      SEA_EXPORT: '海运出口使用(forSeaExp)',
      SEA_IMPORT: '海运进口使用(forSeaImp)',
      AIR_EXPORT: '空运出口使用(forAirExp)',
      AIR_IMPORT: '空运进口使用(forAirImp)',
      DEFAULT_AR_CODE: '默认应收对象(defaultArCode)',
      DEFAULTARCURRENCY: '默认应收币种(defaultArCurrency)',
      DEFAULTARPRICE: '默认应收单价(defaultApPrice)',
      DEFAULT_AP_CODE: '默认应付对象(defaultApCode)',
      DEFAULTAPCURRENCY: '默认应付币种(defaultApCurrency)',
      DEFAULTAPPRICE: '默认应付单价(defaultApPrice)',
      REMARK: '费用项目备注(remark)',
      SCALE_CODE: '交互代码(scaleCode)',
      SURCHARGE: '附加费(surcharge)',
      LOCAL_CHARGE: '本地费用(localCharge)',
      DES_CHARGE: '目的地费用(desCharge)',
      SERVICE_TYPE: '服务项目(serviceType)',
      DEFAULT_CHARGE_ITEM: '是否默认费用(defaultChargeItem)',
      RAILWAY_EXPORT: '铁路出口使用(forRailwayExp)',
      ChargeItem: '费用项(ChargeItem)'
    },
    Network: {
      CODE: '网络代码(code)',
      NAME: '网络名(name)',
      Network: '海外网络(Network)'
    },
    VesselCarrier: {
      CARRIER_ID: '船公司(carrierId)',
      EDICODE: '船名EDI(EDICode)',
      REMARKS: '备注(remarks)',
      VesselCarrier: '关联共舱船公司(VesselCarrier)'
    },
    Vessel: {
      VESSEL_ID: '船名序号(vesselId)',
      ENGLISH_NAME: '英文船名(englishName)',
      CHINESE_NAME: '中文船名(chineseName)',
      IMO_CODE: '劳氏代码(imoCode)',
      MMSI_CODE: '水上移动通讯标识号(mmsiCode)',
      CALL_SIGN: '呼号(callSign)',
      CARRIER_ID: '船公司(carrierId)',
      IMPORT_VOYAGE: '是否导入航次(importVoyage)',
      REG_COUNTRY: '船名注册国(regCountry)',
      Vessel: '船名(Vessel)'
    },
    Voyage: {
      VOYAGE_ID: '航次序号(voyageId)',
      VESSEL_ID: '船名序号(vesselId)',
      VOYAGE_NO: '航次代码(voyageNo)',
      EDI_VOYAGE_CODE: 'EDI航次名称(ediVoyageCode)',
      EDI_VOYAGE_NO: 'EDI航次代码(ediVoyageNo)',
      EXTERNAL_IMPORT: '是否外部导入(externalImport)',
      Voyage: '航次(Voyage)'
    },
    VoyageSegment: {
      PORT_OF_CALL: '停靠港(portOfCall)',
      BERTH: '港区(berth)',
      ETA: 'ETA',
      ETD: 'ETD',
      EDI_CODE: 'EDI船舶呼号(ediCode)',
      EXTERNAL_IMPORT: '是否外部导入(externalImport)',
      VoyageSegment: '航次明细(VoyageSegment)'
    },
    Business: {
      ID: '序号(Id)',
      COMPANY_ENAME: '公司英文名称(companyEName)',
      COMPANY_CODE: '公司代码(companyCode)',
      INSPECTION_CODE: '商检编码(inspectionCode)',
      COMPANY_CNAME: '公司中文名(companyCName)',
      TEN_DIGIT_CODE: '海关十位码(tenDigitCode)',
      REMARKS: '备注(remarks)',
      Business: '海关十位码(Business)'
    },
    OrderFormType: {
      CODE: 'code',
      NAME: 'name',
      TIMES: '提单允许打印次数(times)',
      OrderFormType: '提单种类(OrderFormType)'
    },
    ShippingTerm: {
      SERIAL_NUMBER: '序号(serialNumber)',
      INTERCHANGE_CODE: '交换码(interchangeCode)',
      ISO_CODE: 'ISO代码(isoCode)',
      CODE: 'code',
      NAME: 'name',
      LOCAL_NAME: '本地化名称(localName)',
      REMARK: '备注(remark)',
      ShippingTerm: '运输条款(ShippingTerm)'
    },
    ChargeItemGroup: {
      GROUPID: '费用组序号(groupId)',
      NAME: '费用组名称(name)',
      REMARK: '费用组备注(remark)',
      SERVICE_TYPE: '服务项目(serviceType)',
      ChargeItemGroup: '费用组(ChargeItemGroup)'
    },
    GroupDetail: {
      DETAIL_ID: '明细序号(detailId)',
      CHARGE_ITEM_ID: '费用项目Id(chargeItemId)',
      DEFAULT_CHARGE_ITEM: '是否默认费用(defaultChargeItem)',
      GroupDetail: '费用组明细(GroupDetail)'
    },
    ChargeScheme: {
      SCHEMEID: '费用方案序号(schemeId)',
      BRANCH_ID: '分公司(branchId)',
      LOB: '业务类型(lob)',
      NAME: '费用方案名称(name)',
      REMARK: '方案说明(remark)',
      INPUT_BY: '方案创建人(inputBy)',
      INPUT_DATE: '方案创建日期(inputDate)',
      INPUT_BY_DEP: '创建人部门(inputByDep)',
      CUSTOMER_ID: '委托单位编码(customerId)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      CARRIER_ID: '承运人编号(carrierId)',
      CARGO_TYPE: '货物种类(cargoType)',
      CONTAINER_LOAD_TYPE: '整拼类型(containerLoadType)',
      REGION: '航线/区域(region)',
      APPROVED_STATE: '审核状态(approvedState)',
      APPROVED_BY: '审核人(approvedBy)',
      DATE_APPROVED: '审核日期(dateApproved)',
      REJECT_REASON: '拒绝原因(rejectReason)',
      EFFECTIVE_DATE: '生效日期(effectiveDate)',
      EXPIRY_DATE: '失效日期(expiryDate)',
      DESTINATION_AGENT: '目的港代理(destinationAgent)',
      ChargeScheme: '费用方案(ChargeScheme)'
    },
    SchemeDetail: {
      DETAILID: '明细序号(detailId)',
      RECEIVABLE: '收付(receivable)',
      CHARGEITEMID: '费用名称Id(chargeItemId)',
      ACCOUNT_ID: '固定结算对象(accountId)',
      PARTNER_TYPE: '合作伙伴类型(partnerType)',
      MEASURE: '收费种类(measure)',
      UNIT_RATE: '单价(unitRate)',
      CURRENCY: '币种(currency)',
      AMOUNT: '固定金额(amount)',
      REMARK: '备注(remark)',
      LEVEL: '序号(level)',
      UNIT_STEP: '收费单元(unitStep)',
      MINIMUM: '最小收费金额(minimum)',
      RANGE_FROM: '收费区间开始(rangeFrom)',
      RANGE_TO: '收费区间结束(rangeTo)',
      EQTYPE: '箱种(EQType)',
      EQSIZE: '箱型EQsize',
      QUANTITY: '数量(quantity)',
      SchemeDetail: '费用方案明细(SchemeDetail)'
    },
    SchemeCriteria: {
      CRITERIA_TYPE: '条件类型(criteriaType)',
      CRITERIA_VALUE: '条件值(criteriaValue)',
      SchemeCriteria: '费用方案条件(SchemeCriteria)'
    },
    CargoType: {
      CODE: '代码(code)',
      ENGLISH_NAME: '英文名称(englishName)',
      CHINESE_NAME: '中文名称(chineseName)',
      AIR: '是否空运(air)',
      SEA: '是否海运(sea)',
      CargoType: '货物类型(CargoType)'
    },
    IncoTerm: {
      SERIAL_NUMBER: '序号(serialNumber)',
      INTERCHANGE_CODE: '交换码(interchangeCode)',
      ISO_CODE: 'ISO代码(isoCode)',
      CODE: '代码(code)',
      NAME: '名称(name)',
      LOCAL_NAME: '货币本地化名称(localName)',
      REMARK: '备注(remark)',
      IncoTerm: '贸易条款(IncoTerm)'
    },
    TradeTerm: {
      SERIAL_NUMBER: '序号(serialNumber)',
      INTERCHANGE_CODE: '交换码(interchangeCode)',
      ISO_CODE: 'ISO代码(isoCode)',
      CODE: '代码(code)',
      NAME: '名称(name)',
      LOCAL_NAME: '货币本地化名称(localName)',
      REMARK: '备注(remark)',
      TradeTerm: '贸易方式(TradeTerm)'
    },
    PaymentTerm: {
      SERIAL_NUMBER: '序号(serialNumber)',
      INTERCHANGE_CODE: '交换码(interchangeCode)',
      ISO_CODE: 'ISO代码(isoCode)',
      CODE: '代码(code)',
      NAME: '名称(name)',
      LOCAL_NAME: '本地化名称(localName)',
      REMARK: '备注(remark)',
      PaymentTerm: '运费条款(PaymentTerm)'
    },
    Continent: {
      CODE: '代码(code)',
      NAME: '洲名(name)',
      Continent: '洲(Continent)'
    },
    TemplateType: {
      TEMPLATE_TYPE: '模板类(templateType)',
      TEMPLATE_TYPE_DESC: '模板类型说明(TemplateTypeDesc)',
      SCHEMA_TYPE: '结构说明(SchemaType)',
      DEFAULT_ENGINE: '默认模板引擎(DefaultEngine)',
      REMARKS: '备注(remarks)',
      TemplateType: '打印模板类型(TemplateType)'
    },
    TemplateSchemaScript: {
      SCHEMA_TYPE: '模板类(SchemaType)',
      SCHEMA_TABLE: '数据表(SchemaTable)',
      SCRIPT: '脚本(Script)',
      TemplateSchemaScript: '打印模板查询脚本(TemplateSchemaScript)'
    },
    Template: {
      TEMPLATE_ID: '模板序号(templateId)',
      NAME: '模板名称(name)',
      TEMPLATE_TYPE: '模板类(templateType)',
      OFFICE_ID: '分公司序号(officeId)',
      TEMPLATE_FILE: '模板文件(templateFile)',
      FILTER: '过滤脚本(filter)',
      REMARKS: '备注(remarks)',
      ENGINE: '模板引擎(Engine)',
      DOCUMENT_ID: '模板文件云存储ID(DocumentId)',
      COVER_TEMPLATE_UUID: '附加输出关联模板(CoverTemplateUUID)',
      TEMPLATE_USAGE: '模板用途(templateUsage)',
      Template: '打印模板(Template)'
    },
    TemplateAccess: {
      TEMPLATE_ID: '模板序号(templateId)',
      NAME: '模板名称(name)',
      TEMPLATE_TYPE: '模板类型(templateType)',
      OFFICE_ID: '分公司序号(officeId)',
      TEMPLATE_FILE: '模板文件(templateFile)',
      REMARKS: '备注(remarks)',
      DOC_ID: '业务关键字(DocId)',
      DOC_TYPE: '业务类型(DocType)',
      TemplateAccess: '模板访问日志(TemplateAccess)'
    },
    FeeFcl: {
      FEE_ID: '附加费序号(feeId)',
      CODE: 'code',
      CHINESE_NAME: 'chineseName',
      ENGLISH_NAME: 'englishName',
      FeeFcl: '附加费(FeeFcl)'
    },
    PriceConfigFcl: {
      ROUTE: '航线(route)',
      CATEGORY: '类(category)',
      VALUE: '值(value)',
      PriceConfigFcl: '海运整箱报价配置(PriceConfigFcl)'
    },
    Config: {
      CONFIG_ID: '配置项(configId)',
      OFFICE_ID: '分公司(officeId)',
      VALUE: '值(value)',
      OVERRIDEABLE: '可否重设(overrideable)',
      Config: '系统配置(Config)'
    },
    ConfigDef: {
      CONFIG_ID: '配置项(configId)',
      NAME: '配置名(name)',
      OFFICE_OPTION: '分公司选项(officeOption)',
      CLIENT: '界面设置(client)',
      SERVER: '服务设置(server)',
      DATA_TYPE: '类型(dataType)',
      LITERALS: '可选项(literals)',
      VALUE: '缺省值(value)',
      REMARKS: '备注(remarks)',
      ConfigDef: '系统配置定义(ConfigDef)'
    },
    ConfigProfile: {
      PROFILE_ID: '模板序号(profileId)',
      NAME: '模板名(name)',
      REMARKS: '备注(remarks)',
      ConfigProfile: '配置模板(ConfigProfile)'
    },
    ProfileDetail: {
      PROFILE_ID: '模板序号(profileId)',
      CONFIG_ID: '配置项(configId)',
      VALUE: '值(value)',
      OVERRIDEABLE: '可否重设(overrideable)',
      ProfileDetail: '配置模板细节(ProfileDetail)'
    },
    IataPrice: {
      CARRIER: '航空公司简称(carrier)',
      POL: '起运港(POL)',
      POD: '目的港(POD)',
      CARGO_TYPE: '货物类型(cargoType)',
      LEVEL_M: '运价M(levelM)',
      LEVEL_N: '运价N(levelN)',
      LEVEL45: '运价45(level45)',
      LEVEL100: '运价100(level100)',
      LEVEL300: '运价300(level300)',
      LEVEL500: '运价500(level500)',
      LEVEL1000: '运价1000(level1000)',
      LEVEL2000: '运价2000(level2000)',
      REMARK: '备注(remark)',
      IataPrice: 'IATA运价(IataPrice)'
    },
    Berth: {
      PORT: '港口(port)',
      NAME: '港区名称(name)',
      Berth: '港区(Berth)'
    },
    OtherChargeItem: {
      CHARGE_ITEM_CODE: '费用代码(chargeItemcode)',
      CHINESE_NAME: '中文名(chineseName)',
      MEASURE: '费用计费方式(measure)',
      DEFAULT_AP_PRICE: '默认应收单价(defaultApPrice)',
      REMARK: '费用项目备注(remark)',
      OtherChargeItem: '空运运单杂费(OtherChargeItem)'
    },
    PriceServiceAir: {
      CODE: '代码(code)',
      CHINESE_NAME: '中文名称(chineseName)',
      ENGLISH_NAME: '英文名称(englishName)',
      PriceServiceAir: '空运运价服务项目(PriceServiceAir)'
    },
    AirRoute: {
      CODE: '代码(code)',
      NAME: '名称(name)',
      ENGLISH_NAME: '英文名称(englishName)',
      ORIGIN_REGION_CODE: '起运区域代码(originRegionCode)',
      TARGET_REGION_CODE: '目的区域代码(targetRegionCode)',
      AirRoute: '空运航线(AirRoute)'
    },
    AirRegion: {
      CODE: '代码(code)',
      NAME: '名称(name)',
      ENGLISH_NAME: '英文名称(englishName)',
      AirRegion: '空运区域(AirRegion)'
    },
    AirPortRegion: {
      AIR_PORT_ID: '空港代码(airPortCode)',
      AirPortRegion: '空运区域港口(AirPortRegion)'
    },
    OperationResponsibility: {
      NAME: '名称(name)',
      ENGLISH_NAME: '英文名称(englishName)',
      OperationResponsibility: '操作职责(OperationResponsibility)'
    },
    OperationResponsibilityCriteria: {
      CRITERIA_TYPE: '条件类型(criteriaType)',
      CRITERIA_VALUE: '条件值(CriteriaValue)',
      OperationResponsibilityCriteria: '操作职责条件(OperationResponsibilityCriteria)'
    },
    DocumentCategory: {
      LOB: '业务类型(lob)',
      LEVEL: '序号(level)',
      CODE: '代码(code)',
      NAME: '名称(name)',
      LOCAL_NAME: '本地名称(localName)',
      REMARKS: '备注(remarks)',
      DocumentCategory: '文件归类(DocumentCategory)'
    },
    DocumentType: {
      LEVEL: '序号(level)',
      CODE: '代码(code)',
      NAME: '名称(name)',
      LOCAL_NAME: '本地名称(localName)',
      ESSENTIAL_SCENE: '必要场景(essentialScene)',
      ORIGINAL_SCENE: '正本场景(originalScene)',
      REMARKS: '备注(remarks)',
      SALES: '销售(sales)',
      OP: '操作(op)',
      OTHER: '其他(other)',
      CUSTOMER: '委托单位(customer)',
      CONSIGNEE: '收货人(consignee)',
      SHIPPER: '发货人(shipper)',
      DESTINATION_AGENT: '海外代理(destinationAgent)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      SHARED: '是否允许外部访问(shared)',
      TEMPLATE_RULE_ONE: '模板名称1(templateRuleOne)',
      TEMPLATE_RULE_TWO: '模板名称2(templateRuleTwo)',
      TEMPLATE_RULE_THREE: '模板名称3(templateRuleThree)',
      TEMPLATE_RULE_FOUR: '模板名称4(templateRuleFour)',
      SEPARATORS: '分隔符(separators)',
      TEMPLATE_RULE_NAME: '模板名称(templateRuleName)',
      DocumentType: ' 电子文件类型(DocumentType)'
    },
    ImageType: {
      CODE: '代码(code)',
      NAME: '名称(name)',
      WIDTH: '宽(width)',
      HEIGHT: '高(height)',
      MAXSIZE: '最大容量(maxSize)',
      FORMAT: '格式(format)',
      REMARKS: '备注(remarks)',
      ImageType: '图片类型(ImageType)'
    },
    SystemImage: {
      NAME: '图片名称(name)',
      OFFICE_ID: '分公司(officeId)',
      IMAGE_FILE: '图片文件(imageFile)',
      WIDTH: '宽(width)',
      HEIGHT: '高(height)',
      SystemImage: '系统图片(SystemImage)'
    },
    OperationRequirementDescription: {
      DESCRIPTION_ID: '描述Id(descriptionId)',
      LOB: '业务类型(lob)',
      OPERATION_REQUIREMENT_TYPE: '操作要求类型(operationRequirementType)',
      CODE: '代码(code)',
      CONTENT_DESCRIPTION: '内容描述(contentDescription)',
      REMARKS: '备注(remarks)',
      OperationRequirementDescription: '操作要求描述(OperationRequirementDescription)'
    },
    ScacCodes: {
      SCAC: 'SCAC CODE(scac)',
      ENGLISH_NAME: '英文名(englishName)',
      CHINESE_NAME: '中文名(chineseName)',
      ABBREVIATION: '简称(abbreviation)',
      ScacCodes: '船公司标准代码库(ScacCodes)'
    },
    HsCode: {
      COUNTRY_CODE: '国家代码(countryCode)',
      CODE: '商品编码(code)',
      COMMODITY_NAME: '品名(commodityName)',
      MFN_RATE: '最惠国税率(mfnRate)',
      GENERAL_RATE: '普通税率(generalRate)',
      VAT: '增值税(vat)',
      LEGAL_UNIT: '法定单位(legalUnit)',
      SECOND_UNIT: '第二单位(secondUnit)',
      SUPERVISE_MODE: '监管方式(superviseMode)',
      MSC_COMMODITY: '英文品名(MSC)',
      HsCode: '海关商品编号(HsCode)'
    },
    EntityDefaultValue: {
      BRANCH_ID: '分公司(branchId)',
      USER_ID: '用户id(userId)',
      ENTITY_CODE: '实体代码(entityCode)',
      ENTITY_NAME: '实体名称(entityName)',
      FIELD_CODE: '字段代码(fieldCode)',
      FIELD_NAME: '字段名称(fieldName)',
      VALUE_TYPE: '值类型(valueType)',
      DEFAULT_VALUE: '默认值(defaultValue)',
      EntityDefaultValue: '实体默认值(EntityDefaultValue)'
    },
    CheckRule: {
      CHECK_NODE: '验证节点(checkNode)',
      CHECK_CATEGORY: '验证类型(checkCategory)',
      RULE_NAME: '规则名称(ruleName)',
      CHECK_MODE: '验证模式(checkMode)',
      CONTINUE_CHECK: '是否继续验证(continueCheck)',
      REMARKS: '备注(remarks)',
      CheckRule: '验证规则(CheckRule)'
    },
    CheckCriteria: {
      RELATION: '关系(relation)',
      FILTER_DIMENSION: '过滤依据(filterDimension)',
      OPERATOR: '操作(operator)',
      FILTER_VALUE: '过滤值(filterValue)',
      CheckCriteria: '验证条件(CheckCriteria)'
    },
    CheckExpression: {
      RELATION: '关系(relation)',
      CHECK_ITEM: '验证项目(checkItem)',
      OPERATOR: '操作(operator)',
      CHECK_VALUE: '验证值(checkValue)',
      CheckExpression: '验证表达式(CheckExpression)'
    },
    StatementConfig: {
      BRANCH_ID: '分公司(branchId)',
      USER_ID: '用户id(userId)',
      LOB: '业务类型(lob)',
      NAME: '名称(name)',
      StatementConfig: '操作报表配置(StatementConfig)'
    },
    StatementColumn: {
      SERIAL_NUMBER: '顺序号(serialNumber)',
      NAME: '名称(name)',
      DISPLAY_NAME: '显示名(displayName)',
      StatementColumn: '报表列(StatementColumn)'
    },
    MeasureCriteria: {
      FILTER_DIMENSION: '过滤依据(filterDimension)',
      OPERATOR: '操作(operator)',
      FILTER_VALUE: '过滤值(filterValue)',
      MeasureCriteria: '度量计算条件(MeasureCriteria)'
    },
    BlMode: {
      SERIAL_NUMBER: '序号(serialNumber)',
      INTERCHANGE_CODE: '交换码(interchangeCode)',
      ISO_CODE: 'ISO代码(isoCode)',
      CODE: 'code',
      NAME: 'name',
      LOCAL_NAME: '本地化名称(localName)',
      REMARK: '备注(remark)',
      BL_TYPE: '提单类型(blType)',
      BlMode: '提单方式(BlMode)'
    },
    JobNoRule: {
      RULE_DESC: '编码规则说明(ruleDesc)',
      TYPE: '业务类型(type)',
      REGULATION: '编码规则(regulation)',
      SEQ_REGULATION: '编码流水号规则(seqRegulation)',
      MIN_SEQ: '起始流水号(minSeq)',
      GENERATE_TYPE: '生成时机',
      JobNoRule: '工作号生成规则(JobNoRule)'
    },
    CutomJobType: {
      SERIAL_NUMBER: '序号(serialNumber)',
      CODE: 'code',
      NAME: 'name',
      LOCAL_NAME: '本地化名称(localName)',
      REMARKS: '备注(remarks)',
      TYPE: '业务类型(type)',
      CONTAINER_LOAD_TYPE: '整拼类型(containerLoadType)',
      ENGLISH_NAME: '英文名称(englishName)',
      CutomJobType: '工作号内部类型(customJobType)'
    },
    CustomerService: {
      PATNER_ID: '合作伙伴ID(partnerId)',
      SERVICE_NAME: '查询服务名(serviceName)',
      REMARKS: '备注(remarks)',
      SERVICE_TYPE: '类型(serviceType)',
      CustomerService: '合作伙伴信息查询(partnerWSInfo)'
    },
    DateAutoInitRule: {
      DATE_ENTITY: '待更新数据(dateEntity)',
      TYPE: '业务类型(type)',
      BASE_DATE_FIELD: '基数(baseDateField)',
      CALC_RULE: '计算规则(calcRule)',
      REMARKS: '备注(remarks)',
      DATA_FILTER: '过滤条件(dataFilter)',
      DateAutoInitRule: '业务日期默认计算规则(dateAutoInitRule)'
    },
    EntityTriggerType: {
      ENTITY_CODE: '实体代码(entityCode)',
      ENTITY_NAME: '实体名称(entityName)',
      ENTITY_ENAME: '实体英文名称(entityEname)',
      FIELD_CODE: '字段代码(fieldCode)',
      FIELD_NAME: '字段名称(fieldName)',
      FIELD_ENAME: '字段英文名称(fieldEname)',
      TRIGGER_TYPE: '更新类型(triggerType)',
      FIELD_CHECK_TYPE: '字段校验方式(fieldCheckType)',
      FIELD_CHECK_VALUE: '字段校验值(fieldCheckValue)',
      EntityTriggerType: '实体触发器类型(EntityTriggerType)'
    },
    MailServer: {
      SMTP_HOST: 'SMTP邮件服务器(smtpHost)',
      SMTP_PORT: 'SMTP端口(smtpPort)',
      SMTP_SSL: 'SMTP是否使用安全套接字层(smtpSsl)',
      SMTP_TIME_OUT: '发送服务器SMTP超时值(smtpTimeOut)',
      SENDER_MAIL: '邮件发送方邮件(senderMail)',
      SENDER_DISPLAY_NAME: '邮件发送方名称(senderDisplayName)',
      AUTH_SENDER: 'STMP验证用户名(authSender)',
      AUTH_SENDER_PWD: 'SMTP验证密码(authSenderPwd)',
      RETURN_PATH: '默认回信地址(returnPath)',
      USER_EMAIL: '用户mail(userEmail)',
      REMARKS: '备注(remarks)',
      BRANCH_ID: '分公司(branchId)',
      ERROR_EMAIL: '异常接收邮箱(errorEmail)',
      IF_AUTO: '是否自动推送(ifAuto)',
      IF_SOP: '确认是否开启SOP推送(ifSop)',
      MailServer: '邮件发送服务器配置(MailServer)'
    },
    TransmitFileType: {
      LOB: '业务类型(lob)',
      SERIAL_NUMBER: '序号(level)',
      CODE: '代码(code)',
      NAME: '名称(name)',
      LOCAL_NAME: '本地名称(localName)',
      REMARKS: '备注(remarks)',
      INTERCHANGE_CODE: '交换代码(code)',
      ENGLISH_NAME: '英文名称(englishName)',
      TransmitFileType: '文件流转文件类型(TransmitFileType)'
    },
    ProjectItem: {
      CODE: '项目代码(code)',
      NAME: '项目名(name)',
      ProjectItem: '项目(ProjectItem)'
    },
    RegionWarehouseMapping: {
      REGION_CODE: '航线代码(regionCode)',
      WAREHOUSE_ID: '仓库(warehouseId)',
      REMARK: '备注(remark)',
      RegionWarehouseMapping: '区域与仓库映射(RegionWarehouseMapping)'
    },
    CommissionRule: {
      JOB_TYPE: '业务类型(jobType)',
      ACCOUNT_PERIOD_BEGIN: '账期范围起始天数(accountPeriodBegin)',
      ACCOUNT_PERIOD_END: '账期范围结束天数(accountPeriodEnd)',
      PERCENTAGE: '提成比例(percentage)',
      DATE_DATUM: '日期基准(dateDatum)  0-ETD  1-其他日期',
      ROLE: '岗位(role)',
      CommissionRule: '提成规则表(CommissionRule)'
    },
    IMDGCode: {
      UN_NO: '危险品联合国编号(unNo)',
      SUBSTANCE: 'substance(substance)',
      PSN: '正确运输名称(psn)',
      CLASSIFICATION: '危险品级别分类(classification)',
      SUBSIDIARY_RISKS: 'subsidiaryRisks(subsidiaryRisks)',
      PACKING_GROUP: '包装类型代码(packingGroup)',
      SPECIAL_PROVISIONS: 'specialProvisions(specialProvisions)',
      LIMITED_QUANTITIES: 'limitedQuantities(limitedQuantities)',
      EXCEPTED_QUANTITIES: 'exceptedQuantities(exceptedQuantities)',
      FLASHPOINT: '危险品货物闪点(flashpoint)',
      EMERGENCY_SCHEDULE: '航运危险品应急措施(emergencySchedule)',
      PACKING_INSTRUCTION: 'packingInstruction(packingInstruction)',
      PACKING_PROVISIONS: 'packingProvisions(packingProvisions)',
      IBCS_INSTRUCTION: 'ibcsInstruction(ibcsInstruction)',
      IBCS_PROVISIONS: 'ibcsProvisions(ibcsProvisions)',
      TANKS_INSTRUCTIONS: 'tanksInstruction(tanksInstruction)',
      TANKS_PROVISIONS: 'tanksProvisions(tanksProvisions)',
      STOWAGE_HANDLING: 'stowageHandling(stowageHandling)',
      SEGREGATION: 'segregation(segregation)',
      PROPERTIES_OBSERVATIONS: 'propertiesObservations(propertiesObservations)',
      PSN_CODE: 'PSN CODE(psnCode)',
      TECH_CHEM_NAME: 'TECH.CHEM.NAME(techChemName)',
      IMO_SORT: 'IMO SORT(imoSort)',
      SEG_GROUP: 'SEG GROUP(segGroup)',
      CAA: 'CAA(caa)',
      PIH: 'PIH(pih)',
      REPORTABLE_QTY: 'EPORTABLE QTY(reportabelQty)',
      EMER_TEMP: 'EMER TEMP(emerTemp)',
      MP_CODE: 'MP CODE(mpCode)',
      CONTROL_TEMP: 'CONTROL TEMP(controlTemp)',
      DENSITY: 'DENSITY(density)',
      IMDG_FROM: 'IMDG FROM(imdgFrom)',
      IMDG_TO: 'IMDG TO(imdgTo)',
      MP: 'MP(mp)',
      IMDGCode: 'IMDG CODE(海运危险货物规则)'
    },
    SensitiveWord: {
      WORDS: '敏感词(words)',
      WORD_FIELD: '检测字段(wordField)',
      SensitiveWord: 'SensitiveWord(敏感词)'
    },
    MscServiceCode: {
      SERVICE_CODE: '代码(serviceCode)',
      SERVICE_NAME: '名称(serviceName)',
      MscServiceCode: 'MscServiceCode(Msc服务代码)'
    },
    InnerPackage: {
      PACKAGE_TYPE_CODE: '类型代码(packageTypeCode)',
      PACKAGE_TYPE_NAME: '类型名称(packageTypeName)',
      LCV: 'LCV(lcv)',
      InnerPackage: 'InnerPackage(Msc内包装类型)'
    },
    MscImoSort: {
      IMO_CODE: 'imoCode(imoCode)',
      IMO_DESCRIPTION: 'description(描述)',
      MscImoSort: 'MscImoSort(IMO SORT)'
    },
    MscSegGroup: {
      SEG_GROUP_NAME: '名称(segGroupName)',
      MscSegGroup: 'MscSegGroup(SegGroup)'
    },
    Location: {
      CHINESE_NAME: '中文名称(chineseName)',
      ENGLISH_NAME: '英文名称(englishName)',
      LOCATION_CODE: '五子码(locationCode)',
      CODE: '代码(code)',
      COUNTRY_CODE: '国家代码(countryCode)',
      Location: '地点(Location)'
    },
    LocationMapping: {
      MAP_TYPE: '映射类型(mapType)',
      SOURCE_CODE: '源代码(sourceCode)',
      TARGET_CODE: '目标代码(targetCode)',
      TARGET_NAME: '目标名称(targetName)',
      LocationMapping: '地点映射(LocationMapping)'
    },
    MsgNotify: {
      NOTIFY_DATE: '通知内容的时间(notifyDate)',
      CONTENT: '内容/富文本(content)',
      TYPE: '事件类型:0公告/1通知/2私信(type)',
      TARGET: '事件源对象目标ID(target)',
      TARGET_TYPE: '事件源对象目标类型:财务/业务/合作伙伴ClassName(targetType)',
      ACTION_CODE: '动作编码(actionCode)',
      SENDER: '发送人(sender)',
      RECEIVER: '接收人(receiver)',
      TOPIC: '主题(topic)',
      READED: '是否已读(readed)',
      VISIBLE: '是否可见(visible)',
      CONFIRMED: '是否确认(confirmed)',
      MsgNotify: '消息通知(MsgNotify)'
    },
    ContractConfig: {
      OFFICE_ID: '分公司ID',
      WARN_DAYS: '天数',
      WARN_ADMIN: '提醒:合同管理员',
      WARN_SALE: '提醒:销售',
      FORBID_CREATE: '不能再创建业务',
      ContractConfig: '合同到期提醒配置(ContractConfig)'
    },
    RailwayLine: {
      CODE: '代码(code)',
      NAME: '区域名(name)',
      NAME_ENGLISH: '区域英文名(nameEnglish)',
      RailwayLine: '铁路航线(RailwayLine)'
    },
    RailwayStation: {
      SERIAL_NUMBER: '序号(serialNumber)',
      CODE: '站点代码(code)',
      ENGLISH_NAME: '英文名称(englishName)',
      CHINESE_NAME: '中文名称(chineseName)',
      COUNTRY_CODE: '国家代码(countryCode)',
      REGION: '航线/区域(region)',
      CITY_CODE: '城市代码(cityCode)',
      CITY_NAME: '城市名称(cityName)',
      INTERCHANGE_CODE: '交换码(interchangeCode)',
      ISO_CODE: 'ISO代码(isoCode)',
      RailwayStation: '铁路站点(RailwayStation)'
    },
    InvoiceGoodsName: {
      OFFICE_ID: '分公司ID',
      INVOICE_TYPE: '发票类型',
      GOODS_NAME_RMB: 'RMB费用项目名称',
      GOODS_NAME_USD: 'USD费用项目名称',
      DEFAULT_GOODSNAME: '是否默认',
      TAX_RATE: '税率',
      InvoiceGoodsName: '开票项目名称维护(InvoiceGoodsName)'
    },
    UserRersonalizeModule: {
      USER_ID: '当前用户(userId)',
      MODULAR_CODE: '模块标识(modularCode)',
      CACHE_TYPE: '缓存类型(cacheType) 0.模块 1.桌面 2.表格颜色 3.合作伙伴显示',
      CONFIG_CONTENT: '配置内容(configContent)',
      UserRersonalizeModule: '模块(UserRersonalizeModule)'
    },
    SearchWrapFilter: {
      USER_ID: '当前用户(userId)',
      MODULE_CODE: '模块标识(moduleCode)',
      FILTER_NAME: '过滤器名称(filterName)',
      LEVEL: '序号(level)',
      DISPLAY: '是否展示(display)',
      SEARCH_CONDITION: '查询条件(searchCondition)',
      SUB_OPEN: '开启订阅(subOpen)',
      SUB_TIME: '订阅时间(subTime)',
      SEARCH_RESULT: '查询结果(searchResult)',
      SearchWrapFilter: '查询过滤器(SearchWrapFilter)'
    },
    Company: {
      BRANCH_ID: '分公司(branchId)',
      CMP_IDX: 'cmpIdx',
      ENGLISH_NAME: '英文名称(englishName)',
      CHINESE_NAME: '中文名称(chineseName)',
      SHORT_NAME: '简称(shortName)',
      CN_SHORT_NAME: '客户中文名首字母(cnShortName)',
      ADDRESS: '地址(address)',
      ZIP_CODE: '邮编(zipCode)',
      TEL: '电话(tel)',
      FAX: '传真(fax)',
      URL: '网址(url)',
      REGION: '国家(region)',
      RMB_ACCOUNT: '人民币开户行/帐号(rmbAccount)',
      USD_ACCOUNT: '美圆开户行/帐号(usdAccount)',
      ACTIVE: '是否有效(active)',
      GLOBAL: '集团公司(global)',
      SEA_CMP: '船公司(seaCmp)',
      AIR_CMP: '航空公司(airCmp)',
      SEA_CMP_AGENT: '船代(seaCmpAgent)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      LOCAL: '本地代理(localAgent)',
      OVERSEA_AGENT: '海外代理(overseaAgent)',
      MUST_INPUT_SCN: '收发通是否选择录入(mustInputSCN)',
      DESIGNATION_AGENT: '指定代理(designationAgent)',
      CUSTOMER: '委托单位(customer)',
      TRUCK_CMP: '车队(truckCmp)',
      CUSTOMS_BROKER: '报关公司(customsBroker)',
      WAREHOUSE: '仓库(warehouse)',
      SETTLEMENT_AGENT: '结算代理(settlementAgent)',
      OTHER: '其他(other)',
      SEA_EXPORT: '海运出口(seaExport)',
      SEA_IMPORT: '海运进口(seaImport)',
      AIR_EXPORT: '空运出口(airExport)',
      AIR_IMPORT: '空运进口(airImport)',
      REMARKS: '附加说明(remarks)',
      LINKED_BRANCH_ID: '连接分公司(linkedBranchId)',
      COLLECTION: '托收结算(collection)',
      SHIPPER: '发货人(shipper)',
      CONSIGNEE: '收货人(consignee)',
      NOTIFY: '通知人(notify)',
      TAX_RATE: '税率(taxRate)',
      SCAC: '标准代码(scac)',
      PROVINCE: '省(province)',
      CITY: '市(city)',
      DISTRICTS: '区(districts)',
      DETAILED_ADDRESS: '详细地址(detailedAddress)',
      APPROVED_STATE: '审核状态(approvedState)',
      APPROVED_BY: '审核人(approvedBy)',
      DATE_APPROVED: '审核日期(dateApproved)',
      REJECT_REASON: '拒绝原因(rejectReason)',
      PARENT_BRANCH_ID: '上级分公司(parentBranchId)',
      RELATE_TENANT_UUID: '关联TENANT的UUID(relateTenantUUID)',
      RELATE_TENANT_ID: '关联Tenant的ID(relateTenantId)',
      RELATE_TENANT_OFFICE_ID: '关联Tenant分公司ID(relateTenantOfficeId)',
      PLATE_CODE: '车队编码(plateCode)',
      FREIGHT_VOLUME_30: '30天内走货量(freightVolume30)',
      FREIGHT_VOLUME_60: '60天内走货量(freightVolume60)',
      FREIGHT_VOLUME_90: '90天内走货量(freightVolume90)',
      FREIGHT_VOLUME_GT_90: '大于90天走货量(freightVolumeGt90)',
      IF_OPEN_SOP: '是否开启SOP推送(ifOpenSop)',
      RAILWAY_EXPORT: '铁路出口(railwayExport)',
      PORT_AGENT: '口岸代理(portAgent)',
      FORWARDING_AGENT: '发运代理(forwardingAgent)',
      LOADINGPLACE_COMPANY: '装货地公司(loadingPlaceCompany)',
      SIGNBILLPLACE_COMPANY: '签单地公司(signBillPlaceCompany)',
      DISCHARGEPORT_COMPANY: '卸货港公司(dischargePortCompany)',
      DESTINATIONPORT_COMPANY: '目的港公司(destinationPortCompany)',
      EXTERNAL_KEY_CUST: '外部客户主键(externalKeyCust)',
      EXTERNAL_KEY_VEND: '外部供应商主键(externalKeyVend)',
      Company: '合作伙伴(Company)'
    },
    CreditInfo: {
      CREDIT_DATE_TYPE: '账款日期类型(creditDateType)',
      CREDIT_DATE_LIMITED: '账期(creditTerm)',
      TERM_UNIT: '账期单位(termUnit)',
      CREDIT: '放帐额度(credit)',
      CURRENCY: '币种(currency)',
      BLACKLIST: '是否黑名单(blacklist)',
      USED_AMOUNT: '已用额度(usedAmount)',
      AMOUNT_EXCEEDED: '是否超额度(amountExceeded)',
      DATE_EXCEEDED: '是否超期(dateExceeded)',
      REMARKS: '备注(remarks)',
      RECEIVABLE_DEPOSIT: '是否收款押金(receivableDeposit)',
      DEPOSIT_CURRENCY: '押金币种(depositCurrency)',
      DEPOSIT_AMOUNT: '押金金额(depositAmount)',
      DEPOSIT_DATE: '押金收付日期(depositDate)',
      DEPOSIT_TYPE: '押金收付方式(depositType)',
      CREDIT_REMARKS: '附加说明(creditRemarks)',
      CreditInfo: '放账信息(CreditInfo)'
    },
    Contact: {
      CONTACT_PERSON: '联系人(ContactPerson)',
      DEFAULT_CONTACT: '是否默认联系人(defaultContact)',
      ROLE: '职能(role)',
      TELEPHONE: 'telephone',
      FAX: 'fax',
      MOBILE: 'mobile',
      EMAIL: 'email',
      REMARKS: 'remarks',
      RELATE_USER_ID: 'relateUserId(关联账号id)',
      AIRLINE: '航线(airline)',
      PUSH_NODE: '推送节点(pushNode)',
      PUSH_MODE: '推送方式(pushMode)',
      Contact: '联系人(Contact)'
    },
    Site: {
      NAME: '门点名称(name)',
      CONTACT: '门点联系人(contact)',
      PHONE: '联系人电话(phone)',
      ADDRESS: '门点地址(address)',
      REMARKS: 'remarks',
      Site: '门点(Site)'
    },
    SpecialRequest: {
      REQUEST_ID: 'requestId',
      REQUEST: '特殊要求(request)',
      LOB: '业务类型(lob)',
      REMARKS: 'remarks',
      SpecialRequest: '特殊要求(SpecialRequest)'
    },
    Title: {
      TITLE: '开票抬头(title)',
      TAX_ACCOUNT: '纳税人识别号(taxAccount)',
      ADDRESS: '发票地址(address)',
      TELEPHONE: '电话(telephone)',
      DEFAULT_TITLE: '是否默认抬头(defaultTitle)',
      EMAIL: '邮箱地址(email)',
      AUTO_SEND: '默认自动发送邮箱(autoSend)',
      Title: '开票抬头(Title)'
    },
    TitleBank: {
      CURRENCY: '币种(currency)',
      BANK: '银行名称(bank)',
      BANK_ACCOUNT: '银行帐号(bankAccount)',
      DEFAULT_BANK: '是否默认银行(defaultBank)',
      TitleBank: '开票抬头银行(TitleBank)'
    },
    OverseaAgent: {
      BILL_ADDRESS: '账单地址(billAddress)',
      FORCAST_ADDRESS: '预报地址(forcastAddress)',
      BL_ADDRESS: '海运提单地址(blAddressLine1)',
      BL_ADDRESS_LINE2: '海运提单地址(blAddressLine2)',
      BL_ADDRESS_LINE3: '海运提单地址(blAddressLine3)',
      BL_ADDRESS_LINE4: '海运提单地址(blAddressLine4)',
      BL_ADDRESS_LINE5: '海运提单地址(blAddressLine5)',
      BL_ADDRESS_LINE6: '海运提单地址(blAddressLine6)',
      AIR_ADDRESS_LINE1: '空运提单地址(airAddressLine1)',
      AIR_ADDRESS_LINE2: '空运提单地址(airAddressLine2)',
      AIR_ADDRESS_LINE3: '空运提单地址(airAddressLine3)',
      AIR_ADDRESS_LINE4: '空运提单地址(airAddressLine4)',
      AIR_ADDRESS_LINE5: '空运提单地址(airAddressLine5)',
      AIR_ADDRESS_LINE6: '空运提单地址(airAddressLine6)',
      NETWORK: '网络(network)',
      OWNER: '网络负责人(owner)',
      GRADE: '代理等级(grade)',
      BL_ADDRESS_LINE7: '海运提单地址(blAddressLine7)',
      AIR_ADDRESS_LINE7: '空运提单地址(airAddressLine7)',
      OverseaAgent: '海外代理(OverseaAgent)'
    },
    Airline: {
      AIRLINE_CODE: 'airlineCode',
      MAWBPREFIX: 'MAWBPrefix',
      Airline: '航空公司(Airline)'
    },
    MAWBInfo: {
      BRANCH_ID: '分公司(branchId)',
      SCHEME_NAME: '方案名称(schemeName)',
      IATA_CODE: 'IATACode',
      HANDING_INFO: 'HandingInfo',
      ACCOUNT_INFO: 'AccountInfo',
      ACCOUNT_NO: 'accountNo',
      ISSUED_BY: 'issuedBy',
      CARRIER_AGENT_CITY: 'carrierAgentCity',
      INSURED_AMOUNT: 'insuredAmount',
      CARRIAGE_DV: 'carriageDV',
      DVFOR_CUSTOMS: 'customsDV',
      RATE_CHARGE: 'rateCharge',
      MAWBInfo: '航空公司主单默认信息(MAWBInfo)'
    },
    MAWBInfoOtherCharge: {
      CHARGE_ITEM: '费用名称(chargeItem)',
      MEASURE: '单位类型(measure)',
      UNIT_RATE: '单价(unitRate)',
      REMARK: '附加说明(remark)',
      MIN_AMOUNT: '最小收费金额(minAmount)',
      MAWBInfoOtherCharge: '航空公司主单默认其它费用 (MAWBInfoOtherCharge)'
    },
    Contract: {
      CONTRACT_NO: 'contractNo',
      BEGIN_DATE: 'beginDate',
      END_DATE: 'endDate',
      REMARKS: 'remarks',
      CONTRACT_TYPE: '合同类型',
      CONTRACT_STATE: '合同状态: 4=已续签; 5=终止合同',
      CONTRACT_AGREEMENT: '合同协议',
      CREDIT_DATE_TYPE: '结算方式',
      DATE_TYPE: '日期类型',
      CREDIT_DATE_LIMITED: '账期',
      TERM_UNIT: '账期单位',
      CREDIT: '信用额度',
      CURRENCY: '信用额度币种',
      POSTPONE: '是否到期后顺延',
      POSTPONE_LIMITED: '顺延期限',
      POSTPONE_UNIT: '顺延期限单位',
      POSTPONE_TYPE: '顺延周期类型',
      IS_NEED_SYSHCRONIZE: '是否需要同步',
      Contract: '合同(Contract)'
    },
    Customer: {
      CUSTOMER_TYPE_ID: '客户类型Id(customerTypeId)',
      CUSTOMER_STATE: '货主类型(ownerType)',
      CLEARING_TYPE: '货主性质(ownerClass)',
      DESIGNATED: '指定货客户(designated)',
      SEFT_CANVASS: '自揽货客户(seftCanvass)',
      PEER: '是否同行(peer)',
      SALES: '销售(sales)',
      OWNER_DEPARTMENT: '归属部门(ownerDepartment)',
      INVOICE_MODE: '开票方式(invoiceMode)',
      OVER_INVOICING: '可高开发票(overInvoicing)',
      INVOICE_REMARKS: '开票备注(invoiceRemarks)',
      PRICE_LEVEL: '运价级(priceLevel)',
      ITRACE_SERVICE: 'iTrace服务(iTraceService)',
      ITRACE_START_DATE: 'iTrace服务启用日期(iTraceStartDate)',
      Customer: '委托单位(Customer)'
    },
    PortDestinationAgent: {
      DESTINATION_PORT: 'destinationPort',
      DESTINATION_AGENT_ID: 'destinationAgentId',
      DEFAULT_AGENT: 'defaultAgent',
      REMARKS: 'remarks',
      LOADING_PORT: '起运港(loadingPort)',
      PortDestinationAgent: '指定货客户目的港代理(PortDestinationAgent)'
    },
    Warehouse: {
      WAREHOUSE_TYPE: 'warehouseType',
      WAREHOUSE_NAME: '仓库名称(warehouseName)',
      WAREHOUSE_ADDRESS: '仓库地址(warehouseAddress)',
      WAREHOUSE_CONTACT: '联系人(warehouseContact)',
      WAREHOUSE_CONTACT_TEL: '联系人电话(warehouseContactTel)',
      WAREHOUSE_CONTACT_FAX: '联系人传真(warehouseContactFax)',
      MAP_FILE_NAME: '地图(mapFileName)',
      MAP_FILE: '地图图片(mapFile)',
      DEFAULT_WAREHOUSE: '是否默认仓库(defaultWarehouse)',
      REMARKS: '备注(remarks)',
      Warehouse: '仓库(Warehouse)'
    },
    BillAddress: {
      PARTNER_ID: '合作伙伴编号(partnerId)',
      OFFICE_ID: '分公司编号(officeId)',
      LOB: '空运海运(lob)',
      LAST_USED: '最近使用时间(lastUsed)',
      POD: '卸货港(pod)',
      SHIPPER_CODE: '发货人代码(shipperCode)',
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      SHIPPER_SHORT_CODE: '发货人代码缩写(shipperShortCode)',
      SHIPPER_ENTERPRISE_CODE: '发货人企业代码(shipperEnterpriseCode)',
      SHIPPER_ENTERPRISE_NAME: '发货人企业名称(shipperEnterpriseName)',
      SHIPPER_ADDRESS: '发货人详细地址(shipperAddress)',
      SHIPPER_CONTACTS_TYPE: '发货人联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      SHIPPER_CONTACTS: '发货人联系人(shipperContacts)',
      SHIPPER_CITY_NAME: '发货人城市名称(shipperCityName)',
      SHIPPER_PROVINCE_CODE: '发货人省份代码(shipperProvinceCode)',
      SHIPPER_PROVINCE_NAME: '发货人省份名称(shipperProvinceName)',
      SHIPPER_ZIP_CODE: '发货人邮政编码(shipperZipCode)',
      SHIPPER_COUNTRY_CODE: '发货人国家代码(shipperCountryCode)',
      SHIPPER_AEO_ENTERPRISE_CODE: '发货人AEO企业编码(shipperAeoEnterpriseCode)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(consigneeLine1)',
      CONSIGNEE_LINE2: '收货人(consigneeLine2)',
      CONSIGNEE_LINE3: '收货人(consigneeLine3)',
      CONSIGNEE_LINE4: '收货人(consigneeLine4)',
      CONSIGNEE_LINE5: '收货人(consigneeLine5)',
      CONSIGNEE_LINE6: '收货人(consigneeLine6)',
      CONSIGNEE_LINE7: '收货人(consigneeLine7)',
      CONSIGNEE_SHORT_CODE: '收货人代码缩写(consigneeShortCode)',
      CONSIGNEE_ENTERPRISE_CODE: '收货人企业代码(consigneeEnterpriseCode)',
      CONSIGNEE_ENTERPRISE_NAME: '发货人企业名称(consigneeEnterpriseName)',
      CONSIGNEE_ADDRESS: '收货人详细地址(consigneeAddress)',
      CONSIGNEE_CONTACTS_TYPE: '收货人联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      CONSIGNEE_CONTACTS: '收货人联系人(consigneeContacts)',
      CONSIGNEE_CITY_NAME: '收货人城市名称(consigneeCityName)',
      CONSIGNEE_PROVINCE_CODE: '收货人省份代码(consigneeProvinceCode)',
      CONSIGNEE_PROVINCE_NAME: '收货人省份名称(consigneeProvinceName)',
      CONSIGNEE_ZIP_CODE: '收货人邮政编码(consigneeZipCode)',
      CONSIGNEE_COUNTRY_CODE: '收货人国家代码(consigneeCountryCode)',
      CONSIGNEE_AEO_ENTERPRISE_CODE: '收货人AEO企业编码(consigneeAeoEnterpriseCode)',
      CONSIGNEE_SPECIFIC_CONTACTS_NAME: '收货人具体联系人名称(consigneeSpecificContactsName)',
      CONSIGNEE_SPECIFIC_CONTACTS_TYPE: '收货人具体联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      CONSIGNEE_SPECIFIC_CONTACTS: '收货人具体联系人(consigneeSpecificContacts)',
      NOTIFY_CODE: '通知人代码(notifyCode)',
      NOTIFY_LINE1: '通知人(notifyLine1)',
      NOTIFY_LINE2: '通知人(notifyLine2)',
      NOTIFY_LINE3: '通知人(notifyLine3)',
      NOTIFY_LINE4: '通知人(notifyLine4)',
      NOTIFY_LINE5: '通知人(notifyLine5)',
      NOTIFY_LINE6: '通知人(notifyLine6)',
      NOTIFY_LINE7: '通知人(notifyLine7)',
      NOTIFY_SHORT_CODE: '通知人代码缩写(notifyShortCode)',
      NOTIFY_ENTERPRISE_CODE: '通知人企业代码(notifyEnterpriseCode)',
      NOTIFY_ENTERPRISE_NAME: '通知人企业名称(notifyEnterpriseName)',
      NOTIFY_ADDRESS: '通知人详细地址(notifyAddress)',
      NOTIFY_CONTACTS_TYPE: '通知人联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      NOTIFY_CONTACTS: '通知人联系人(notifyContacts)',
      NOTIFY_CITY_NAME: '通知人城市名称(notifyCityName)',
      NOTIFY_PROVINCE_CODE: '通知人省份代码(notifyProvinceCode)',
      NOTIFY_PROVINCE_NAME: '通知人省份名称(notifyProvinceName)',
      NOTIFY_ZIP_CODE: '通知人邮政编码(notifyZipCode)',
      NOTIFY_COUNTRY_CODE: '通知人国家代码(notifyCountryCode)',
      NOTIFY_AEO_ENTERPRISE_CODE: '通知人AEO企业编码(notifyAeoEnterpriseCode)',
      INSTRUCT_BILL: '指示提单instructBill(instructBill)',
      BILL_HISTORY_TYPE: '提单历史类型(billHistoryType)',
      BillAddress: '收发通(BillAddress)'
    },
    Shipping: {
      BRANCH_ID: '分公司(branchId)',
      SEND_CODE: '发送方代码(sendCode)',
      RECEIVE_CODE: '接收方代码(receiveCode)',
      EDI: '是否导EDI(EDI)',
      CN_CODE: 'CN代码(CNCode)',
      BOOKING_AGENT_ID: '订舱代理(bookingAgentId)',
      BOOKING_PARTY_CODE: '订舱人代码(BookingPartyCode)',
      Shipping: '船公司信息(Shipping)'
    },
    CreditHistory: {
      ACTION: 'action',
      COMPANY_UUID: 'companyUuid',
      JOB_UUID: 'jobUuid',
      REASON: 'reason',
      JOB_NO: 'jobNo',
      CreditHistory: '信誉历史(CreditHistory)'
    },
    ChargePardon: {
      CHARGE_UUID: 'chargeUuid',
      REMARKS: 'remarks',
      ChargePardon: 'ChargePardon'
    },
    OverseaAgentPort: {
      LOB: '空运海运(lob)',
      PORT: '港口(port)',
      OverseaAgentPort: '海外代理港口(OverseaAgentPort)'
    },
    CustomerType: {
      TYPE_ID: '类型Id(typeId)',
      ENGLISH_NAME: '英文名称(englishName)',
      CHINESE_NAME: '中文名称(chineseName)',
      CustomerType: '客户类型(CustomerType)'
    },
    BookingAgentCarrier: {
      BRANCH_ID: '分公司(branchId)',
      CARRIER_TYPE: '承运人类型(carrierType)',
      BOOKING_MODE: '订舱方式(bookingMode)',
      BookingAgentCarrier: '订舱代理承运人(BookingAgentCarrier)'
    },
    CompanyUser: {
      LOB: '业务类型(lob)',
      ROLE_TYPE: '用户岗位类型(roleType)',
      USER_ID: '用户(userId)',
      DEFAULT_USER: '是否默认(defaultUser)',
      REMARKS: '备注(remarks)',
      CompanyUser: '合作伙伴对应的用户(CompanyUser)'
    },
    PartnerAuthorization: {
      AUTHORIZATION_TYPE: '授权类型(authorizationType)',
      AUTHORIZATION_VALUE: '授权内容(authorizationValue)',
      PartnerAuthorization: '合作伙伴授权(PartnerAuthorization)'
    },
    ManifestAddress: {
      SHORT_CODE: '代码缩写(shortCode)',
      ENTERPRISE_CODE: '企业代码(enterpriseCode)',
      ENTERPRISE_NAME: '名称(enterpriseName)',
      ADDRESS: '详细地址(address)',
      CONTACTS_TYPE: '联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      CONTACTS: '联系人(contacts)',
      CITY_NAME: '城市名称(cityName)',
      PROVINCE_CODE: '省份代码(provinceCode)',
      PROVINCE_NAME: '省份名称(provinceName)',
      ZIP_Code: '邮政编码(zipCode)',
      COUNTRY_CODE: '国家代码(countryCode)',
      AEO_ENTERPRISE_CODE: 'AEO企业编码(aeoEnterpriseCode)',
      SPECIFIC_CONTACTS_NAME: '具体联系人名称(specificContactsName)',
      SPECIFIC_CONTACTS_TYPE: '具体联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      SPECIFIC_CONTACTS: '具体联系人(specificContacts)',
      ADDRESS_LINE1: '地址一(addressLine1)',
      ADDRESS_LINE2: '地址二(addressLine2)',
      ADDRESS_LINE3: '地址三(addressLine3)',
      ADDRESS_LINE4: '地址四(addressLine4)',
      ADDRESS_LINE5: '地址五(addressLine5)',
      ADDRESS_LINE6: '地址六(addressLine6)',
      ADDRESS_LINE7: '地址七(addressLine7)',
      ManifestAddress: '舱单地址信息(ManifestAddress)'
    },
    OverseaAgentUser: {
      LOB: '业务类型(lob)',
      ROLE_TYPE: '用户岗位类型(roleType)',
      USER_ID: '用户(userId)',
      DEFAULT_USER: '是否默认(defaultUser)',
      REMARKS: '备注(remarks)',
      OverseaAgentUser: '目的港对应的海外客服(OverseaAgentUser)'
    },
    SopPushConfig: {
      OFFICE_ID: '分公司(officeId)',
      IF_AUTO: '是否自动推送(ifAuto)',
      IF_APPLIED: '应用总公司(ifApplied)',
      IF_EMAIL: '是否开启邮件推送(ifEmail)',
      IF_NOTE: '是否开启短信推送(ifNote)',
      IF_SOP: '是否校验推送接收人(ifSop)',
      NOTE_CHINESE: '短信中文(noteChinese)',
      NOTE_ENGLISH: '短信英文(noteEnglish)',
      SopPushConfig: 'SOP推送配置(SopPushConfig)'
    },
    Order: {
      ORDER_ID: '订单号(orderId)',
      ORDER_DATE: '订单日期(orderDate)',
      SALES_OFFICE_ID: '销售公司(salesOffice)',
      SALES_DEP: '业务员部门(salesDep)',
      SALES_PERSON: '业务员(sales)',
      CANCELLED: '是否取消(cancelled)',
      CUSTOMER: '委托单位(customer)',
      CUSTOMER_CONTACT: '联系人(customerContact)',
      CONTECT_TELEPHONE: '联系电话(contactTelephone)',
      CONTACT_FAX: '联系电传(contactFax)',
      DESIGNATION_AGENT: '指定代理(designationAgent)',
      DESTINATION_AGENT: '目的港代理(destinationAgent)',
      DISPATCH_PORT: '起运地(dispatchingPort)',
      LOADING_PORT_CODE: '装货港代码(loadingPortCode)',
      DISCHARGING_PORT_CODE: '卸货港代码(dischargingPortCode)',
      DESTINATION_PORT: '目的地(destinationPort)',
      FREIGHT_TYPE: '业务类型(freightType)',
      QUANTITY: '货物件数(quantity)',
      WEIGHT: '货物重量(weight)',
      CUBAGE: '货物体积(cubage)',
      PACKING: '包装类型(packing)',
      DESCRIPTION: '中文品名(description)',
      REMARKS: '备注(remarks)',
      INPUT_BY: '创建人(inputBy)',
      INPUT_DATE: '创建日期(inputDate)',
      CHECK_BY: '审核人(checkBy)',
      CHECK_DATE: '审核日期(checkDate)',
      INPUT_BY_DEP: '创建人部门(inputByDep)',
      INPUT_BY_OFFICE: '创建人分公司(inputByOffice)',
      CHECK_REMARK: '审批备注(checkRemark)',
      OP: '指派操作(op)',
      ORDER_NO: '订单编号(orderNo)',
      Order: '订单(Order)'
    },
    OrderSeaEQ: {
      EQID: '序号(EQid)',
      EQSIZE: '箱型EQsize',
      EQTYPE: '箱种(EQtype)',
      QUANTITY: '数量(quantity)',
      OrderSeaEQ: '预录箱型箱量(OrderSeaEQ)'
    },
    OrderCharge: {
      CHARGE_ID: '预录费用序号(chargeId)',
      LOCAL: '是否国内(isLocal)',
      AR: '是否应收(isAr)',
      ACCOUNT_ID: '结算对象(accountId)',
      CHARGE_CODE: '费用名称(chargeCode)',
      CURRENCY: '币种(currency)',
      AMOUNT: '金额(amount)',
      INPUT_BY: '创建人(inputBy)',
      INPUT_BY_DEP: '创建人部门(inputByDep)',
      INPUT_BY_OFFICE: '创建人公司(inputByOffice)',
      OrderCharge: '预录费用(OrderCharge)'
    },
    Job: {
      JOB_NO: '工作号(jobNo)',
      WAREHOUSE_NO: '进仓编号(warehouseNo)',
      CUSTOMER_REF_NO: '客户参考号(customerRefNo)',
      AGENTREFNO: '代理业务编号(agentRefNo)',
      MBL: 'MBL(mbl)',
      MBL_NO5: 'MBL_NO5(mblNo5)',
      RELATED_JOB: '公司往来关联号(relatedJob)',
      RELATED_JOB2: '联运编号(relatedJob2)',
      MBL_ONLY: '是否直发(mblOnly)',
      JOIN_FLAG: 'MBL并单标志(joinFlagMBL)',
      JOIN_FLAG_HBL: 'HBL并单标志(joinFlagHBL)',
      MASTER_FLAG: '拼箱主号标志(masterFlag)',
      CANCELLED: '是否取消(cancelled)',
      SALES_OFFICE: '销售公司(salesOffice)',
      SALES_DEPT: '销售部门(salesDepartment)',
      SALES_ID: '业务员(sales)',
      CSR_OFFICE: '客服公司(csrOffice)',
      CSR_DEPT: '客服部门(csrDepartment)',
      CSR_ID: '客服(csr)',
      OP_OFFICE: '操作公司(opOffice)',
      OP_DEPARTMENT: '操作部门(opDepartment)',
      OP_ID: '操作(op)',
      CUSTOMER_ID: '委托单位编码(customerId)',
      CUSTOMER_CONTACT: '联系人(customerContact)',
      CONTACT_TELEPHONE: '联系电话(contactTelephone)',
      CONTACT_FAX: '联系电传(contactFax)',
      DESIGNATION_AGENT: '指定代理(designationAgent)',
      DESTINATION_AGENT: '目的港代理(destinationAgent)',
      LOCAL_AGENT: '本地代理(localAgent)',
      MASTER_AGENT: '是否主代理(masterAgent)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      CUSTOMS_BROKER: '报关行(customsBroker)',
      DISCHARGING_PLACE: '发货地(dispatchingPlace)',
      DESTINATION_PLACE: '最终目的地(destinationPlace)',
      DESTINATION_PLACE_CODE: '最终目的地代码(destinationPlaceCode)',
      LOADING_PORT_CODE: '装货港代码(loadingPortCode)',
      DISCHARGING_PORT_CODE: '卸货港代码(dischargingPortCode)',
      DESTINATION_PORT_CODE: '目的港代码(destinationPortCode)',
      QUANTITY_CONTRACT: '委托货物件数(quantityContract)',
      WEIGHT_CONTRACT: '委托货物重量(weightContract)',
      CUBAGE_CONTRACT: '委托货物体积(cubageContract)',
      QUANTITY_ACTUAL: '实际货物件数(quantityActual)',
      WEIGHT_ACTUAL: '实际货物重量(weightActual)',
      CUBAGE_ACTUAL: '实际货物体积(cubageActual)',
      CHARGE_WEIGHT: '计费重量(chargeWeight)',
      CHARGE_CUBAGE: '计费体积(chargeCubage)',
      MEASUREMENTS: '货物尺寸(measurements)',
      CARGO_TYPE: '货物种类(cargoType)',
      PACKING: '包装(packing)',
      PAYMENT_TERM_MBL: '主单运费方式(paymentTermMBL)',
      PAYMENT_TERM_HBL: '分单运费方式(paymentTermHBL)',
      CARGO_CHINESE_NAME: '中文品名(cargoChineseName)',
      CARGO_ENGLISH_NAME: '英文品名(cargoEnglishName)',
      MARK: '唛头(mark)',
      CARRIER_ID: '承运人编号(carrierId)',
      CARRIER_AGENT_ID: '船代(carrierAgentId)',
      VESSEL: '船名(vessel)',
      VOYAGE_FLIGHT: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      JOB_STATE: '业务状态(jobState)',
      COMMISSION: '业务提成金额(commission)',
      REMARKS: '备注(remarks)',
      BUSINESS_DATE: '业务日期(businessDate)',
      LOB: '业务类型(lob)',
      SHUT_OUT: '是否退关(shutOut)',
      SATISFIED_REQUESTS: ' 满足的特殊要求(satisfiedRequests)',
      DC_OFFICE: '单证公司(dcOffice)',
      DC_DEPT: '单证部门(dcDepartment)',
      DC_ID: '单证(dc)',
      PONO: '项目编号(PONO)',
      AGENT_LEVEL: '代理等级(agentLevel)',
      CARGO_SOURCE: '货物来源(cargoSource)',
      CONTAINER_DESC: '货量描述(containerDesc)',
      TEU: 'teu',
      PROFIT: 'profit',
      WAREHOUSING: '是否仓储(warehousing)',
      LAND_TRANSPORTATION: '是否路运(landTransportation)',
      INTERNATIONAL: '是否国际运输(international)',
      MULTIPLE_PICKUPS: '是否多次派车(multiplePickups)',
      ADVANCE: '是否垫付(advance)',
      BLOCKED: '是否等待特批(blocked)',
      EXPRESS: '是否是快递(express)',
      DECLARE_CUSTOMS_STATE: '报关状态(declareCustomsState)',
      WAREHOUSE_NO_FORMAT: '进仓编号格式化(warehouseNoFormat)',
      SHIPPER_ID: '发货人Id(shipperId)',
      CONSIGNEE_ID: '收货人Id(consigneeId)',
      NOTIFY_ID: '通知人Id(notifyId)',
      PREVERIFY_STATE: '预审核状态(preverifyState)',
      TRUST_FROM_JOB: '委托来源关联号(trustFromJob)',
      SIGN_MBL: '是否签发主单(signMBL)',
      SIGN_HBL: '是否签发分单(signHBL)',
      ESTIMATE_ACCOUNTS_RECEIVABLE: '预估收入(EstimateAccountsReceivable)',
      ESTIMATE_ACCOUNTS_PAYABLE: '预估成本(EstimateAccountsPayable)',
      ESTIMATE_GROSS_PROFIT: '预估利润(EstimateGrossProfit)',
      SHIPPER_CODE: '发货人代码(shipperCode)',
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(consigneeLine1)',
      CONSIGNEE_LINE2: '收货人(consigneeLine2)',
      CONSIGNEE_LINE3: '收货人(consigneeLine3)',
      CONSIGNEE_LINE4: '收货人(consigneeLine4)',
      CONSIGNEE_LINE5: '收货人(consigneeLine5)',
      CONSIGNEE_LINE6: '收货人(consigneeLine6)',
      CONSIGNEE_LINE7: '收货人(consigneeLine7)',
      NOTIFY_CODE: '通知人代码(notifyCode)',
      NOTIFY_LINE1: '通知人(notifyLine1)',
      NOTIFY_LINE2: '通知人(notifyLine2)',
      NOTIFY_LINE3: '通知人(notifyLine3)',
      NOTIFY_LINE4: '通知人(notifyLine4)',
      NOTIFY_LINE5: '通知人(notifyLine5)',
      NOTIFY_LINE6: '通知人(notifyLine6)',
      NOTIFY_LINE7: '通知人(notifyLine7)',
      ALSO_NOTIFY: '第二通知人(alsoNotify)',
      BOOKING_REFUSE_NOTE: '拒绝订舱理由(bookingRefuseNote)',
      CUSTOMS_DATE: '报关日期(customsDate)',
      CUSTOMS_REMARKS: '报关备注(customsRemarks)',
      DNGR_HS_CODE: 'HS Code(HSCODE)',
      OPERATION_CONTENT: '操作要求说明(operationContent)',
      SITUATION: '情况说明(situation)',
      ATD: 'ATD',
      CHECK_DATA: '已核对数据(checkData)',
      VIRTUAL_HBL: '是否形式分单(virtualHBL)',
      RECEIVABLE_STATE: '应收状态(receivableState)',
      PAYABLES_STATE: '应付状态(payablesState)',
      PRICE_NO: '运价No(priceNo)',
      BOOKING: '是否订舱(booking)',
      PRICE_TIER: '运价等级(priceTier)',
      SELF_DELIVER: '是否自拉自送(selfDeliver)',
      BOOKING_STATE: '订舱状态(bookingState)',
      ITM_SERVICE: '是否有外贸(ITMService)',
      CUSTOMS_JOB_NO: '报关关联号(customsJobNo)',
      CUSTOM_JOB_TYPE: '客户自定义业务种类(customJobType)',
      PREVERIFIER: '预审审核人(preverifier)',
      PREVERIFY_DATE: '预审审核时间(preverifyDate)',
      SALE_PRICE: '是否特价(salePrice)',
      SALE_PRICE_REMARKS: '特价备注(salePriceRemarks)',
      SALES_CHANNEL: '订舱渠道(salesChannel)',
      DEPOSIT_RECEIVED: '预付款(depositReceived)',
      CONTACT_EMAIL: '联系邮件(contactEmail)',
      PROVISIONED: '已计提(provisioned)',
      PROVISIONED_DATE: '计提时间(provisionedDate)',
      PROVISIONED_BY: '计提人(provisionedBy)',
      PLANNER: '航线(planner)',
      PLANNER_DEPARTMENT: '航线部门(plannerDepartment)',
      RIVER_CARRIER_ID: '江船公司(riverCarrierId)',
      TRADE_TERM: '贸易方式(tradeTerm)',
      OVERSEA_OP_DEPARTMENT: '外海操作部门(overseaOpDepartment)',
      OVERSEA_OP: '海外操作(overseaOp)',
      USER_DEFINED_FIELD_1: '自定义字段1(userDefinedField1)',
      USER_DEFINED_FIELD_2: '自定义字段2(userDefinedField2)',
      USER_DEFINED_FIELD_3: '自定义字段3(userDefinedField3)',
      MANAGE_AUDIT_REMARK: '审核备注(manageAuditRemark)',
      MANAGE_AUDIT_REJECT_REMARK: '审核拒绝备注(manageAuditRejectRemark)',
      MANAGE_AUDIT_STATUS: '主管审核状态(manageAuditStatus)',
      SUBMITTER_USER: '提交人(submitterUser)',
      AUDIT_CHECK_NODE: '提交审核节点(auditCheckNode)',
      TYPE_HBL: '分单类型(typeHBL)',
      TYPE_MBL: '主单类型(typeMBL)',
      IF_PUSH_SOP_M: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      IF_PUSH_SOP_Z: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      IF_PUSH_SOP_Q: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      IF_PUSH_SOP: '是否确认推送SOP信息(ifPushSop)',
      CHANGE_STATE: '改单状态(changeState)',
      CARGO_SALES_ID: '揽货销售(cargoSalesId)',
      CHANGE_BY: '改单人(changeBy)',
      CHANGE_DATE: '改单时间(changeDate)',
      CLOSINGACCOUNT_STATUS: '结转状态(closingAccountStatus)',
      FIRST_PROVISIONED_DATE: '首次计提时间(firstProvisionedDate)',
      FIRST_PROVISIONED_PROFIT: '首次提成利润(firstProvisionedProfit)',
      PROVISIONED_PROFIT: '累计提成利润(provisionedProfit)',
      PROVISIONED_STATUS: '计提状态(provisionedStatus)',
      SALES_REQUIRE: '销售要求(salesRequire)',
      USER_DEFINED_FIELD_4: '自定义字段4(userDefinedField4)',
      VESSEL_PORT_AREA: '港区船名(vesselPortArea)',
      VOYAGE_FLIGHT_PORT_AREA: '港区航次(voyageFlightPortArea)',
      CUSTOMER_TENANT_ID: '委托单位所属tenantId(customerTenantId)',
      CUSTOMER_TENANT_NAME: '委托单位所属tenantName(customerTenantName)',
      Job: '工作单(Job)'
    },
    SeaExportJob: {
      CONTAINER_LOAD_TYPE: '整拼类型(containerLoadType)',
      SELF_CONSOLIDATION: '是否自拼箱(selfConsolidation)',
      LOADING_TERM: '装箱方式(loadingTerm)',
      BOOKING_TERM: '订舱性质(bookingTerm)',
      CUSTOM_CLAIM: '报关方式(customClaim)',
      INCO_TERM: '贸易条款(incoTerm)',
      DANGEROUS_GOODS: '是否危险品(dangerousGoods)',
      SAILING_DAY: '航期(sailingDay)',
      FREIGHT_TERM: '运输条款(freightTerm)',
      FREIGHT_TERM_HBL: '分单运输条款(freightTermHBL)',
      REMARKS_BOOKING: '配舱通知书备注(remarksBooking)',
      REMARKS_SHIPPING: 'SHIPPING ADVICE备注(remarksShipping)',
      INSIDE_QUANTITY: '小件数(insideQuantity)',
      INSIDE_PACKING: '小件数包装类型(insidePacking)',
      SECOND_VESSEL_ETD: '二程开航日期(secondVesselETD)',
      SECOND_VESSEL_VOYAGE: '二程船名(secondVesselVoyage)',
      SECOND_VOYAGE: '二程航次(secondVoyage)',
      THIRD_VESSEL_ETD: '三程开航日期(thirdVesselETD',
      THIRD_VESSEL_VOYAGE: '三程船名航次(thirdVesselVoyage)',
      PORT_DISTRICT: '港区(portDistrict)',
      PORT_CODE: '港口代码(portCode)',
      ADDRESS_EIR: '交接单地址(addressEIR)',
      CONTACT_EIR: '交接单地址联系人(contactEIR)',
      PHONE_EIR: '交接单地址联系方式(phoneEIR)',
      TERMINAL_OPENDATE: '开港日期(terminalOpendate)',
      TERMINAL_CUTOFF: '截港日期(terminalCutoff)',
      CUSTOM_CUTOFF: '截关日期(customCutoff)',
      FILECUTOFF: '截单日期(fileCutoff)',
      COMERCIAL_INSPECTATION: '是否商检(comercialInspectation)',
      TRANSFERING: '是否转运(transfering)',
      CUSTOMS: '是否报关(customs)',
      HEATING: '是否薰蒸(heating)',
      BATCH: '是否分批(batch)',
      AMS: '是否AMS(AMS)',
      BARGE: '是否驳船(barge)',
      VGM: '是否VGM(vgm)',
      BARGE_VESSEL: '驳船船名(bargeVessel)',
      BARGE_VOYAGE: '驳船航次(bargeVoyage)',
      BARGE_ETD: '驳船ETD(bargeETD)',
      BARGE_ETA: '驳船ETA(bargeETA)',
      BARGE_POL: '驳船POL(bargePOL)',
      BARGE_POD: '驳船POD(bargePOD)',
      SO_NO: '配舱编号(soNo)',
      CURRENCY: '货值币种(currency)',
      AMOUNT: '货值金额(amount)',
      QUOTATION_NO: '运费协议号(quotationNo)',
      BOOKING_EDI: '是否导订舱EDI(bookingEDI)',
      BLEDI: '是否导提单EDI(BLEDI)',
      AGENT_EDI: '是否导海外代理EDI(agentEDI)',
      SOC: '是否货主箱(SOC)',
      AGENT_PRICE: '是否代理约价(agentPrice)',
      TRANSFER_PORT_CODE: '中转港代码(transferPortCode)',
      WAREHOUSE_PRINTED: '是否打印进仓通知(warehousePrinted)',
      PRICE_OWNER: '约主(priceOwner)',
      YARD_CODE: '堆场代码(yardCode)',
      VESSEL_CODE: '船舶呼号(vesselCode)',
      AP_CODE: 'apCode',
      AP_NAME: 'apName',
      BOOKING_NO: '订舱编号(bookingNo)',
      HDS: 'HDS(hds)',
      SC_NO: '约号(scNo)',
      CUSTOMER_CUTOFF: '客户截关日期(customerCutoff)',
      CUSTOMER_SHUTOUT: '客户退关日期(CustomerShutOut)',
      BARGE_CUSTOM_CUTOFF: '驳船截关日期(bargeCustomCutoff)',
      VESSEL_LINE_CODE: '船舶航线代码(vesselLineCode)',
      FREE_TIME: '集装箱免租期(freeTime)',
      RETURN_PERIOD_BEGIN: '预计还柜期间开始(returnPeriodBegin)',
      RETURN_PERIOD_END: '预计还柜期间结束(returnPeriodEnd)',
      AMS_CUTOFF: '截AMS/ENS时间(amsCutoff)',
      OPERATION_TIPS: '操作提示(operationTips)',
      LANE_CODE: '航线代码(laneCode)',
      SUB_CONTRACT_NO: '子合同号(subContractNo)',
      NA: 'N/A(na)',
      NA_CODE: 'N/A CODE(naCode)',
      REAL_ARRIVALS_DATE: '实际进港时间(realArrivalsDate)',
      BERTH_PLAN_DATE: '计划靠泊时间(berthPlanDate)',
      UN_BERTH_PLAN_DATE: '计划离泊时间(unBerthPlanDate)',
      ACTUAL_BERTH_PLAN_DATE: '实际靠泊时间(actualBerthPlanDate)',
      ACTUAL_UNBERTH_PLAN_DATE: '实际离泊时间(actualUnBerthPlanDate)',
      BERTH_PLAN_PLACE: '计划靠泊泊位(berthPlanPlace)',
      ACTUAL_BERTH_PLAN_PLACE: '实际靠泊泊位(actualBerthPlanPlace)',
      FNL_TM: 'FNL TM(fnlTm 名称/代码：Truck/TRK，Barge/BRG，Rail/RAL)',
      INSIDE_QUANTITY_SIZE: '小件数尺寸(insideQuantitySize)',
      SPELLING: '舱单是否加拼业务(Spelling)',
      VESSEL_IMO: '船名IMO(vesselIMO)',
      ACTUAL_ARRIVAL_TIME: '实际到港时间(actualArrivalTime)',
      DEST_PORT_CUSTOMS_CLEARANCE_TIME: '目的港放关时间(destPortCustomsClearanceTime)',
      DEST_PORT_DELIVERY_TIME: '目的港送货时间(destPortDeliveryTime)',
      DEST_PORT_RETURN_TIME: '目的港还箱时间(destPortReturnTime)',
      SUB_TENANT_ID: '客户编号(subTenantId)',
      JOB_NO: '工作号(jobNo)',
      WAREHOUSE_NO: '进仓编号(warehouseNo)',
      CUSTOMER_REF_NO: '客户参考号(customerRefNo)',
      AGENTREFNO: '代理业务编号(agentRefNo)',
      MBL: 'MBL(mbl)',
      MBL_NO5: 'MBL_NO5(mblNo5)',
      RELATED_JOB: '公司往来关联号(relatedJob)',
      RELATED_JOB2: '联运编号(relatedJob2)',
      MBL_ONLY: '是否直发(mblOnly)',
      JOIN_FLAG: 'MBL并单标志(joinFlagMBL)',
      JOIN_FLAG_HBL: 'HBL并单标志(joinFlagHBL)',
      MASTER_FLAG: '拼箱主号标志(masterFlag)',
      CANCELLED: '是否取消(cancelled)',
      SALES_OFFICE: '销售公司(salesOffice)',
      SALES_DEPT: '销售部门(salesDepartment)',
      SALES_ID: '业务员(sales)',
      CSR_OFFICE: '客服公司(csrOffice)',
      CSR_DEPT: '客服部门(csrDepartment)',
      CSR_ID: '客服(csr)',
      OP_OFFICE: '操作公司(opOffice)',
      OP_DEPARTMENT: '操作部门(opDepartment)',
      OP_ID: '操作(op)',
      CUSTOMER_ID: '委托单位编码(customerId)',
      CUSTOMER_CONTACT: '联系人(customerContact)',
      CONTACT_TELEPHONE: '联系电话(contactTelephone)',
      CONTACT_FAX: '联系电传(contactFax)',
      DESIGNATION_AGENT: '指定代理(designationAgent)',
      DESTINATION_AGENT: '目的港代理(destinationAgent)',
      LOCAL_AGENT: '本地代理(localAgent)',
      MASTER_AGENT: '是否主代理(masterAgent)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      CUSTOMS_BROKER: '报关行(customsBroker)',
      DISCHARGING_PLACE: '发货地(dispatchingPlace)',
      DESTINATION_PLACE: '最终目的地(destinationPlace)',
      DESTINATION_PLACE_CODE: '最终目的地代码(destinationPlaceCode)',
      LOADING_PORT_CODE: '装货港代码(loadingPortCode)',
      DISCHARGING_PORT_CODE: '卸货港代码(dischargingPortCode)',
      DESTINATION_PORT_CODE: '目的港代码(destinationPortCode)',
      QUANTITY_CONTRACT: '委托货物件数(quantityContract)',
      WEIGHT_CONTRACT: '委托货物重量(weightContract)',
      CUBAGE_CONTRACT: '委托货物体积(cubageContract)',
      QUANTITY_ACTUAL: '实际货物件数(quantityActual)',
      WEIGHT_ACTUAL: '实际货物重量(weightActual)',
      CUBAGE_ACTUAL: '实际货物体积(cubageActual)',
      CHARGE_WEIGHT: '计费重量(chargeWeight)',
      CHARGE_CUBAGE: '计费体积(chargeCubage)',
      MEASUREMENTS: '货物尺寸(measurements)',
      CARGO_TYPE: '货物种类(cargoType)',
      PACKING: '包装(packing)',
      PAYMENT_TERM_MBL: '主单运费方式(paymentTermMBL)',
      PAYMENT_TERM_HBL: '分单运费方式(paymentTermHBL)',
      CARGO_CHINESE_NAME: '中文品名(cargoChineseName)',
      CARGO_ENGLISH_NAME: '英文品名(cargoEnglishName)',
      MARK: '唛头(mark)',
      CARRIER_ID: '承运人编号(carrierId)',
      CARRIER_AGENT_ID: '船代(carrierAgentId)',
      VESSEL: '船名(vessel)',
      VOYAGE_FLIGHT: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      JOB_STATE: '业务状态(jobState)',
      COMMISSION: '业务提成金额(commission)',
      REMARKS: '备注(remarks)',
      BUSINESS_DATE: '业务日期(businessDate)',
      LOB: '业务类型(lob)',
      SHUT_OUT: '是否退关(shutOut)',
      SATISFIED_REQUESTS: ' 满足的特殊要求(satisfiedRequests)',
      DC_OFFICE: '单证公司(dcOffice)',
      DC_DEPT: '单证部门(dcDepartment)',
      DC_ID: '单证(dc)',
      PONO: '项目编号(PONO)',
      AGENT_LEVEL: '代理等级(agentLevel)',
      CARGO_SOURCE: '货物来源(cargoSource)',
      CONTAINER_DESC: '货量描述(containerDesc)',
      TEU: 'teu',
      PROFIT: 'profit',
      WAREHOUSING: '是否仓储(warehousing)',
      LAND_TRANSPORTATION: '是否路运(landTransportation)',
      INTERNATIONAL: '是否国际运输(international)',
      MULTIPLE_PICKUPS: '是否多次派车(multiplePickups)',
      ADVANCE: '是否垫付(advance)',
      BLOCKED: '是否等待特批(blocked)',
      EXPRESS: '是否是快递(express)',
      DECLARE_CUSTOMS_STATE: '报关状态(declareCustomsState)',
      WAREHOUSE_NO_FORMAT: '进仓编号格式化(warehouseNoFormat)',
      SHIPPER_ID: '发货人Id(shipperId)',
      CONSIGNEE_ID: '收货人Id(consigneeId)',
      NOTIFY_ID: '通知人Id(notifyId)',
      PREVERIFY_STATE: '预审核状态(preverifyState)',
      TRUST_FROM_JOB: '委托来源关联号(trustFromJob)',
      SIGN_MBL: '是否签发主单(signMBL)',
      SIGN_HBL: '是否签发分单(signHBL)',
      ESTIMATE_ACCOUNTS_RECEIVABLE: '预估收入(EstimateAccountsReceivable)',
      ESTIMATE_ACCOUNTS_PAYABLE: '预估成本(EstimateAccountsPayable)',
      ESTIMATE_GROSS_PROFIT: '预估利润(EstimateGrossProfit)',
      SHIPPER_CODE: '发货人代码(shipperCode)',
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(consigneeLine1)',
      CONSIGNEE_LINE2: '收货人(consigneeLine2)',
      CONSIGNEE_LINE3: '收货人(consigneeLine3)',
      CONSIGNEE_LINE4: '收货人(consigneeLine4)',
      CONSIGNEE_LINE5: '收货人(consigneeLine5)',
      CONSIGNEE_LINE6: '收货人(consigneeLine6)',
      CONSIGNEE_LINE7: '收货人(consigneeLine7)',
      NOTIFY_CODE: '通知人代码(notifyCode)',
      NOTIFY_LINE1: '通知人(notifyLine1)',
      NOTIFY_LINE2: '通知人(notifyLine2)',
      NOTIFY_LINE3: '通知人(notifyLine3)',
      NOTIFY_LINE4: '通知人(notifyLine4)',
      NOTIFY_LINE5: '通知人(notifyLine5)',
      NOTIFY_LINE6: '通知人(notifyLine6)',
      NOTIFY_LINE7: '通知人(notifyLine7)',
      ALSO_NOTIFY: '第二通知人(alsoNotify)',
      BOOKING_REFUSE_NOTE: '拒绝订舱理由(bookingRefuseNote)',
      CUSTOMS_DATE: '报关日期(customsDate)',
      CUSTOMS_REMARKS: '报关备注(customsRemarks)',
      DNGR_HS_CODE: 'HS Code(HSCODE)',
      OPERATION_CONTENT: '操作要求说明(operationContent)',
      SITUATION: '情况说明(situation)',
      ATD: 'ATD',
      CHECK_DATA: '已核对数据(checkData)',
      VIRTUAL_HBL: '是否形式分单(virtualHBL)',
      RECEIVABLE_STATE: '应收状态(receivableState)',
      PAYABLES_STATE: '应付状态(payablesState)',
      PRICE_NO: '运价No(priceNo)',
      BOOKING: '是否订舱(booking)',
      PRICE_TIER: '运价等级(priceTier)',
      SELF_DELIVER: '是否自拉自送(selfDeliver)',
      BOOKING_STATE: '订舱状态(bookingState)',
      ITM_SERVICE: '是否有外贸(ITMService)',
      CUSTOMS_JOB_NO: '报关关联号(customsJobNo)',
      CUSTOM_JOB_TYPE: '客户自定义业务种类(customJobType)',
      PREVERIFIER: '预审审核人(preverifier)',
      PREVERIFY_DATE: '预审审核时间(preverifyDate)',
      SALE_PRICE: '是否特价(salePrice)',
      SALE_PRICE_REMARKS: '特价备注(salePriceRemarks)',
      SALES_CHANNEL: '订舱渠道(salesChannel)',
      DEPOSIT_RECEIVED: '预付款(depositReceived)',
      CONTACT_EMAIL: '联系邮件(contactEmail)',
      PROVISIONED: '已计提(provisioned)',
      PROVISIONED_DATE: '计提时间(provisionedDate)',
      PROVISIONED_BY: '计提人(provisionedBy)',
      PLANNER: '航线(planner)',
      PLANNER_DEPARTMENT: '航线部门(plannerDepartment)',
      RIVER_CARRIER_ID: '江船公司(riverCarrierId)',
      TRADE_TERM: '贸易方式(tradeTerm)',
      OVERSEA_OP_DEPARTMENT: '外海操作部门(overseaOpDepartment)',
      OVERSEA_OP: '海外操作(overseaOp)',
      USER_DEFINED_FIELD_1: '自定义字段1(userDefinedField1)',
      USER_DEFINED_FIELD_2: '自定义字段2(userDefinedField2)',
      USER_DEFINED_FIELD_3: '自定义字段3(userDefinedField3)',
      MANAGE_AUDIT_REMARK: '审核备注(manageAuditRemark)',
      MANAGE_AUDIT_REJECT_REMARK: '审核拒绝备注(manageAuditRejectRemark)',
      MANAGE_AUDIT_STATUS: '主管审核状态(manageAuditStatus)',
      SUBMITTER_USER: '提交人(submitterUser)',
      AUDIT_CHECK_NODE: '提交审核节点(auditCheckNode)',
      TYPE_HBL: '分单类型(typeHBL)',
      TYPE_MBL: '主单类型(typeMBL)',
      IF_PUSH_SOP_M: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      IF_PUSH_SOP_Z: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      IF_PUSH_SOP_Q: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      IF_PUSH_SOP: '是否确认推送SOP信息(ifPushSop)',
      CHANGE_STATE: '改单状态(changeState)',
      CARGO_SALES_ID: '揽货销售(cargoSalesId)',
      CHANGE_BY: '改单人(changeBy)',
      CHANGE_DATE: '改单时间(changeDate)',
      CLOSINGACCOUNT_STATUS: '结转状态(closingAccountStatus)',
      FIRST_PROVISIONED_DATE: '首次计提时间(firstProvisionedDate)',
      FIRST_PROVISIONED_PROFIT: '首次提成利润(firstProvisionedProfit)',
      PROVISIONED_PROFIT: '累计提成利润(provisionedProfit)',
      PROVISIONED_STATUS: '计提状态(provisionedStatus)',
      SALES_REQUIRE: '销售要求(salesRequire)',
      USER_DEFINED_FIELD_4: '自定义字段4(userDefinedField4)',
      VESSEL_PORT_AREA: '港区船名(vesselPortArea)',
      VOYAGE_FLIGHT_PORT_AREA: '港区航次(voyageFlightPortArea)',
      CUSTOMER_TENANT_ID: '委托单位所属tenantId(customerTenantId)',
      CUSTOMER_TENANT_NAME: '委托单位所属tenantName(customerTenantName)',
      SeaExportJob: '海运出口工作单(SeaExportJob)'
    },
    SeaImportJob: {
      CONTAINER_LOAD_TYPE: '整拼类型(containerLoadType)',
      HBL: '分单号(HBL)',
      INCO_TERM: '贸易条款(incoTerm)',
      PORT_DISTRICT: '港区(portDistrict)',
      FREIGHT_TERM_MBL: '主单运输条款(freightTermMBL)',
      FREIGHT_TERM_HBL: '客户运输条款(freightTermHBL)',
      RELEASE_TYPE: '放货方式(releaseType)',
      PAYMENT_PLACE: '付款地点(paymentPlace)',
      TRANS_DATE: '换单日期(transDate)',
      RELEASE_DATE: '放货日期(releaseDate)',
      DELIVER_DATE: '送货日期(deliverDate)',
      ESD: '预计提箱日期(ESD)',
      RETURN_DATE: '还箱日期(returnDate)',
      RELEASE_TYPE_MBL: '主单放单方式(releaseTypeMBL)',
      RELEASE_TYPE_HBL: '分单放单方式(releaseTypeHBL)',
      SECOND_VESSEL: '二程船名(secondVessel)',
      SECOND_VOYAGE: '二程航次(secondVoyage)',
      TRANS: '是否换单(trans)',
      CUSTOMS: '是否报关(customs)',
      CUSTOM_DATE: '报关日期(customDate)',
      PARTS: '是否拆箱(parts)',
      QUARANTINE: '是否动卫检(quarantine)',
      ARRIVE_STORAGE_DATE: '到库日期(arriveStorageDate)',
      CUSTOMS_HBL: '海关分单号(customsHBL)',
      VESSEL_UN_CODE: '船舶代码(vesselUnCode)',
      DELIVER_REMARKS: '提货备注(deliverRemarks)',
      ARRIVE_STORAGE_REMARKS: '到库备注(arriveStorageRemarks)',
      CUSTOMER_REMARKS: '委托单位备注(customerRemarks)',
      CUSTOMS_NO: '海关编号(customsNo)',
      VESSEL_CHINESE_NAME: '中文船名(vesselChineseName)',
      LOADING_PORT_OP: '起运港操作(loadingPortOp)',
      DESTINATION_PORT_OP: '目的地操作(destinationPortOp)',
      BOOKING_TERM: '约价性质(bookingTerm)',
      SC_NO: '船公司约号(scNo)',
      INSIDE_QUANTITY: '小件数(insideQuantity)',
      INSIDE_PACKING: '小件数包装类型(insidePacking)',
      VESSEL_CODE: '船舶呼号(vesselCode)',
      BARGE: '是否驳船(barge)',
      BARGE_VESSEL: '驳船船名(bargeVessel)',
      BARGE_VOYAGE: '驳船航次(bargeVoyage)',
      SUB_TENANT_ID: '客户编号(subTenantId)',
      JOB_NO: '工作号(jobNo)',
      WAREHOUSE_NO: '进仓编号(warehouseNo)',
      CUSTOMER_REF_NO: '客户参考号(customerRefNo)',
      AGENTREFNO: '代理业务编号(agentRefNo)',
      MBL: 'MBL(mbl)',
      MBL_NO5: 'MBL_NO5(mblNo5)',
      RELATED_JOB: '公司往来关联号(relatedJob)',
      RELATED_JOB2: '联运编号(relatedJob2)',
      MBL_ONLY: '是否直发(mblOnly)',
      JOIN_FLAG: 'MBL并单标志(joinFlagMBL)',
      JOIN_FLAG_HBL: 'HBL并单标志(joinFlagHBL)',
      MASTER_FLAG: '拼箱主号标志(masterFlag)',
      CANCELLED: '是否取消(cancelled)',
      SALES_OFFICE: '销售公司(salesOffice)',
      SALES_DEPT: '销售部门(salesDepartment)',
      SALES_ID: '业务员(sales)',
      CSR_OFFICE: '客服公司(csrOffice)',
      CSR_DEPT: '客服部门(csrDepartment)',
      CSR_ID: '客服(csr)',
      OP_OFFICE: '操作公司(opOffice)',
      OP_DEPARTMENT: '操作部门(opDepartment)',
      OP_ID: '操作(op)',
      CUSTOMER_ID: '委托单位编码(customerId)',
      CUSTOMER_CONTACT: '联系人(customerContact)',
      CONTACT_TELEPHONE: '联系电话(contactTelephone)',
      CONTACT_FAX: '联系电传(contactFax)',
      DESIGNATION_AGENT: '指定代理(designationAgent)',
      DESTINATION_AGENT: '目的港代理(destinationAgent)',
      LOCAL_AGENT: '本地代理(localAgent)',
      MASTER_AGENT: '是否主代理(masterAgent)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      CUSTOMS_BROKER: '报关行(customsBroker)',
      DISCHARGING_PLACE: '发货地(dispatchingPlace)',
      DESTINATION_PLACE: '最终目的地(destinationPlace)',
      DESTINATION_PLACE_CODE: '最终目的地代码(destinationPlaceCode)',
      LOADING_PORT_CODE: '装货港代码(loadingPortCode)',
      DISCHARGING_PORT_CODE: '卸货港代码(dischargingPortCode)',
      DESTINATION_PORT_CODE: '目的港代码(destinationPortCode)',
      QUANTITY_CONTRACT: '委托货物件数(quantityContract)',
      WEIGHT_CONTRACT: '委托货物重量(weightContract)',
      CUBAGE_CONTRACT: '委托货物体积(cubageContract)',
      QUANTITY_ACTUAL: '实际货物件数(quantityActual)',
      WEIGHT_ACTUAL: '实际货物重量(weightActual)',
      CUBAGE_ACTUAL: '实际货物体积(cubageActual)',
      CHARGE_WEIGHT: '计费重量(chargeWeight)',
      CHARGE_CUBAGE: '计费体积(chargeCubage)',
      MEASUREMENTS: '货物尺寸(measurements)',
      CARGO_TYPE: '货物种类(cargoType)',
      PACKING: '包装(packing)',
      PAYMENT_TERM_MBL: '主单运费方式(paymentTermMBL)',
      PAYMENT_TERM_HBL: '分单运费方式(paymentTermHBL)',
      CARGO_CHINESE_NAME: '中文品名(cargoChineseName)',
      CARGO_ENGLISH_NAME: '英文品名(cargoEnglishName)',
      MARK: '唛头(mark)',
      CARRIER_ID: '承运人编号(carrierId)',
      CARRIER_AGENT_ID: '船代(carrierAgentId)',
      VESSEL: '船名(vessel)',
      VOYAGE_FLIGHT: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      JOB_STATE: '业务状态(jobState)',
      COMMISSION: '业务提成金额(commission)',
      REMARKS: '备注(remarks)',
      BUSINESS_DATE: '业务日期(businessDate)',
      LOB: '业务类型(lob)',
      SHUT_OUT: '是否退关(shutOut)',
      SATISFIED_REQUESTS: ' 满足的特殊要求(satisfiedRequests)',
      DC_OFFICE: '单证公司(dcOffice)',
      DC_DEPT: '单证部门(dcDepartment)',
      DC_ID: '单证(dc)',
      PONO: '项目编号(PONO)',
      AGENT_LEVEL: '代理等级(agentLevel)',
      CARGO_SOURCE: '货物来源(cargoSource)',
      CONTAINER_DESC: '货量描述(containerDesc)',
      TEU: 'teu',
      PROFIT: 'profit',
      WAREHOUSING: '是否仓储(warehousing)',
      LAND_TRANSPORTATION: '是否路运(landTransportation)',
      INTERNATIONAL: '是否国际运输(international)',
      MULTIPLE_PICKUPS: '是否多次派车(multiplePickups)',
      ADVANCE: '是否垫付(advance)',
      BLOCKED: '是否等待特批(blocked)',
      EXPRESS: '是否是快递(express)',
      DECLARE_CUSTOMS_STATE: '报关状态(declareCustomsState)',
      WAREHOUSE_NO_FORMAT: '进仓编号格式化(warehouseNoFormat)',
      SHIPPER_ID: '发货人Id(shipperId)',
      CONSIGNEE_ID: '收货人Id(consigneeId)',
      NOTIFY_ID: '通知人Id(notifyId)',
      PREVERIFY_STATE: '预审核状态(preverifyState)',
      TRUST_FROM_JOB: '委托来源关联号(trustFromJob)',
      SIGN_MBL: '是否签发主单(signMBL)',
      SIGN_HBL: '是否签发分单(signHBL)',
      ESTIMATE_ACCOUNTS_RECEIVABLE: '预估收入(EstimateAccountsReceivable)',
      ESTIMATE_ACCOUNTS_PAYABLE: '预估成本(EstimateAccountsPayable)',
      ESTIMATE_GROSS_PROFIT: '预估利润(EstimateGrossProfit)',
      SHIPPER_CODE: '发货人代码(shipperCode)',
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(consigneeLine1)',
      CONSIGNEE_LINE2: '收货人(consigneeLine2)',
      CONSIGNEE_LINE3: '收货人(consigneeLine3)',
      CONSIGNEE_LINE4: '收货人(consigneeLine4)',
      CONSIGNEE_LINE5: '收货人(consigneeLine5)',
      CONSIGNEE_LINE6: '收货人(consigneeLine6)',
      CONSIGNEE_LINE7: '收货人(consigneeLine7)',
      NOTIFY_CODE: '通知人代码(notifyCode)',
      NOTIFY_LINE1: '通知人(notifyLine1)',
      NOTIFY_LINE2: '通知人(notifyLine2)',
      NOTIFY_LINE3: '通知人(notifyLine3)',
      NOTIFY_LINE4: '通知人(notifyLine4)',
      NOTIFY_LINE5: '通知人(notifyLine5)',
      NOTIFY_LINE6: '通知人(notifyLine6)',
      NOTIFY_LINE7: '通知人(notifyLine7)',
      ALSO_NOTIFY: '第二通知人(alsoNotify)',
      BOOKING_REFUSE_NOTE: '拒绝订舱理由(bookingRefuseNote)',
      CUSTOMS_DATE: '报关日期(customsDate)',
      CUSTOMS_REMARKS: '报关备注(customsRemarks)',
      DNGR_HS_CODE: 'HS Code(HSCODE)',
      OPERATION_CONTENT: '操作要求说明(operationContent)',
      SITUATION: '情况说明(situation)',
      ATD: 'ATD',
      CHECK_DATA: '已核对数据(checkData)',
      VIRTUAL_HBL: '是否形式分单(virtualHBL)',
      RECEIVABLE_STATE: '应收状态(receivableState)',
      PAYABLES_STATE: '应付状态(payablesState)',
      PRICE_NO: '运价No(priceNo)',
      BOOKING: '是否订舱(booking)',
      PRICE_TIER: '运价等级(priceTier)',
      SELF_DELIVER: '是否自拉自送(selfDeliver)',
      BOOKING_STATE: '订舱状态(bookingState)',
      ITM_SERVICE: '是否有外贸(ITMService)',
      CUSTOMS_JOB_NO: '报关关联号(customsJobNo)',
      CUSTOM_JOB_TYPE: '客户自定义业务种类(customJobType)',
      PREVERIFIER: '预审审核人(preverifier)',
      PREVERIFY_DATE: '预审审核时间(preverifyDate)',
      SALE_PRICE: '是否特价(salePrice)',
      SALE_PRICE_REMARKS: '特价备注(salePriceRemarks)',
      SALES_CHANNEL: '订舱渠道(salesChannel)',
      DEPOSIT_RECEIVED: '预付款(depositReceived)',
      CONTACT_EMAIL: '联系邮件(contactEmail)',
      PROVISIONED: '已计提(provisioned)',
      PROVISIONED_DATE: '计提时间(provisionedDate)',
      PROVISIONED_BY: '计提人(provisionedBy)',
      PLANNER: '航线(planner)',
      PLANNER_DEPARTMENT: '航线部门(plannerDepartment)',
      RIVER_CARRIER_ID: '江船公司(riverCarrierId)',
      TRADE_TERM: '贸易方式(tradeTerm)',
      OVERSEA_OP_DEPARTMENT: '外海操作部门(overseaOpDepartment)',
      OVERSEA_OP: '海外操作(overseaOp)',
      USER_DEFINED_FIELD_1: '自定义字段1(userDefinedField1)',
      USER_DEFINED_FIELD_2: '自定义字段2(userDefinedField2)',
      USER_DEFINED_FIELD_3: '自定义字段3(userDefinedField3)',
      MANAGE_AUDIT_REMARK: '审核备注(manageAuditRemark)',
      MANAGE_AUDIT_REJECT_REMARK: '审核拒绝备注(manageAuditRejectRemark)',
      MANAGE_AUDIT_STATUS: '主管审核状态(manageAuditStatus)',
      SUBMITTER_USER: '提交人(submitterUser)',
      AUDIT_CHECK_NODE: '提交审核节点(auditCheckNode)',
      TYPE_HBL: '分单类型(typeHBL)',
      TYPE_MBL: '主单类型(typeMBL)',
      IF_PUSH_SOP_M: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      IF_PUSH_SOP_Z: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      IF_PUSH_SOP_Q: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      IF_PUSH_SOP: '是否确认推送SOP信息(ifPushSop)',
      CHANGE_STATE: '改单状态(changeState)',
      CARGO_SALES_ID: '揽货销售(cargoSalesId)',
      CHANGE_BY: '改单人(changeBy)',
      CHANGE_DATE: '改单时间(changeDate)',
      CLOSINGACCOUNT_STATUS: '结转状态(closingAccountStatus)',
      FIRST_PROVISIONED_DATE: '首次计提时间(firstProvisionedDate)',
      FIRST_PROVISIONED_PROFIT: '首次提成利润(firstProvisionedProfit)',
      PROVISIONED_PROFIT: '累计提成利润(provisionedProfit)',
      PROVISIONED_STATUS: '计提状态(provisionedStatus)',
      SALES_REQUIRE: '销售要求(salesRequire)',
      USER_DEFINED_FIELD_4: '自定义字段4(userDefinedField4)',
      VESSEL_PORT_AREA: '港区船名(vesselPortArea)',
      VOYAGE_FLIGHT_PORT_AREA: '港区航次(voyageFlightPortArea)',
      CUSTOMER_TENANT_ID: '委托单位所属tenantId(customerTenantId)',
      CUSTOMER_TENANT_NAME: '委托单位所属tenantName(customerTenantName)',
      SeaImportJob: '海运进口工作单(SeaImportJob)'
    },
    AirExportJob: {
      OPERATE_TYPE: '操作模式(operateType)',
      HAWB: '分单号(HAWB)',
      BOOKING_TERM: '订舱性质(bookingTerm)',
      CUSTOM_CLAIM: '报关方式(customClaim)',
      INCO_TERM: '贸易条款(incoTerm)',
      TYPE_HAWB: '分单类型(typeHAWB)',
      SECOND_PORT_CODE: '二程港口(secondPortCode)',
      SECOND_BOOKING_AGENT_ID: '二程订舱代理(secondBookingAgentId)',
      SECOND_CARRIER_ID: '二程航空公司(secondCarrierId)',
      SECOND_ETD: '二程开航日期(secondETD)',
      SECOND_FLIGHT: '二程航班(secondFlight)',
      SECOND_MAWB: '二程运单号(secondMAWB)',
      THIRD_CARRIER_ID: '三程航空公司(thirdCarrierId)',
      THIRD_ETD: '三程开航日期(thirdETD)',
      THIRD_FLIGHT: '三程航班(thirdFlight)',
      THIRD_MAWB: '三程运单号(thirdMAWB)',
      THIRD_PORT_CODE: '三程港口(thirdPortCode)',
      COMERCIAL_INSPECTATION: '是否商检(comercialInspectation)',
      DOCUMENT_ALL: '是否单齐(documentAll)',
      CARGO_ARRIVE: '是否货到(cargoArrive)',
      COMERCIAL_INSPECT_CHECK: '是否商检查验(comercialInspectCheck)',
      INSPECT_CHECK: '是否海关查验(InspectCheck)',
      CURRENCY: '币种(currency)',
      KC_NO: 'KCNo',
      CABIN_REQ: '舱位要求(cabinReq)',
      LOAD_REQ: '装板要求(loadReq)',
      DOC_REQ: '制单要求(docReq)',
      REMARKS_SHIPPING: 'SHIPPING ADVICE备注(remarksShipping)',
      INSIDE_QUANTITY: '小件数(insideQuantity)',
      INSIDE_PACKING: '小件数包装类型(insidePacking)',
      LOADING_AGENT_ID: '起运港代理(loadingAgentId)',
      CARGO_PROP: '二级货物类型(cargoProp)',
      C_WEIGHT: '实际计费重量(cWeight)',
      TRANSFERING: '是否转运(transfering)',
      LOADING_TERM: '本地服务(loadingTerm)',
      CUSTOMS_CLAIM2: '委托报关类别(customsClaim2)',
      QUANTITY_BOOKING: '订舱件数(quantityBooking)',
      WEIGHT_BOOKING: '订舱重量(weightBooking)',
      CUBAGE_BOOKING: '订舱体积(cubageBooking)',
      CHARGE_WEIGHT_BOOKING: '订舱计费重量(chargeWeightBooking)',
      CS_TOTAL: '报关票数(csTotal)',
      CS_COUNTS: '已报关票数(csCounts)',
      CHECK_COUNTS: '查验票数(checkCounts)',
      CI_COUNTS: '商检票数(ciCounts)',
      SHIPMENT: '是否已出货(shipment)',
      HAND_OFF: '是否已交接(handOff)',
      PB_PROPORTION: '客户分泡比例(pbProportion)',
      PB_PROPORTION2: '供应商分泡比例(pbProportion2)',
      SITE_REMARK: '现场备注(siteRemark)',
      SELLING: '卖价(selling)',
      BUYING: '买价(buying)',
      SITE_OP_DEPARTMENT: '现场操作部门(siteOpDepartment)',
      SITE_OP: '现场操作(siteOP)',
      SEAL_COUNTS: '关封票数(sealCounts)',
      AUTHORIZE_COUNTS: '授权票数(authorizeCounts)',
      PATCH_UP_COUNTS: '联单票数(patchUpCounts)',
      OWN_WAREHOUSE: '货进本仓(ownWarehouse)',
      TAKE_PHOTOS: '拍照(takePhotos)',
      DOCUMENTS_ATTACHED: '附随机文件(documentsAttached)',
      ESTIMATED_DATE_OF_WAREHOUSINGE: '预计进仓时间(estimatedDateOfWarehousinge)',
      OTHER_WAREHOUSE_NOTES: '其它进仓说明(otherWarehouseNotes)',
      DELIVERY_AGENT: '交货代理(deliveryAgent)',
      DELIVERY_REMARK: '交货备注(deliveryRemark)',
      OTHER_CHARGES: '杂费(otherCharges)',
      PREDICTION_OPERATION: '预报操作(predictionOperation)',
      PRINTED_LABEL: '已打印标签(printedLabel)',
      ACTUAL_FLIGHT: '实际航班(actualFlight)',
      ONWARD_JOURNEY: '续程信息(onwardJourney)',
      PROTOCOL_TYPE: '协议类型(protocolType)',
      FILECUTOFF: '截单日期(fileCutoff)',
      SUB_TENANT_ID: '客户编号(subTenantId)',
      JOB_NO: '工作号(jobNo)',
      WAREHOUSE_NO: '进仓编号(warehouseNo)',
      CUSTOMER_REF_NO: '客户参考号(customerRefNo)',
      AGENTREFNO: '代理业务编号(agentRefNo)',
      MBL: 'MBL(mbl)',
      MBL_NO5: 'MBL_NO5(mblNo5)',
      RELATED_JOB: '公司往来关联号(relatedJob)',
      RELATED_JOB2: '联运编号(relatedJob2)',
      MBL_ONLY: '是否直发(mblOnly)',
      JOIN_FLAG: 'MBL并单标志(joinFlagMBL)',
      JOIN_FLAG_HBL: 'HBL并单标志(joinFlagHBL)',
      MASTER_FLAG: '拼箱主号标志(masterFlag)',
      CANCELLED: '是否取消(cancelled)',
      SALES_OFFICE: '销售公司(salesOffice)',
      SALES_DEPT: '销售部门(salesDepartment)',
      SALES_ID: '业务员(sales)',
      CSR_OFFICE: '客服公司(csrOffice)',
      CSR_DEPT: '客服部门(csrDepartment)',
      CSR_ID: '客服(csr)',
      OP_OFFICE: '操作公司(opOffice)',
      OP_DEPARTMENT: '操作部门(opDepartment)',
      OP_ID: '操作(op)',
      CUSTOMER_ID: '委托单位编码(customerId)',
      CUSTOMER_CONTACT: '联系人(customerContact)',
      CONTACT_TELEPHONE: '联系电话(contactTelephone)',
      CONTACT_FAX: '联系电传(contactFax)',
      DESIGNATION_AGENT: '指定代理(designationAgent)',
      DESTINATION_AGENT: '目的港代理(destinationAgent)',
      LOCAL_AGENT: '本地代理(localAgent)',
      MASTER_AGENT: '是否主代理(masterAgent)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      CUSTOMS_BROKER: '报关行(customsBroker)',
      DISCHARGING_PLACE: '发货地(dispatchingPlace)',
      DESTINATION_PLACE: '最终目的地(destinationPlace)',
      DESTINATION_PLACE_CODE: '最终目的地代码(destinationPlaceCode)',
      LOADING_PORT_CODE: '装货港代码(loadingPortCode)',
      DISCHARGING_PORT_CODE: '卸货港代码(dischargingPortCode)',
      DESTINATION_PORT_CODE: '目的港代码(destinationPortCode)',
      QUANTITY_CONTRACT: '委托货物件数(quantityContract)',
      WEIGHT_CONTRACT: '委托货物重量(weightContract)',
      CUBAGE_CONTRACT: '委托货物体积(cubageContract)',
      QUANTITY_ACTUAL: '实际货物件数(quantityActual)',
      WEIGHT_ACTUAL: '实际货物重量(weightActual)',
      CUBAGE_ACTUAL: '实际货物体积(cubageActual)',
      CHARGE_WEIGHT: '计费重量(chargeWeight)',
      CHARGE_CUBAGE: '计费体积(chargeCubage)',
      MEASUREMENTS: '货物尺寸(measurements)',
      CARGO_TYPE: '货物种类(cargoType)',
      PACKING: '包装(packing)',
      PAYMENT_TERM_MBL: '主单运费方式(paymentTermMBL)',
      PAYMENT_TERM_HBL: '分单运费方式(paymentTermHBL)',
      CARGO_CHINESE_NAME: '中文品名(cargoChineseName)',
      CARGO_ENGLISH_NAME: '英文品名(cargoEnglishName)',
      MARK: '唛头(mark)',
      CARRIER_ID: '承运人编号(carrierId)',
      CARRIER_AGENT_ID: '船代(carrierAgentId)',
      VESSEL: '船名(vessel)',
      VOYAGE_FLIGHT: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      JOB_STATE: '业务状态(jobState)',
      COMMISSION: '业务提成金额(commission)',
      REMARKS: '备注(remarks)',
      BUSINESS_DATE: '业务日期(businessDate)',
      LOB: '业务类型(lob)',
      SHUT_OUT: '是否退关(shutOut)',
      SATISFIED_REQUESTS: ' 满足的特殊要求(satisfiedRequests)',
      DC_OFFICE: '单证公司(dcOffice)',
      DC_DEPT: '单证部门(dcDepartment)',
      DC_ID: '单证(dc)',
      PONO: '项目编号(PONO)',
      AGENT_LEVEL: '代理等级(agentLevel)',
      CARGO_SOURCE: '货物来源(cargoSource)',
      CONTAINER_DESC: '货量描述(containerDesc)',
      TEU: 'teu',
      PROFIT: 'profit',
      WAREHOUSING: '是否仓储(warehousing)',
      LAND_TRANSPORTATION: '是否路运(landTransportation)',
      INTERNATIONAL: '是否国际运输(international)',
      MULTIPLE_PICKUPS: '是否多次派车(multiplePickups)',
      ADVANCE: '是否垫付(advance)',
      BLOCKED: '是否等待特批(blocked)',
      EXPRESS: '是否是快递(express)',
      DECLARE_CUSTOMS_STATE: '报关状态(declareCustomsState)',
      WAREHOUSE_NO_FORMAT: '进仓编号格式化(warehouseNoFormat)',
      SHIPPER_ID: '发货人Id(shipperId)',
      CONSIGNEE_ID: '收货人Id(consigneeId)',
      NOTIFY_ID: '通知人Id(notifyId)',
      PREVERIFY_STATE: '预审核状态(preverifyState)',
      TRUST_FROM_JOB: '委托来源关联号(trustFromJob)',
      SIGN_MBL: '是否签发主单(signMBL)',
      SIGN_HBL: '是否签发分单(signHBL)',
      ESTIMATE_ACCOUNTS_RECEIVABLE: '预估收入(EstimateAccountsReceivable)',
      ESTIMATE_ACCOUNTS_PAYABLE: '预估成本(EstimateAccountsPayable)',
      ESTIMATE_GROSS_PROFIT: '预估利润(EstimateGrossProfit)',
      SHIPPER_CODE: '发货人代码(shipperCode)',
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(consigneeLine1)',
      CONSIGNEE_LINE2: '收货人(consigneeLine2)',
      CONSIGNEE_LINE3: '收货人(consigneeLine3)',
      CONSIGNEE_LINE4: '收货人(consigneeLine4)',
      CONSIGNEE_LINE5: '收货人(consigneeLine5)',
      CONSIGNEE_LINE6: '收货人(consigneeLine6)',
      CONSIGNEE_LINE7: '收货人(consigneeLine7)',
      NOTIFY_CODE: '通知人代码(notifyCode)',
      NOTIFY_LINE1: '通知人(notifyLine1)',
      NOTIFY_LINE2: '通知人(notifyLine2)',
      NOTIFY_LINE3: '通知人(notifyLine3)',
      NOTIFY_LINE4: '通知人(notifyLine4)',
      NOTIFY_LINE5: '通知人(notifyLine5)',
      NOTIFY_LINE6: '通知人(notifyLine6)',
      NOTIFY_LINE7: '通知人(notifyLine7)',
      ALSO_NOTIFY: '第二通知人(alsoNotify)',
      BOOKING_REFUSE_NOTE: '拒绝订舱理由(bookingRefuseNote)',
      CUSTOMS_DATE: '报关日期(customsDate)',
      CUSTOMS_REMARKS: '报关备注(customsRemarks)',
      DNGR_HS_CODE: 'HS Code(HSCODE)',
      OPERATION_CONTENT: '操作要求说明(operationContent)',
      SITUATION: '情况说明(situation)',
      ATD: 'ATD',
      CHECK_DATA: '已核对数据(checkData)',
      VIRTUAL_HBL: '是否形式分单(virtualHBL)',
      RECEIVABLE_STATE: '应收状态(receivableState)',
      PAYABLES_STATE: '应付状态(payablesState)',
      PRICE_NO: '运价No(priceNo)',
      BOOKING: '是否订舱(booking)',
      PRICE_TIER: '运价等级(priceTier)',
      SELF_DELIVER: '是否自拉自送(selfDeliver)',
      BOOKING_STATE: '订舱状态(bookingState)',
      ITM_SERVICE: '是否有外贸(ITMService)',
      CUSTOMS_JOB_NO: '报关关联号(customsJobNo)',
      CUSTOM_JOB_TYPE: '客户自定义业务种类(customJobType)',
      PREVERIFIER: '预审审核人(preverifier)',
      PREVERIFY_DATE: '预审审核时间(preverifyDate)',
      SALE_PRICE: '是否特价(salePrice)',
      SALE_PRICE_REMARKS: '特价备注(salePriceRemarks)',
      SALES_CHANNEL: '订舱渠道(salesChannel)',
      DEPOSIT_RECEIVED: '预付款(depositReceived)',
      CONTACT_EMAIL: '联系邮件(contactEmail)',
      PROVISIONED: '已计提(provisioned)',
      PROVISIONED_DATE: '计提时间(provisionedDate)',
      PROVISIONED_BY: '计提人(provisionedBy)',
      PLANNER: '航线(planner)',
      PLANNER_DEPARTMENT: '航线部门(plannerDepartment)',
      RIVER_CARRIER_ID: '江船公司(riverCarrierId)',
      TRADE_TERM: '贸易方式(tradeTerm)',
      OVERSEA_OP_DEPARTMENT: '外海操作部门(overseaOpDepartment)',
      OVERSEA_OP: '海外操作(overseaOp)',
      USER_DEFINED_FIELD_1: '自定义字段1(userDefinedField1)',
      USER_DEFINED_FIELD_2: '自定义字段2(userDefinedField2)',
      USER_DEFINED_FIELD_3: '自定义字段3(userDefinedField3)',
      MANAGE_AUDIT_REMARK: '审核备注(manageAuditRemark)',
      MANAGE_AUDIT_REJECT_REMARK: '审核拒绝备注(manageAuditRejectRemark)',
      MANAGE_AUDIT_STATUS: '主管审核状态(manageAuditStatus)',
      SUBMITTER_USER: '提交人(submitterUser)',
      AUDIT_CHECK_NODE: '提交审核节点(auditCheckNode)',
      TYPE_HBL: '分单类型(typeHBL)',
      TYPE_MBL: '主单类型(typeMBL)',
      IF_PUSH_SOP_M: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      IF_PUSH_SOP_Z: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      IF_PUSH_SOP_Q: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      IF_PUSH_SOP: '是否确认推送SOP信息(ifPushSop)',
      CHANGE_STATE: '改单状态(changeState)',
      CARGO_SALES_ID: '揽货销售(cargoSalesId)',
      CHANGE_BY: '改单人(changeBy)',
      CHANGE_DATE: '改单时间(changeDate)',
      CLOSINGACCOUNT_STATUS: '结转状态(closingAccountStatus)',
      FIRST_PROVISIONED_DATE: '首次计提时间(firstProvisionedDate)',
      FIRST_PROVISIONED_PROFIT: '首次提成利润(firstProvisionedProfit)',
      PROVISIONED_PROFIT: '累计提成利润(provisionedProfit)',
      PROVISIONED_STATUS: '计提状态(provisionedStatus)',
      SALES_REQUIRE: '销售要求(salesRequire)',
      USER_DEFINED_FIELD_4: '自定义字段4(userDefinedField4)',
      VESSEL_PORT_AREA: '港区船名(vesselPortArea)',
      VOYAGE_FLIGHT_PORT_AREA: '港区航次(voyageFlightPortArea)',
      CUSTOMER_TENANT_ID: '委托单位所属tenantId(customerTenantId)',
      CUSTOMER_TENANT_NAME: '委托单位所属tenantName(customerTenantName)',
      AirExportJob: '空运出口工作单(AirExportJob)'
    },
    AirImportJob: {
      HBL: '分单号(HBL)',
      OPERATE_TYPE: '操作模式(operateType)',
      FREIGHT_TERM: '运输条款(freightTerm)',
      RELEASE_TYPE_MBL: '主单放货方式(releaseTypeMbl)',
      RELEASE_TYPE_HBL: '分单放货方式(releaseTypeHbl)',
      LOADING_AGENT_ID: '起运港代理(loadingAgentId)',
      GROUND_AGENT_ID: '地面代理(groundAgentId)',
      CUSTOMS: '是否报关(customs)',
      TRANS_DATE: '换单日期(transDate)',
      RELEASE_DATE: '放货日期(releaseDate)',
      DELIVER_DATE: '送货日期(deliverDate)',
      ARRIVE_STORAGE_DATE: '到库日期(arriveStorageDate)',
      CUSTOMS_HBL: '海关分单号(customsHBL)',
      DELIVER_REMARKS: '提货备注(deliverRemarks)',
      ARRIVE_STORAGE_REMARKS: '到库备注(arriveStorageRemarks)',
      LOADING_PORT_OP: '起运港操作(loadingPortOp)',
      DESTINATION_PORT_OP: '目的地操作(destinationPortOp)',
      INCO_TERM: '贸易条款(incoTerm)',
      SUB_TENANT_ID: '客户编号(subTenantId)',
      JOB_NO: '工作号(jobNo)',
      WAREHOUSE_NO: '进仓编号(warehouseNo)',
      CUSTOMER_REF_NO: '客户参考号(customerRefNo)',
      AGENTREFNO: '代理业务编号(agentRefNo)',
      MBL: 'MBL(mbl)',
      MBL_NO5: 'MBL_NO5(mblNo5)',
      RELATED_JOB: '公司往来关联号(relatedJob)',
      RELATED_JOB2: '联运编号(relatedJob2)',
      MBL_ONLY: '是否直发(mblOnly)',
      JOIN_FLAG: 'MBL并单标志(joinFlagMBL)',
      JOIN_FLAG_HBL: 'HBL并单标志(joinFlagHBL)',
      MASTER_FLAG: '拼箱主号标志(masterFlag)',
      CANCELLED: '是否取消(cancelled)',
      SALES_OFFICE: '销售公司(salesOffice)',
      SALES_DEPT: '销售部门(salesDepartment)',
      SALES_ID: '业务员(sales)',
      CSR_OFFICE: '客服公司(csrOffice)',
      CSR_DEPT: '客服部门(csrDepartment)',
      CSR_ID: '客服(csr)',
      OP_OFFICE: '操作公司(opOffice)',
      OP_DEPARTMENT: '操作部门(opDepartment)',
      OP_ID: '操作(op)',
      CUSTOMER_ID: '委托单位编码(customerId)',
      CUSTOMER_CONTACT: '联系人(customerContact)',
      CONTACT_TELEPHONE: '联系电话(contactTelephone)',
      CONTACT_FAX: '联系电传(contactFax)',
      DESIGNATION_AGENT: '指定代理(designationAgent)',
      DESTINATION_AGENT: '目的港代理(destinationAgent)',
      LOCAL_AGENT: '本地代理(localAgent)',
      MASTER_AGENT: '是否主代理(masterAgent)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      CUSTOMS_BROKER: '报关行(customsBroker)',
      DISCHARGING_PLACE: '发货地(dispatchingPlace)',
      DESTINATION_PLACE: '最终目的地(destinationPlace)',
      DESTINATION_PLACE_CODE: '最终目的地代码(destinationPlaceCode)',
      LOADING_PORT_CODE: '装货港代码(loadingPortCode)',
      DISCHARGING_PORT_CODE: '卸货港代码(dischargingPortCode)',
      DESTINATION_PORT_CODE: '目的港代码(destinationPortCode)',
      QUANTITY_CONTRACT: '委托货物件数(quantityContract)',
      WEIGHT_CONTRACT: '委托货物重量(weightContract)',
      CUBAGE_CONTRACT: '委托货物体积(cubageContract)',
      QUANTITY_ACTUAL: '实际货物件数(quantityActual)',
      WEIGHT_ACTUAL: '实际货物重量(weightActual)',
      CUBAGE_ACTUAL: '实际货物体积(cubageActual)',
      CHARGE_WEIGHT: '计费重量(chargeWeight)',
      CHARGE_CUBAGE: '计费体积(chargeCubage)',
      MEASUREMENTS: '货物尺寸(measurements)',
      CARGO_TYPE: '货物种类(cargoType)',
      PACKING: '包装(packing)',
      PAYMENT_TERM_MBL: '主单运费方式(paymentTermMBL)',
      PAYMENT_TERM_HBL: '分单运费方式(paymentTermHBL)',
      CARGO_CHINESE_NAME: '中文品名(cargoChineseName)',
      CARGO_ENGLISH_NAME: '英文品名(cargoEnglishName)',
      MARK: '唛头(mark)',
      CARRIER_ID: '承运人编号(carrierId)',
      CARRIER_AGENT_ID: '船代(carrierAgentId)',
      VESSEL: '船名(vessel)',
      VOYAGE_FLIGHT: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      JOB_STATE: '业务状态(jobState)',
      COMMISSION: '业务提成金额(commission)',
      REMARKS: '备注(remarks)',
      BUSINESS_DATE: '业务日期(businessDate)',
      LOB: '业务类型(lob)',
      SHUT_OUT: '是否退关(shutOut)',
      SATISFIED_REQUESTS: ' 满足的特殊要求(satisfiedRequests)',
      DC_OFFICE: '单证公司(dcOffice)',
      DC_DEPT: '单证部门(dcDepartment)',
      DC_ID: '单证(dc)',
      PONO: '项目编号(PONO)',
      AGENT_LEVEL: '代理等级(agentLevel)',
      CARGO_SOURCE: '货物来源(cargoSource)',
      CONTAINER_DESC: '货量描述(containerDesc)',
      TEU: 'teu',
      PROFIT: 'profit',
      WAREHOUSING: '是否仓储(warehousing)',
      LAND_TRANSPORTATION: '是否路运(landTransportation)',
      INTERNATIONAL: '是否国际运输(international)',
      MULTIPLE_PICKUPS: '是否多次派车(multiplePickups)',
      ADVANCE: '是否垫付(advance)',
      BLOCKED: '是否等待特批(blocked)',
      EXPRESS: '是否是快递(express)',
      DECLARE_CUSTOMS_STATE: '报关状态(declareCustomsState)',
      WAREHOUSE_NO_FORMAT: '进仓编号格式化(warehouseNoFormat)',
      SHIPPER_ID: '发货人Id(shipperId)',
      CONSIGNEE_ID: '收货人Id(consigneeId)',
      NOTIFY_ID: '通知人Id(notifyId)',
      PREVERIFY_STATE: '预审核状态(preverifyState)',
      TRUST_FROM_JOB: '委托来源关联号(trustFromJob)',
      SIGN_MBL: '是否签发主单(signMBL)',
      SIGN_HBL: '是否签发分单(signHBL)',
      ESTIMATE_ACCOUNTS_RECEIVABLE: '预估收入(EstimateAccountsReceivable)',
      ESTIMATE_ACCOUNTS_PAYABLE: '预估成本(EstimateAccountsPayable)',
      ESTIMATE_GROSS_PROFIT: '预估利润(EstimateGrossProfit)',
      SHIPPER_CODE: '发货人代码(shipperCode)',
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(consigneeLine1)',
      CONSIGNEE_LINE2: '收货人(consigneeLine2)',
      CONSIGNEE_LINE3: '收货人(consigneeLine3)',
      CONSIGNEE_LINE4: '收货人(consigneeLine4)',
      CONSIGNEE_LINE5: '收货人(consigneeLine5)',
      CONSIGNEE_LINE6: '收货人(consigneeLine6)',
      CONSIGNEE_LINE7: '收货人(consigneeLine7)',
      NOTIFY_CODE: '通知人代码(notifyCode)',
      NOTIFY_LINE1: '通知人(notifyLine1)',
      NOTIFY_LINE2: '通知人(notifyLine2)',
      NOTIFY_LINE3: '通知人(notifyLine3)',
      NOTIFY_LINE4: '通知人(notifyLine4)',
      NOTIFY_LINE5: '通知人(notifyLine5)',
      NOTIFY_LINE6: '通知人(notifyLine6)',
      NOTIFY_LINE7: '通知人(notifyLine7)',
      ALSO_NOTIFY: '第二通知人(alsoNotify)',
      BOOKING_REFUSE_NOTE: '拒绝订舱理由(bookingRefuseNote)',
      CUSTOMS_DATE: '报关日期(customsDate)',
      CUSTOMS_REMARKS: '报关备注(customsRemarks)',
      DNGR_HS_CODE: 'HS Code(HSCODE)',
      OPERATION_CONTENT: '操作要求说明(operationContent)',
      SITUATION: '情况说明(situation)',
      ATD: 'ATD',
      CHECK_DATA: '已核对数据(checkData)',
      VIRTUAL_HBL: '是否形式分单(virtualHBL)',
      RECEIVABLE_STATE: '应收状态(receivableState)',
      PAYABLES_STATE: '应付状态(payablesState)',
      PRICE_NO: '运价No(priceNo)',
      BOOKING: '是否订舱(booking)',
      PRICE_TIER: '运价等级(priceTier)',
      SELF_DELIVER: '是否自拉自送(selfDeliver)',
      BOOKING_STATE: '订舱状态(bookingState)',
      ITM_SERVICE: '是否有外贸(ITMService)',
      CUSTOMS_JOB_NO: '报关关联号(customsJobNo)',
      CUSTOM_JOB_TYPE: '客户自定义业务种类(customJobType)',
      PREVERIFIER: '预审审核人(preverifier)',
      PREVERIFY_DATE: '预审审核时间(preverifyDate)',
      SALE_PRICE: '是否特价(salePrice)',
      SALE_PRICE_REMARKS: '特价备注(salePriceRemarks)',
      SALES_CHANNEL: '订舱渠道(salesChannel)',
      DEPOSIT_RECEIVED: '预付款(depositReceived)',
      CONTACT_EMAIL: '联系邮件(contactEmail)',
      PROVISIONED: '已计提(provisioned)',
      PROVISIONED_DATE: '计提时间(provisionedDate)',
      PROVISIONED_BY: '计提人(provisionedBy)',
      PLANNER: '航线(planner)',
      PLANNER_DEPARTMENT: '航线部门(plannerDepartment)',
      RIVER_CARRIER_ID: '江船公司(riverCarrierId)',
      TRADE_TERM: '贸易方式(tradeTerm)',
      OVERSEA_OP_DEPARTMENT: '外海操作部门(overseaOpDepartment)',
      OVERSEA_OP: '海外操作(overseaOp)',
      USER_DEFINED_FIELD_1: '自定义字段1(userDefinedField1)',
      USER_DEFINED_FIELD_2: '自定义字段2(userDefinedField2)',
      USER_DEFINED_FIELD_3: '自定义字段3(userDefinedField3)',
      MANAGE_AUDIT_REMARK: '审核备注(manageAuditRemark)',
      MANAGE_AUDIT_REJECT_REMARK: '审核拒绝备注(manageAuditRejectRemark)',
      MANAGE_AUDIT_STATUS: '主管审核状态(manageAuditStatus)',
      SUBMITTER_USER: '提交人(submitterUser)',
      AUDIT_CHECK_NODE: '提交审核节点(auditCheckNode)',
      TYPE_HBL: '分单类型(typeHBL)',
      TYPE_MBL: '主单类型(typeMBL)',
      IF_PUSH_SOP_M: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      IF_PUSH_SOP_Z: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      IF_PUSH_SOP_Q: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      IF_PUSH_SOP: '是否确认推送SOP信息(ifPushSop)',
      CHANGE_STATE: '改单状态(changeState)',
      CARGO_SALES_ID: '揽货销售(cargoSalesId)',
      CHANGE_BY: '改单人(changeBy)',
      CHANGE_DATE: '改单时间(changeDate)',
      CLOSINGACCOUNT_STATUS: '结转状态(closingAccountStatus)',
      FIRST_PROVISIONED_DATE: '首次计提时间(firstProvisionedDate)',
      FIRST_PROVISIONED_PROFIT: '首次提成利润(firstProvisionedProfit)',
      PROVISIONED_PROFIT: '累计提成利润(provisionedProfit)',
      PROVISIONED_STATUS: '计提状态(provisionedStatus)',
      SALES_REQUIRE: '销售要求(salesRequire)',
      USER_DEFINED_FIELD_4: '自定义字段4(userDefinedField4)',
      VESSEL_PORT_AREA: '港区船名(vesselPortArea)',
      VOYAGE_FLIGHT_PORT_AREA: '港区航次(voyageFlightPortArea)',
      CUSTOMER_TENANT_ID: '委托单位所属tenantId(customerTenantId)',
      CUSTOMER_TENANT_NAME: '委托单位所属tenantName(customerTenantName)',
      AirImportJob: '空运进口工作单(AirImportJob)'
    },
    CustomsJob: {
      INCO_TERM: '贸易条款(incoTerm)',
      DANGEROUS_GOODS: '是否危险品(dangerousGoods)',
      FREIGHT_TERM: '运输条款(freightTerm)',
      COMERCIAL_INSPECTATION: '是否商检(comercialInspectation)',
      HEATING: '是否薰蒸(heating)',
      CURRENCY: '货值币种(currency)',
      AMOUNT: '货值金额(amount)',
      CARGO_JOB_NO: '货代业务关联号(cargoJobNo)',
      JOB_NO: '工作号(jobNo)',
      WAREHOUSE_NO: '进仓编号(warehouseNo)',
      CUSTOMER_REF_NO: '客户参考号(customerRefNo)',
      AGENTREFNO: '代理业务编号(agentRefNo)',
      MBL: 'MBL(mbl)',
      MBL_NO5: 'MBL_NO5(mblNo5)',
      RELATED_JOB: '公司往来关联号(relatedJob)',
      RELATED_JOB2: '联运编号(relatedJob2)',
      MBL_ONLY: '是否直发(mblOnly)',
      JOIN_FLAG: 'MBL并单标志(joinFlagMBL)',
      JOIN_FLAG_HBL: 'HBL并单标志(joinFlagHBL)',
      MASTER_FLAG: '拼箱主号标志(masterFlag)',
      CANCELLED: '是否取消(cancelled)',
      SALES_OFFICE: '销售公司(salesOffice)',
      SALES_DEPT: '销售部门(salesDepartment)',
      SALES_ID: '业务员(sales)',
      CSR_OFFICE: '客服公司(csrOffice)',
      CSR_DEPT: '客服部门(csrDepartment)',
      CSR_ID: '客服(csr)',
      OP_OFFICE: '操作公司(opOffice)',
      OP_DEPARTMENT: '操作部门(opDepartment)',
      OP_ID: '操作(op)',
      CUSTOMER_ID: '委托单位编码(customerId)',
      CUSTOMER_CONTACT: '联系人(customerContact)',
      CONTACT_TELEPHONE: '联系电话(contactTelephone)',
      CONTACT_FAX: '联系电传(contactFax)',
      DESIGNATION_AGENT: '指定代理(designationAgent)',
      DESTINATION_AGENT: '目的港代理(destinationAgent)',
      LOCAL_AGENT: '本地代理(localAgent)',
      MASTER_AGENT: '是否主代理(masterAgent)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      CUSTOMS_BROKER: '报关行(customsBroker)',
      DISCHARGING_PLACE: '发货地(dispatchingPlace)',
      DESTINATION_PLACE: '最终目的地(destinationPlace)',
      DESTINATION_PLACE_CODE: '最终目的地代码(destinationPlaceCode)',
      LOADING_PORT_CODE: '装货港代码(loadingPortCode)',
      DISCHARGING_PORT_CODE: '卸货港代码(dischargingPortCode)',
      DESTINATION_PORT_CODE: '目的港代码(destinationPortCode)',
      QUANTITY_CONTRACT: '委托货物件数(quantityContract)',
      WEIGHT_CONTRACT: '委托货物重量(weightContract)',
      CUBAGE_CONTRACT: '委托货物体积(cubageContract)',
      QUANTITY_ACTUAL: '实际货物件数(quantityActual)',
      WEIGHT_ACTUAL: '实际货物重量(weightActual)',
      CUBAGE_ACTUAL: '实际货物体积(cubageActual)',
      CHARGE_WEIGHT: '计费重量(chargeWeight)',
      CHARGE_CUBAGE: '计费体积(chargeCubage)',
      MEASUREMENTS: '货物尺寸(measurements)',
      CARGO_TYPE: '货物种类(cargoType)',
      PACKING: '包装(packing)',
      PAYMENT_TERM_MBL: '主单运费方式(paymentTermMBL)',
      PAYMENT_TERM_HBL: '分单运费方式(paymentTermHBL)',
      CARGO_CHINESE_NAME: '中文品名(cargoChineseName)',
      CARGO_ENGLISH_NAME: '英文品名(cargoEnglishName)',
      MARK: '唛头(mark)',
      CARRIER_ID: '承运人编号(carrierId)',
      CARRIER_AGENT_ID: '船代(carrierAgentId)',
      VESSEL: '船名(vessel)',
      VOYAGE_FLIGHT: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      JOB_STATE: '业务状态(jobState)',
      COMMISSION: '业务提成金额(commission)',
      REMARKS: '备注(remarks)',
      BUSINESS_DATE: '业务日期(businessDate)',
      LOB: '业务类型(lob)',
      SHUT_OUT: '是否退关(shutOut)',
      SATISFIED_REQUESTS: ' 满足的特殊要求(satisfiedRequests)',
      DC_OFFICE: '单证公司(dcOffice)',
      DC_DEPT: '单证部门(dcDepartment)',
      DC_ID: '单证(dc)',
      PONO: '项目编号(PONO)',
      AGENT_LEVEL: '代理等级(agentLevel)',
      CARGO_SOURCE: '货物来源(cargoSource)',
      CONTAINER_DESC: '货量描述(containerDesc)',
      TEU: 'teu',
      PROFIT: 'profit',
      WAREHOUSING: '是否仓储(warehousing)',
      LAND_TRANSPORTATION: '是否路运(landTransportation)',
      INTERNATIONAL: '是否国际运输(international)',
      MULTIPLE_PICKUPS: '是否多次派车(multiplePickups)',
      ADVANCE: '是否垫付(advance)',
      BLOCKED: '是否等待特批(blocked)',
      EXPRESS: '是否是快递(express)',
      DECLARE_CUSTOMS_STATE: '报关状态(declareCustomsState)',
      WAREHOUSE_NO_FORMAT: '进仓编号格式化(warehouseNoFormat)',
      SHIPPER_ID: '发货人Id(shipperId)',
      CONSIGNEE_ID: '收货人Id(consigneeId)',
      NOTIFY_ID: '通知人Id(notifyId)',
      PREVERIFY_STATE: '预审核状态(preverifyState)',
      TRUST_FROM_JOB: '委托来源关联号(trustFromJob)',
      SIGN_MBL: '是否签发主单(signMBL)',
      SIGN_HBL: '是否签发分单(signHBL)',
      ESTIMATE_ACCOUNTS_RECEIVABLE: '预估收入(EstimateAccountsReceivable)',
      ESTIMATE_ACCOUNTS_PAYABLE: '预估成本(EstimateAccountsPayable)',
      ESTIMATE_GROSS_PROFIT: '预估利润(EstimateGrossProfit)',
      SHIPPER_CODE: '发货人代码(shipperCode)',
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(consigneeLine1)',
      CONSIGNEE_LINE2: '收货人(consigneeLine2)',
      CONSIGNEE_LINE3: '收货人(consigneeLine3)',
      CONSIGNEE_LINE4: '收货人(consigneeLine4)',
      CONSIGNEE_LINE5: '收货人(consigneeLine5)',
      CONSIGNEE_LINE6: '收货人(consigneeLine6)',
      CONSIGNEE_LINE7: '收货人(consigneeLine7)',
      NOTIFY_CODE: '通知人代码(notifyCode)',
      NOTIFY_LINE1: '通知人(notifyLine1)',
      NOTIFY_LINE2: '通知人(notifyLine2)',
      NOTIFY_LINE3: '通知人(notifyLine3)',
      NOTIFY_LINE4: '通知人(notifyLine4)',
      NOTIFY_LINE5: '通知人(notifyLine5)',
      NOTIFY_LINE6: '通知人(notifyLine6)',
      NOTIFY_LINE7: '通知人(notifyLine7)',
      ALSO_NOTIFY: '第二通知人(alsoNotify)',
      BOOKING_REFUSE_NOTE: '拒绝订舱理由(bookingRefuseNote)',
      CUSTOMS_DATE: '报关日期(customsDate)',
      CUSTOMS_REMARKS: '报关备注(customsRemarks)',
      DNGR_HS_CODE: 'HS Code(HSCODE)',
      OPERATION_CONTENT: '操作要求说明(operationContent)',
      SITUATION: '情况说明(situation)',
      ATD: 'ATD',
      CHECK_DATA: '已核对数据(checkData)',
      VIRTUAL_HBL: '是否形式分单(virtualHBL)',
      RECEIVABLE_STATE: '应收状态(receivableState)',
      PAYABLES_STATE: '应付状态(payablesState)',
      PRICE_NO: '运价No(priceNo)',
      BOOKING: '是否订舱(booking)',
      PRICE_TIER: '运价等级(priceTier)',
      SELF_DELIVER: '是否自拉自送(selfDeliver)',
      BOOKING_STATE: '订舱状态(bookingState)',
      ITM_SERVICE: '是否有外贸(ITMService)',
      CUSTOMS_JOB_NO: '报关关联号(customsJobNo)',
      CUSTOM_JOB_TYPE: '客户自定义业务种类(customJobType)',
      PREVERIFIER: '预审审核人(preverifier)',
      PREVERIFY_DATE: '预审审核时间(preverifyDate)',
      SALE_PRICE: '是否特价(salePrice)',
      SALE_PRICE_REMARKS: '特价备注(salePriceRemarks)',
      SALES_CHANNEL: '订舱渠道(salesChannel)',
      DEPOSIT_RECEIVED: '预付款(depositReceived)',
      CONTACT_EMAIL: '联系邮件(contactEmail)',
      PROVISIONED: '已计提(provisioned)',
      PROVISIONED_DATE: '计提时间(provisionedDate)',
      PROVISIONED_BY: '计提人(provisionedBy)',
      PLANNER: '航线(planner)',
      PLANNER_DEPARTMENT: '航线部门(plannerDepartment)',
      RIVER_CARRIER_ID: '江船公司(riverCarrierId)',
      TRADE_TERM: '贸易方式(tradeTerm)',
      OVERSEA_OP_DEPARTMENT: '外海操作部门(overseaOpDepartment)',
      OVERSEA_OP: '海外操作(overseaOp)',
      USER_DEFINED_FIELD_1: '自定义字段1(userDefinedField1)',
      USER_DEFINED_FIELD_2: '自定义字段2(userDefinedField2)',
      USER_DEFINED_FIELD_3: '自定义字段3(userDefinedField3)',
      MANAGE_AUDIT_REMARK: '审核备注(manageAuditRemark)',
      MANAGE_AUDIT_REJECT_REMARK: '审核拒绝备注(manageAuditRejectRemark)',
      MANAGE_AUDIT_STATUS: '主管审核状态(manageAuditStatus)',
      SUBMITTER_USER: '提交人(submitterUser)',
      AUDIT_CHECK_NODE: '提交审核节点(auditCheckNode)',
      TYPE_HBL: '分单类型(typeHBL)',
      TYPE_MBL: '主单类型(typeMBL)',
      IF_PUSH_SOP_M: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      IF_PUSH_SOP_Z: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      IF_PUSH_SOP_Q: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      IF_PUSH_SOP: '是否确认推送SOP信息(ifPushSop)',
      CHANGE_STATE: '改单状态(changeState)',
      CARGO_SALES_ID: '揽货销售(cargoSalesId)',
      CHANGE_BY: '改单人(changeBy)',
      CHANGE_DATE: '改单时间(changeDate)',
      CLOSINGACCOUNT_STATUS: '结转状态(closingAccountStatus)',
      FIRST_PROVISIONED_DATE: '首次计提时间(firstProvisionedDate)',
      FIRST_PROVISIONED_PROFIT: '首次提成利润(firstProvisionedProfit)',
      PROVISIONED_PROFIT: '累计提成利润(provisionedProfit)',
      PROVISIONED_STATUS: '计提状态(provisionedStatus)',
      SALES_REQUIRE: '销售要求(salesRequire)',
      USER_DEFINED_FIELD_4: '自定义字段4(userDefinedField4)',
      VESSEL_PORT_AREA: '港区船名(vesselPortArea)',
      VOYAGE_FLIGHT_PORT_AREA: '港区航次(voyageFlightPortArea)',
      CUSTOMER_TENANT_ID: '委托单位所属tenantId(customerTenantId)',
      CUSTOMER_TENANT_NAME: '委托单位所属tenantName(customerTenantName)',
      CustomsJob: '报关工作单(CustomsJob)'
    },
    SpecialGoods: {
      DNGR_CLASS_NO: '危险货物类别(danClassNo)',
      DNGR_UNNO: '联合国编号(danUNNo)',
      DNGR_PACKING: '货物包装类别(danPacking)',
      DAN_LABLE: '危险品标签(danLable)',
      DNGR_EMS: 'Emergency Schedule(航运危险品应急措施号 danEMS)',
      DNGR_FLASH_POINT: 'Flashpoint(危险货物闪点 danPoint)',
      DAN_MFAG_NO: '医疗救急指南号(danMfagNo)',
      DNGR_EMERGENCY_CONTACT: '24小时紧急联系人(dan24man)',
      DNGR_TELEPHONE: '24小时紧急联系人(dan24tel)',
      RESPONSIBLE_PARTY: '责任方(responsibleParty)',
      DNGR_PICKUP_TIME: '提箱时间(danPickTime)',
      DNGR_POLLUTION: '海洋污染(danSeaPullution)',
      GOH_TIER: '挂衣箱层(gohTier)',
      GOH_HANGER: '挂衣箱每层根数(gohHanger)',
      GOH_ROPES: '每管几跟绳(gohRopes)',
      GOH_KNOTS: '每根绳几各节(gohKnots)',
      GOH_REFORM_COST: '改制费用(gohReformCost)',
      REEF_VENTILATION: '通风量(reefVentilation)',
      REEF_HUMIDITY: '冷藏箱湿度(reefHumidity)',
      REEF_PTI: '预冷提前天数(reefPTI)',
      REEF_MEASURE: '湿度计量单位(reefMeasure)',
      REEF_TEMPERATURE: '设置温度(reefTemperature)',
      REEF_HIGHEST_TEMP: '最高温度(reefHighestTemp)',
      REEF_LOWEST_TEMP: '最低温度(reefLowestTemp)',
      REEF_CONTAINER_YARD: '进箱点(reefContainerYard)',
      REEF_PORT_DISTRICT: '送箱港区(reefDeliverTime)',
      OVER_FRONT: '前超(overFront)',
      OVER_BACK: '后超(overBack)',
      OVER_LEFT: '左超(overLeft)',
      OVER_RIGHT: '右超(overRight)',
      OVER_HEIGHT: '超高(overHeight)',
      DNGR_NO: '特殊货物编号(danNo)',
      CHINESE_COMMODITY: '中文品名(chineseCommodity)',
      ENGLISH_COMMODITY: '英文品名(englishCommodity)',
      SO_NO: 'soNo(soNo)',
      CORRECT_TRANSPORT_NAME: '正确运输名称(correctTransportName)',
      SECONDARY_SPECIAL_GOODS: '副危险品(secondarySpecialGoods)',
      GROSS_WEIGHT: '危险品毛重(grossWeight)',
      NEAT_WEIGHT: '危险品净重(neatWeight)',
      OUTER_PACKAGING_TYPE: '外包装类型(outerPackagingType)',
      OUTER_PACKAGING_QUANTITY: '外包装件数(outerPackagingQuantity)',
      INNER_PACKAGING_TYPE: '内包装类型(innerPackagingType)',
      INNER_PACKAGING_QUANTITY: '内包装件数(innerPackagingQuantity)',
      REMARK: '备注(remark)',
      PACKING_CODE: '包装代码(packingCode)',
      HS_CODE: 'HS Code(hsCode)',
      SpecialGoods: '特殊物品(SpecialGoods)'
    },
    File: {
      FILE_ID: '流水号(fileId)',
      FILE_NO: '文件编号(fileNo)',
      JOB_NO: '业务编号(jobNo)',
      FILE_TYPE: '文件类型(fileType)',
      TAX: '是否退税(tax)',
      TEN_DIGIT_CODE: '海关十位码(tenDigitCode)',
      COMPANY_CNAME: '经营单位(companyCName)',
      CUSTOMS_BROKER: '报关行(customsBroker)',
      STATE: '文件状态(state)',
      EXPRESS_ADDRESS: '快递地址(expressAddress)',
      RECEIVE_COMPANY: '收件单位(receiveCompany)',
      RECEIVE_PERSON: '收件人(receivePerson)',
      RECEIVE_TEL: '收件人电话(receiveTel)',
      RETURN_EXPRESS_NO: '退还快递号(returnExpressNo)',
      SEND_DATE: '送出日期(sendDate)',
      BACK_DATE: '取回日期(backDate)',
      BACK_USER: '取回人(backUser)',
      RETURN_DATE: '退还日期(returnDate)',
      RETURN_PERSON: '退单经手人(returnPerson)',
      REMARK: '备注(remark)',
      SECOND: '是否二次送出(isSecond)',
      SECOND_SEND_DATE: '二次送出日期(secondSendDate)',
      SECOND_SEND_BY: '二次送出人(secondSendBy)',
      INPUT_BY: '创建人(inputBy)',
      INPUT_DATE: '创建日期(inputDate)',
      INPUT_BY_DEP: '创建人部门(inputByDep)',
      BRANCH_ID: '分公司(branchId)',
      RECEIVE_DATE: '收到日期(receiveDate)',
      SEND_EXPRESS_ADDRESS: '送出快递地址(sendExpressAddress)',
      SEND_RECEIVE_COMPANY: '送出收件单位(sendReceiveCompany)',
      SEND_RECEIVE_PERSON: '送出收件人(sendReceivePerson)',
      SEND_RECEIVE_TEL: '送出收件人电话(sendReceiveTel)',
      SEND_EXPRESS_NO: '送出快递号(sendExpressNo)',
      SEND_BY: '送出人(SendBy)',
      CUSTOMS_NO: '海关编号(customsNo)',
      ORIGIN_FILE_ID: '源文件Id(originFileId)',
      CURRENT_HOLDER: '当前持有人(currentHolder)',
      PRERECORDING_NO: '预录入单号(prerecordingNo)',
      DECLARE_DATE: '申报日期(declareDate)',
      CUSTOMS_PAGE_NUMBER: '报关单页数(customsPageNumber)',
      CUSTOMS_TRANSFER: '是否转关(customsTransfer)',
      TRADE_MODE: '贸易方式(tradeMode)',
      FILED_USER: '归档人(filedUser)',
      FILED_DATE: '归档日期(filedDate)',
      REBATED_USER: '退税人(rebatedUser)',
      REBATED_DATE: '退税日期(rebatedDate)',
      RETURNED_USER: '退回人(returnedUser)',
      RETURNED_DATE: '退回日期(returnedDate)',
      ACCEPTED_USER: '接单人(acceptedUser)',
      ACCEPTED_DATE: '接单日期(acceptedDate)',
      File: '文件(File)'
    },
    CargoDoc: {
      STATE: '状态(state)',
      DOC_TYPE: '提单种类(docType)',
      HBL_NBR2: '二级编号(hblNbr2)',
      SHIPPER_ID: '发货人编号(shipperId)',
      SHIPPER_CODE: '发货人代码(shipperCode)',
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      CONSIGNEE_ID: '收货人编号(consigneeId)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(consigneeLine1)',
      CONSIGNEE_LINE2: '收货人(consigneeLine2)',
      CONSIGNEE_LINE3: '收货人(consigneeLine3)',
      CONSIGNEE_LINE4: '收货人(consigneeLine4)',
      CONSIGNEE_LINE5: '收货人(consigneeLine5)',
      CONSIGNEE_LINE6: '收货人(consigneeLine6)',
      CONSIGNEE_LINE7: '收货人(consigneeLine7)',
      NOTIFY_ID: '通知人编号(notifyId)',
      NOTIFY_CODE: '通知人代码(notifyCode)',
      NOTIFY_LINE1: '通知人(notifyLine1)',
      NOTIFY_LINE2: '通知人(notifyLine2)',
      NOTIFY_LINE3: '通知人(notifyLine3)',
      NOTIFY_LINE4: '通知人(notifyLine4)',
      NOTIFY_LINE5: '通知人(notifyLine5)',
      NOTIFY_LINE6: '通知人(notifyLine6)',
      NOTIFY_LINE7: '通知人(notifyLine7)',
      AGENT_CODE: '代理代码(agentCode)',
      AGENT_PARTY_LINE1: '代理地址(agentPartyLine1)',
      AGENT_PARTY_LINE2: '代理地址(agentPartyLine2)',
      AGENT_PARTY_LINE3: '代理地址(agentPartyLine3)',
      AGENT_PARTY_LINE4: '代理地址(agentPartyLine4)',
      AGENT_PARTY_LINE5: '代理地址(agentPartyLine5)',
      AGENT_PARTY_LINE6: '代理地址(agentPartyLine6)',
      AGENT_PARTY_LINE7: '代理地址(agentPartyLine7)',
      QUANTITY: '提单件数(quantity)',
      WEIGHT: '提单重量(weight)',
      CUBAGE: '提单体积(cubage)',
      CHARGE_WEIGHT: '计费重量(chargeWeight)',
      PACKING: '包装(packing)',
      CARGO_ENGLISH_NAME: '英文品名(cargoEnglishName)',
      MARK: '唛头(mark)',
      BLNUMBER: '提单份数(BLNumber)',
      SIGN_DATE_BL: '签单日期(signDateBL)',
      SIGN_PLACE_BL: '签单地点(signPlaceBL)',
      SIGN_DATE_BY: '签单人(signDateBy)',
      RELEASE_TYPE: '放单方式(releaseType)',
      ISSUER_BL: '分单种类(issuerBL)',
      OVERSEA: '是否异地放单(oversea)',
      INSIDE_QUANTITY: '小件数(insideQuantity)',
      INSIDE_PACKING: '小件数包装类型(insidePacking)',
      PAYMENT_TERM: '运费方式(paymentTerm)',
      CFM_STATE: '对单状态(CfmState)',
      FREIGHT_CHARGES_TOTAL: '提单运费USD合计(freightChargeTotal)',
      FREIGHT_CHARGES_EN_UPPER: 'USD费用合计英文大写(freightChargeEnUpper)',
      CargoDoc: '提单(CargoDoc)'
    },
    SeaCargoDoc: {
      SUB_DOC_TYPE2: '二级主单编号(mblNbr2)',
      QUANTITYSUM: '提单货量英文合计(quantitySum)',
      CONTAINERSUM: '提单箱量英文合计(containerSum)',
      LOADINGPORT: '装货港(loadingPort)',
      DISCHARGINGPORT: '中转港(dischargingPort)',
      DESTINATIONPORT: '目的港(destinationPort)',
      DISPATCHINGPLACE: '发货地(dispatchingPlace)',
      DESTINATIONPLACE: '最终目的地(destinationPlace)',
      PAYMENT_PLACE_BL: '付款地点(paymentPlaceBL)',
      EDI: '是否导提单EDI(EDI)',
      MANIFEST_EDI: '是否导舱单EDI(manifestEDI)',
      REMARKS: '备注(remarks)',
      PRINT_PARAM1: '打印参数1(printParam1)',
      PRINT_PARAM2: '打印参数2(printParam2)',
      PRINT_PARAM3: '打印参数3(printParam3)',
      PRINT_PARAM4: '打印参数4(printParam4)',
      PRINT_PARAM5: '打印参数5(printParam5)',
      PRINT_PARAM6: '打印参数6(printParam6)',
      SERIAL_NO: '提单流水号(serialNo)',
      SEAEQ: '分票箱型箱量(seaeq)',
      CONTAINER: '分票箱封(container)',
      ALSO_NOTIFY: '第二通知人(alsoNotify)',
      COSTCO_NO: '电子装箱单编号(costcoNo)',
      CARGO_MANIFEST_NAME: '舱单品名(cargoManifestName)',
      MBL_ID: '分单对应主单Id(MblId)',
      SHIPPER_TEL: '发货人联系电话(ShipperTel)',
      CONSIGNEE_TEL: '收货人联系电话(ConsigneeTel)',
      NOTIFY_TEL: '通知人联系电话(NotifyTel)',
      RELEASE_REVIEW: '放单审核(releaseReview)',
      REVIEW_DATE: '放单审核时间(reviewDate)',
      RELEASE_STATE: '放单状态(releaseState)',
      RELEASE_DATE: '放单时间(releaseDate)',
      PAYABLE: '是否可付款(payable)',
      AGREE_PAY_DATE: '同意付款时间(agreePayDate)',
      WITHHOLD: '是否扣货(withhold)',
      WITHHOLD_DATE: '扣货时间(withholdDate)',
      WITHHOLD_REASON: '扣货原因(withholdReason)',
      SECOND_RELEASE_DATE: '目的港放货时间(secondReleaseDate)  二次放货时间',
      SURRENDERED_APPLICANT: '电放申请人(surrenderedApplicant)',
      SURRENDERED_APPLICATION_DATE: '电放申请时间(surrenderedApplicationDate)',
      SURRENDERED_NO: '电放号(surrenderedNo)',
      CUSTOMER_CFM_EXCEPTION: '客户对单异常信息(customerCfmException)',
      ORIGINAL_BL_WAY: '正本提单寄送方式(originalBLWay)',
      WAREHOUSE_NO: '进仓编号(warehouseNo)',
      FREIGHT_TERM_HBL: '运输条款(freightTermHBL)',
      SHIPPER_CONTACT: '发货人联系人(shipperContact)',
      SHIPPER_MOBILE: '发货人联系电话(shipperMobile)',
      SHIPPER_FAX: '发货人传真(shipperFax)',
      SHIPPER_EMAIL: '发货人邮箱(shipperEmail)',
      SHIPPER_ZIP_CODE: '发货人邮编(shipperZipCode)',
      SHIPPER_CITY: '发货人城市(shipperCity)',
      CONSIGNEE_CONTACT: '收货人联系人(consigneeContact)',
      CONSIGNEE_MOBILE: '收货人联系电话(consigneeMobile)',
      CONSIGNEE_FAX: '收货人传真(consigneeFax)',
      CONSIGNEE_EMAIL: '收货人邮箱(consigneeEmail)',
      CONSIGNEE_ZIP_CODE: '收货人邮编(consigneeZipCode)',
      CONSIGNEE_CITY: '收货人城市(consigneeCity)',
      NOTIFY_CONTACT: '通知人联系人(notifyContact)',
      NOTIFY_MOBILE: '通知人联系电话(notifyMobile)',
      NOTIFY_FAX: '通知人传真(notifyFax)',
      NOTIFY_EMAIL: '通知人邮箱(notifyEmail)',
      NOTIFY_ZIP_CODE: '通知人邮编(notifyZipCode)',
      NOTIFY_CITY: '通知人城市(notifyCity)',
      ALSO_NOTIFY_CODE: '第二通知人代码(alsoNotifyCode)',
      ALSO_NOTIFY_LINE1: '第二通知人(alsoNotifyLine1)',
      ALSO_NOTIFY_LINE2: '第二通知人(alsoNotifyLine2)',
      ALSO_NOTIFY_LINE3: '第二通知人(alsoNotifyLine3)',
      ALSO_NOTIFY_LINE4: '第二通知人(alsoNotifyLine4)',
      ALSO_NOTIFY_LINE5: '第二通知人(alsoNotifyLine5)',
      ALSO_NOTIFY_LINE6: '第二通知人(alsoNotifyLine6)',
      ALSO_NOTIFY_LINE7: '第二通知人(alsoNotifyLine7)',
      ALSO_NOTIFY_CONTACT: '第二通知人联系人(alsoNotifyContact)',
      ALSO_NOTIFY_MOBILE: '第二通知人联系电话(alsoNotifyMobile)',
      ALSO_NOTIFY_FAX: '第二通知人传真(alsoNotifyFax)',
      ALSO_NOTIFY_EMAIL: '第二通知人邮箱(alsoNotifyEmail)',
      ALSO_NOTIFY_ZIP_CODE: '第二通知人邮编(alsoNotifyZipCode)',
      ALSO_NOTIFY_CITY: '第二通知人城市(alsoNotifyCity)',
      DGCONSIGN_CODE: 'dgconsignCode(dgconsignCode)',
      DGCONSIGN_LINE1: 'dgconsign(dgconsignLine1)',
      DGCONSIGN_LINE2: 'dgconsign(dgconsignLine2)',
      DGCONSIGN_LINE3: 'dgconsign(dgconsignLine3)',
      DGCONSIGN_LINE4: 'dgconsign(dgconsignLine4)',
      DGCONSIGN_LINE5: 'dgconsign(dgconsignLine5)',
      DGCONSIGN_LINE6: 'dgconsign(dgconsignLine6)',
      DGCONSIGN_LINE7: 'dgconsign(dgconsignLine7)',
      DGCONSIGN_CONTACT: 'dgconsign联系人(dgconsignContact)',
      DGCONSIGN_MOBILE: 'dgconsign联系电话(dgconsignMobile)',
      DGCONSIGN_FAX: 'dgconsign传真(dgconsignFax)',
      DGCONSIGN_EMAIL: 'dgconsign邮箱(dgconsignEmail)',
      DGCONSIGN_ZIP_CODE: 'dgconsign邮编(dgconsignZipCode)',
      DGCONSIGN_CITY: 'dgconsign城市(dgconsignCity)',
      ELSE_INVOICE_CODE: 'elseInvoiceCode(elseInvoiceCode)',
      ELSE_INVOICE_LINE1: 'elseInvoice(elseInvoiceLine1)',
      ELSE_INVOICE_LINE2: 'elseInvoice(elseInvoiceLine2)',
      ELSE_INVOICE_LINE3: 'elseInvoice(elseInvoiceLine3)',
      ELSE_INVOICE_LINE4: 'elseInvoice(elseInvoiceLine4)',
      ELSE_INVOICE_LINE5: 'elseInvoice(elseInvoiceLine5)',
      ELSE_INVOICE_LINE6: 'elseInvoice(elseInvoiceLine6)',
      ELSE_INVOICE_LINE7: 'elseInvoice(elseInvoiceLine7)',
      ELSE_INVOICE_CONTACT: 'elseInvoice联系人(elseInvoiceContact)',
      ELSE_INVOICE_MOBILE: 'elseInvoice联系电话(elseInvoiceMobile)',
      ELSE_INVOICE_FAX: 'elseInvoice传真(elseInvoiceFax)',
      ELSE_INVOICE_EMAIL: 'elseInvoice邮箱(elseInvoiceEmail)',
      ELSE_INVOICE_ZIP_CODE: 'elseInvoice邮编(elseInvoiceZipCode)',
      ELSE_INVOICE_CITY: 'elseInvoice城市(elseInvoiceCity)',
      SHOW_POD_AGENCY: 'showPODAgency(showPODAgency)',
      RECEIVED_DATE: '接收时间(receivedDate)',
      GETBACK_DATE: '取回时间(getBackDate)',
      CLAIM_DATE: '认领时间(claimDate)',
      CUSTOMER_SELF_RELEASE: '自出单类型(customerSelfRelease)',
      STATE: '状态(state)',
      DOC_TYPE: '提单种类(docType)',
      HBL_NBR2: '二级编号(hblNbr2)',
      SHIPPER_ID: '发货人编号(shipperId)',
      SHIPPER_CODE: '发货人代码(shipperCode)',
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      CONSIGNEE_ID: '收货人编号(consigneeId)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(consigneeLine1)',
      CONSIGNEE_LINE2: '收货人(consigneeLine2)',
      CONSIGNEE_LINE3: '收货人(consigneeLine3)',
      CONSIGNEE_LINE4: '收货人(consigneeLine4)',
      CONSIGNEE_LINE5: '收货人(consigneeLine5)',
      CONSIGNEE_LINE6: '收货人(consigneeLine6)',
      CONSIGNEE_LINE7: '收货人(consigneeLine7)',
      NOTIFY_ID: '通知人编号(notifyId)',
      NOTIFY_CODE: '通知人代码(notifyCode)',
      NOTIFY_LINE1: '通知人(notifyLine1)',
      NOTIFY_LINE2: '通知人(notifyLine2)',
      NOTIFY_LINE3: '通知人(notifyLine3)',
      NOTIFY_LINE4: '通知人(notifyLine4)',
      NOTIFY_LINE5: '通知人(notifyLine5)',
      NOTIFY_LINE6: '通知人(notifyLine6)',
      NOTIFY_LINE7: '通知人(notifyLine7)',
      AGENT_CODE: '代理代码(agentCode)',
      AGENT_PARTY_LINE1: '代理地址(agentPartyLine1)',
      AGENT_PARTY_LINE2: '代理地址(agentPartyLine2)',
      AGENT_PARTY_LINE3: '代理地址(agentPartyLine3)',
      AGENT_PARTY_LINE4: '代理地址(agentPartyLine4)',
      AGENT_PARTY_LINE5: '代理地址(agentPartyLine5)',
      AGENT_PARTY_LINE6: '代理地址(agentPartyLine6)',
      AGENT_PARTY_LINE7: '代理地址(agentPartyLine7)',
      QUANTITY: '提单件数(quantity)',
      WEIGHT: '提单重量(weight)',
      CUBAGE: '提单体积(cubage)',
      CHARGE_WEIGHT: '计费重量(chargeWeight)',
      PACKING: '包装(packing)',
      CARGO_ENGLISH_NAME: '英文品名(cargoEnglishName)',
      MARK: '唛头(mark)',
      BLNUMBER: '提单份数(BLNumber)',
      SIGN_DATE_BL: '签单日期(signDateBL)',
      SIGN_PLACE_BL: '签单地点(signPlaceBL)',
      SIGN_DATE_BY: '签单人(signDateBy)',
      RELEASE_TYPE: '放单方式(releaseType)',
      ISSUER_BL: '分单种类(issuerBL)',
      OVERSEA: '是否异地放单(oversea)',
      INSIDE_QUANTITY: '小件数(insideQuantity)',
      INSIDE_PACKING: '小件数包装类型(insidePacking)',
      PAYMENT_TERM: '运费方式(paymentTerm)',
      CFM_STATE: '对单状态(CfmState)',
      FREIGHT_CHARGES_TOTAL: '提单运费USD合计(freightChargeTotal)',
      FREIGHT_CHARGES_EN_UPPER: 'USD费用合计英文大写(freightChargeEnUpper)',
      SeaCargoDoc: '海运提单(SeaCargoDoc)'
    },
    SeaImCargoDoc: {
      MBL_NBR2: '二级主单编号(mblNbr2)',
      QUANTITY_SUM: '提单货量英文合计(quantitySum)',
      CONTAINER_SUM: '提单箱量英文合计(containerSum)',
      LOADING_PORT: '装货港(loadingPort)',
      DISCHARGING_PORT: '中转港(dischargingPort)',
      DESTINATION_PORT: '目的港(destinationPort)',
      DISPATCHING_PLACE: '发货地(dispatchingPlace)',
      DESTINATION_PLACE: '最终目的地(destinationPlace)',
      PAYMENT_PLACE_BL: '付款地点(paymentPlaceBL)',
      EDI: '是否导提单EDI(EDI)',
      MANIFEST_EDI: '是否导舱单EDI(manifestEDI)',
      REMARKS: '备注(remarks)',
      PRINT_PARAM1: '打印参数1(printParam1)',
      PRINT_PARAM2: '打印参数2(printParam2)',
      PRINT_PARAM3: '打印参数3(printParam3)',
      PRINT_PARAM4: '打印参数4(printParam4)',
      PRINT_PARAM5: '打印参数5(printParam5)',
      PRINT_PARAM6: '打印参数6(printParam6)',
      SERIAL_NO: '提单流水号(serialNo)',
      SEAEQ: '分票箱型箱量(seaeq)',
      CONTAINER: '分票箱封(container)',
      ALSO_NOTIFY: '第二通知人(alsoNotify)',
      COSTCO_NO: '电子装箱单编号(costcoNo)',
      CARGO_MANIFEST_NAME: '舱单品名(cargoManifestName)',
      MBL_ID: '分单对应主单Id(mblId)',
      SHIPPER_TEL: '发货人联系电话(shipperTel)',
      CONSIGNEE_TEL: '收货人联系电话(consigneeTel)',
      NOTIFY_TEL: '通知人联系电话(notifyTel)',
      RELEASE_REVIEW: '放单审核(releaseReview)',
      REVIEW_DATE: '放单审核时间(reviewDate)',
      RELEASE_STATE: '放单状态(releaseState)',
      RELEASE_DATE: '放单时间(releaseDate)',
      PAYABLE: '是否可付款(payable)',
      AGREE_PAY_DATE: '同意付款时间(agreePayDate)',
      WITHHOLD: '是否扣货(withhold)',
      WITHHOLD_DATE: '扣货时间(withholdDate)',
      WITHHOLD_REASON: '扣货原因(withholdReason)',
      SECOND_RELEASE_DATE: '目的港放货时间(secondReleaseDate)  二次放货时间',
      SURRENDERED_APPLICANT: '电放申请人(surrenderedApplicant)',
      SURRENDERED_APPLICATION_DATE: '电放申请时间(surrenderedApplicationDate)',
      SURRENDERED_NO: '电放号(surrenderedNo)',
      CUSTOMER_CFM_EXCEPTION: '客户对单异常信息(customerCfmException)',
      ORIGINAL_BL_WAY: '正本提单寄送方式(originalBLWay)',
      WAREHOUSE_NO: '进仓编号(warehouseNo)',
      FREIGHT_TERM_HBL: '运输条款(freightTermHBL)',
      SHIPPER_CONTACT: '发货人联系人(shipperContact)',
      SHIPPER_MOBILE: '发货人联系电话(shipperMobile)',
      SHIPPER_FAX: '发货人传真(shipperFax)',
      SHIPPER_EMAIL: '发货人邮箱(shipperEmail)',
      SHIPPER_ZIP_CODE: '发货人邮编(shipperZipCode)',
      SHIPPER_CITY: '发货人城市(shipperCity)',
      CONSIGNEE_CONTACT: '收货人联系人(consigneeContact)',
      CONSIGNEE_MOBILE: '收货人联系电话(consigneeMobile)',
      CONSIGNEE_FAX: '收货人传真(consigneeFax)',
      CONSIGNEE_EMAIL: '收货人邮箱(consigneeEmail)',
      CONSIGNEE_ZIP_CODE: '收货人邮编(consigneeZipCode)',
      CONSIGNEE_CITY: '收货人城市(consigneeCity)',
      NOTIFY_CONTACT: '通知人联系人(notifyContact)',
      NOTIFY_MOBILE: '通知人联系电话(notifyMobile)',
      NOTIFY_FAX: '通知人传真(notifyFax)',
      NOTIFY_EMAIL: '通知人邮箱(notifyEmail)',
      NOTIFY_ZIP_CODE: '通知人邮编(notifyZipCode)',
      NOTIFY_CITY: '通知人城市(notifyCity)',
      ALSO_NOTIFY_CODE: '第二通知人代码(alsoNotifyCode)',
      ALSO_NOTIFY_LINE1: '第二通知人(alsoNotifyLine1)',
      ALSO_NOTIFY_LINE2: '第二通知人(alsoNotifyLine2)',
      ALSO_NOTIFY_LINE3: '第二通知人(alsoNotifyLine3)',
      ALSO_NOTIFY_LINE4: '第二通知人(alsoNotifyLine4)',
      ALSO_NOTIFY_LINE5: '第二通知人(alsoNotifyLine5)',
      ALSO_NOTIFY_LINE6: '第二通知人(alsoNotifyLine6)',
      ALSO_NOTIFY_LINE7: '第二通知人(alsoNotifyLine7)',
      ALSO_NOTIFY_CONTACT: '第二通知人联系人(alsoNotifyContact)',
      ALSO_NOTIFY_MOBILE: '第二通知人联系电话(alsoNotifyMobile)',
      ALSO_NOTIFY_FAX: '第二通知人传真(alsoNotifyFax)',
      ALSO_NOTIFY_EMAIL: '第二通知人邮箱(alsoNotifyEmail)',
      ALSO_NOTIFY_ZIP_CODE: '第二通知人邮编(alsoNotifyZipCode)',
      ALSO_NOTIFY_CITY: '第二通知人城市(alsoNotifyCity)',
      DGCONSIGN_CODE: 'dgconsignCode(dgconsignCode)',
      DGCONSIGN_LINE1: 'dgconsign(dgconsignLine1)',
      DGCONSIGN_LINE2: 'dgconsign(dgconsignLine2)',
      DGCONSIGN_LINE3: 'dgconsign(dgconsignLine3)',
      DGCONSIGN_LINE4: 'dgconsign(dgconsignLine4)',
      DGCONSIGN_LINE5: 'dgconsign(dgconsignLine5)',
      DGCONSIGN_LINE6: 'dgconsign(dgconsignLine6)',
      DGCONSIGN_LINE7: 'dgconsign(dgconsignLine7)',
      DGCONSIGN_CONTACT: 'dgconsign联系人(dgconsignContact)',
      DGCONSIGN_MOBILE: 'dgconsign联系电话(dgconsignMobile)',
      DGCONSIGN_FAX: 'dgconsign传真(dgconsignFax)',
      DGCONSIGN_EMAIL: 'dgconsign邮箱(dgconsignEmail)',
      DGCONSIGN_ZIP_CODE: 'dgconsign邮编(dgconsignZipCode)',
      DGCONSIGN_CITY: 'dgconsign城市(dgconsignCity)',
      ELSE_INVOICE_CODE: 'elseInvoiceCode(elseInvoiceCode)',
      ELSE_INVOICE_LINE1: 'elseInvoice(elseInvoiceLine1)',
      ELSE_INVOICE_LINE2: 'elseInvoice(elseInvoiceLine2)',
      ELSE_INVOICE_LINE3: 'elseInvoice(elseInvoiceLine3)',
      ELSE_INVOICE_LINE4: 'elseInvoice(elseInvoiceLine4)',
      ELSE_INVOICE_LINE5: 'elseInvoice(elseInvoiceLine5)',
      ELSE_INVOICE_LINE6: 'elseInvoice(elseInvoiceLine6)',
      ELSE_INVOICE_LINE7: 'elseInvoice(elseInvoiceLine7)',
      ELSE_INVOICE_CONTACT: 'elseInvoice联系人(elseInvoiceContact)',
      ELSE_INVOICE_MOBILE: 'elseInvoice联系电话(elseInvoiceMobile)',
      ELSE_INVOICE_FAX: 'elseInvoice传真(elseInvoiceFax)',
      ELSE_INVOICE_EMAIL: 'elseInvoice邮箱(elseInvoiceEmail)',
      ELSE_INVOICE_ZIP_CODE: 'elseInvoice邮编(elseInvoiceZipCode)',
      ELSE_INVOICE_CITY: 'elseInvoice城市(elseInvoiceCity)',
      SHOW_PODAGENCY: 'showPODAgency(showPODAgency)',
      RECEIVED_DATE: '接收时间(receivedDate)',
      GET_BACK_DATE: '取回时间(getBackDate)',
      CLAIM_DATE: '认领时间(claimDate)',
      CUSTOMER_SELF_RELEASE: '自出单类型(customerSelfRelease)',
      STATE: '状态(state)',
      DOC_TYPE: '提单种类(docType)',
      HBL_NBR2: '二级编号(hblNbr2)',
      SHIPPER_ID: '发货人编号(shipperId)',
      SHIPPER_CODE: '发货人代码(shipperCode)',
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      CONSIGNEE_ID: '收货人编号(consigneeId)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(consigneeLine1)',
      CONSIGNEE_LINE2: '收货人(consigneeLine2)',
      CONSIGNEE_LINE3: '收货人(consigneeLine3)',
      CONSIGNEE_LINE4: '收货人(consigneeLine4)',
      CONSIGNEE_LINE5: '收货人(consigneeLine5)',
      CONSIGNEE_LINE6: '收货人(consigneeLine6)',
      CONSIGNEE_LINE7: '收货人(consigneeLine7)',
      NOTIFY_ID: '通知人编号(notifyId)',
      NOTIFY_CODE: '通知人代码(notifyCode)',
      NOTIFY_LINE1: '通知人(notifyLine1)',
      NOTIFY_LINE2: '通知人(notifyLine2)',
      NOTIFY_LINE3: '通知人(notifyLine3)',
      NOTIFY_LINE4: '通知人(notifyLine4)',
      NOTIFY_LINE5: '通知人(notifyLine5)',
      NOTIFY_LINE6: '通知人(notifyLine6)',
      NOTIFY_LINE7: '通知人(notifyLine7)',
      AGENT_CODE: '代理代码(agentCode)',
      AGENT_PARTY_LINE1: '代理地址(agentPartyLine1)',
      AGENT_PARTY_LINE2: '代理地址(agentPartyLine2)',
      AGENT_PARTY_LINE3: '代理地址(agentPartyLine3)',
      AGENT_PARTY_LINE4: '代理地址(agentPartyLine4)',
      AGENT_PARTY_LINE5: '代理地址(agentPartyLine5)',
      AGENT_PARTY_LINE6: '代理地址(agentPartyLine6)',
      AGENT_PARTY_LINE7: '代理地址(agentPartyLine7)',
      QUANTITY: '提单件数(quantity)',
      WEIGHT: '提单重量(weight)',
      CUBAGE: '提单体积(cubage)',
      CHARGE_WEIGHT: '计费重量(chargeWeight)',
      PACKING: '包装(packing)',
      CARGO_ENGLISH_NAME: '英文品名(cargoEnglishName)',
      MARK: '唛头(mark)',
      BLNUMBER: '提单份数(BLNumber)',
      SIGN_DATE_BL: '签单日期(signDateBL)',
      SIGN_PLACE_BL: '签单地点(signPlaceBL)',
      SIGN_DATE_BY: '签单人(signDateBy)',
      RELEASE_TYPE: '放单方式(releaseType)',
      ISSUER_BL: '分单种类(issuerBL)',
      OVERSEA: '是否异地放单(oversea)',
      INSIDE_QUANTITY: '小件数(insideQuantity)',
      INSIDE_PACKING: '小件数包装类型(insidePacking)',
      PAYMENT_TERM: '运费方式(paymentTerm)',
      CFM_STATE: '对单状态(CfmState)',
      FREIGHT_CHARGES_TOTAL: '提单运费USD合计(freightChargeTotal)',
      FREIGHT_CHARGES_EN_UPPER: 'USD费用合计英文大写(freightChargeEnUpper)',
      SeaImCargoDoc: '海运进口提单(SeaImCargoDoc)'
    },
    AfrAddress: {
      STATE: '状态(state)',
      DOC_TYPE: '提单种类(docType)',
      CONSOLIDATION_CLOSED: '拼箱最后提单(ConsolidationClosed)',
      SHIPPER_CODE: '发货人代码(ShipperCode)',
      SHIPPER_LINE1: '发货人(ShipperLine1)',
      SHIPPER_LINE2: '发货人(ShipperLine2)',
      SHIPPER_LINE3: '发货人(ShipperLine3)',
      SHIPPER_LINE4: '发货人(ShipperLine4)',
      SHIPPER_LINE5: '发货人(ShipperLine5)',
      SHIPPER_LINE6: '发货人(ShipperLine6)',
      SHIPPER_TEL: '发货人联系电话(ShipperTel)',
      SHIPPER_FAX: '发货人联系传真(ShipperFax)',
      SHIPPER_CITY: '发货人城市(ShipperCity)',
      SHIPPER_PROVINCE: '发货人省份(ShipperProvince)',
      SHIPPER_COUNTRY: '发货人国家代码(ShipperCountry)',
      SHIPPER_POSTALCODE: '发货人邮编(ShipperPostalcode)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(ConsigneeLine1)',
      CONSIGNEE_LINE2: '收货人(ConsigneeLine2)',
      CONSIGNEE_LINE3: '收货人(ConsigneeLine3)',
      CONSIGNEE_LINE4: '收货人(ConsigneeLine4)',
      CONSIGNEE_LINE5: '收货人(ConsigneeLine5)',
      CONSIGNEE_LINE6: '收货人(ConsigneeLine6)',
      CONSIGNEE_TEL: '收货人联系电话(ConsigneeTel)',
      CONSIGNEE_FAX: '收货人联系传真(ConsigneeFax)',
      CONSIGNEE_CITY: '收货人城市(ConsigneeCity)',
      CONSIGNEE_PROVINCE: '收货人省份(ConsigneeProvince)',
      CONSIGNEE_COUNTRY: '收货人国家代码(ConsigneeCountry)',
      CONSIGNEE_POSTALCODE: '收货人邮编(ConsigneePostalcode)',
      NOTIFY_CODE: '通知人代码(NotifyCode)',
      NOTIFY_LINE1: '通知人(NotifyLine1)',
      NOTIFY_LINE2: '通知人(NotifyLine2)',
      NOTIFY_LINE3: '通知人(NotifyLine3)',
      NOTIFY_LINE4: '通知人(NotifyLine4)',
      NOTIFY_LINE5: '通知人(NotifyLine5)',
      NOTIFY_LINE6: '通知人(NotifyLine6)',
      NOTIFY_TEL: '通知人联系电话(NotifyTel)',
      NOTIFY_FAX: '通知人联系传真(NotifyFax)',
      NOTIFY_CITY: '通知人城市(NotifyCity)',
      NOTIFY_PROVINCE: '通知人省份(NotifyProvince)',
      NOTIFY_COUNTRY: '通知人国家代码(NotifyCountry)',
      NOTIFY_POSTALCODE: '通知人邮编(NotifyPostalcode)',
      ALSONOTIFY_CODE: '第二通知人代码(AlsonotifyCode)',
      ALSONOTIFY_LINE1: '第二通知人(AlsonotifyLine1)',
      ALSONOTIFY_LINE2: '第二通知人(AlsonotifyLine2)',
      ALSONOTIFY_LINE3: '第二通知人(AlsonotifyLine3)',
      ALSONOTIFY_LINE4: '第二通知人(AlsonotifyLine4)',
      ALSONOTIFY_LINE5: '第二通知人(AlsonotifyLine5)',
      ALSONOTIFY_LINE6: '第二通知人(AlsonotifyLine6)',
      ALSONOTIFY_TEL: '第二通知人联系电话(AlsonotifyTel)',
      ALSONOTIFY_FAX: '第二通知人联系传真(AlsonotifyFax)',
      ALSONOTIFY_CITY: '第二通知人城市(AlsonotifyCity)',
      ALSONOTIFY_PROVINCE: '第二通知人省份(AlsonotifyProvince)',
      ALSONOTIFY_COUNTRY: '第二通知人国家代码(AlsonotifyCountry)',
      ALSONOTIFY_POSTALCODE: '第二通知人邮编(AlsonotifyPostalcode)',
      AfrAddress: 'JP24反恐舱单地址(AfrAddress)'
    },
    AirCargoDoc: {
      C_WEIGHT: '提单计费重量(cWeight)',
      IATA_CODE: 'IATACode',
      ACCOUNT_CODE: 'accountCode',
      HANDING_INFO: 'handingInfo',
      ACCOUNTING_INFO: 'accountingInfo',
      TSREMARKS: 'TSRemarks',
      AIRPORT_OF_DEPARTURE: 'airportOfDeparture',
      AIRPORT_OF_DESTINATION: 'airportOfDestination',
      POD_TO: 'PODTo',
      CARRIER_BY: 'carrierBy',
      POD_TO1: 'PODTo1',
      CARRIER_BY1: 'carrierBy1',
      POD_TO2: 'PODTo2',
      CARRIER_BY2: 'carrierBy2',
      CURRENCY: 'currency',
      WT_VAL: 'WtVal',
      OTHER: 'other',
      CARRIAGE_DV: 'carriageDV',
      DVFOR_CUSTOMS: 'customsDV',
      INSURED_AMOUNT: 'insuredAmount',
      PP1: 'PP1',
      PP2: 'PP2',
      PP3: 'PP3',
      PP4: 'PP4',
      PP5: 'PP5',
      PP6: 'PP6',
      CC1: 'CC1',
      CC2: 'CC2',
      CC3: 'CC3',
      CC4: 'CC4',
      CC5: 'CC5',
      CC6: 'CC6',
      RATE_CLASS: 'rateClass',
      RATE: 'rate',
      RATE_CHARGE: 'rateCharge',
      DIMENSION: 'dimension',
      REMARK1: 'remark1',
      REMARK2: 'remark2',
      SIGN_BY_SHIPPER: '货主签单人(signByShipper)',
      SIGN_BY_CARRIER: '承运人签单人(signByCarrier)',
      ISSUED_BY: 'issuedBy',
      KGLB: 'kglb',
      C_TOTAL: '(提单总金额)cTotal',
      STATE: '状态(state)',
      DOC_TYPE: '提单种类(docType)',
      HBL_NBR2: '二级编号(hblNbr2)',
      SHIPPER_ID: '发货人编号(shipperId)',
      SHIPPER_CODE: '发货人代码(shipperCode)',
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      CONSIGNEE_ID: '收货人编号(consigneeId)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(consigneeLine1)',
      CONSIGNEE_LINE2: '收货人(consigneeLine2)',
      CONSIGNEE_LINE3: '收货人(consigneeLine3)',
      CONSIGNEE_LINE4: '收货人(consigneeLine4)',
      CONSIGNEE_LINE5: '收货人(consigneeLine5)',
      CONSIGNEE_LINE6: '收货人(consigneeLine6)',
      CONSIGNEE_LINE7: '收货人(consigneeLine7)',
      NOTIFY_ID: '通知人编号(notifyId)',
      NOTIFY_CODE: '通知人代码(notifyCode)',
      NOTIFY_LINE1: '通知人(notifyLine1)',
      NOTIFY_LINE2: '通知人(notifyLine2)',
      NOTIFY_LINE3: '通知人(notifyLine3)',
      NOTIFY_LINE4: '通知人(notifyLine4)',
      NOTIFY_LINE5: '通知人(notifyLine5)',
      NOTIFY_LINE6: '通知人(notifyLine6)',
      NOTIFY_LINE7: '通知人(notifyLine7)',
      AGENT_CODE: '代理代码(agentCode)',
      AGENT_PARTY_LINE1: '代理地址(agentPartyLine1)',
      AGENT_PARTY_LINE2: '代理地址(agentPartyLine2)',
      AGENT_PARTY_LINE3: '代理地址(agentPartyLine3)',
      AGENT_PARTY_LINE4: '代理地址(agentPartyLine4)',
      AGENT_PARTY_LINE5: '代理地址(agentPartyLine5)',
      AGENT_PARTY_LINE6: '代理地址(agentPartyLine6)',
      AGENT_PARTY_LINE7: '代理地址(agentPartyLine7)',
      QUANTITY: '提单件数(quantity)',
      WEIGHT: '提单重量(weight)',
      CUBAGE: '提单体积(cubage)',
      CHARGE_WEIGHT: '计费重量(chargeWeight)',
      PACKING: '包装(packing)',
      CARGO_ENGLISH_NAME: '英文品名(cargoEnglishName)',
      MARK: '唛头(mark)',
      BLNUMBER: '提单份数(BLNumber)',
      SIGN_DATE_BL: '签单日期(signDateBL)',
      SIGN_PLACE_BL: '签单地点(signPlaceBL)',
      SIGN_DATE_BY: '签单人(signDateBy)',
      RELEASE_TYPE: '放单方式(releaseType)',
      ISSUER_BL: '分单种类(issuerBL)',
      OVERSEA: '是否异地放单(oversea)',
      INSIDE_QUANTITY: '小件数(insideQuantity)',
      INSIDE_PACKING: '小件数包装类型(insidePacking)',
      PAYMENT_TERM: '运费方式(paymentTerm)',
      CFM_STATE: '对单状态(CfmState)',
      FREIGHT_CHARGES_TOTAL: '提单运费USD合计(freightChargeTotal)',
      FREIGHT_CHARGES_EN_UPPER: 'USD费用合计英文大写(freightChargeEnUpper)',
      AirCargoDoc: '空运主分单(AirCargoDoc)'
    },
    OtherCharge: {
      CHARGE_ITEM: '费用名称(chargeItem)',
      MEASURE: '单位类型(measure)',
      UNIT_RATE: '单价(unitRate)',
      AMOUNT: '金额(amount)',
      REMARK: '附加说明(remark)',
      MIN_AMOUNT: '最小收费金额(minAmount)',
      CHARGE_ID: '费用序号(chargeId)',
      OtherCharge: '空运提单其它费用 (OtherCharge)'
    },
    TruckingInfo: {
      TRUCKING_ID: '陆运序号(truckingId)',
      CARRYING_CMP: '运输公司(carryingCmp)',
      LOADING_DATE: '预计装货日期(loadingDate)',
      DRIVER: '司机(driver)',
      DRIVER_TEL: '司机电话(driverTel)',
      DOOR_NAME: '门点(doorName)',
      DOOR_MAN: '门点联系人(doorMan)',
      DOOR_MAN_TEL: '门点联系人电话(doorManTel)',
      DOOR_ADDR: '门点地址(doorAddr)',
      REMARKS: '备注(remarks)',
      QUANTITY: '件数(quantity)',
      WEIGHT: '重量(weight)',
      CUBAGE: '体积(cubage)',
      SO_NO: 'soNo(soNo)',
      TRUCK_ORDER_NO: '派车单号(TruckOrderNo)',
      PRINT_STATE: '派车单打印状态(PrintState)',
      PRINT_DATE: '派车单打印日期(PrintDate)',
      PRINT_BY: '派车单打印人(PrintBy)',
      PLATE_NUMBER: '车牌号(plateNumber)',
      TRUCKING_FEE: '拖车费(truckingFee)',
      SEND_STATE: '派车状态(sendState)',
      INTERACTIVE_NO: '交互单号(InteractiveNo)',
      TRAVEL_HOUR: '在途时间-小时(TravelHour)',
      TRAVEL_MINUTE: '在途时间-分钟(TravelMinute)',
      TruckingInfo: '本地运输(TruckingInfo)'
    },
    WarehouseInfo: {
      WAREHOUSE_ID: '仓储序号(warehouseId)',
      WAREHOUSE_CMP: '仓储公司(warehouseCmp)',
      ARRIVE_DATE: '预计送货日期(arriveDate)',
      WAREHOUSE_CONTACT: '联系人(warehouseContact)',
      WAREHOUSE_CONTACT_TEL: '联系人电话(warehouseContactTel)',
      WAREHOUSE_CONTACT_FAX: '联系人传真(warehouseContactFax)',
      WAREHOUSE_ADDRESS: '仓库地址(warehouseAddress)',
      REMARKS: '备注(remarks)',
      QUANTITY: '破损受潮件数(quantity)',
      WAREHOUSE_NAME: '仓库名称(warehouseName)',
      MAP_FILE: '地图图片(mapFile)',
      WarehouseInfo: '仓储(WarehouseInfo)'
    },
    CustomsInfo: {
      CUSTOMS_ID: '报关序号(customsId)',
      CUSTOMS_BROKER: '报关行(customsBroker)',
      COMPANY_CNAME: '经营单位(companyCName)',
      TEN_DIGIT_CODE: '报关十位码(tenDigitCode)',
      INSPECTION_CODE: '报检十位码(inspectionCode)',
      HS_CODE: 'hsCode',
      REMARKS: '备注(remarks)',
      CUSTOMS_DATE: '报关日期(customsDate)',
      LEVEL: '序号(level)',
      DECLARE_CUSTOMS_STATE: '报关状态(declareCustomsState)',
      COMMODITY_INSPECTION: '是否商检(commodityInspection )',
      SPOT_INSPECTION: '是否查验(spotInspection)',
      QUANTITY_ACTUAL: '实际货物件数(quantityActual)',
      WEIGHT_ACTUAL: '实际货物重量(weightActual)',
      CUBAGE_ACTUAL: '实际货物体积(cubageActual)',
      SO_NO: '关单号(soNo)',
      CUSTOMS_NO: '海关编号(customsNo)',
      DECLARE_CUSTOMS_TYPE: '报关类别(declareCustomsType)',
      PRE_NUMBER: '预录入编号(preNumber)',
      PLATE_NUMBER: '车牌号(plateNumber)',
      CONTAINER_NO: '柜型柜号(containerNo)',
      CustomsInfo: '报关信息(CustomsInfo)'
    },
    SeaEQ: {
      EQID: '流水号(EQid)',
      EQSIZE: '箱型EQsize',
      EQTYPE: '箱种EQtype',
      EQQUANTITY: '数量EQquantity',
      CONTAINERNO: '箱号containerNo',
      SEALNO: '封号sealNo',
      SOC: '是否货主箱(SOC)',
      SIZE_LENGTH: '长(sizeLength)',
      SIZE_WIDTH: '宽(sizeWidth)',
      SIZE_HEIGHT: '高(sizeHeight)',
      SeaEQ: '箱型箱量(SeaEQ)'
    },
    Container: {
      CONTAINERID: 'containerId',
      CONTAINERNO: '箱号containerNo',
      SEALNO: '封号sealNo',
      RESEALED: '是否更改封号reSealed',
      EQTYPE: '箱种EQtype',
      EQSIZE: '箱型EQsize',
      REMARK: '备注remark',
      CONTAINER_WEIGHT: '皮重containerWeight',
      CARGO_NAME: '品名(cargoName)',
      MARK: '唛头(mark)',
      VGM_WEIGHT: 'VGM重量(VGMWeight)',
      VGM_WEIGHTING_METHOD: 'VGM称重方法(VGMWeightingMethod)',
      VGM_WEIGHTING_TIME: 'VGM称重时间(VGMWeightingTime)',
      VGM_WEIGHTING_PLACE: 'VGMWeightingPlace',
      QUANTITY: '件数quantity',
      WEIGHT: '重量weight',
      CUBAGE: '体积cubage',
      APPROACH_DATE: '进场时间(approachDate)',
      PLAY_DATE: '出场时间(playDate)',
      DISCHARGING_PORT: '卸货港(dischargingPort)',
      DESTINATION_PORT: '目的港(destinationPort)',
      TRANSPORT_MESSAGE_DATE: '运抵报文发送时间(transportMessageDate)',
      WHARF_RELEASE_DATE: '码头放行时间(wharfReleaseDate)',
      CUSTOM_RELEASE_DATE: '海关放行时间(customReleaseDate)',
      CONTAINER_ASCRIPTION: '箱属（备选COC/SOC）(containerAscription)',
      BOX_ASCRIPTION: '箱属(箱管)(boxAscription)',
      PLATE_NUMBER: '车牌号(plateNumber)',
      PLATE_APPROACH_DATE: '集卡进场时间(plateApproachDate)',
      PLATE_PLAY_DATE: '集卡出场时间(platePlayDate)',
      LOADING_PORT: '装货港(loadingPort)',
      IN_SPECTED: '是否查验(inSpected)',
      BOX_OWNER: '箱主',
      RETURN_BOX_TIME: '箱管-还箱时间(returnBoxTime)',
      Container: '集装箱(Container)',
      SIZE_LENGTH: '长(sizeLength)',
      SIZE_WIDTH: '宽(sizeWidth)',
      SIZE_HEIGHT: '高(sizeHeight)'
    },
    ContainerUsage: {
      QUANTITY: '件数quantity',
      WEIGHT: '重量weight',
      CUBAGE: '体积cubage',
      MASTER_JOIN: '并单主单关联号(masterJoin)',
      SERIAL_NO: '拼箱装箱序号(serialNo)',
      HSCODE: 'HSCODE',
      SOC: '是否货主箱(SOC)',
      TRUCKING_INFO_UUID: '本地运输UUID(truckingInfoUuid)',
      TYPE: '互联派车订单状态变更类型(type)',
      CODE: '互联派车验证结果代码(code)',
      DESCRIPTION: '互联派车状态描述(description)',
      TRUCKING_FEE: '拖车费(truckingFee)',
      TRUCK_STATUS: '互联派车状态(truckStatus)',
      HL_DRIVER_NAME: '司机姓名(driverNameHL)',
      HL_DRIVER_PHONE: '司机手机号(driverPhoneHL)',
      HL_TRUCK_NO: '互联车牌号码(truckNoHL)',
      HL_TMS_NO: '互联派车单号(tmsNoHL)',
      HL_CONTAINER_NO_DIFF: '互联箱封号提醒(containerNoDiff)',
      HL_DC_TICKET_NO: '互联DC票号',
      HL_DC_SEQUENCE: '互联DC柜序号',
      HL_AUDIT_ID: '互联费用确认编号',
      HL_AUDIT_URL: '互联费用确认URL',
      HL_AUDIT_MONEY: '互联费用确认金额',
      HL_AUDIT_STATE: '互联费用确认状态(1:确认 2:退回)',
      TRUCKING_PLACE_OF_DEP: '提柜堆场(TRUCKING_PLACE_OF_DEP)',
      TRUCKING_PLACE_OF_DEST: '还柜堆场(TRUCKING_PLACE_OF_DEST)',
      TOS_CAR_NUM: 'G7车牌号',
      TOS_DRIVER_NAME: 'G7司机名称',
      TOS_DRIVER_PHONE: 'G7司机联系电话',
      TOS_TASK_ID: 'G7任务id',
      TOS_START_TIME: 'G7计划发车时间',
      TOS_END_TIME: 'G7计划到达时间',
      TOS_GSTART_TIME: 'G7实际发车时间',
      TOS_GARRIVE_TIME: 'G7实际到达时间',
      TOS_IN_TIME: 'G7计划到达工厂时间',
      TOS_GIN_TIME: 'G7实际到达工厂时间',
      TOS_OUT_TIME: 'G7计划离开工厂时间',
      TOS_GOUT_TIME: 'G7实际离开工厂时间',
      TOS_NODE_DATE: '节点变更时间',
      TOS_LOCATION: 'G7定位信息',
      TOS_ERROR_TYPE: 'G7运输异常标识',
      TOS_ERROR_MESSAGE: 'G7异常信息',
      CARGO_NAME: '品名(cargoName)',
      MARK: '唛头(mark)',
      ContainerUsage: '装箱明细(ContainerUsage)'
    },
    ContainerUsageTrucking: {
      CONTAINER_UUID: '集装箱(containerUuid)',
      JOB_UUID: '业务(jobUuid)',
      TRUCKING_INFO_UUID: '业务(truckingUuid)',
      SEQUENCE: '序号(sequence)',
      STATUS: '互联派车状态(status)',
      GOODS_DESCRIPTION: '品名(goodsDescription)',
      FEEFER_TEMPERATURE: '温度要求(feeferTemperaTrue)',
      VENTILATION: '通风要求(ventilaction)',
      CONTAINER_SIZE_TYPE: '箱型(containerSizeType)',
      SHIP_COMPANY: '船公司(shipCompany)',
      CONTAINER_OWNER: '箱属(containerOwner)',
      CONTAINER_NO: '箱号containerNo',
      SEAL_NO: '封号sealNo',
      PACKAGES: '单箱件数(packages)',
      WEIGHT: '单箱重量(weight)',
      MEARSUREMENT: '单箱体积(mearsurement)',
      TRUCKING_DATE: '装/送货时间(truckingDate)',
      TRUCKING_PLACE_OF_DEP: '起点(truckingPalceOfDep)',
      TRUCKING_PLACE_OF_DEST: '终点(truckingPalceOfDest)',
      TRUCKING_PLACE: '装/卸货点(truckingPalce)',
      TRUCKING_DATA: '装/卸货点(truckingData)',
      SHIPPER: '发货人(shipper)',
      SHIPPER_CONTACT: '发货人联系人(shipperContact)',
      SHIPPER_CONTACT_PHONE: '发货人联系电话(shipperContactPhone)',
      RECEIVER: '收货人(receiver)',
      RECEIVER_CONTACT: '收货人联系人(receiverContact)',
      RECEIVER_CONTACT_PHONE: '收货人联系电话(receiverContactPhone)',
      SHIP_COMPANY_REQUIREMENT: '船公司备注(shipCompanyRequirement)',
      TRUCK_FEE: '拖车费(truckFee)',
      FEE_REMARK: '费用备注(feeRemark)',
      ATTACHMENTS: '数组: 客户上传的附件标识，为返回的FILEUNIQUEKEY(attachments)',
      ACCEPTING: '审核通过操作时间(accepting)',
      REFUSE_REASON: '拒绝订单原因(refuseReason)',
      REFUSING: '拒绝订单操作时间(refusing)',
      ASSIGNING: '分配车辆操作时间(assigning)',
      ASSIGN_REASON: '分配车辆异常原因(assingReason)',
      ASSIGN_REMARK: '分配车辆异常备注(assingRemark)',
      LOADING: '服务商(车队)派车时，提供的车辆到厂时间(loading)',
      LOADING_TIME: '提供到厂时间的录入时间(loadingTime)',
      TRUCK_NO: '车牌号码(truckNo)',
      DRIVER_NAME: '司机姓名(driverName)',
      DRIVER_PHONE: '司机手机号(driverPhone)',
      NEW_LOADING: '(提柜后更新的)预计车辆到厂时间(newLoading)',
      CONTAINER_WEIGHT: '空柜重量(containerWeigth)',
      PICKUP_TIME: '提空时间(pickupTime)',
      OFFER_INFO: '报柜时间(offerInfo)',
      PICKUP_REASON: '提柜异常原因(pickupReason)',
      PICKUP_REMARK: '提柜异常备注(pickupRemark)',
      UPDATE_TIME: '更新司机资料或箱信息操作时间(updateTime)',
      GROSS_WEIGHT: '过磅重量(grossWeight)',
      WEIGH_REASON: '修改信息异常原因(weighReason)',
      WEIGH_REMARK: '修改信息异常备注(weighRemark)',
      REVOKE_TIME: '撤销订单操作时间(revokeTime)',
      RETURN_TIME: '还柜进港操作时间(returnTime)',
      RETURN_REASON: '还柜进港异常原因(returnReason)',
      RETURN_REMARK: '还柜进港异常备注(returnRemark)',
      TRUCK_ATTACHMENTS: '数组: 车队提供的附件地址(truckAttachments)',
      B_ACTIVE: '有效,0=历史(active)',
      ContainerUsageTrucking: '装箱明细派车信息(ContainerUsageTrucking)'
    },
    MAWB: {
      SEQUENCE: '序号(sequence)',
      CARRIER_ID: '航空公司(carrierId)',
      BOOKINGAGENT_ID: '订舱代理(bookingAgentId)',
      START_NO: '主单起始号(startNo)',
      NUMBER: '主单份数(number)',
      REMARK: '附加说明(remark)',
      INPUT_BY: '领用人(inputBy)',
      DEP: '领用部门(dep)',
      INPUT_DATE: '领用日期(inputDate)',
      EFFECT_DATE: '失效日期(effectDate)',
      BRANCH_ID: '分公司(branchId)',
      MAWB: '主单 (MAWB)'
    },
    MAWBDetail: {
      JOBNO: '业务编号(jobNo)',
      STATE: '状态(state)',
      MAWB_NO: '主单号(MAWBNo)',
      AGENT_ID: '过单代理(agentId)',
      BORROW_DATE: '过单日期(borrowDate)',
      RETURN_DATE: '预计返回日期(returnDate)',
      ACTUAL_RETURN_DATE: '实际返回日期(actualReturnDate)',
      REMARK: '附加说明(remark)',
      MAWBDetail: '主单明细 (MAWBDetail)'
    },
    JobProfit: {
      JOB_NO: ' 工作号(jobNo)',
      RATE: '汇率(rate)',
      PROFIT_USD: '美元利润(profitUSD)',
      PROFIT_RMB: '人民币利润(profitRMB)',
      PROFIT: '利润(profit)',
      JobProfit: '利润分析(JobProfit)'
    },
    EDIContainer: {
      CONTAINER_NO: '箱号(containerNo)',
      SEAL_NO: '封号(sealNo)',
      EQ_TYPE: '箱种(eqType)',
      EQ_SIZE: '箱型(eqSize)',
      QUANTITY: '件数(quantity)',
      WEIGHT: '重量(weight)',
      CUBAGE: '体积(cubage)',
      REMARK: '备注(remarks)',
      HV: 'hv(hv)',
      REF_NO: '客户参考号(refNo)',
      PAY_LOAD: '收货载重(payLoad)',
      NR: '非操作冷柜(nr)',
      TEMPERATURE: '温度(temperature)',
      VENTILATED: '开通风盘(ventilated)',
      OPENNING: '通风比例(openning)',
      FUM_POL: '起运港熏蒸证(fumPol)',
      FUM_DATE: '熏蒸日期(fumDate)',
      VEN_POL_DATE: '开通风盘日期(venPolDate)',
      FUM_UNNO: '熏蒸货物Un no(fumUnNo)',
      FUM_IMO_CLASS: '熏蒸货物imo class(fumImoClass)',
      DE_FUM_POD: '卸货港免熏蒸证(deFumPod)',
      DC_CER_RECEIVED: 'dcCerReceived(dcCerReceived)',
      OLD_CONTAINER: 'oldContainer(oldContainer)',
      EDIContainer: '提单EDI箱封信息(EDIContainer)'
    },
    AirFlight: {
      AIR_FLIGHT_ID: '序号(airFlightId)',
      CARRIER_ID: '航空公司(carrierId)',
      FLIGHT: '航班(flight)',
      ETD: '开航日期(ETD)',
      FLIGHT_LOCKED: '是否锁定(locked)',
      REMARK: '附加说明(remark)',
      INPUT_BY: '创建人(inputBy)',
      DEPT: '创建部门(dept)',
      BRANCH_ID: '分公司(branchId)',
      AirFlight: '空运航班表(AirFlight)'
    },
    WarehouseIn: {
      WAREHOUSE_ID: '入库流水号(warehouseId)',
      WAREHOUSE: '仓库名称(warehouse)',
      BRANCH_ID: '分公司(branchId)',
      WAREHOUSE_NO: '进仓编号(warehouseNo)',
      RECEIPT_NO: '回执单号(receiptNo)',
      WAREHOUSE_IN_DATE: '入库日期(warehouseInDate)',
      WAREHOUSE_OP: '仓库员(warehouseOP)',
      LOCATION: '库位(location)',
      PALLET_SUM: '托盘数量(palletSum)',
      QUANTITY_SUM: '入库件数合计(quantitySum)',
      WEIGHT_SUM: '入库重量合计(weightSum)',
      CUBAGE_SUM: '入库体积合计(cubageSum)',
      DELIVERY_CMP: '送货公司(deliveryCMP)',
      TRUCK_NO: '车牌(truckNo)',
      DRIVER: '司机(driver)',
      DRIVER_TEL: '司机联系电话(driverTel)',
      REMARKS: '备注(remarks)',
      BROKEN: '是否破损受潮(broken)',
      BROKEN_QUANTITY: '破损受潮件数(brokenQuantity)',
      BROKEN_DES: '货损描述(brokenDes)',
      COMMENTS: '处理意见(comments)',
      RECEIVE_DC: '是否收到文件(receiveDC)',
      WAREHOUSE_OUT_DATE: '出库日期(warehouseOutDate)',
      OUT_TYPE: '出库方式(outType)',
      LABEL: '分标签(label)',
      WAREHOUSE_NO_FORMAT: '进仓编号格式化(warehouseNoFormat)',
      SEAL_CARGO: '是否关封货(sealCargo)',
      SEAL_WEIGHT: '关封重量(sealWeight)',
      LOB: '业务类型(lob)',
      REFERENCE_NO: '参考号(ReferenceNo)',
      INSTORE_FROM: '入库操作类型(InstoreFrom)',
      OUTSTORE_TO: '出库操作类型(OutstoreTo)',
      MARKS: '唛头(Marks)',
      WarehouseIn: '仓储入库(WarehouseIn)'
    },
    WarehouseInDetail: {
      PACKING: '包装类型(packing)',
      QUANTITY: '件数(quantity)',
      WEIGHT: '重量(weight)',
      CUBAGE: '体积(cubage)',
      DIMENSION: '尺寸(dimension)',
      REMARKS: '备注(remarks)',
      WAREHOUSE_IN_DATE: '入库日期(warehouseInDate)',
      WarehouseInDetail: '仓储入库明细(WarehouseInDetail)'
    },
    TrackingInfo: {
      CODE: '主状态代码(code)',
      CODE_CNAME: '主状态中文名(codeCname)',
      CODE_ENAME: '主状态英文名(codeEname)',
      SUB_CODE: '子状态代码(subCode)',
      SUB_CODE_CNAME: '子状态中文名(subCodeCname)',
      SUB_CODE_ENAME: '子状态英文名(subCodeEname)',
      MODIFY_DATE: '状态更新时间(modifyDate)',
      MODIFY_BY: '状态更新人(modifyBy)',
      REMARK: '状态说明(remark)',
      ROLE_TYPE: '用户类型(ROLE_TYPE)',
      TrackingInfo: '业务状态跟踪(TrackingInfo)'
    },
    AirFlightDetail: {
      BOARD_NO: '板号(boardNo)',
      BOARD_TYPE: '板型(boardType)',
      WEIGHT: '板重(weight)',
      WHOLE_BOARD: '是否包板(wholeBoard)',
      REMARK: '附加说明(remark)',
      TRANS_BY: '交接人(transBy)',
      TRANS_DATE: '交接日期(transDate)',
      AirFlightDetail: '空运航班明细表(AirFlightDetail)'
    },
    TrackingInfoHistory: {
      CODE: '主状态代码(code)',
      CODE_CNAME: '主状态中文名(codeCname)',
      CODE_ENAME: '主状态英文名(codeEname)',
      SUB_CODE: '子状态代码(subCode)',
      SUB_CODE_CNAME: '子状态中文名(subCodeCname)',
      SUB_CODE_ENAME: '子状态英文名(subCodeEname)',
      MODIFY_DATE: '状态更新时间(modifyDate)',
      MODIFY_BY: '状态更新人(modifyBy)',
      TrackingInfoHistory: '业务状态跟踪历史(TrackingInfoHistory)'
    },
    Flight: {
      ETD: '开航日期(ETD)',
      ATD: '实际起飞时间(ATD)',
      ATA: '实际到达时间(ATA)',
      HAND_OFF_DATETIME: '交货时间(handOffDateTime)',
      BRANCH_ID: '分公司(branchId)',
      DEPARTURE_TIME: '起飞时间(departureTime)',
      SETTLE_STATE: '结算状态(settleState)',
      Flight: '航班(Flight)'
    },
    AirExportBooking: {
      BOOKING_NO: '订舱号(bookingNo)',
      BOOKING_DATE: '订舱日期(bookingDate)',
      BOOKING_STATE: '订舱状态(bookingState)',
      BOOKING_NOTES: '订舱备注(bookingNotes)',
      BOOKING_RESULT_NOTES: '订舱结果说明(bookingResultNotes)',
      INPUT_BY: '创建人(inputBy)',
      INPUT_DATE: '创建日期(inputDate)',
      INPUT_BY_DEP: '创建人部门(inputByDep)',
      INPUT_BY_OFFICE: '创建人分公司(inputByOffice)',
      AirExportBooking: '空运出口订舱(AirExportBooking)'
    },
    AirExportBookingItem: {
      SUCCESS: '是否成功(isSuccess)',
      AirExportBookingItem: '空运出口订舱项(AirExportBookingItem)'
    },
    AirExportLoadingNotes: {
      NOTES: '说明(notes)',
      TAKE_PHOTOS: '拍照(takePhotos)',
      AirExportLoadingNotes: '空运出口装板说明(AirExportLoadingNotes)'
    },
    Business_Document: {
      DOCUMENT_ID: '文档ID(documentId)',
      DOCUMENT_CATEGORY: '文档类型(documentCategory)',
      FILE_NAME: '文件名(fileName)',
      FILE_CATEGORY: '文件归类(fileCategory)',
      FILE_TYPE: '文件类型(fileType)',
      FILE_SIZE: '文件大小(fileSize)',
      BUSINESS_ID: '业务ID(businessId)',
      SOURCE_TYPE: '文件来源(sourceType)',
      REMARKS: '备注(remarks)',
      Business_Document: '业务文档(Business_Document)'
    },
    AirExportTransitRoutingAdjustment: {
      ADJUSTER: '调整人(adjuster)',
      ADJUSTED_TIME: '调整时间(adjustedTime)',
      VERIFIER: '审核人(verifier)',
      VERIFIED_TIME: '审核时间(verifiedTime)',
      ORIGIN_AIR_TRANSIT_ROUTING_DESCRIPTION_UUID: '源线路描述Id(originAirTransitRoutingDescriptionUUID)',
      TARGET_AIR_TRANSIT_ROUTING_DESCRIPTION_UUID: '目标线路描述Id(targetAirTransitRoutingDescriptionUUID)',
      ORIGIN_FLIGHT_ID: '源航班Id(originFlightId)',
      TARGET_FLIGHT_ID: '目标航班Id(targetFlightId)',
      AirExportTransitRoutingAdjustment: '空运线路调整(AirExportTransitRoutingAdjustment)'
    },
    ExceptionHandling: {
      OPERATE_TYPE: '操作类型(OPERATE_TYPE)',
      OPERATOR: '操作人(operator)',
      OPERATE_TIME: '操作时间(operateTime)',
      OPERATION_REQUIREMENT: '操作要求(operationRequirement)',
      EXECUTOR: '执行人(executor)',
      EXECUTE_TIME: '执行时间(executeTime)',
      ExceptionHandling: '异常处理(ExceptionHandling)'
    },
    LayAside: {
      OPERATOR: '操作人(operator)',
      OPERATE_TIME: '操作时间(operateTime)',
      LAY_ASIDE_NODE: '拉货环节(layAsideNode)',
      LAY_ASIDE_REASON: '拉货原因(layAsideReason)',
      LayAside: '拉货(LayAside)'
    },
    TrackingNode: {
      JOB_UUID: 'jobuuid(jobuuid)',
      ACTIVE: '有效(active)',
      TrackingNode: '业务节点(TrackingNode)'
    },
    AirExportFlightCustomer: {
      FLIGHT_NO: '航班号(flightNo)',
      ETD: 'ETD',
      CUSTOMER_ID: '委托单位编码(customerId)',
      AirExportFlightCustomer: '空运出口航班客户(AirExportFlightCustomer)'
    },
    FileHandover: {
      HANDOVER_STATUS: '交接状态(handoverStatus)',
      SENDER: '发送人(sender)',
      SENDED_DATE: '发送时间(sendedDate)',
      RECIPIENT: '接收人(recipient)',
      RECEIVED_DATE: '接收时间(receivedDate)',
      REMARKS: '备注(remarks)',
      RETURNED_REASON: '退回原因(returnedReason)',
      FileHandover: '文件交接(FileHandover)'
    },
    FileHandoverDetail: {
      FILE_TYPE: '文件类型(fileType)',
      HANDOVER_STATUS: '交接状态(handoverStatus)',
      FileHandoverDetail: '文件交接明细(FileHandoverDetail)'
    },
    AirTransitRoutingDescription: {
      FIRST_TRANSSHIPMENT_PORT_CODE: '一程中转港代码(firstTransshipmentPortCode)',
      SECOND_TRANSSHIPMENT_PORT_CODE: '二程中转港代码(secondTransshipmentPortCode)',
      BEGIN_VALID_DATE: '生效时间(beginValidDate)',
      END_VALID_DATE: '失效时间(endValidDate)',
      CREATE_DEPARTMENT: '创建部门(createDepartment)',
      BRANCH_ID: '分公司(branchId)',
      AirTransitRoutingDescription: '空运线路描述(AirTransitRoutingDescription)'
    },
    AirInteriorPoints: {
      INTERIOR_POINT_PORT_ID: '转运港代码(interiorPointPortId)',
      AirInteriorPoints: '空运内陆转运点(AirInteriorPoints)'
    },
    FlightDescription: {
      FLIGHT_NO: '航班号(flightNo)',
      CARRIER_ID: '航空公司(carrierId)',
      LOADING_PORT_CODE: '起运港代码(loadingPortCode)',
      DESTINATION_PORT_CODE: '目的港代码(destinationPortCode)',
      BEGIN_VALID_DATE: '生效时间(beginValidDate)',
      END_VALID_DATE: '失效时间(endValidDate)',
      CREATE_DEPARTMENT: '创建部门(createDepartment)',
      BRANCH_ID: '分公司(branchId)',
      CARGO_TERMINALS: '货站(cargoTerminals)',
      FlightDescription: '航班描述(FlightDescription)'
    },
    FlightScheduleItem: {
      ITEM_NAME: '项名称(itemName)',
      DEPARTURE_TIME: '起飞时间(departureTime)',
      FLYING_DAYS: '飞行天数(flyingDays)',
      ARRIVAL_TIME: '到达时间(arrivalTime)',
      FlightScheduleItem: '航班时刻表计划项(FlightScheduleItem)'
    },
    Tracking: {
      LOB: '业务类型(lob)',
      LEVEL: '主状态序号(level)',
      CODE: '主状态代码(code)',
      CODE_CNAME: '主状态中文名(codeCname)',
      CODE_ENAME: '主状态英文名(codeEname)',
      REMARK: '备注(remark)',
      NODE_TYPE: '节点类型(nodeType)',
      PUBLISHED: '是否公开(published)',
      DEFAULT_TRACKING: '默认跟踪(defaultTracking)',
      KEY_NODE: '关键节点(keyNode)',
      OFFSET_DAY: '预计执行时间-天(offsetDay)',
      OFFSET_HOUR: '预计执行时间-小时(offsetHour)',
      SOP_TYPE_UUID: 'SOP类型UUID(sopTypeUuid)',
      Tracking: '业务跟踪状态配置(Tracking)'
    },
    TrackingDetail: {
      DEFAULT_NODE: '默认节点(defaultNode)',
      LEVEL: '子状态序号(level)',
      CODE: '子状态代码(code)',
      CODE_CNAME: '子状态中文名(codeCname)',
      CODE_ENAME: '子状态英文名(codeEname)',
      TYPE: '状态触发类型(type)',
      EVENT: '状态触发事件(event)',
      REMARK: '备注(remark)',
      STATE_TYPE: '状态类型(stateType)',
      PUBLISHED: '是否公开(published)',
      TEMPLATE_UUID: '输出报表模板(templateUuid)',
      DOCUMENT_TYPE_UUID: '触发文件类型(documentTypeUuid)',
      EXTERNAL_CODE: '外部代码(externalCode)',
      APPLY_TYPE: '应用类型(applyType 0.全部 1.内部 2.外部)',
      SEND_INNER_NOTIFY: '是否发送内部通知(sendInnerNotify)',
      INNER_CONFIG: '内部配置(innerConfig)',
      TrackingDetail: '业务跟踪状态配置明细(TrackingDetail)'
    },
    SOPExternalCodeConfig: {
      SERVICE_NAME: '对接服务名称(serviceName)',
      CODE: '代码(code)',
      DESCRIPTION: '描述(description)',
      SOPExternalCodeConfig: 'SOP外部映射(SOPExternalMapping)'
    },
    TrackingDetailNotifyExt: {
      TRACKING_DETAIL_UUID: '跟踪状态明细UUID(trackingDetailUuid)',
      MESSAGE_CODE: '输出标识(messageCode)',
      MESSAGE_DESC: '输出说明(messageDesc)',
      ENTITY_NAME: '数据来源(entityName)',
      FIELD_NAME: '数据字段(fieldName)',
      REMARKS: '备注(remarks)',
      TrackingDetailNotifyExt: '业务跟踪状态明细消息附加信息(TrackingDetailNotifyExt)'
    },
    OperationRequirement: {
      DESCRIPTION_ID: '描述Id(descriptionId)',
      FINISHED: '是否完成(finished)',
      FINISHED_DATE: '完成时间(finishedDate)',
      REMARKS: '备注(remarks)',
      OperationRequirement: '操作要求(OperationRequirement)'
    },
    SurchargeTerms: {
      CHARGE_ITEM_ID: '费用项id(chargeItemId)',
      TERMS: '条款(terms)',
      SurchargeTerms: '附加费条款(SurchargeTerms)'
    },
    Memo: {
      JOB_UUID: '业务UUID(jobUuid)',
      TALK: '说说(talk)',
      JOB_NO: '工作号(jobNo)',
      LISTENER: '消息接收人(Listener)',
      Memo: '备忘录(Memo)'
    },
    MailHistory: {
      JOB_UUID: '业务UUID(JobUuid)',
      JOB_NOS: '业务号码(JobNos)',
      MAIL_SUBJECT: '主题(MailSubject)',
      MAIL_TO: 'TO(MailTo)',
      MAIL_CC: 'CC(MailCc)',
      MAIL_BCC: 'BCC(MailBcc)',
      MAIL_CONTENT: '邮件内容(MailContent)',
      RETURN_TO: '回复接受人(ReturnTo)',
      ATTACHMENT_PATH: '附件保存位置(AttachmentPath)',
      DOC_ID_LIST: '附件云存储位置(docIdList)',
      MailHistory: '业务邮件历史(MailHistory)'
    },
    DataTransfer: {
      TRANSFER_TYPE: '传输类型(TransferType)',
      DATA_TYPE: '数据类型(DataType)',
      DATA_KEY: '业务数据关联键(DataKey)',
      REFERENCE_NO: '传输参考号(ReferenceNo)',
      REF_CONTENT: '传输参考信息(RefContent)',
      DATE_UPLOADED: '数据导出时间(DateUploaded)',
      DataTransfer: '工作单数据传递信息(DataTransfer)'
    },
    JobPriceHistory: {
      JOB_UUID: '工作单uuid(jobUuid)',
      OLD_PRICE_NO: '原运价编号(oldPriceNo)',
      NEW_PRICE_NO: '新运价编号(newPriceNo)',
      BATCH_NUMBER: '批次号(batchNumber)',
      NOTIFY_STATE: '通知状态(notifyState)',
      JobPriceHistory: '业务运价更新历史(JobPriceHistory)'
    },
    PoItems: {
      ORDER_NO: '订单号(OrderNo)',
      MODULE_CODE: '型号(ModuleCode)',
      CASE_NO: 'CaseNo(CaseNo)',
      ITEM_NO: 'ItemNo(ItemNo)',
      SUB_ITEM_NO: 'SubItemNo(SubItemNo)',
      SUPPLY_PART_NO: 'SupplyPartNo(SupplyPartNo)',
      ORDER_PART_NO: 'OrderPartNo(OrderPartNo)',
      HS_CODE: '海关编码(HsCode)',
      CHINESE_COMMODITY: '中文品名(ChineseCommodity)',
      ENGLISH_COMMODITY: '英文品名(EnglishCommodity)',
      CUSTOMS_COMMODITY: '海关品名(CustomsCommodity)',
      QUANTITY: '货物件数(quantity)',
      GROSS_WEIGHT: '货物毛重(GrossWeight)',
      ORG_REGION: '产地(OrgRegion)',
      CUBAGE: '货物体积(cubage)',
      PURCHASE_PRICE: '买价(PurchasePrice)',
      PURCHASE_AMOUNT: '买入货款(PurchaseAmount)',
      PURCHASE_TARIFF_RATE: '买入关税税率(PurchaseTariffRate)',
      PURCHASE_TARIFF_AMOUNT: '买入关税(PurchaseTariffAmount)',
      PURCHASE_VAL_RATE: '买入增值税税率(PurchaseValRate)',
      PURCHASE_VAL_AMOUNT: '买入增值税(PurchaseValAmount)',
      PURCHASE_EXCISE_RATE: '买入消费税税率(PurchaseExciseRate)',
      PURCHASE_EXCISE_AMOUNT: '买入消费税(PurchaseExciseAmount)',
      PURCHASE_CURRENCY: '买入币种(PurchaseCurrency)',
      PURCHASE_EXCHANGE_RATE: '买入汇率(PurchaseExchangeRate)',
      SELL_PRICE: '卖价(SellPrice)',
      SELL_AMOUNT: '卖出货款(SellAmount)',
      SELL_VAL_RATE: '卖出增值税税率(SellValRate)',
      SELL_VAL_AMOUNT: '卖出增值税(SellValAmount)',
      CUSSTOMS_BILL_SEQ: '报关归类序号(CustomsBillSeq)',
      REMARKS: '备注(remarks)',
      NET_WEIGHT: '货物净重(netWeight)',
      ITEM_SPEC: '货物规格(itemSpec)',
      MEASURE: '费用计费方式(measure)',
      RELATED: '是否关联(related)',
      CONTAINER_NO: '箱号(containerNo)',
      EQTYPE: '箱种(EQtype)',
      EQSIZE: '箱型(EQsize)',
      SEALNO: '封号(sealNo)',
      CONTAINER_USAGE_UUID: '装箱信息(containerUsageKey)',
      PSN_CODE: 'psdCode(psdCode)',
      TECH_CHEM_NAME: 'techChemName(techChemName)',
      IMO_SORT: 'imoSort(imoSort)',
      SEG_GROUP: 'segGroup(segGroup)',
      CAA: 'caa(caa)',
      PIH: 'pih(pih)',
      REPORTABLE_QTY: 'reportableQty(reportableQty)',
      EMER_TEMP: 'emerTemp(emerTemp)',
      MP_CODE: 'mpCode(mpCode)',
      CONTROL_TEMP: 'controlTemp(controlTemp)',
      DENSITY: 'density(density)',
      IMDG_FROM: 'imdgFrom(imdgFrom)',
      IMDG_TO: 'imdgTo(imdgTo)',
      MAR_POLLUTANT: 'MAR POLLUTANT(marPollutant)',
      FLASH_POINT: 'FLASH POINT(flashPoint)',
      DC_PACKAGE: 'DC PACKAGE(dcPackage)',
      DC_PACKAGING: 'DC PACKING(dcPackaging)',
      DC_WEIGHT: 'DC WEIGHT(dcWeight)',
      QUTER_QTY: 'QUTER QTY(quterQty)',
      INNER_PACKAGE: 'INNER PACKAGE(innerPackage)',
      INNER_QTY: 'INNER QTY(innerQty)',
      EMER_PROVIDER: 'EMER PROVIDER(emerProvider)',
      CONTACT_NAME: 'CONTACT NAME(contactName)',
      EMER_PHONE: 'EMER PHONE(emerPhone)',
      PoItems: 'PO货物明细(PoItems)'
    },
    PoList: {
      PO_NO: '订单号(PONo)',
      CUSTOMER_ID: '委托单位(CustomerId)',
      PO_STATE: 'PO状态（PoState)',
      SEALES_OFFICE: '销售公司(salesOffice)',
      SALES_DEPARTMENT: '销售部门(salesDepartment)',
      SALES: '业务员(sales)',
      SUPPORTOR: '销售支持(supportor)',
      FIRST_PO: '是否首单(FirstPo)',
      VAL_PATH: '退税路径(VALPath)',
      PO_AMOUNT: '订单金额(POAmount)',
      PO_DECLARE_AMOUNT: '订单核销金额(PODeclareAmount)',
      PO_CURRENCY: '订单币种(PoCurrency)',
      PO_EXCHANGE_RATE: '订单汇率(PoExchangeRate)',
      FA_CONTRACT: '服务框架合同号(FAContract)',
      COMMISION_DISCOUNT: '服务费折扣率(CommisionDiscount)',
      OP_REMARKS: '操作说明(OPRemarks)',
      REMARKS: '备注(remarks)',
      PoList: 'PO信息(PoList)'
    },
    ForexPayment: {
      PAYMENT_NO: '结汇编号(PaymentNo)',
      PAYMENT_DATE: '外汇进账日期(PaymentDate)',
      FOREX_TYPE: '结汇方式(ForexType)',
      REFERENCE_NO: '参考编号(RerfrenceNo)',
      FOREX_AMOUNT: '结汇金额(ForexAmount)',
      FOREX_CURRENCY: '结汇币种(ForexCurrency)',
      FOREX_EXCHANGE_RATE: '汇率(ForexExchangeRate)',
      PAYMENT_PRE_LOCALAMOUNT: '付汇预款项(PaymentPreLocalAmount)',
      COMMISSION: '手续费(Commission)',
      POSTAL_COMMISSION: '邮电费(PostalCommission)',
      ACCEPT_COMMISSION: '承兑手续费(AcceptCommission)',
      DIFF_AMOUNT: '调整差额(DiffAmount)',
      REMARKS: '备注(remarks)',
      ForexPayment: '付汇信息(ForexPayment)'
    },
    BatchDataGroup: {
      GROUP_CODE: '分组号码(groupCode)',
      DATA_TYPE: '数据类型(dataType)',
      GROUP_TYPE: '用途(groupType)',
      DATA_KEY: '业务ID(dataKey)',
      BatchDataGroup: '批量处理分组定义(batchDataGroup)'
    },
    CheckCargoDocHistory: {
      TIMESTAMP: '批次时间戳(timestamp)',
      FIELD_NAME: '字段名(fieldName)',
      FIELD_VALUE: '字段值(fieldValue)',
      FIELD_TYPE: '字段类型(fieldType)',
      CheckCargoDocHistory: '对单修改历史记录(CheckCargoDocHistory)'
    },
    ContainerUsageHistory: {
      TIMESTAMP: '批次时间戳(timestamp)',
      FIELD_NAME: '字段名(fieldName)',
      FIELD_VALUE: '字段值(fieldValue)',
      FIELD_TYPE: '字段类型(fieldType)',
      ContainerUsageHistory: '装箱明细修改历史记录(ContainerUsageHistory)'
    },
    VGM: {
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      SHIPPER_CONTACT: 'VGM联系人(shipperContact)',
      SHIPPER_CONTACT_EMAIL: 'VGM联系人邮箱(shipperContactEmail)',
      SHIPPER_CONTACT_WAY: 'VGM联系方式(shipperContactWay)',
      SHIPPER_PERSON: 'VGM负责人(shipperPerson)',
      COMPANY_CONTACT: '公司联系人(companyContact)',
      COMPANY_CONTACT_EMAIL: '公司联系人邮箱(companyContactEmail)',
      COMPANY_CONTACT_WAY: '公司联系方式(companyContactWay)',
      COMPANY_PRINCIPAL: '公司负责人(companyPrincipal)',
      COMPANY_NAME: '公司名称(companyName)',
      COMPANY_ADDRESS: '公司地址(companyAddress)',
      VGM: 'VGM'
    },
    CrossTenantHistory: {
      SEND_TENANT_ID: '发送方TenantId(sendTenantId)',
      SEND_JOB_NO: '发送方业务编号(sendJobNo)',
      RECEIVE_TENANT_ID: '接受方tenantId(receiveTenantId)',
      RECEIVE_JOB_NO: '接受方jobNo(receiveJobNo)',
      STATE: '状态(state)',
      OPERATE_DATE: '操作日期(operateDate)',
      OPERATOR_ID: '操作人Id(operatorId)',
      REMARK: '附加信息(remark)',
      OPERATOR_NAME: '操作人姓名(operatorName)',
      LOADING_PORT_CODE: '起运港(loadingPortCode)',
      DESTINATION_PORT_CODE: '目的港(destinationPortCode)',
      CARRIER_ID: '承运人编号(carrierId)',
      CARRIER_NAME: '承运人姓名(carrierName)',
      ETD: 'ETD',
      CONTAINER_INFO: '箱型箱量(containerInfo)',
      CrossTenantHistory: '跨Tenant委托日志(CrossTenantHistory)'
    },
    FreightCharges: {
      CHARGEITEMID: '费用名称代码(chargeItemId)',
      AMOUNT: '金额(amount)',
      PAYMENT_TERM_HBL: '分单运费方式(paymentTermHBL)',
      UNIT_RATE: '单价(unitRate)',
      CURRENCY: '币种(currency)',
      QUANTITY: '数量(quantity)',
      EQSIZE: '箱型EQsize',
      EQTYPE: '箱种EQtype',
      FreightCharges: 'HBL提单运费(freightCharges)'
    },
    SubscribePortPushHistory: {
      TIMESTAMP: '批次时间戳(timestamp)',
      JOB_UUID: '业务ID(jobUuid)',
      MBL: '提单号(mbl)',
      FIELD_NAME: '字段名称(fieldName)',
      SOURCE_VALUE: '原值(sourceValue)',
      TARGET_VALUE: '新值(targetValue)',
      RECORD_ID: '修改的实体记录UUID(recordId)',
      SOURCE_TYPE: '数据源类型(sourceType)',
      SubscribePortPushHistory: '推送历史表(SubscribePortPushHistory)'
    },
    SubscribePortPushStatistics: {
      JOB_UUID: '业务编号(jobUUID)',
      MBL: '提单号(mbl)',
      YEAR: '年份(year)',
      MONTH: '月份(month)',
      OFFICE_ID: '操作分公司(officeId)',
      SubscribePortPushStatistics: '推送统计表(SubscribePortPushStatistics)'
    },
    ThirdPartyUser: {
      UNIONID: 'unionid(unionid)',
      OPENID: 'openid(openid)',
      NICKNAME: 'nickname(nickname)',
      AVATAR_URL: '头像url(avatarUrl)',
      COUNTRY: '国家(country)',
      PROVINCE: '省份(province)',
      CITY: '城市(city)',
      GENDER: '性别(gender  0:未知 1:男 2:女)',
      PHONE: '联系电话(phone)',
      STATUS: 'status(status)',
      USER_ID: 'userId(userId)',
      ThirdPartyUser: '第三方用户登录(ThirdPartyUser)'
    },
    MscCargoDoc: {
      SO_NO: 'soNo(soNo)',
      CUSTOMER_REF_NO: '参考号(customerRefNo)',
      MST_BOOKING: '主单号(mstBooking)',
      SPLIT_TYPE: '拆分类型(splitType)',
      RELATED_ORDER_NO: '相关订单号(relatedOrderNo)',
      CONTRACT_TYPE: '签约类型(contractType)',
      SERVICE_CODE: '服务代码(serviceCode)',
      REMARKS: '备注(remarks)',
      PRODUCTION_ASSEMBLY_STATION: '产装地场站(producionAssemblyStation)',
      PRODUCTION_FREIGHT_TYPE: '产装运输方式(productionFreightType)',
      LOADING_PORT: '起运港(loadingPort)',
      LOADING_PORT_WHARF: '起运港码头(loadingPortWharf)',
      DISCHARGING_PORT: '卸货港(dischargingPort)',
      DISCHARGING_PORT_WHARF: '卸港码头(dischargingPortWharf)',
      DESTINATION_PORT: '目的地(destinationPort)',
      ZIP_CODE: '邮编(zipCode)',
      DESTINATION_PORT_STATION: '目的地场站(destinationPortStation)',
      DESTINATION_TRANSFER_TYPE: '目的地转运方式(destinationTransferType)',
      TRANSIT_COUNTRY: '中转国(transitCountry)',
      BILL_TYPE: '提单类型(billType)',
      SIGN_DATE_BL: '签发日期(sighDateBl)',
      FREIGHT_BL: 'Freight BL(freightBl)',
      POD_AGENCY: 'POD Agency(podAgency)',
      LAST_DESCRIPTION: '最后一个箱子品名(lastDescription)',
      TO_ORDER_TYPE: 'To Order Type(toOrderType)',
      MBL: '主单号(mbl)',
      BILL_LOADING_PORT: '提单起运港(billLoadingPort)',
      BILL_DISCHARGING_PORT: '提单卸货港(billDischargingPort)',
      BILL_DESTINATION_PORT: '提单交货地(billDestinationPort)',
      MscCargoDoc: 'MSC提单(MscCargoDoc)'
    },
    MscCompanyTypeAddress: {
      COMPANY_TYPE: '公司类型(companyType)',
      MSC_CARGO_DOC_UUID: 'Msc提单UUID(mscUUID)',
      MscCompanyTypeAddress: 'MSC提单类型地址(MscCompanyTypeAddress)'
    },
    SubLocation: {
      SUBLOCATION_CODE: '代码(subLocationCode)',
      SUBLOCATION: '名称(sublocation)',
      SubLocation: '产装地场站(SubLocation)'
    },
    Wharf: {
      PORT_CODE: '港口代码(portCode)',
      TERMINAL: '码头名称(terminal)',
      TERMINAL_CODE: '代码(terminalCode)',
      Wharf: '港口码头(Wharf)'
    },
    ContainerUsageDgStuffing: {
      EDI_CONTAINER_UUID: 'EDI装箱信息UUID(ediContainerUUID)',
      ContainerUsageDgStuffing: '装箱信息关联危险品装箱地址(ContainerUsageDgStuffing)'
    },
    MscBillAddress: {
      COMPANY_NAME: '公司名称(companyName)',
      COMPANY_ADDRESS: '公司地址(companyAddress)',
      CITY: '城市(city)',
      CITY_NAME: '城市名称(cityName)',
      ZIP_CODE: '邮政编码(zipCode)',
      PHONE: '电话(phone)',
      FAX: '传真(fax)',
      CONTACT: '联系人(contact)',
      EMAIL: '电子邮件(email)',
      VIPCODE: 'VIP代码(vipCode)',
      INTTRACODE: 'Inttra代码(inttraCode)',
      MSCCODE: 'MSC代码(mscCode)',
      GROUPCODE: '公司代码(groupCode)',
      OTHER_INFORMATION: '其他信息(otherInformation)',
      BL_TITLE: '提单抬头(blTitle)',
      BL_ADDRESS: '提单地址(blAddress)',
      BL_CONTACT: '提单联系信息(blContact)',
      JOINED_UUID: '关联的UUID(joinedUUID)',
      MscBillAddress: 'MSC提单地址信息表(MscBillAddress)'
    },
    MscHistoryBillAddress: {
      COMPANY_NAME: '公司名称(companyName)',
      COMPANY_ADDRESS: '公司地址(companyAddress)',
      CITY: '城市(city)',
      CITY_NAME: '城市名称(cityName)',
      ZIP_CODE: '邮政编码(zipCode)',
      PHONE: '电话(phone)',
      FAX: '传真(fax)',
      CONTACT: '联系人(contact)',
      EMAIL: '电子邮件(email)',
      VIPCODE: 'VIP代码(vipCode)',
      INTTRACODE: 'Inttra代码(inttraCode)',
      MSCCODE: 'MSC代码(mscCode)',
      GROUPCODE: '公司代码(groupCode)',
      OTHER_INFORMATION: '其他信息(otherInformation)',
      BL_TITLE: '提单抬头(blTitle)',
      BL_ADDRESS: '提单地址(blAddress)',
      BL_CONTACT: '提单联系信息(blContact)',
      MscHistoryBillAddress: 'MSC提单地址历史信息表(MscHistoryBillAddress)'
    },
    IntelligentDocument: {
      FILE_NAME: '文件名(fileName)',
      FILE_TYPE: '文件类型(fileType)',
      FILE_SIZE: '文件大小(fileSize)',
      STATUS: '处理状态(status)',
      FILE_ID: '云存储ID(fileId)',
      RESULT_JSON: '解析结果(resultJson)',
      REMARK: '备注(remark)',
      CLIENT_REF_ID: '客户端唯一标识(clientRefId)',
      FILE_NO: '文件单号(fileNo)',
      JOB_UUID: '业务UUID(jobUuid)',
      JOB_NO: '业务编号(jobNo)',
      ANALYSIS_COMPLETE_DATE: '解析完成时间(analysisCompleteDate)',
      IntelligentDocument: 'IntelligentDocument(IntelligentDocument)'
    },
    StatusChangeHistory: {
      STATUS_TYPE: '状态类型(statusType)',
      STATUS_VALUE: '状态值(statusValue)',
      BUSINESS_DATA_ID: '业务ID(businessDataId)',
      REMARKS: '备注(remarks)',
      StatusChangeHistory: '状态修改记录(StatusChangeHistory)'
    },
    CargoBulkDetail: {
      INSIDE_QUANTITY: '小件数(insideQuantity)',
      WEIGHT: '重量(weight)',
      CUBAGE: '体积(cubage)',
      SIZE_LENGTH: '长(sizeLength)',
      SIZE_WIDTH: '宽(sizeWidth)',
      SIZE_HEIGTH: '高(sizeHeight)',
      CargoBulkDetail: '散杂货明细'
    },
    SpecialSeaEQ: {
      EQSIZE: '箱型(EQsize)',
      EQQUANTITY: '数量(EQquantity)',
      SIZE_LENGTH: '长(sizeLength)',
      SIZE_WIDTH: '宽(sizeWidth)',
      SIZE_HEIGHT: '高(sizeHeight)',
      SpecialSeaEQ: '特种箱箱型箱量(SpecialSeaEQ)'
    },
    TenantMessage: {
      MESSAGE_ID: '消息唯一ID号(messageId)',
      SENDER: '发送方ID(sender)',
      RECEIVER: '接收方ID(receiver)',
      SENDER_OFFICE: '发送方分公司(senderOffice)',
      RECEIVE_OFFICE: '接收方分公司(receiveOffice)',
      SNED_JOB_NO: '发送方业务编号(sendJobNo)',
      RECEIVE_JOB_NO: '接收方业务编号(receiveJobNo)',
      TYPE: '消息类型(type)',
      STATE: '消息状态(state)',
      SUMMARY: '摘要(summary)',
      SEND_DATE: '发送时间(sendDate)',
      RECEIVE_DATE: '接收时间(receiveDate)',
      TIMEOUT_DATE: '超时时间(timeoutDate)',
      PAYLOAD: '消息内容(payload)',
      SEND_USER: '发送人ID(sendUser)',
      RECEIVE_USER: '接收人ID(receiveUser)',
      TenantMessage: '跨tenant传递消息(tenantMessage)'
    },
    TenantMessageEvent: {
      TRIGGER_TIME: '触发时间(triggerTime)',
      NAME: '事件名(name)',
      STATE: '事件类型(state)',
      TenantMessageEvent: '跨tenant传递消息事件(tenantMessageEvent)'
    },
    SopType: {
      CODE: '类型代码(code)',
      CODE_CNAME: '类型中文名(codeCname)',
      CODE_ENAME: '类型英文名(codeEname)',
      LOB: '业务类型(lob)',
      LEVEL: '类型序号(level)',
      REMARK: '备注(remark)',
      NOTIFY: '是否通知(isNotify)',
      NOTIFY_EMAIL: '邮件通知(isNotifyEmail)',
      NOTIFY_SMS: '短信通知(isNotifySms)',
      BASE_LINE_TYPE: '基准时间类型(baseLineType)',
      OFFSET: '偏移时间(offset)',
      SopType: 'SOP类型配置(SopType)'
    },
    ManifestInfo: {
      SHIPPER_SHORT_CODE: '发货人代码缩写(shipperShortCode)',
      SHIPPER_ENTERPRISE_CODE: '发货人企业代码(shipperEnterpriseCode)',
      SHIPPER_ENTERPRISE_NAME: '发货人企业名称(shipperEnterpriseName)',
      SHIPPER_ADDRESS: '发货人详细地址(shipperAddress)',
      SHIPPER_CONTACTS_TYPE: '发货人联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      SHIPPER_CONTACTS: '发货人联系人(shipperContacts)',
      SHIPPER_CITY_NAME: '发货人城市名称(shipperCityName)',
      SHIPPER_PROVINCE_CODE: '发货人省份代码(shipperProvinceCode)',
      SHIPPER_PROVINCE_NAME: '发货人省份名称(shipperProvinceName)',
      SHIPPER_ZIP_CODE: '发货人邮政编码(shipperZipCode)',
      SHIPPER_COUNTRY_CODE: '发货人国家代码(shipperCountryCode)',
      SHIPPER_AEO_ENTERPRISE_CODE: '发货人AEO企业编码(shipperAeoEnterpriseCode)',
      CONSIGNEE_SHORT_CODE: '收货人代码缩写(consigneeShortCode)',
      CONSIGNEE_ENTERPRISE_CODE: '收货人企业代码(consigneeEnterpriseCode)',
      CONSIGNEE_ENTERPRISE_NAME: '发货人企业名称(consigneeEnterpriseName)',
      CONSIGNEE_ADDRESS: '收货人详细地址(consigneeAddress)',
      CONSIGNEE_CONTACTS_TYPE: '收货人联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      CONSIGNEE_CONTACTS: '收货人联系人(consigneeContacts)',
      CONSIGNEE_CITY_NAME: '收货人城市名称(consigneeCityName)',
      CONSIGNEE_PROVINCE_CODE: '收货人省份代码(consigneeProvinceCode)',
      CONSIGNEE_PROVINCE_NAME: '收货人省份名称(consigneeProvinceName)',
      CONSIGNEE_ZIP_CODE: '收货人邮政编码(consigneeZipCode)',
      CONSIGNEE_COUNTRY_CODE: '收货人国家代码(consigneeCountryCode)',
      CONSIGNEE_AEO_ENTERPRISE_CODE: '收货人AEO企业编码(consigneeAeoEnterpriseCode)',
      CONSIGNEE_SPECIFIC_CONTACTS_NAME: '收货人具体联系人名称(consigneeSpecificContactsName)',
      CONSIGNEE_SPECIFIC_CONTACTS_TYPE: '收货人具体联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      CONSIGNEE_SPECIFIC_CONTACTS: '收货人具体联系人(consigneeSpecificContacts)',
      NOTIFY_SHORT_CODE: '通知人代码缩写(notifyShortCode)',
      NOTIFY_ENTERPRISE_CODE: '通知人企业代码(notifyEnterpriseCode)',
      NOTIFY_ENTERPRISE_NAME: '通知人企业名称(notifyEnterpriseName)',
      NOTIFY_ADDRESS: '通知人详细地址(notifyAddress)',
      NOTIFY_CONTACTS_TYPE: '通知人联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      NOTIFY_CONTACTS: '通知人联系人(notifyContacts)',
      NOTIFY_CITY_NAME: '通知人城市名称(notifyCityName)',
      NOTIFY_PROVINCE_CODE: '通知人省份代码(notifyProvinceCode)',
      NOTIFY_PROVINCE_NAME: '通知人省份名称(notifyProvinceName)',
      NOTIFY_ZIP_CODE: '通知人邮政编码(notifyZipCode)',
      NOTIFY_COUNTRY_CODE: '通知人国家代码(notifyCountryCode)',
      NOTIFY_AEO_ENTERPRISE_CODE: '通知人AEO企业编码(notifyAeoEnterpriseCode)',
      INSTRUCT_BILL: '指示提单instructBill(instructBill)',
      CFM_STATE: '舱单状态(cfmState)',
      SO_NO: '关单号(soNo)',
      SHIPPER_ID: '发货人Id(shipperId)',
      CONSIGNEE_ID: '收货人Id(consigneeId)',
      NOTIFY_ID: '通知人Id(notifyId)',
      ManifestInfo: '舱单数据格式化(ManifestInfo)'
    },
    ManifestGoodsInfo: {
      SO_NO: '关单号(soNo)',
      EQSIZE: '箱型EQsize',
      CONTAINERNO: '箱号containerNo',
      SEALNO: '封号sealNo',
      CARGO_ENGLISH_NAME: '英文品名(cargoEnglishName)',
      HSCODE: 'HS Code(HSCODE)',
      QUANTITY: '件数(quantity)',
      WEIGHT: '重量(weight)',
      CUBAGE: '体积(cubage)',
      PACKING: '包装(packing)',
      MARK: '唛头(mark)',
      DNGR_CLASS_NO: '危险货物类别(danClassNo)',
      DNGR_UNNO: '联合国编号(danUNNo)',
      EDI_STATUS: 'EDI发送以及处理状态,0:未发送,1:已发送,2:已成功,3:已失败,3:未发送,4:修复成功',
      ManifestGoodsInfo: '舱单格式化货物信息'
    },
    ManifestVGMInfo: {
      SO_NO: '关单号(soNo)',
      EQSIZE: '箱型EQsize',
      CONTAINERNO: '箱号containerNo',
      SEALNO: '封号sealNo',
      VGM_WEIGHT: '总量(VGMWeight)',
      VGM_WEIGHTING_MEOTHD: '称重方式(VGMWeightingMeothd)',
      VGM_LIABILITY_COMPANY: 'VGM责任公司(VGMLiabilityCompany)',
      VGM_AUTOGRAPH: 'VGM签名(VGMAutoGraph)',
      CONTACT_EMAIL: 'VGM邮箱(contactEmail)',
      GROSS_WEIGHT: '箱皮重(grossWeight)',
      TELEPHONE: '电话(telephone)',
      WEIGHING_ADDRESS: '称重地址(weighingAddress)',
      ManifestVGMInfo: '舱单格式化VGM信息'
    },
    ContainerUsageTostaskstatus: {
      IDS: '任务方的唯一id',
      ORG_ROOT: '所属机构号',
      ORG_CODE: '顶级机构号',
      ACTIONS: '数据动作，每次推送必有，action的值必须为，add（添加）、update（更新）、del（删除）',
      REMARK: '备注',
      ORDER_NO: '业务编号',
      TASK_CODE: '任务号',
      POST_LINE_NAME: '任务线路',
      POST_LINE_CODE: '线路编码',
      START_TIME: '计划发车时间',
      G_START_TIME: '实际开始时间',
      START_DELAY: '发车延误 秒',
      END_TIME: '计划到达时间',
      G_ARRIVE_TIME: '实际到达时间',
      ARRIVE_DELAY: '到达延误 秒',
      PLAN_DISTANCE: '计划总里程',
      TOTAL_DISTANCE: '实际总里程',
      RUN_TIME: '运行时间 秒',
      G_RUN_TIME: '实际运行时间 秒',
      RUN_DELAY: '运行延误 秒',
      EVENTS: '异常事件数目',
      RESPONSIBILITY: '延误有责: 0无；1有',
      RESPONSIBLE_TIME: '有责时长 秒',
      AUDITOR: '审核人',
      IS_AUDITED: '是否审核：0、否，1、是，2申诉状态',
      AUDIT_TIME: '审核时间',
      CUSTOME: '客户名称',
      IN_HAVEN_TIME: '进始发站时间',
      START_POINT: '始发地',
      START_POINT_CODE: '始发地编码',
      END_POINT: '到达地',
      END_POINT_CODE: '到达地编码',
      CAR_NUM: '车牌号',
      TRUCK_ID: '车辆id',
      GPS_NO: '设备号',
      DRIVER_NAME: '任务司机',
      DRIVER_PHONE: '司机电话',
      CARRIAGE_TYPE: '运费类型',
      POSTLINE_TYPE: '线路类型',
      IS_EXCEPTION: '完成异常',
      FINE_AMOUNT: '罚款金额',
      JSON_LOG: 'json报文记录',
      ContainerUsageTostaskstatus: 'tos任务状态'
    },
    ContainerUsageToslocation: {
      CODE: '编号',
      MESSAGE: '消息',
      EVENT: '事件类型',
      PUSH_TIME: '推送时间',
      RECEIVE_ORG_CODE: '接收数据的机构号',
      PLATE_NUM: '车牌号',
      COURSE: '方向角',
      IMEI: '设备终端号',
      LAT: '纬度',
      LNG: '经度',
      SPEED: '速度',
      TIME: '定位时间',
      JSON_LOG: 'json报文记录',
      ContainerUsageToslocation: 'tos定位数据'
    },
    ContainerUsageTostasktime: {
      IDS: '任务方的唯一id',
      ORG_ROOT: '顶级机构号',
      ORG_CODE: '所属机构号',
      ACTIONS: '数据动作，每次推送必有，action的值必须为，add（添加）、update（更新）、del（删除）',
      TASK_ID: '任务id',
      TASK_CODE: '任务编码',
      ORDER_NO: '站点顺序',
      SITE_ID: '站点id',
      SITE_NAME: '站点名',
      IN_TIME: '计划进场时间',
      G_IN_TIME: '实际进场时间',
      OUT_TIME: '计划出发时间',
      G_OUT_TIME: '实际出发时间',
      RUN_TIME: '计划运行时长 秒',
      G_RUN_TIME: '实际运行时长 秒',
      PLAN_DISTANCE: '计划里程,单位米',
      TOTAL_DISTANCE: '实际里程,单位米',
      JSON_LOG: 'json报文记录',
      ContainerUsageTostasktime: 'tos任务时效数据'
    },
    ContainerUsageTosevents: {
      IDS: '事件id',
      ORG_ROOT: '顶级机构号',
      ORG_CODE: '所属机构号',
      ACTIONS: '数据动作，每次推送必有，action的值必须为，add（添加）、update（更新）、del（删除）',
      TASK_ID: '这个事件绑定的任务id，创建任务的时候tos 会返回',
      TASK_CODE: '这个事件绑定的任务编码',
      LAT: '事件开始的纬度',
      LNG: '事件开始的经度',
      STATUS: '时间状态，0事件开始，1事件结束，2单次事件（无开始和结束）',
      ELAT: '事件结束的纬度,当status不为1的时候此字段无效',
      ELNG: '事件结束的经度,当status不为1的时候此字段无效',
      EVENT_TYPE: '事件类型，offline：离线，problem：异常停车，slow：缓行，late_leave：晚发预警，late_arrive：晚到预警，path_offset：线路偏移，late_out：晚发报警',
      GPS_NO: '设备号',
      CAR_NUM: '车牌号',
      DRIVER_NAME: '司机姓名',
      DRIVER_PHONE: '司机手机号',
      EVENT_ADDR: '事件发生地址',
      S_TIME: '事件开始时间戳',
      EVENT_TIME: '事件发生事件戳',
      E_TIME: '事件结束时间戳，当status不为1的时候此字段无效',
      C_TIME: '事件创建时间戳',
      U_TIME: '事件修改事件戳',
      IS_HANDLE: '事件是否处理了，1：是，0否',
      PATH_ID: '线路偏移的id',
      IS_CHECK: '事件是否审核了，1：是，0否',
      IS_APPEAL: '事件是否申诉了，1：是，0否',
      MILE: '事件持续里程,单位米，当status不为1的时候此字段无效',
      PHOTO: '如果存在此字段则是增量的照片列表:[{id:唯一id（用于修改、删除）,url:照片地址，ctime:创建时间戳},............]',
      DETAIL: '增量推送,处理过程[{id:唯一id（用于更新）,etype:类型，ctime:创建时间戳,min:免责时长，-1 未知，0全责,大于0为免责时间，单位分,resp:是否有责，1无，2 部分有责，3全责},............]',
      MINS: '免责时长，-1 未知，0全责,大于0为免责时间，单位分，仅当事件problem：异常停车，slow：缓行,path_offset：线路偏移,traffic:拥堵事件有效',
      JSON_LOG: 'json报文记录',
      ContainerUsageTosevents: 'tos事件推送'
    },
    SopEmailReceiver: {
      PUSH_OBJECT: '推送对象(pushObject)',
      RECEIVING_MODE: '接收方式(receivingMode)',
      NAME: '姓名(name)',
      PUSH_NODE: '推送节点(pushNode)',
      EMAIL: '邮箱(email)',
      PHONE: '电话(phone)',
      CMP_IDX: '合作伙伴标识(cmpId)',
      RELATION_ID: '关联业务(relationId)',
      SopEmailReceiver: 'sop邮件接收人(SopEmailReceiver)'
    },
    SopEmailRecord: {
      ORDER_NO: '流水号(orderNo)',
      TYPE: '类型(type)',
      PUSH_NODE: '推送节点(pushNode)',
      PUSH_OBJECT: '推送对象(pushObject)',
      PUSHING_CHANNEL: '推送渠道(pushingChannel)',
      PUSHING_RESULT: '推送结果(pushingResult)',
      RECEIVING_USER: '接收人(receivingUser)',
      RECEIVING_TXT: '内容描述(receivingTxt)',
      FILE_ID: '附件编号(fileId)',
      RELATION_ID: '关联业务(relationId)',
      MODIFY_DATE: '节点推送时间',
      SopEmailRecord: 'sop邮件推送记录(SopEmailRecord)'
    },
    TrackingTemplateConfig: {
      PUSH_OBJECT: '推送对象(pushObject)',
      PUSH_CHANNEL: '推送渠道(pushChannel)',
      TEMPLATE_TITLE: '模板主题(templateTitle)',
      PUSH_NODE: '推送节点(pushNode)',
      TEMPLATE_TEXT: '模板正文(templateText)',
      FILE_ID: '附件(fileId)',
      LOB: '业务类型(lob)',
      TRACKING_DETAIL_UUID: '关联状态详情(trackingDetailUuid)',
      TrackingTemplateConfig: '业务消息推送模板配置(TrackingTemplateConfig)'
    },
    RailwayExportJob: {
      HEADWAY_TAIL: '是否头程尾程',
      CONTAINER_LOAD_TYPE: '委托类型',
      TRANSPORT_TYPE: '运输类型',
      FULL_HALF: '全程/半程',
      TRANSPORT_LINE: '航线',
      DEPARTURE_STATION: '始发站',
      TRANSFER_STATION: '中转站',
      TRANSIT_STATION: '过境站',
      DESTINATION_STATION: '目的站',
      DESTINATION_COUNTRY: '目的国',
      PORT_AGENT: '口岸代理',
      FORWARDING_AGENT: '发运代理',
      PAYMENT_METHOD: '付款方式',
      DIFFPLACES_COLLABORATE: '是否异地协同',
      LOADINGPLACE_COMPANY: '装货地公司',
      SIGNBILLPLACE_COMPANY: '签单地公司',
      FULL_SHIPMENT: '是否全程出运',
      DISCHARGEPORT_COMPANY: '卸货港公司',
      DESTINATIONPORT_COMPANY: '目的港公司',
      TRANSFER: '是否中转',
      OPERATION_TIPS: '操作提示',
      LOADING_TERM: '装箱方式',
      SAILING_DAY: '航期/班期',
      CUSTOMS: '是否报关',
      COMERCIAL_INSPECTATION: '是否商检',
      HEATING: '是否薰蒸',
      SUB_TENANT_ID: '客户编号(subTenantId)',
      JOB_NO: '工作号(jobNo)',
      WAREHOUSE_NO: '进仓编号(warehouseNo)',
      CUSTOMER_REF_NO: '客户参考号(customerRefNo)',
      AGENTREFNO: '代理业务编号(agentRefNo)',
      MBL: 'MBL(mbl)',
      MBL_NO5: 'MBL_NO5(mblNo5)',
      RELATED_JOB: '公司往来关联号(relatedJob)',
      RELATED_JOB2: '联运编号(relatedJob2)',
      MBL_ONLY: '是否直发(mblOnly)',
      JOIN_FLAG: 'MBL并单标志(joinFlagMBL)',
      JOIN_FLAG_HBL: 'HBL并单标志(joinFlagHBL)',
      MASTER_FLAG: '拼箱主号标志(masterFlag)',
      CANCELLED: '是否取消(cancelled)',
      SALES_OFFICE: '销售公司(salesOffice)',
      SALES_DEPT: '销售部门(salesDepartment)',
      SALES_ID: '业务员(sales)',
      CSR_OFFICE: '客服公司(csrOffice)',
      CSR_DEPT: '客服部门(csrDepartment)',
      CSR_ID: '客服(csr)',
      OP_OFFICE: '操作公司(opOffice)',
      OP_DEPARTMENT: '操作部门(opDepartment)',
      OP_ID: '操作(op)',
      CUSTOMER_ID: '委托单位编码(customerId)',
      CUSTOMER_CONTACT: '联系人(customerContact)',
      CONTACT_TELEPHONE: '联系电话(contactTelephone)',
      CONTACT_FAX: '联系电传(contactFax)',
      DESIGNATION_AGENT: '指定代理(designationAgent)',
      DESTINATION_AGENT: '目的港代理(destinationAgent)',
      LOCAL_AGENT: '本地代理(localAgent)',
      MASTER_AGENT: '是否主代理(masterAgent)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      CUSTOMS_BROKER: '报关行(customsBroker)',
      DISCHARGING_PLACE: '发货地(dispatchingPlace)',
      DESTINATION_PLACE: '最终目的地(destinationPlace)',
      DESTINATION_PLACE_CODE: '最终目的地代码(destinationPlaceCode)',
      LOADING_PORT_CODE: '装货港代码(loadingPortCode)',
      DISCHARGING_PORT_CODE: '卸货港代码(dischargingPortCode)',
      DESTINATION_PORT_CODE: '目的港代码(destinationPortCode)',
      QUANTITY_CONTRACT: '委托货物件数(quantityContract)',
      WEIGHT_CONTRACT: '委托货物重量(weightContract)',
      CUBAGE_CONTRACT: '委托货物体积(cubageContract)',
      QUANTITY_ACTUAL: '实际货物件数(quantityActual)',
      WEIGHT_ACTUAL: '实际货物重量(weightActual)',
      CUBAGE_ACTUAL: '实际货物体积(cubageActual)',
      CHARGE_WEIGHT: '计费重量(chargeWeight)',
      CHARGE_CUBAGE: '计费体积(chargeCubage)',
      MEASUREMENTS: '货物尺寸(measurements)',
      CARGO_TYPE: '货物种类(cargoType)',
      PACKING: '包装(packing)',
      PAYMENT_TERM_MBL: '主单运费方式(paymentTermMBL)',
      PAYMENT_TERM_HBL: '分单运费方式(paymentTermHBL)',
      CARGO_CHINESE_NAME: '中文品名(cargoChineseName)',
      CARGO_ENGLISH_NAME: '英文品名(cargoEnglishName)',
      MARK: '唛头(mark)',
      CARRIER_ID: '承运人编号(carrierId)',
      CARRIER_AGENT_ID: '船代(carrierAgentId)',
      VESSEL: '船名(vessel)',
      VOYAGE_FLIGHT: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      JOB_STATE: '业务状态(jobState)',
      COMMISSION: '业务提成金额(commission)',
      REMARKS: '备注(remarks)',
      BUSINESS_DATE: '业务日期(businessDate)',
      LOB: '业务类型(lob)',
      SHUT_OUT: '是否退关(shutOut)',
      SATISFIED_REQUESTS: ' 满足的特殊要求(satisfiedRequests)',
      DC_OFFICE: '单证公司(dcOffice)',
      DC_DEPT: '单证部门(dcDepartment)',
      DC_ID: '单证(dc)',
      PONO: '项目编号(PONO)',
      AGENT_LEVEL: '代理等级(agentLevel)',
      CARGO_SOURCE: '货物来源(cargoSource)',
      CONTAINER_DESC: '货量描述(containerDesc)',
      TEU: 'teu',
      PROFIT: 'profit',
      WAREHOUSING: '是否仓储(warehousing)',
      LAND_TRANSPORTATION: '是否路运(landTransportation)',
      INTERNATIONAL: '是否国际运输(international)',
      MULTIPLE_PICKUPS: '是否多次派车(multiplePickups)',
      ADVANCE: '是否垫付(advance)',
      BLOCKED: '是否等待特批(blocked)',
      EXPRESS: '是否是快递(express)',
      DECLARE_CUSTOMS_STATE: '报关状态(declareCustomsState)',
      WAREHOUSE_NO_FORMAT: '进仓编号格式化(warehouseNoFormat)',
      SHIPPER_ID: '发货人Id(shipperId)',
      CONSIGNEE_ID: '收货人Id(consigneeId)',
      NOTIFY_ID: '通知人Id(notifyId)',
      PREVERIFY_STATE: '预审核状态(preverifyState)',
      TRUST_FROM_JOB: '委托来源关联号(trustFromJob)',
      SIGN_MBL: '是否签发主单(signMBL)',
      SIGN_HBL: '是否签发分单(signHBL)',
      ESTIMATE_ACCOUNTS_RECEIVABLE: '预估收入(EstimateAccountsReceivable)',
      ESTIMATE_ACCOUNTS_PAYABLE: '预估成本(EstimateAccountsPayable)',
      ESTIMATE_GROSS_PROFIT: '预估利润(EstimateGrossProfit)',
      SHIPPER_CODE: '发货人代码(shipperCode)',
      SHIPPER_LINE1: '发货人(shipperLine1)',
      SHIPPER_LINE2: '发货人(shipperLine2)',
      SHIPPER_LINE3: '发货人(shipperLine3)',
      SHIPPER_LINE4: '发货人(shipperLine4)',
      SHIPPER_LINE5: '发货人(shipperLine5)',
      SHIPPER_LINE6: '发货人(shipperLine6)',
      SHIPPER_LINE7: '发货人(shipperLine7)',
      CONSIGNEE_CODE: '收货人代码(consigneeCode)',
      CONSIGNEE_LINE1: '收货人(consigneeLine1)',
      CONSIGNEE_LINE2: '收货人(consigneeLine2)',
      CONSIGNEE_LINE3: '收货人(consigneeLine3)',
      CONSIGNEE_LINE4: '收货人(consigneeLine4)',
      CONSIGNEE_LINE5: '收货人(consigneeLine5)',
      CONSIGNEE_LINE6: '收货人(consigneeLine6)',
      CONSIGNEE_LINE7: '收货人(consigneeLine7)',
      NOTIFY_CODE: '通知人代码(notifyCode)',
      NOTIFY_LINE1: '通知人(notifyLine1)',
      NOTIFY_LINE2: '通知人(notifyLine2)',
      NOTIFY_LINE3: '通知人(notifyLine3)',
      NOTIFY_LINE4: '通知人(notifyLine4)',
      NOTIFY_LINE5: '通知人(notifyLine5)',
      NOTIFY_LINE6: '通知人(notifyLine6)',
      NOTIFY_LINE7: '通知人(notifyLine7)',
      ALSO_NOTIFY: '第二通知人(alsoNotify)',
      BOOKING_REFUSE_NOTE: '拒绝订舱理由(bookingRefuseNote)',
      CUSTOMS_DATE: '报关日期(customsDate)',
      CUSTOMS_REMARKS: '报关备注(customsRemarks)',
      DNGR_HS_CODE: 'HS Code(HSCODE)',
      OPERATION_CONTENT: '操作要求说明(operationContent)',
      SITUATION: '情况说明(situation)',
      ATD: 'ATD',
      CHECK_DATA: '已核对数据(checkData)',
      VIRTUAL_HBL: '是否形式分单(virtualHBL)',
      RECEIVABLE_STATE: '应收状态(receivableState)',
      PAYABLES_STATE: '应付状态(payablesState)',
      PRICE_NO: '运价No(priceNo)',
      BOOKING: '是否订舱(booking)',
      PRICE_TIER: '运价等级(priceTier)',
      SELF_DELIVER: '是否自拉自送(selfDeliver)',
      BOOKING_STATE: '订舱状态(bookingState)',
      ITM_SERVICE: '是否有外贸(ITMService)',
      CUSTOMS_JOB_NO: '报关关联号(customsJobNo)',
      CUSTOM_JOB_TYPE: '客户自定义业务种类(customJobType)',
      PREVERIFIER: '预审审核人(preverifier)',
      PREVERIFY_DATE: '预审审核时间(preverifyDate)',
      SALE_PRICE: '是否特价(salePrice)',
      SALE_PRICE_REMARKS: '特价备注(salePriceRemarks)',
      SALES_CHANNEL: '订舱渠道(salesChannel)',
      DEPOSIT_RECEIVED: '预付款(depositReceived)',
      CONTACT_EMAIL: '联系邮件(contactEmail)',
      PROVISIONED: '已计提(provisioned)',
      PROVISIONED_DATE: '计提时间(provisionedDate)',
      PROVISIONED_BY: '计提人(provisionedBy)',
      PLANNER: '航线(planner)',
      PLANNER_DEPARTMENT: '航线部门(plannerDepartment)',
      RIVER_CARRIER_ID: '江船公司(riverCarrierId)',
      TRADE_TERM: '贸易方式(tradeTerm)',
      OVERSEA_OP_DEPARTMENT: '外海操作部门(overseaOpDepartment)',
      OVERSEA_OP: '海外操作(overseaOp)',
      USER_DEFINED_FIELD_1: '自定义字段1(userDefinedField1)',
      USER_DEFINED_FIELD_2: '自定义字段2(userDefinedField2)',
      USER_DEFINED_FIELD_3: '自定义字段3(userDefinedField3)',
      MANAGE_AUDIT_REMARK: '审核备注(manageAuditRemark)',
      MANAGE_AUDIT_REJECT_REMARK: '审核拒绝备注(manageAuditRejectRemark)',
      MANAGE_AUDIT_STATUS: '主管审核状态(manageAuditStatus)',
      SUBMITTER_USER: '提交人(submitterUser)',
      AUDIT_CHECK_NODE: '提交审核节点(auditCheckNode)',
      TYPE_HBL: '分单类型(typeHBL)',
      TYPE_MBL: '主单类型(typeMBL)',
      IF_PUSH_SOP_M: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      IF_PUSH_SOP_Z: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      IF_PUSH_SOP_Q: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      IF_PUSH_SOP: '是否确认推送SOP信息(ifPushSop)',
      CHANGE_STATE: '改单状态(changeState)',
      CARGO_SALES_ID: '揽货销售(cargoSalesId)',
      CHANGE_BY: '改单人(changeBy)',
      CHANGE_DATE: '改单时间(changeDate)',
      CLOSINGACCOUNT_STATUS: '结转状态(closingAccountStatus)',
      FIRST_PROVISIONED_DATE: '首次计提时间(firstProvisionedDate)',
      FIRST_PROVISIONED_PROFIT: '首次提成利润(firstProvisionedProfit)',
      PROVISIONED_PROFIT: '累计提成利润(provisionedProfit)',
      PROVISIONED_STATUS: '计提状态(provisionedStatus)',
      SALES_REQUIRE: '销售要求(salesRequire)',
      USER_DEFINED_FIELD_4: '自定义字段4(userDefinedField4)',
      VESSEL_PORT_AREA: '港区船名(vesselPortArea)',
      VOYAGE_FLIGHT_PORT_AREA: '港区航次(voyageFlightPortArea)',
      CUSTOMER_TENANT_ID: '委托单位所属tenantId(customerTenantId)',
      CUSTOMER_TENANT_NAME: '委托单位所属tenantName(customerTenantName)',
      RailwayExportJob: '铁路出口工作单(RailwayExportJob)'
    },
    RailwayHeadwayTail: {
      HEADWAY_TAIL: '头程/尾程',
      TRANSPORT_METHOD: '运输方式',
      TRANSPORT_COMPANY: '运输公司',
      REGION: '国家',
      PROVINCE: '省',
      CITY: '市',
      DISTRICTS: '区',
      ADDRESS: '详细信息',
      CONTACT: '门点联系人',
      TELEPHONE: '电话',
      REMARKS: '备注',
      RailwayHeadwayTail: '铁路出口头程尾程(RailwayHeadwayTail)'
    },
    RailwayContainer: {
      EQSIZE: '箱型',
      EQTYPE: '箱种',
      CONTAINERNO: '箱号',
      UNIT_PRICE: '单价',
      CONTAINER_STATUS: '箱子状态',
      CONTAINER_ASCRIPTION: '箱属',
      JOB_NO: '关联业务编号',
      JOB_UUID: '关联业务',
      CONTAINER_UUID: '关联箱',
      CURRENCY_CODE: '币种',
      ORDER_UUID: '关联订单',
      RailwayContainer: '箱管-明细(RailwayContainer)'
    },
    RailwayContainerOrder: {
      ORDER_NO: '流水号',
      SELLER_ID: '箱主/卖家编号',
      SELLER_NAME: '箱主/卖家中文',
      BUYER_ID: '箱主/买家编号',
      BUYER_NAME: '箱主/买家中文',
      CURRENCY_CODE: '币种',
      ORDER_TYPE: '订单类型',
      AMOUNT: '订单金额',
      IF_SETTLEMENT: '是否结算',
      SETTLEMENT_DATE: '结算时间',
      BUYER_DATE: '买箱时间',
      SELLER_DATE: '卖箱时间',
      RENT_DATE: '起租时间',
      RETURN_DATE: '退还时间',
      RailwayContainerOrder: '箱管-订单(RailwayContainerOrder)'
    },
    RailwayReturnBox: {
      CONTAINERNO: '箱号',
      JOB_NO: '关联业务编号',
      JOB_UUID: '箱主/买家中文',
      CONTAINER_UUID: '关联箱',
      RETURN_BOX_USER: '还箱人',
      RETURN_BOX_OPERATION_TIME: '还箱操作时间',
      RETURN_BOX_TIME: '还箱时间',
      RailwayReturnBox: '箱管-还箱(RailwayReturnBox)'
    },
    Charge: {
      CHARGE_ID: '费用ID(chargeId)',
      CHARGEITEMID: '费用名称代码(chargeItemId)',
      ACCOUNT_RECEIVABLE: '收支类型(receivable)',
      OVERSEA: '国内国外(oversea)',
      ADJUSTMENT: '是否调整费用(adjustment)',
      SHARED: '是否分摊费用(shared)',
      SHARE_SCHEME: '分摊类型(shareScheme)',
      SHAREREFNO: '分摊关联编号(shareRefNo)',
      COMMISSION: '是否佣金(commission)',
      ADVANCE: '是否垫付(advance)',
      PREPAID: '是否托收拆分(prepaid)',
      PAID_OFF: '已付清(paidOff)',
      COLLECTION: '已转入托收(collection)',
      RELATED_ID: '内结费用编号(relatedId)',
      ACCOUNT_ID: '结算单位代码(accountId)',
      INVOICE_TITLE: '发票抬头(invoiceTitle)',
      CURRENCY: '币种(currency)',
      MEASURE: '单位类型(measure)',
      QUANTITY: '数量(quantity)',
      UNIT_RATE: '单价(unitRate)',
      AMOUNT: '金额(amount)',
      VERIFIED_AMOUNT: '已核销金额(verfiedAmount)',
      EXCHANGE_RATE: '汇率(exchangeRate)',
      BILL_NO: '帐单号(billNo)',
      COUNTER_PARTY_BILLING_NO: '对方账单号(counterPartyBillingNo)',
      PAYMENT_NO: '付款审批号(paymentNo)',
      INVOICE_NO: '发票号/税金号(invoiceNo)',
      VOUCHER_NO: '财务接口编号(voucherNo)',
      CONTAINER_NO: '箱号(containerNo)',
      INPUT_BY: '录入人(inputBy)',
      INPUT_DATE: '录入日期(inputDate)',
      AUDITOR: '审核人(auditor)',
      AUDIT_DATE: '审核日期(auditDate)',
      ACCOUNTING_DATE: '财务日期(accountingDate)',
      CLEARING_DATE: '销账日期(clearingDate)',
      PAY_RECEIVE_DATE: '最后收付日期(payReceiveDate)',
      REMARKS: '备注(remarks)',
      INPUT_BY_DEP: '录入人部门(inputByDep)',
      BRANCH_ID: '费用分公司(branchId)',
      TAX_RATE: '税率(taxRate)',
      TAX_AMOUNT: '税额(taxAmount)',
      EXCLUDING_TAX_AMOUNT: '不含税额(excludingTaxAmount)',
      CONTROLLED: '是否受控(controlled)',
      CHARGE_SOURCE: '费用来源(chargeSource)',
      CHARGE_STATE: '费用状态(chargeState)',
      CONFIRM_STATE: '确认状态(confirmState)',
      CONFIRM_DATE: '确认日期(confirmDate)',
      CONFIRM_USER: '费用确认人(confirmUser)',
      BILLING_AMOUNT: '对帐金额(billingAmount)',
      CONFIRM_REMARKS: '确认备注(confirmRemarks)',
      DIFFERENT_STATE: '差异调整状态(differentState)',
      INVOICE_AMOUNT: '开票金额(invoiceAmount)',
      INVOICE_EXCLUDING_TAX: '开票不含税额(invoiceExcludingTax)',
      INVOICE_TAX: '开票税额(invoiceTax)',
      OFFSET_STATE: '红冲状态(offsetState)',
      SERVICE_TYPE: '服务项目(serviceType)',
      CONTACT_PERSON: '联系人(ContactPerson)',
      PAYABLE: '是否可付款(payable)',
      PPCC: '预付到付(ppcc)',
      RELATED_MBL: '关联提单号(relatedMbl)',
      NEED_INVOICE: '是否需要开票(needInvoice)',
      PAYMENT_COMPANY: '来款单位(paymentCompany)',
      SERIAL_NUMBER: '序号(serialNumber)',
      BILLINGDATE: '账单日期(billingDate)',
      INVOICEDATE: '开票日期(invoiceDate)',
      BUSINESS_DATE: '业务日期(businessDate)',
      VOUCHER_JOB: '是否按业务生成凭证(voucherJob)',
      VOUCHER_BILLING: '是否按账单生成凭证(voucherBilling)',
      VOUCHER_INVOICE: '是否按发票生成凭证(voucherInvoice)',
      PROVISIONED_DATE: '计提时间(provisionedDate)',
      CLOSINGACCOUNT_EXCLUDING_TAX: '结转不含税额(closingAccountExcludingTax)',
      CLOSINGACCOUNT_TAX: '结转税额(closingAccountTax)',
      SPLIT_RELATION_KEY: '拆分关系(splitRelationKey)',
      SPECIAL: '是否特殊费用(special)',
      VOUCHER_DATE: '凭证日期(voucherDate)',
      TRUCK_ORDER_NO: '派车单号(TruckOrderNo)',
      TARGET_VOUCHER_NO: '对方凭证号(targetVoucherNo)',
      Charge: '费用(Charge)'
    },
    Billing: {
      BANKACCOUNT: '银行帐号(bankAccount)',
      SWIFT_CODE: 'swiftCode(swiftCode)',
      CLEARING_STATE: '核销状态(clearingState)',
      AGENTREFNO: '代理编号(agentRefNo)',
      BILLINGID: '账单序号(billingId)',
      BILLINGNO: '账单号(billingNo)',
      COUNTER_PARTY_BILLING_NO: '对方账单号(counterPartyBillingNo)',
      BILLINGTYPE: '账单类型(billingType)',
      AR: '账单收支(isAr)',
      STATE: '账单状态(state)',
      ACCOUNTID: '结算对象(accountId)',
      CONTACT: '结算对象联系人(contact)',
      CURRENCY: '币种(currency)',
      RATE: '汇率(rate)',
      CHARGE_CURRENCY1: '费用币种1(chargeCurrency1)',
      CHARGE_RATE1: '费用汇率1(chargeRate1)',
      CHARGE_CURRENCY2: '费用币种2(chargeCurrency2)',
      CHARGE_RATE2: '费用汇率2(chargeRate2)',
      AMOUNT: '金额(amount)',
      TAX_AMOUNT: '税额(taxAmount)',
      CURRENCY_AMOUNT: '分币种合计(currencyAmount)',
      BANK_ACCOUNT_ID: '银行帐号Id(bankAccountId)',
      INVOICEDEMAND: '开票要求(invoiceDemand)',
      TITLE: '开票抬头(title)',
      PERCENTAGE: '分成比例(percentage)',
      JOB_NO: '工作号(jobNo)1',
      MBL: '主单号(mbl)',
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      POD2: '目的港(pod2)',
      ETD: '开航日期(ETD)',
      ETA: '到港日期(ETA)',
      VOYAGE_FLIGHT: '船名航次(voyageFlight)',
      CONTAINER_SEAL: '箱封号(containerSeal)',
      TITLE_BRANCH_ID: '账单抬头分公司(titleBranchId)',
      BILLINGADDRESS: '账单地址(billingAddress)',
      REMARK: '账单备注(remark)',
      INPUTBY: '创建人(inputBy)',
      INPUT_BY_DEP: '创建人部门(inputByDep)',
      INPUTDATE: '创建日期(inputDate)',
      PRINT_DATE: '打印日期(printDate)',
      INVALIDBY: '作废人(invalidBy)',
      INVALIDDATE: '作废日期(invalidDate)',
      CANCELLATION_DETAILS: '作废细节(cancellationDetails)',
      BRANCH_ID: '分公司(branchId)',
      SALES: '销售(sales)',
      SOURCE_CURRENCY1: '原币种1(sourceCurrency1)',
      SOURCE_CURRENCY2: '原币种2(sourceCurrency2)',
      SOURCE_CURRENCY3: '原币种3(sourceCurrency3)',
      SOURCE_RATE1: '原币对目标币种汇率1(sourceRate1)',
      SOURCE_RATE2: '原币对目标币种汇率2(sourceRate2)',
      SOURCE_RATE3: '原币对目标币种汇率3(sourceRate3)',
      AMOUNT1: '原币转换的金额(amount1)',
      AMOUNT2: '原币转换的金额(amount2)',
      AMOUNT3: '原币转换的金额(amount3)',
      BUYER_TAX_ACCOUNT: '纳税人识别号(buyerTaxAccount)',
      BUYER_BANK: '开户银行(buyerBank)',
      BUYER_BANK_ACCOUNT: '银行帐号(buyerBankAccount)',
      BUYER_ADDRESS: '纳税人地址(buyerAddress)',
      BUYER_TELEPHONE: '电话(buyerTelephone)',
      MARK_USER: '标记人(markUser)',
      MARK_DATE: '标记时间(markDate)',
      MARK: '已标记(isMark)',
      SETTLEMENT_AGENT: '结算代理(settlementAgent)',
      SETTLEMENT_AGENT_ID: '结算代理ID(settlementAgentId)',
      Billing: '账单(Billing)'
    },
    BillingGroup: {
      BILLING_ID: '账单序号(billingId)',
      BILLING_NO: '账单号(billingNo)',
      COUNTER_PARTY_BILLING_NO: '对方账单号(counterPartyBillingNo)',
      BILLING_TYPE: '账单类型(billingType)',
      AR: '账单收支(isAr)',
      STATE: '账单状态(state)',
      ACCOUNT_ID: '结算对象(accountId)',
      CURRENCY: '币种(currency)',
      RATE: '汇率(rate)',
      AMOUNT: '金额(amount)',
      CURRENCY_AMOUNT: '分币种合计(currencyAmount)',
      BANK_ACCOUNT_ID: '银行帐号Id(bankAccountId)',
      INVOICE_DEMAND: '开票要求(invoiceDemand)',
      TITLE: '开票抬头(title)',
      TITLE_BRANCH_ID: '账单抬头分公司(titleBranchId)',
      BILLING_ADDRESS: '账单地址(billingAddress)',
      REMARK: '账单备注(remark)',
      INPUT_BY: '创建人(inputBy)',
      INPUT_BY_DEP: '创建人部门(inputByDep)',
      INPUT_DATE: '创建日期(inputDate)',
      BRANCH_ID: '分公司(branchId)',
      SALES: '销售(sales)',
      BUYER_TAX_ACCOUNT: '纳税人识别号(buyerTaxAccount)',
      BUYER_BANK: '开户银行(buyerBank)',
      BUYER_BANK_ACCOUNT: '银行帐号(buyerBankAccount)',
      BUYER_ADDRESS: '纳税人地址(buyerAddress)',
      BUYER_TELEPHONE: '电话(buyerTelephone)',
      BillingGroup: '对账单(BillingGroup)'
    },
    Invoice: {
      BATCH_NO: '发票批次号(batchNo)',
      VAT: '是否专用发票(VAT)',
      ACTIVE: '是否有效发票(active)',
      TAX: '是否已报税(TAX)',
      MERGED: '是否合并开票(merged)',
      MERGE_NO: '合并开票编号(mergeNo)',
      INVOICEID: '发票序号(invoiceId)',
      INVOICE_TYPE: '发票类型(invoiceType)',
      CLEARING_STATE: '核销状态(clearingState)',
      AR: '发票收支(isAr)',
      INVOICENO: '发票号(invoiceNo)',
      INVOICEDATE: '开票日期(invoiceDate)',
      ACCOUNTID: '结算对象(accountId)',
      TITLE: '发票抬头(title)',
      CURRENCY: '币种(currency)',
      AMOUNT: '发票金额(amount)',
      CHINEDEAMOUNT: '金额中文合计(chineseAmount)',
      RATE: '发票汇率(rate)',
      CHARGE_CURRENCY1: '费用币种1(chargeCurrency1)1',
      CHARGE_EXCHANGE_RATE1: '费用汇率1(chargeExchangeRate1)',
      CHARGE_CURRENCY2: '费用币种2(chargeCurrency2)',
      CHARGE_EXCHANGE_RATE2: '费用汇率2(chargeExchangeRate2)',
      INVOICEDEMAND: '开票要求(invoiceDemand)',
      REMARK: '发票备注(remark)',
      PRINTED: '是否打印(printed)',
      REVOKED: '是否作废(revoked)',
      REVOKEDBY: '发票作废人(revokedBy)',
      REVOKEDDATE: '发票作废日期(revokedDate)',
      INPUTBY: '发票创建人(inputBy)',
      INPUTDATE: '发票创建日期(inputDate)',
      INPUT_BY_DEP: '发票创建人部门(inputByDep)',
      BRANCH_ID: '分公司(branchId)',
      TAX_ACCOUNT: '纳税人识别号(taxAccount)',
      BANK: '银行名称(bank)',
      BANKACCOUNT: '银行帐号(bankAccount)',
      ADDRESS: '发票地址(address)',
      TELEPHONE: '电话(telephone)',
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      POD2: '目的港(pod2)',
      JOB_NO: '工作号(jobNo)',
      MBL: '主单号(mbl)',
      CUSTOMERREFNO: '客户编号(customerRefNo)',
      ETD: '开航日期(ETD)',
      ETA: '到港日期(ETA)',
      VESSEL_VOYAGE: '船名航次(vesselVoyage)',
      PARTCARGO: '货物拼接(partCargo)',
      PARTCHARGENAME: '费用名称拼接(partChargeName)',
      PARTQUANTITY: '拼接数量(partQuantity)',
      PARTUNITPRICE: '拼接单价(partUnitPrice)',
      PARTCURRENCY: '原币种拼接(partCurrency)',
      PARTAMOUNT: '原金额拼接(partAmount)',
      PARTAMOUNT2: '折算金额拼接(partAmount2)',
      EXCLUDING_TAX_AMOUNT: '不含税额(excludingTaxAmount)1',
      TAX_RATE: '税率(taxRate)',
      TAX_AMOUNT: '税额(taxAmount)',
      BUYER_TAX_ACCOUNT: '纳税人识别号(buyerTaxAccount)',
      BUYER_BANK: '银行名称(buyerBank)',
      BUYER_BANK_ACCOUNT: '银行帐号(buyerBankAccount)',
      BUYER_ADDRESS: '发票地址(buyerAddress)',
      BUYER_TELEPHONE: '电话(buyerTelephone)',
      PAYEE: '收款人(payee)',
      AUDITOR: '审核人(auditor)',
      EXPORT_TO_INTERFACE: '已导出(exportToInterface)',
      MERGE_TYPE: '拼票类型(mergeType)',
      INVOICE_STATE: '发票状态(invoiceState)',
      REMARK2: '发票备注2(remark2)',
      SELL_TITLE: '销货单位发票抬头(sellTitle)',
      VAL_INVOICE_CODE: '发票代码(valInvoiceCode)',
      MAKE_TYPE: '开票种类(0.纸质发票 1.电子发票)',
      SEND_STATUS: '电子发票发送状态(1.已发送 0.未发送)',
      DOWNLOADS: '客户下载次数(downloads)',
      WEB_PDF_URL: '金税PDF路径(webPdfUrl)',
      WEB_PDF_FILE: '金税PDF文件(webPdfFile)',
      RETURN_TAX_CODE: '金税结果代码(0000:下发成功,9999:下发失败)',
      RETURN_TAX_MSG: '金税结果描述(错误原因)',
      REVIEW: '是否复核(review)',
      REVIEW_DATE: '复核日期(reviewDate)',
      EXPORT_TO_GOLDEN_TAX: '金税是否已导出(exportToGoldenTax)',
      ACTUAL_RECEIPT_DATE: '实际收票日期(actualReceiptDate)',
      BERED_INVOICE_UUID: '被红冲发票UUID(beredInvoiceUuid)',
      CNNOTICE_NO: '专票红字通知单号(cnnoticeNo)',
      Invoice: '发票(Invoice)'
    },
    InvoiceItem: {
      LEVEL: '序号(level)',
      GOODS_NAME: '货物名称(goodsName)',
      DIMENSION: '规格型号(dimension)',
      UNIT: '单位(unit)',
      QUANTITY: '数量(quantity)',
      UNIT_RATE: '单价(unitRate)',
      AMOUNT: '金额(amount)',
      TAX_RATE: '税率(taxRate)',
      TAX_AMOUNT: '税额(taxAmount)',
      InvoiceItem: '发票项目(InvoiceItem)'
    },
    ConfirmBill: {
      CONFIRMBILLID: '费用确认单序号(confirmBillId)',
      ACCOUNTID: '结算对象(accountId)',
      CONTACT: '结算对象联系人(contact)',
      CURRENCY: '币种(currency)',
      AMOUNT: '金额(amount)',
      RATE: '汇率(rate)',
      REMARK: '备注(remark)',
      INVOICEDEMAND: '开票要求(invoiceDemand)',
      TITLE: '开票抬头(title)',
      BANK: '银行名称(bank)',
      BANKACCOUNT: '银行帐号(bankAccount)',
      INPUT_BY_DEP: '创建人部门(inputByDep)',
      INPUTBY: '创建人(inputBy)',
      INPUTDATE: '创建日期(inputDate)',
      BRANCH_ID: '分公司(branchId)',
      STATE: '费用确认单状态(state)',
      COMMIT_DATE: '提交开票申请日期(commitDate)',
      INVOICE_TYPE: '发票类型(invoiceType)',
      EXCLUDING_TAX_AMOUNT: '不含税额(excludingTaxAmount)',
      ConfirmBill: '费用确认单(ConfirmBill)'
    },
    BillPayment: {
      BILL_PAYMENT_ID: '付款审批单序号(billPaymentId)',
      BILLPAYMENTNO: '付款审批单号(billPaymentNo)',
      JOB_NO: '业务编号(jobNo)',
      YWTYPE: '业务类型(ywType)',
      SE: '包括海运出口(SE)',
      SI: '包括海运进口(SI)',
      AE: '包括空运出口(AE)',
      AI: '包括空运进口(AI)',
      PAYTYPE: '支付类型(payType)',
      ACCOUNTID: '支付对象(accountId)',
      SETTLEMENT_AGENT_ID: '结算代理(settlementAgentId)',
      CURRENCY: '币种(currency)',
      AMOUNT: '金额(amount)',
      RATE: '汇率(rate)',
      STATE: '状态(state)',
      DEADLINE: '付款期限(deadline)',
      REMARK: '备注(remark)',
      INPUTBY: '创建人(inputBy)',
      INPUT_BY_DEP: '创建人部门(inputByDep)',
      INPUTDATE: '创建日期(inputDate)',
      BRANCH_ID: '分公司(branchId)',
      CLEARING_STATE: '核销状态(clearingState)',
      COST_INVOICE_NO: '供应商发票号(costInvoiceNo)',
      CHINEDEAMOUNT: '金额中文合计(chineseAmount)',
      ADVANCE: '是否垫付(advance)',
      CUSTOMER_ID: '客户ID(customerId)',
      BUSINESS_VERIFIER: '业务审核人(businessVerifier)',
      BUSINESS_VERIFY_DATE: '业务审核日期(businessVerifyDate)',
      FINANCE_VERIFIER: '财务审核人(financeVerifier)',
      FINANCE_VERIFY_DATE: '财务审核日期(financeVerifyDate)',
      CURRENCY_AMOUNT: '分币种合计(currencyAmount)',
      BUYER_BANK: '开户银行(buyerBank)',
      BUYER_BANK_ACCOUNT: '银行帐号(buyerBankAccount)',
      BillPayment: '付款审批(BillPayment)'
    },
    ClearHistory: {
      ACCOUNTID: '结算对象(accountId)',
      AR: '是否应收(isAr)',
      JOBNO: '费用业务编号(jobNo)',
      INVOICENO: '费用发票号(invoiceNo)',
      BILLINGNO: '海外账单号(billingNo)',
      PAYMENTNO: '付款审批单号(paymentNo)',
      CURRENCY: '原始费用币种(chargeCurrency)',
      CLEARCURRENCY: '核销币种(actualCurrency)',
      CONFIRM_STATE: '结款确认状态(confirmState)',
      NOTIFIER: '通知人(notifier)',
      NOTIFY_DATE: '通知日期(notifyDate)',
      CONFIRMER: '确认人(confirmer)',
      CONFIRM_DATE: '确认日期(confirmDate)',
      RATE: '费用汇率(rate)',
      AMOUNT: '本次核销原始金额(amount)',
      CLEARRATE: '核销汇率(clearRate)',
      CLEARAMOUNT: '本次核销实收金额(actualAmount)',
      CLEARREMARK: '备注(clearRemark)',
      BRANCH_ID: '分公司(branchId)',
      VERIFICATIONBY: '核销人(verificationBy)',
      VERIFICATION_BY_DEP: '核销人部门(verificationByDep)',
      VERIFICATIONDATE: '核销日期(verificationDate)',
      CLEAR_ID: '核销序号(clearId)',
      PAYMENT_AMOUNT: '收付金额(paymentAmount)',
      DIFFCHANGE: '汇兑损益(diffChange)',
      FINANCIAL_COST: '财务费用(financialCost)',
      CLEARODD: '零头短账(clearOdd)',
      WRITEOFF_SEQ_NO: '核销批次号(writeoffSeqNo)',
      VOUCHER: '是否生成凭证(isVoucher)',
      VOUCHER_DATE: '凭证日期(voucherDate)',
      TARGET_VOUCHER_NO: '对方凭证号(targetVoucherNo)',
      ClearHistory: '核销历史(ClearHistory)'
    },
    ActualAmount: {
      REMAINAMOUNT: '余额(remainAmount)',
      AR_INCLUDED: '是否含应收费用(isArIncluded)',
      AP_INCLUDED: '是否含应付费用(isApIncluded)',
      VOUCHER: '是否导财务(isVoucher)',
      VOUCHERNO: '财务凭证号(voucherNo)',
      VOUCHERDATE: '导财务日期(voucherDate)',
      RECONCILIATION: '是否船公司托收(Reconciliation)',
      ADVANCE: '是否垫付(advance)',
      OVERSEA: '国内国外(oversea)',
      VERIFICATIONBY: '核销人(verificationBy)',
      VERIFICATION_BY_DEP: '核销人部门(verificationByDep)',
      VERIFICATIONDATE: '核销日期(verificationDate)',
      ACTUAL_AMOUNT_ID: '实际收付序号(actualAmountId)',
      ACTUALAMOUNTNO: '实际收付编号(actualAmountNo)',
      STATE: '实际收付状态(state)',
      AR: '是否实收(isAr)',
      ACCOUNTID: '结算对象(accountId)',
      SETTLEMENT_AGENT_ID: '结算代理(settlementAgentId)',
      PAYMENT_COMPANY: '付款单位(paymentCompany)',
      CURRENCY: '币种(currency)',
      RATE: '汇率(rate)',
      AMOUNT: '收付金额(amount)',
      DIFFCHANGE: '汇兑损益(diffChange)',
      FINANCIAL_COST: '财务费用(financialCost)',
      CLEARODD: '零头短账(clearOdd)',
      VERFIED_AMOUNT: '已核销金额(verfiedAmount)',
      TYPE: '收付方式(type)',
      BANK_WATER_NO: '银行水单号(bankWaterNo)',
      COMPANYBANK: '对方银行(companyBank)',
      COMPANYBANKACCOUNT: '对方银行帐号(companyBankAccount)',
      OURBANK: '我方银行(ourBank)',
      OURBANKACCOUNT: '我方银行帐号(ourBankAccount)',
      PAY_RECEIVE_DATE: '收付日期(payReceiveDate)',
      CHARGE_CURRENCY1: '费用币种1(chargeCurrency1)2',
      CHARGE_EXCHANGE_RATE1: '费用汇率1(chargeExchangeRate1)',
      CHARGE_CURRENCY2: '费用币种2(chargeCurrency2)',
      CHARGE_EXCHANGE_RATE2: '费用汇率2(chargeExchangeRate2)',
      REMARK: '备注(remark)',
      BRANCH_ID: '分公司(branchId)',
      PREPAY: '预收预付(prepay)',
      APPROVED_STATE: '审核状态(approvedState)',
      APPROVED_BY: '审核人(approvedBy)',
      DATE_APPROVED: '审核日期(dateApproved)',
      CASH_TRANSFER_STATE: '水单状态(cashTransferState)',
      WRITEOFF_SEQ_NO: '核销批次号(writeoffSeqNo)',
      BANK_SLIP: '是否水单(isBankSlip)',
      RELEASE_STATE: '发布状态(releaseState)',
      BANK_SLIP_STATE: '认领状态(bankSlipState)',
      PRE_AMOUNT: '预收款金额(preAmount)',
      PRE_BANK_SLIP_STATE: '预收款状态(preBankSlipState)',
      PRE_PAYMENT: '是否预收(isPrePayment)',
      RETURN_AMOUNT: '退回金额(returnAmount)',
      BANK_SLIP_RECEIVE_BY: '认领人(bankSlipReceiveBy)',
      RED_PUNCH_ACTUAL_AMOUNT_UUID: '红冲费用记录UUID(redPunchActualAmountUuid)',
      ActualAmount: '实际收付(ActualAmount)'
    },
    DismatchedAmount: {
      ID: '序号(Id)',
      STATE: '未核销预收款状态(state)',
      PAYMENT_COMPANY: '付款单位(paymentCompany)',
      CURRENCY: '币种(currency)',
      AMOUNT: '未核销预收款金额(amount)',
      RATE: '汇率(rate)',
      TYPE: '收款方式(type)',
      BANK_WATER_NO: '银行水单号(bankWaterNo)',
      COMPANY_BANK: '对方银行(companyBank)',
      COMPANY_BANK_ACCOUNT: '对方银行帐号(companyBankAccount)',
      OUR_BANK: '我方银行(ourBank)',
      OUR_BANK_ACCOUNT: '我方银行帐号(ourBankAccount)',
      REMARK: '备注(remark)',
      PAY_RECEIVE_DATE: '收付日期(payReceiveDate)',
      VERIFICATION_BY: '核销人(verificationBy)',
      VERIFICATION_DATE: '核销日期(verificationDate)',
      INPUT_BY: '创建人(inputBy)',
      INPUT_BY_DEP: '创建人部门(inputByDep)',
      INPUT_DATE: '创建日期(inputDate)',
      BRANCH_ID: '分公司(branchId)',
      DismatchedAmount: '未核销预收款(DismatchedAmount)'
    },
    BankActualAmount: {
      BANKACTUAL_AMOUNT_ID: '银行记账序号(bankactualAmountId)',
      WATER_NO: '银行水单号(waterNo)',
      PAYMENT_COMPANY: '收付款单位(paymentCompany)',
      CURRENCY: '币种(currency)',
      AMOUNT: '银行记账金额(amount)',
      AR: '是否应收(isAr)',
      TYPE: '收付方式(type)',
      COMPANY_BANK: '对方银行(companyBank)',
      COMPANY_BANK_ACCOUNT: '对方银行帐号(companyBankAccount)',
      OUR_BANK: '我方银行(ourBank)',
      OUR_BANK_ACCOUNT: '我方银行帐号(ourBankAccount)',
      REMARK: '记账备注(remark)',
      PAY_RECEIVE_DATE: '收付日期(payReceiveDate)',
      INPUT_BY: '记账人(inputBy)',
      VERIFICATION_DATE: '记账日期(verificationDate)',
      BRANCH_ID: '分公司(branchId)',
      BankActualAmount: '银行记账(BankActualAmount)'
    },
    ClosingAccount: {
      BRANCH_ID: '关帐分公司(branchId)',
      INPUT_BY: '关帐人(inputBy)',
      CLOSING_DATE: '关帐日期(closingDate)',
      VERIFIED_BY: '审核人(verifiedBy)',
      VERIFY_DATE: '审核日期(verifyDate)',
      ClosingAccount: '关帐(ClosingAccount)'
    },
    ActualMailHistory: {
      BRANCH_ID: '分公司(branchId)',
      ACCOUNT_ID: '结算单位代码(accountId)',
      CURRENCY: '币种(currency)',
      AMOUNT: '金额(amount)',
      REMITTANCE: '汇费(remittance)',
      EXCHANGE_DIFF: '汇差(exchangeDiff )',
      STATE: '邮件发送状态(state)',
      SEND_DATE: '发送日期(senddate)',
      SEND_NO: '发送编号(sendNo)',
      ActualMailHistory: '海外结算邮件历史(ActualMailHistory)'
    },
    PurchaseInvoiceRecords: {
      INVOICE_TYPE: '发票类型(invoiceType)',
      START_INVOICE_NO: '开始号码(startInvoiceNo)',
      END_INVOICE_NO: '结束号码(endInvoiceNo)',
      QUANTITY: '购买份数(quantity)',
      PURCHASER: '购买人(purchaser)',
      PURCHASING_DATE: '购买时间(purchasingDate)',
      BRANCH_ID: '分公司(branchId)',
      PurchaseInvoiceRecords: '购买发票记录(PurchaseInvoiceRecords)'
    },
    InvoiceNo: {
      INVOICE_TYPE: '发票类型(invoiceType)',
      INVOICE_NO: '发票号(invoiceNo)',
      INVOICE_STATE: '发票状态(invoiceState)',
      ABANDONER: '作废人(abandoner)',
      ABANDONING_DATE: '作废时间(abandoningDate)',
      USER: '使用人(user)',
      USING_DATE: '使用时间(usingDate)',
      BRANCH_ID: '分公司(branchId)',
      InvoiceNo: '发票号(InvoiceNo)'
    },
    RecipientsInvoiceRecords: {
      INVOICE_TYPE: '发票类型(invoiceType)',
      QUANTITY: '领用份数(quantity)',
      RECIPIENTER: '领用人(recipienter)',
      RECIPIENTING_DATE: '领用时间(recipientingDate)',
      BRANCH_ID: '分公司(branchId)',
      RecipientsInvoiceRecords: '领用发票记录(RecipientsInvoiceRecords)'
    },
    AgentCharge: {
      AGENTCHARGEID: '分成费用ID(agentChargeId)',
      AR: '费用收支(isAr)',
      PERCENTAGE: '是否参与分成(isPercentage)',
      CHARGE_ITEM_ID: '费用代码(chargeItemId)',
      CURRENCY: '币种(currency)',
      RATE: '汇率(rate)',
      AMOUNT: '金额(amount)',
      TYPE: '计费单位(type)',
      QUANTITY: '数量(quantity)',
      UNITPRICE: '单价(unitPrice)',
      REMARK: '备注(remark)',
      INPUTBY: '录入人(inputBy)',
      INPUTDATE: '录入日期(inputDate)',
      SERIAL_NUMBER: '序号(serialNumber)',
      PAYMENT_TYPE: '支付类型(paymentType)',
      AgentCharge: '代理分成费用(AgentCharge)'
    },
    NullifyCharge: {
      CHARGE_ID: '费用序号(chargeId)',
      CHARGEITEMID: '费用名称代码(chargeItemId)',
      ACCOUNT_RECEIVABLE: '收支类型(receivable)',
      OVERSEA: '国内国外(oversea)',
      ADJUSTMENT: '是否调整费用(adjustment)',
      SHARED: '是否分摊费用(shared)',
      SHARE_SCHEME: '分摊类型(shareScheme)',
      SHAREREFNO: '分摊关联编号(shareRefNo)',
      COMMISSION: '是否佣金(commission)',
      ADVANCE: '是否垫付(advance)',
      PREPAID: '是否托收拆分(prepaid)',
      PAID_OFF: '已付清(paidOff)',
      COLLECTION: '已转入托收(collection)',
      RELATED_ID: '内结费用编号(relatedId)',
      ACCOUNT_ID: '结算单位代码(accountId)',
      INVOICE_TITLE: '发票抬头(invoiceTitle)',
      CURRENCY: '币种(currency)',
      MEASURE: '单位类型(measure)',
      QUANTITY: '数量(quantity)',
      UNIT_RATE: '单价(unitRate)',
      AMOUNT: '金额(amount)',
      VERIFIED_AMOUNT: '已核销金额(verfiedAmount)',
      EXCHANGE_RATE: '汇率(exchangeRate)',
      BILL_NO: '帐单号(billNo)',
      COUNTER_PARTY_BILLING_NO: '对方账单号(counterPartyBillingNo)',
      PAYMENT_NO: '付款审批号(paymentNo)',
      INVOICE_NO: '发票号/税金号(invoiceNo)',
      VOUCHER_NO: '财务接口编号(voucherNo)',
      CONTAINER_NO: '箱号(containerNo)',
      INPUT_BY: '录入人(inputBy)',
      INPUT_DATE: '录入日期(inputDate)',
      AUDITOR: '审核人(auditor)',
      AUDIT_DATE: '审核日期(auditDate)',
      ACCOUNTING_DATE: '财务日期(accountingDate)',
      CLEARING_DATE: '销账日期(clearingDate)',
      REMARKS: '备注(remarks)',
      INPUT_BY_DEP: '录入人部门(inputByDep)',
      BRANCH_ID: '费用分公司(branchId)',
      TAX_RATE: '税率(taxRate)',
      TAX_AMOUNT: '税额(taxAmount)',
      EXCLUDING_TAX_AMOUNT: '不含税额(excludingTaxAmount)',
      CONTROLLED: '是否受控(controlled)',
      CHARGE_SOURCE: '费用来源(chargeSource)',
      CHARGE_STATE: '费用状态(chargeState)',
      CONFIRM_STATE: '确认状态(confirmState)',
      BILLING_AMOUNT: '对帐金额(billingAmount)',
      CONFIRM_REMARKS: '确认备注(confirmRemarks)',
      DIFFERENT_STATE: '差异调整状态(differentState)',
      INVOICE_AMOUNT: '开票金额(invoiceAmount)',
      INVOICE_EXCLUDING_TAX: '开票不含税额(invoiceExcludingTax)',
      INVOICE_TAX: '开票税额(invoiceTax)',
      OFFSET_STATE: '红冲状态(offsetState)',
      ORIGINAL_CHARGE_UUID: '原始费用UUID(originalChargeUuid)',
      JOB_UUID: '业务UUID(jobUuid)',
      BILLING_UUID: '账单UUID(billingUuid)',
      BILL_PAYMENT_UUID: '付款申请UUID(billPaymentUuid)',
      NullifyCharge: '作废费用(NullifyCharge)'
    },
    EDI: {
      EDIID: 'EDI序号(EDIId)',
      TYPE: 'EDI类型(type)',
      JOB_NO: '业务编号(jobNo)',
      SUPPLY_ID: '船公司或代理编号(supplyId)',
      OUTPUT_DATE: '导出日期(outputDate)',
      STATUS: '状态(status)',
      CONTENT: 'EDI报文(content)',
      RETURN_MESSAGE: '返回信息(returnMessage)',
      FILE_ID: '报文标识(fileId)',
      OFFICE_ID: '分公司(officeId)',
      JOB_UUID: 'JobUUID(jobUuid)',
      SEND_TYPE: '发送地址类型(sendType)',
      EDI: '电子文件数据(EDI)'
    },
    EDIMapping: {
      MAP_ID: '转换序号(mapId)',
      OFFICE_ID: '分公司(officeId)',
      TYPE: '转换类型(type)',
      SUB_TYPE: '子类型(subType)',
      CONDITION1: '转换条件(condition1)',
      CONDITION2: '转换条件(condition2)',
      CONDITION3: '转换条件(condition3)',
      SOURCE_VALUE: '原值(sourceValue)',
      TARGET_VALUE: '新值(targetValue)',
      REMARKS: '备注(remarks)',
      EDIMapping: '电子文件数据转换(EDIMapping)'
    },
    EDIPartnerTemplate: {
      PARNTER_ID: '合作伙伴代码(ParnterId)',
      TEMPLATE_DESCRIBE: '模板说明(TemplateDescribe)',
      SERVICE_TYPE: '服务类型(ServiceType)',
      TEMPLATE_TYPE: '模板类型(TemplateType)',
      TEMPLATE_PATH: '模板访问路径(TemplatePath)',
      REMARKS: '备注(remarks)',
      FILE_COMBINE_TYPE: 'EDI文件合并方式(FileCombineType)',
      DEFAULT_FILE_TYPE: 'EDI文件默认类型(DefaultFileType)',
      ENCODING_TYPE: 'EDI文件编码类型(EncodingType)',
      EMAIL: '邮箱(email)',
      SEND_TYPE: '发送FTP地址类型(sendType)',
      EDIPartnerTemplate: '合作伙伴EDI模板(EDIpartnerTemplate)'
    },
    EDIMappingType: {
      TYPE_CODE: '映射代码(TypeCode)',
      TYPE_DESC: '映射说明(TypeDesc)',
      EDIMappingType: 'EDI映射类型(EDIMappingType)'
    },
    EContainerHistory: {
      CONTAINER_UUID: '集装箱uuid(containerUUID)',
      JOB_UUID: '工作单UUID(jobUUID)',
      PRINTBOX_ID: '箱单唯一标识(printBoxID)',
      PRINTBOX_ONLY_ID: '箱单打印唯一标识(printBoxOnlyID)',
      PARAMETER: '参数(parameter)',
      SUCCESS: '是否成功(success)',
      ERROR_MSG: '失败信息(errorMsg)',
      JOB_NO: '工作单号(jobNo)',
      PRINT_DATE: '打印时间(printDate)',
      PRINT_COUNT: '打印次数(printCount)',
      EContainerHistory: 'UBI与99路电子箱单接口数据传递记录表'
    },
    PriceFcl: {
      STATE: '状态(state)',
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      DIRECT: '直达(direct)',
      VIA: '中转(via)',
      TERM: '付款方式(term)',
      EQ_TYPE: '箱种(eqType)',
      CARRIER: '船公司(carrier)',
      SHIPPING_LINE: '船公司航线代码(shippingLine)',
      CONTRACT_NO: '约号(contractNo)',
      DAYS: 'days',
      SERVICE_MODE: 'serviceMode',
      SERVICE_CODE: 'serviceCode',
      COMMODITY: 'commodity',
      CURRENCY: '币种(currency)',
      BEGIN_DATE: 'beginDate',
      END_DATE: 'endDate',
      REMARKS: '备注(remarks)',
      DATE_APPROVED: 'dateApproved',
      APPROVED_BY: 'approvedBy',
      BRANCH_ID: '分公司(branchId)',
      LANE: '航线代码(lane)',
      PRICE_NO: '运价No(priceNo)',
      PRICE_NO7: '运价No7(priceNo7)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      VAT: '税率(vat)',
      DOCK: '挂靠码头(dock)',
      DESTINATION_DOCK: '目的港码头(destinationDock)',
      FREQUENCY1: '周一船期(frequency1)',
      FREQUENCY2: '周二船期(frequency2)',
      FREQUENCY3: '周三船期(frequency3)',
      FREQUENCY4: '周四船期(frequency4)',
      FREQUENCY5: '周五船期(frequency5)',
      FREQUENCY6: '周六船期(frequency6)',
      FREQUENCY7: '周日船期(frequency7)',
      FREQUENCY8: '一程船期总数frequency8',
      COST20: '成本20(cost20)',
      COST40: '成本40(cost40)',
      COSTHC: '成本HC(costHC)',
      COST45: '成本45(cost45)',
      ONE20: '一级20(one20)',
      ONE40: '一级40(one40)',
      ONEHC: '一级HC(oneHC)',
      ONE45: '一级45(one45)',
      TWO20: '二级20(two20)',
      TWO40: '二级40(two40)',
      TWOHC: '二级HC(twoHC)',
      TWO45: '二级45(two45)',
      THREE20: '三级20(three20)',
      THREE40: '三级40(three40)',
      THREEHC: '三级HC(threeHC)',
      THREE45: '三级45(three45)',
      DATE_EFFECTIVE: '生效日期(dateEffective)',
      DATE_EXPIRATION: '失效日期(dateExpiration)',
      ACTIVE: '是否有效(active)',
      SHARE: '仓位性质(share)',
      TREND: '价格走势(trend)',
      COST_VAT: '成本税率(costVat)',
      SELL_VAT: '卖价税率(sellVat)',
      PRICE_STATE: '运价状态(priceState)',
      REJECT_20: '拒接箱型20(reject20)',
      REJECT_40: '拒接箱型40(reject40)',
      REJECT_HC: '拒接箱型HC(rejectHC)',
      REJECT_45: '拒接箱型45(reject45)',
      SALE_STATE: '特价状态(saleState)',
      FREE_TIME: '集装箱免租期(freeTime)',
      DATE_TYPE_EFFECTIVE: '生效日期类型(dateTypeEffective)',
      DATE_TYPE_EXPIRATION: '失效日期类型(dateTypeExpiration)',
      RECEIVING_TYPE: '接货特殊说明类型(receivingType)',
      RECEIVING_INSTRUCTIONS: '接货特殊说明(receivingInstructions)',
      SECOND_FREQUENCY1: '二程周一(secondFrequency1)',
      SECOND_FREQUENCY2: '二程周二(secondFrequency2)',
      SECOND_FREQUENCY3: '二程周三(secondFrequency3)',
      SECOND_FREQUENCY4: '二程周四(secondFrequency4)',
      SECOND_FREQUENCY5: '二程周五(secondFrequency5)',
      SECOND_FREQUENCY6: '二程周六(secondFrequency6)',
      SECOND_FREQUENCY7: '二程周日(secondFrequency7)',
      VIA2: '中转2(via2)',
      SOURCE_ID: '源运价ID(sourceId)',
      SOURCE_TENANT_ID: '运价来源(sourceTenantId)',
      SUB_CONTRACT_NO: '子合同号(subContractNo)',
      NA: 'N/A(na)',
      NA_CODE: 'N/A Code(naCode)',
      TRANSPORT_MODE: '运输方式(transportMode)',
      CLOSING_DAY: '截关日(closingDay)',
      AMS_ENS: 'amsEns(AMS/ENS)',
      OVER_LOAD_REMARKS: '超重说明(overloadRemarks)',
      TEMPLATE_FILE_ID: '模块文件ID(templateFileId)',
      SOURCE_PRICE_UUID: '原运价UUID(sourcePriceUuid)',
      CUSTOM_SPECS: '自定义规格(customSpecs)',
      PriceFcl: '整箱运价(PriceFcl)'
    },
    Price: {
      STATE: '状态(state)',
      APPROVED_BY: '审核人(approvedBy)',
      DATE_APPROVED: '审核日期(dateApproved)',
      BEGIN_DATE: '有效开始日期(beginDate)',
      END_DATE: '有效截至日期(endDate)',
      CURRENCY: '币种(currency)',
      BRANCH_ID: '分公司(branchId)',
      Price: '价格(Price)'
    },
    PriceWeightLimit: {
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      CARRIER: '船公司(carrier)',
      FREQUENCY1: '周一船期(frequency1)',
      FREQUENCY2: '周二船期(frequency2)',
      FREQUENCY3: '周三船期(frequency3)',
      FREQUENCY4: '周四船期(frequency4)',
      FREQUENCY5: '周五船期(frequency5)',
      FREQUENCY6: '周六船期(frequency6)',
      FREQUENCY7: '周日船期(frequency7)',
      EQ_TYPE: '箱种(eqType)',
      EQ_SIZE: '箱型(eqSize)',
      AMOUNT: '最大重量(amount)',
      REMARKS: '备注(remarks)',
      GRADE_MIN: '运价等级下限(大于等于)(gradeMin)',
      GRADE_MAX: '运价等级上限(小于)(gradeMax)',
      VIA: '中转(via)',
      STATE: '状态(state)',
      APPROVED_BY: '审核人(approvedBy)',
      DATE_APPROVED: '审核日期(dateApproved)',
      BEGIN_DATE: '有效开始日期(beginDate)',
      END_DATE: '有效截至日期(endDate)',
      CURRENCY: '币种(currency)',
      BRANCH_ID: '分公司(branchId)',
      PriceWeightLimit: '整箱限重信息(PriceWeightLimit)'
    },
    SurchargeFCL: {
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      REGION: '航线(region)',
      CARRIER: '船公司(carrier)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      CHARGE_SCALE_CODE: '费用名称(chargeScaleCode)',
      UNIT: '单位(unit)',
      EQ_TYPE: '箱型(eqType)',
      SUM20: '20(sum20)',
      SUM40: '40(sum40)',
      SUMHC: '40HC(sumHC)',
      SUM45: '45(sum45)',
      CASE_PRICE: '单价(casePrice)',
      PAYMENT: '付款方式(payment)',
      VAT: '是否含税(vat)',
      REMARKS: '备注(remarks)',
      CHARGE_TYPE: '费用类别(chargeType)',
      COST20: '成本20(cost20)',
      COST40: '成本40(cost40)',
      COSTHC: '成本HC(costHC)',
      COST45: '成本45(cost45)',
      COST_CASE_PRICE: '单价成本(costCasePrice)',
      COST_VAT: '成本税率(costVat)',
      SELL_VAT: '卖价税率(sellVat)',
      GENERATE_CHARGE: '订舱时生成费用(generateCharge)',
      SOURCE_ID: '源运价ID(sourceId)',
      SOURCE_TENANT_ID: '运价来源(sourceTenantId)',
      DANGEROUS: '是否危险品(dangerous)',
      DANGEROUS_CLASS: '危险品等级(dangerousClass)',
      STATE: '状态(state)',
      APPROVED_BY: '审核人(approvedBy)',
      DATE_APPROVED: '审核日期(dateApproved)',
      BEGIN_DATE: '有效开始日期(beginDate)',
      END_DATE: '有效截至日期(endDate)',
      CURRENCY: '币种(currency)',
      BRANCH_ID: '分公司(branchId)',
      SurchargeFCL: '整箱附加费(SurchargeFCL)'
    },
    PriceFclExtra: {
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      CARRIER: '船公司(carrier)',
      FREQUENCY1: '周一船期(frequency1)',
      FREQUENCY2: '周二船期(frequency2)',
      FREQUENCY3: '周三船期frequency3)',
      FREQUENCY4: '周四船期(frequency4)',
      FREQUENCY5: '周五船期(frequency5)',
      FREQUENCY6: '周六船期(frequency6)',
      FREQUENCY7: '周日船期(frequency7)',
      DOCKLAND: '港区(dockland)',
      SHARE_CARRIER: '共舱船公司(shareCarrier)',
      BILL_TYPE: '提单类型(billType)',
      SHIPPING_TERM: '运输条款(shippingTerm)',
      SEAWAY_BILL: '是否SEAWAY BILL(seawayBill)',
      LANE: '航线代码(lane)',
      OTHER_INFO: '其它信息(otherInfo)',
      STATE: '状态(state)',
      APPROVED_BY: '审核人(approvedBy)',
      DATE_APPROVED: '审核日期(dateApproved)',
      BEGIN_DATE: '有效开始日期(beginDate)',
      END_DATE: '有效截至日期(endDate)',
      CURRENCY: '币种(currency)',
      BRANCH_ID: '分公司(branchId)',
      PriceFclExtra: '整箱运价附加信息(PriceFclExtra)'
    },
    PriceFclAddon: {
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      EQ_TYPE: '箱种(eqType)',
      CARRIER: '船公司(carrier)',
      SHIPPING_LINE: '船公司航线代码(shippingLine)',
      DAYS: 'days',
      PRICE_DATE_TYPE: '运价日期种类(priceDateType)',
      REMARKS: '备注(remarks)',
      SUM20: "20'费用(sum20)",
      SUM40: "40'费用(sum40)",
      SUMHC: "HC'费用(sumHC)",
      SUM45: "45'费用(sum45)",
      STATE: '状态(state)',
      APPROVED_BY: '审核人(approvedBy)',
      DATE_APPROVED: '审核日期(dateApproved)',
      BEGIN_DATE: '有效开始日期(beginDate)',
      END_DATE: '有效截至日期(endDate)',
      CURRENCY: '币种(currency)',
      BRANCH_ID: '分公司(branchId)',
      PriceFclAddon: 'PriceFclAddon'
    },
    PriceAir: {
      STATE: '状态(state)',
      LEVEL: '运价级(level)',
      FLIGHT: '航班号(flight)',
      AIRCRAFT: '机型(aircraft)',
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      VIA: '中转(via)',
      MIN_CHARGE: 'minCharge',
      STEP: 'step',
      FSC: 'fsc',
      SSC: 'ssc',
      P45: 'p45',
      P100: 'p100',
      P300: 'p300',
      P500: 'p500',
      P1000: 'p1000',
      CARRIER: '航空公司(carrier)',
      AGENT: '代理(agent)',
      FREQUENCY1: '周一(frequency1)',
      FREQUENCY2: '周二(frequency2)',
      FREQUENCY3: '周三(frequency3)',
      FREQUENCY4: '周四(frequency4)',
      FREQUENCY5: '周五(frequency5)',
      FREQUENCY6: '周六(frequency6)',
      FREQUENCY7: '周日(frequency7)',
      DAYS: 'days',
      CURRENCY: '币种(currency)',
      BEGIN_DATE: 'beginDate',
      END_DATE: 'endDate',
      REMARKS: '备注(remarks)',
      DATE_APPROVED: 'dateApproved',
      APPROVED_BY: 'approvedBy',
      BRANCH_ID: '分公司(branchId)',
      PRICE_NO: '运价No(priceNo)',
      PRICE_NO7: '运价No7(priceNo7)',
      GROUP_NO: '组号(groupNo)',
      TC: 'tc',
      T1_MIN: 't1Min',
      T1_STEP: 't1Step',
      T1_P45: 't1P45',
      T1_P100: 't1P100',
      T1_P300: 't1P300',
      T1_P500: 't1P500',
      T1_P1000: 't1P1000',
      T2_MIN: 't2Min',
      T2_STEP: 't2Step',
      T2_P45: 't2P45',
      T2_P100: 't2P100',
      T2_P300: 't2P300',
      T2_P500: 't2P500',
      T2_P1000: 't2P1000',
      T3_MIN: 't3Min',
      T3_STEP: 't3Step',
      T3_P45: 't3P45',
      T3_P100: 't3P100',
      T3_P300: 't3P300',
      T3_P500: 't3P500',
      T3_P1000: 't3P1000',
      SALES_ALLOWANCE: '销售补贴(salesAllowance)',
      SECOND_AIRCRAFT: '二程机型(secondAircraft)',
      SECOND_FREQUENCY1: '二程周一(secondFrequency1)',
      SECOND_FREQUENCY2: '二程周二(secondFrequency2)',
      SECOND_FREQUENCY3: '二程周三(secondFrequency3)',
      SECOND_FREQUENCY4: '二程周四(secondFrequency4)',
      SECOND_FREQUENCY5: '二程周五(secondFrequency5)',
      SECOND_FREQUENCY6: '二程周六(secondFrequency6)',
      SECOND_FREQUENCY7: '二程周日(secondFrequency7)',
      VIA2: '中转2(via2)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      TEMPLATE_FILE_ID: '模块文件ID(templateFileId)',
      SOURCE_PRICE_UUID: '原运价UUID(sourcePriceUuid)',
      PriceAir: 'PriceAir'
    },
    PortGroup: {
      GROUP_CODE: 'groupCode',
      PORT_CODE: 'portCode',
      PortGroup: 'PortGroup'
    },
    PriceLcl: {
      STATE: '状态(state)',
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      VIA: '中转(via)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      TERM: '付款方式(term)',
      CARRIER: '船公司(carrier)',
      CLOSING_DAY: '截关日(closingDay)',
      DAYS: 'days(航程)',
      CURRENCY: '币种(currency)',
      BEGIN_DATE: '有效期开始时间(beginDate)',
      END_DATE: '有效期结束时间(endDate)',
      REMARKS: '备注(remarks)',
      DATE_APPROVED: 'dateApproved',
      APPROVED_BY: 'approvedBy',
      BRANCH_ID: '分公司(branchId)',
      PRICE_NO: '运价No(priceNo)',
      PRICE_NO7: '运价No7(priceNo7)',
      COST_WEIGHT_PRICE: '重量价(成本)(costWeightPrice)',
      ONE_WEIGHT_PRICE: '重量价(T1)(oneWeightPrice)',
      TWO_WEIGHT_PRICE: '重量价(T2)(twoWeightPrice)',
      THREE_WEIGHT_PRICE: '重量价(T3)(threeWeightPrice)',
      COST_VOLUME_PRICE: '体积价(成本)(costVolumePrice)',
      ONE_VOLUME_PRICE: '体积价(T1)(oneVolumePrice)',
      TWO_VOLUME_PRICE: '体积价(T2)(twoVolumePrice)',
      THREE_VOLUME_PRICE: '体积价(T3)(threeVolumePrice)',
      ACTIVE: '是否有效(active)',
      TREND: '价格走势(trend)',
      DIRECT: '直达(direct)',
      FREQUENCY1: '周一船期(frequency1)',
      FREQUENCY2: '周二船期(frequency2)',
      FREQUENCY3: '周三船期(frequency3)',
      FREQUENCY4: '周四船期(frequency4)',
      FREQUENCY5: '周五船期(frequency5)',
      FREQUENCY6: '周六船期(frequency6)',
      FREQUENCY7: '周日船期(frequency7)',
      DATE_EFFECTIVE: '生效日期(dateEffective)',
      DATE_EXPIRATION: '失效日期(dateExpiration)',
      SHARE: '仓位性质(share)',
      COST_VAT: '成本税率(costVat)',
      SELL_VAT: '卖价税率(sellVat)',
      SHARE_CARRIER: '共舱船公司(shareCarrier)',
      SHIPPING_LINE: '船公司航线代码(shippingLine)',
      PRICE_STATE: '运价状态(priceState)',
      GRADE_MIN: '运价等级下限(大于等于)(gradeMin)',
      GRADE_MAX: '运价等级上限(小于)(gradeMax)',
      GRADE_UNIT: '运价等级单位(gradeUnit)',
      SALE_STATE: '特价状态(saleState)',
      MINIMUM_TON: '最小计费吨(minimumTon)',
      MINIMUM_TON_COST: '最小计费吨成本(minimumTonCost)',
      MINIMUM_TON_PRICE1: '最小计费吨价格1(minimumTonPrice1)',
      MINIMUM_TON_PRICE2: '最小计费吨价格2(minimumTonPrice2)',
      MINIMUM_TON_PRICE3: '最小计费吨价格3(minimumTonPrice3)',
      SOURCE_ID: '源运价ID(sourceId)',
      SOURCE_TENANT_ID: '运价来源(sourceTenantId)',
      DOCK: '挂靠码头(dock)',
      DESTINATION_DOCK: '目的港挂靠码头(destinationDock)',
      SUB_CONTRACT_NO: '子合同号(subContractNo)',
      NA: 'N/A(na)',
      NA_CODE: 'N/A Code(naCode)',
      TRANSPORT_MODE: '运输方式(transportMode)',
      TEMPLATE_FILE_ID: '模块文件ID(templateFileId)',
      SOURCE_PRICE_UUID: '原运价UUID(sourcePriceUuid)',
      CUSTOM_SPECS: '自定义规格(customSpecs)',
      PriceLcl: 'PriceLcl'
    },
    PodCharge: {
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      TRADE_LANE: '航线(tradeLane)',
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      CHARGE_SCALE_CODE: '费用名称(chargeScaleCode)',
      UNIT: '计费单位(unit)',
      COST_MIN: '最低费用(成本)(costMin)',
      COST_RATE: '费用(成本)(costRate)',
      COLOADER_RATE: '费用(同行)(coloaderRate)',
      COLOADER_MIN: '最低费用(同行)(coloaderMin)',
      CUSTOMER_RATE: '费用(直客)(customerRate)',
      CUSTOMER_MIN: '最低费用(直客)(customerMin)',
      FEE_INDEX: '费用序号(feeIndex)',
      CHARGE_TYPE: '费用类别(chargeType)',
      PAYMENT: '付款方式(payment)',
      VAT: '是否含税(vat)',
      COST_VAT: '成本税率(costVat)',
      SELL_VAT: '卖价税率(sellVat)',
      REMARKS: '备注(remarks)',
      STATE: '状态(state)',
      APPROVED_BY: '审核人(approvedBy)',
      DATE_APPROVED: '审核日期(dateApproved)',
      BEGIN_DATE: '有效开始日期(beginDate)',
      END_DATE: '有效截至日期(endDate)',
      CURRENCY: '币种(currency)',
      BRANCH_ID: '分公司(branchId)',
      PodCharge: 'PodCharge'
    },
    PriceKPI: {
      NAME: '运价类型名称(name)',
      CATEGORY: 'KPI类(category)',
      SHAPE: 'KPI型(shape)',
      POINT: 'KPI点(point)',
      REMARKS: '备注(remarks)',
      PriceKPI: '运价KPI(PriceKPI)'
    },
    Quotation: {
      BRANCH_ID: '分公司(branchId)',
      TYPE: '业务类型(type)',
      QUOTATION_NO: '报价单号(quotationNo)',
      BEGIN_DATE: '有效期开始时间(beginDate)',
      END_DATE: '有效期结束时间(endDate)',
      CLIENT_ID: '客户(clientId)',
      RECEIPT_PLACE: '收货地(receiptPlace)',
      DELIVERY_PLACE: '交货地(deliveryPlace)',
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      GOODS_NAME: '品名(goodsName)',
      HS_CODE: 'HS Code(HSCode)',
      QUANTITY: '件数(quantity)',
      GROSS_WEIGHT: '毛重(grossWeight)',
      CUBAGE: '体积(cubage)',
      SIZE: '尺寸(size)',
      CHARGE_WEIGHT: '计费重量(chargeWeight)',
      FREIGHT_TERM: '运输条款(freightTerm)',
      DANGEROUS_GOODS: '是否危险品(dangerousGoods)',
      UN_NO: '危险品编码(UNNo)',
      HAZARD_CLASS: '危险品等级(hazardClass)',
      EMAIL: '电子邮箱(email)',
      PHONE: '联系电话(phone)',
      FAX: '传真(fax)',
      REMARKS: '备注(remarks)',
      RECEIPT_REMARK: '收货地费用备注(receiptRemark)',
      DELIVERY_REMARK: '交货地费用备注(deliveryRemark)',
      CONTACT: '联系人(contact)',
      NUM_20: '20尺箱数量(num20)',
      NUM_40: '40尺箱数量(num40)',
      NUM_HC: '40HC箱数量(numHC)',
      NUM_45: '45尺箱数量(num45)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      JOB_TYPE: '业务类型(jobType) 0.出口 1.进口',
      JOB_NO: '业务编号(jobNo)',
      CLIENT_TENANT_ID: '客户所属tenantId(clientTenantId)',
      CLIENT_TENANT_NAME: '客户所属tenantName(clientTenantName)',
      STATUS: '状态：0待确认，1已接受，2已拒绝(status)',
      ETD: '预计开航日期(ETD)',
      ETA: '预计到港日期(ETA)',
      Quotation: '报价单(Quotation)'
    },
    QuotationFCLDetail: {
      LEVEL: '运价级(level)',
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      VIA: '中转(via)',
      CARRIER: '船公司(carrier)',
      EQ_TYPE: '箱种(eqType)',
      EQ20: '20价格(eq20)',
      EQ40: '40价格(eq40)',
      EQHC: '40HC价格(eqHC)',
      EQ45: '45价格(eq45)',
      TERM: '付款方式(term)',
      LANE: '航线代码(lane)',
      DEPARTURE_DAY: '开航日(departureDay)',
      CLOSING_DAY: '截关日(closingDay)',
      DAYS: '航程(days)',
      BEGIN_DATE: '有效期开始时间(beginDate)',
      END_DATE: '有效期结束时间(endDate)',
      SERVICE_MODE: 'serviceMode',
      CURRENCY: '币种(currency)',
      REMARKS: '备注(remarks)',
      COMMODITY: 'commodity',
      COST20: '20成本(cost20)',
      COST40: '40成本(cost40)',
      COSTHC: 'HC成本(costHC)',
      COST45: '45成本(cost45)',
      AMOUNT: '金额(amount)',
      PRICE_UUID: '整箱运价UUID(priceUUID)',
      DIRECT: '直达(direct)',
      PRICE_NO: '运价No(priceNo)',
      VAT: '税率(vat)',
      DOCK: '挂靠码头(dock)',
      SHARE: '仓位性质(share)',
      SALE_STATE: '特价状态(saleState)',
      SOURCE_TENANT_ID: '运价来源(sourceTenantId)',
      QuotationFCLDetail: '整箱报价价格明细(QuotationFCLDetail)'
    },
    QuotationLCLDetail: {
      LEVEL: '运价级(level)',
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      VIA: '中转(via)',
      SOURCE: '运价来源(source)',
      TERM: '付款方式(term)',
      CARRIER: '船公司(carrier)',
      SHIPPING_LINE: '船公司航线代码(shippingLine)',
      DEPARTURE_DAY: '开航日(departureDay)',
      CLOSING_DAY: '截关日(closingDay)',
      DAYS: '航程(days)',
      CURRENCY: '币种(currency)',
      WEIGHT_PRICE: '重量价格(weightPrice)',
      VOLUME_PRICE: '体积价格(volumePrice)',
      BEGIN_DATE: '有效期开始时间(beginDate)',
      END_DATE: '有效期结束时间(endDate)',
      REMARKS: '备注(remarks)',
      WEIGHT_COST: '重量成本(weightCost)',
      VOLUME_COST: '体积成本(volumeCost)',
      QuotationLCLDetail: '拼箱报价价格明细(QuotationLCLDetail)'
    },
    QuotationAirDetail: {
      LEVEL: '运价级(level)',
      FLIGHT: '航班号(flight)',
      AIRCRAFT: '机型(aircraft)',
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      VIA: '中转(via)',
      MIN_CHARGE: 'minCharge',
      STEP: 'step',
      FSC: 'fsc',
      SSC: 'ssc',
      P45: 'p45',
      P100: 'p100',
      P300: 'p300',
      P500: 'p500',
      P1000: 'p1000',
      CARRIER: '航空公司(carrier)',
      AGENT: '代理(agent)',
      FREQUENCY1: '周一(frequency1)',
      FREQUENCY2: '周二(frequency2)',
      FREQUENCY3: '周三(frequency3)',
      FREQUENCY4: '周四(frequency4)',
      FREQUENCY5: '周五(frequency5)',
      FREQUENCY6: '周六(frequency6)',
      FREQUENCY7: '周日(frequency7)',
      DAYS: 'days',
      CURRENCY: '币种(currency)',
      BEGIN_DATE: 'beginDate',
      END_DATE: 'endDate',
      REMARKS: '备注(remarks)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      QuotationAirDetail: '空运报价价格明细(QuotationAirDetail)'
    },
    QuotationClient: {
      CLIENT_ID: '客户ID(clientId)',
      BRANCH_ID: '分公司(branchId)',
      OWNER_ID: '所属销售ID(owerId)',
      PRE_OWNER_ID: '上次销售ID(preOwerId)',
      NAME: '客户名称(name)',
      CONTACT: '联系人(contact)',
      PHONE: '电话(phone)',
      FAX: '传真(fax)',
      EMAIL: '电子邮箱(email)',
      ADDRESS: '地址(address)',
      REMARKS: '备注(remarks)',
      ENGLISH_NAME: '英文名(englishName)',
      COMPANY_SIZE: '公司规模人员(companySize)',
      REGISTERED_CAPITAL: '公司注册资金(registeredCapital)',
      DEPARTMENT_ID: '所属部门(department)',
      GROUP_LEADER_ID: '所属组长(groupLeader)',
      ASSIGN_DATE: '分配日期(assignDate)',
      COMPANY_TYPE_CODE: '公司类型(companyTypeCode)',
      CUSTOMER_STATUS_CODE: '客户状态(customerStatusCode)',
      CUSTOMER_LEVEL_CODE: '客户评定等级(customerLevelCode)',
      OVERCOME_LEVEL_CODE: '客户攻克难度指数(overcomeLevelCode)',
      FIRST_MEET_DATE: '初次接触日期(firstMeetDate)',
      SLEEP_DAYS: '沉睡天数(sleepDays)',
      SIGNED: '是否签单(signed)',
      SIGNED_DAYS: '签单天数(signedDays)',
      DUE_TIME: '即将到期天数(dueTime)',
      COMPETITOR_COMPANY: '竞争公司(competitorCompany)',
      COUNTRY: '国(country)',
      PROVINCE: '省(province)',
      CITY: '市(city)',
      DISTRICTS: '区(disricts)',
      COMPANY_UUID: '正式客户(companyKey)',
      ACTIVE: '是否有效(active)',
      APPROVED_STATE: '审核状态0.未审核 1.已审核 2.已拒绝(approvedState)',
      SOURCE_TYPE: '客户来源,0销售自拓,1客户公海,2组长分配,5无(sourceType)',
      QuotationClient: '询价客户(QuotationClient)'
    },
    QuotationClientContact: {
      NAME: '联系人(name)',
      PHONE: '电话(phone)',
      CELLPHONE: '手机(cellphone)',
      QQ_ACCOUT: 'QQ(qqAccout)',
      WECHAT_ACCOUT: '微信号(wechatAccout)',
      SKYPE_ACCOUT: 'skype(skypeAccout)',
      EMAIL: '电子邮箱(email)',
      REMARKS: '备注(remarks)',
      TYPE: '类型(type)',
      QuotationClientContact: '联系人(QuotationClientContact)'
    },
    QuotationClientBusiness: {
      NAME: '货物名称(name)',
      SPECIAL: '有无特殊性(special)',
      DANGEROUS_CHEMICALS: '是否含危化品(dangerousChemicals)',
      SEA_SHIPMENT_MONTHLY_FCL: '月均出货量_海运_FCL(seaShipmentMonthlyFCL)',
      SEA_SHIPMENT_MONTHLY_LCL: '月均出货量_海运_LCL(seaShipmentMonthlyLCL)',
      AIRLINE_SHIPMENT_MONTHLY_MT: '月均出货量_空运_MT(airlineShipmentMonthlyMT)',
      CUSTOMS_BROKER_TYPE: '偏好报关服务类型(customsBrokerType)',
      CUSTOMS_BROKER_ID: '偏好报关行(customsBrokerId)',
      TRUCKING_TYPE: '偏好拖车服务类型(truckingType)',
      TRUCKING_INFO_ID: '偏好拖车服务公司(truckingInfoId)',
      SIGNED_HBL: '是否签HB/L(signedHBL)',
      PAYED: '是否付款买单(payed)',
      REMARKS: '备注(remarks)',
      OVERSEA_AGENT_ID: '偏好目的港代理(overSeaAgentId)',
      QuotationClientBusiness: '业务(QuotationClientBusiness)'
    },
    QuotationClientBusinessMultipleDetail: {
      B_TYPE: '类型(bType)',
      B_VALUE: '值(bValue)',
      QuotationClientBusinessMultipleDetail: '详细(QuotationClientBusinessMultipleDetail)'
    },
    QuotationClientEvent: {
      TITLE_NAME: '主题(titleName)',
      TASK_TIME: '任务时间(taskTime)',
      RECODER_ID: '记录人(recorderID)',
      RECORD_TIME: '记录时间(recordTime)',
      STATUS: '事件状态(status)',
      ADDRESS: '地点(address)',
      PARTICIPANTS: '参与人(participants)',
      CONTENT: '内容(content)',
      ACHIEVEMENT: '成果(achievement)',
      NEXT_TASK: '下一步任务(nextTask)',
      REPORT_TARGET: '汇报对象(reportTarget)',
      REMARKS: '备注(remarks)',
      QuotationClientEvent: '事件记录(QuotationClientEvent)'
    },
    QuotationChargeDetail: {
      CHARGE_ID: '费用ID(chargeId)',
      CHARGE_NAME: '费用名称(chargeName)',
      TYPE: '类别(type)',
      CURRENCY: '币种(currency)',
      RATE: '费率(rate)',
      UNIT: '计费单位(unit)',
      REMARKS: '备注(remarks)',
      NUM: '数量(num)',
      AMOUNT: '金额(amount)',
      QuotationChargeDetail: '本地费用(QuotationChargeDetail)'
    },
    ShippingSchedule: {
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      CARRIER: '船公司(carrier)',
      LANE: '航线代码(lane)',
      DEPARTURE_DAY: '开航日(departureDay)',
      CLOSING_DAY: 'closingDay',
      DAYS: 'days',
      BEGIN_DATE: 'beginDate',
      END_DATE: 'endDate',
      BRANCH_ID: '分公司(branchId)',
      DOCKLAND: '港区(dockland)',
      TRANSFER_PORT: '中转港(transferPort)',
      REMARKS: '备注(remarks)',
      ShippingSchedule: 'ShippingSchedule(船期表)'
    },
    TenantSharing: {
      INVITE_TENANT: '邀请方(inviteTenant)',
      INVITE_TENANT_NAME: '邀请方名称(inviteTenantName)',
      ACCEPT_TENANT: '接受方(acceptTenant)',
      ACCEPT_TENANT_NAME: '接受方名称(acceptTenantName)',
      INVITE_TIME: '邀请日期(inviteTime)',
      ACCEPT_TIME: '接受日期(acceptTime)',
      INVITE_USER: '邀请方用户(inviteUser)',
      INVITE_USER_NAME: '邀请方用户名(inviteUserName)',
      ACCEPT_USER: '接受方用户(acceptUser)',
      ACCEPT_USER_NAME: '接受方用户名(acceptUserName)',
      ACTIVE: '是否有效(active)',
      NAME: '分享标题(name)',
      CATEGORY: '分享类(category)',
      SHAPE: '分享型(shape)',
      POINT: '分享点(point)',
      REMARKS: '备注(remarks)',
      APPLY_FOR: '是否申请分享(applyFor)',
      CHECK_STATE: '同意/拒绝(checkState)',
      TenantSharing: '租户分享(TenantSharing)'
    },
    SurchargeAir: {
      POL: '起运港(pol)',
      POD: '卸货港(pod)',
      REGION: '航线(region)',
      CARRIER: '航空公司(carrier)',
      BOOKING_AGENT: '订舱代理(bookingAgent)',
      SUPPLIER: '供应商(supplier)',
      GENERATE_CHARGE: '订舱时生成费用(generateCharge)',
      CHARGE_TYPE: '费用类别(chargeType)',
      CHARGE_SCALE_CODE: '费用名称(chargeScaleCode)',
      PAYMENT: '付款方式(payment)',
      UNIT: '单位(unit)',
      COST_MIN: '成本最小收费(costMin)',
      COST_PRICE: '成本(costPrice)',
      SELLING_MIN: '卖价最小收费(sellingMin)',
      SELLING_PRICE: '卖价(sellingPrice)',
      FREQUENCY1: '周一(frequency1)',
      FREQUENCY2: '周二(frequency2)',
      FREQUENCY3: '周三(frequency3)',
      FREQUENCY4: '周四(frequency4)',
      FREQUENCY5: '周五(frequency5)',
      FREQUENCY6: '周六(frequency6)',
      FREQUENCY7: '周日(frequency7)',
      REMARKS: '备注(remarks)',
      STATE: '状态(state)',
      APPROVED_BY: '审核人(approvedBy)',
      DATE_APPROVED: '审核日期(dateApproved)',
      BEGIN_DATE: '有效开始日期(beginDate)',
      END_DATE: '有效截至日期(endDate)',
      CURRENCY: '币种(currency)',
      BRANCH_ID: '分公司(branchId)',
      SurchargeAir: '空运附加费(SurchargeAir)'
    },
    PriceSharingRule: {
      NAME: '名称(name)',
      PROPERTY: '字段属性(property)',
      EXPRESSION: '表达式(expression)',
      TENANT_ID: 'TenantId(tenantId)',
      PriceSharingRule: '运价分享规则(PriceSharingRule)'
    },
    PriceSharingProfile: {
      NAME: '机制名称(name)',
      MATCH_TYPE: '匹配方式(matchType)',
      APPLICATION: '数据类型(application)',
      TO_TENANT: '接收方(toTenant)',
      TO_TENANT_NAME: '接收方企业名称(toTenantName)',
      FROM_TENANT: '分享方(fromTenant)',
      FROM_TENANT_NAME: '分享方企业名(fromTenantName)',
      CALLBACK_CLASS: '数据格式(callbackClass)',
      TENANT_ID: 'TenantId(tenantId)',
      PriceSharingProfile: '运价分享机制(PriceSharingProfile)'
    },
    PriceApproveHistory: {
      PRICE_ID: 'pirceId(pirceId)',
      PRICE_TYPE: '运价类型(pricType)',
      MARKUP_TYPES: '加价类型(markupTypes)',
      MARKUP_TIER1: '加价等级T1(markupsTier1)',
      MARKUP_TIER2: '加价等级T2(markupsTier2)',
      MARKUP_TIER3: '加价等级T3(markupsTier3)',
      PriceApproveHistory: '运价审批历史表(PriceApproveHistory)'
    },
    Announcement: {
      NEWS_ID: '公告序号(newsId)',
      NEWS_DATE: '公告日期(newsDate)',
      TITLE: '标题(title)',
      CONTENT: '内容(content)',
      AUTHOR: '发布人(author)',
      RELEASE_VERSION: '版本号(releaseVersion)',
      INVALID: '是否失效(invalid)',
      Announcement: '公告(Announcement)'
    },
    Task: {
      ID: '序号(id)',
      PRIORITY: '优先级(priority)',
      CATEGORY: '任务类(category)',
      PARAMETERS: '任务参数(parameters)',
      ACTIVE: '是否有效(active)',
      TITLE: '标题(title)',
      USER: '用户(user)',
      ROLE: '角色(role)',
      DEADLINE: '期限(deadline)',
      DATE_ESCALATED: 'dateEscalated',
      MANAGER_ESCALATED: 'managerEscalated',
      STATUS: '状态(status)',
      URL: 'url',
      DEPARTMENT: '部门(department)',
      Task: '任务(Task)'
    },
    FaxHistory: {
      ID: '序号(id)',
      STATE: '状态(state)',
      CLIENT_REFERENCE_CODE: '客户参考号(clientReferenceCode)',
      FAX_JOB_NO: '服务号(faxJobNo)',
      FAX_NO: '传真号(faxNo)',
      USER_ID: '用户(userId)',
      FAX_PARAMETER1: 'faxParameter1',
      FAX_PARAMETER2: 'faxParameter2',
      FAX_PARAMETER3: 'faxParameter3',
      FAX_PARAMETER4: 'faxParameter4',
      SERVER_STATE: 'serverState',
      SERVER_TIME: 'serverTime',
      SERVER_TRY: 'serverTry',
      SERVER_COST: 'serverCost',
      SEND_DATE: '发送时间(sendDate)',
      DOCUMENT_ID: '文档ID(documentId)',
      FaxHistory: 'FaxHistory'
    },
    AccountSet: {
      BRANCH_ID: '分公司(branchId)',
      CODE: '帐套编码(code)',
      NAME: '账套名称(name)',
      ACCOUNT_TITLE_GRADE_RULE: '科目分级规则(accountTitleGradeRule)',
      SOFTWARE_VERSIONS: '软件版本(softwareVersions)',
      INTERFACE_SCHEME: '接口方案(interfaceScheme)',
      PERIOD_BEGIN_DAY: '财务期间起始日期(periodBeginDay) 含本天',
      ACCOUNTING_ORGANIZATION: '核算组织(accountingOrganization)',
      AccountSet: '账套(AccountSet)'
    },
    AccountingDocumentsRule: {
      BUSINESS_DATA_TYPE: '数据类型(businessDataType)',
      GROUPING_DIMENSION1: '分组依据1(groupingDimension1)',
      GROUPING_DIMENSION2: '分组依据2(groupingDimension2)',
      GROUPING_DIMENSION3: '分组依据3(groupingDimension3)',
      GROUPING_DIMENSION4: '分组依据4(groupingDimension4)',
      GROUPING_DIMENSION5: '分组依据5(groupingDimension5)',
      GROUPING_DIMENSION6: '分组依据6(groupingDimension6)',
      ACCOUNTING_MODE: '记帐方式(accountingMode)',
      AccountingDocumentsRule: '凭证分组规则(AccountingDocumentsRule)'
    },
    AccountingEntryRule: {
      ENTRY_TYPE: '分录类型(entryType)',
      ENTRY_SERIES: '科目级数(entrySeries)',
      GROUPING_DIMENSION1: '分组依据1(groupingDimension1)',
      GROUPING_DIMENSION2: '分组依据2(groupingDimension2)',
      GROUPING_DIMENSION3: '分组依据3(groupingDimension3)',
      GROUPING_DIMENSION4: '分组依据4(groupingDimension4)',
      GROUPING_DIMENSION5: '分组依据5(groupingDimension5)',
      GROUPING_DIMENSION6: '分组依据6(groupingDimension6)',
      AUXILIARY_GROUPING1: '辅助核算分组依据1(auxiliaryGrouping1)',
      AUXILIARY_GROUPING2: '辅助核算分组依据2(auxiliaryGrouping2)',
      AUXILIARY_GROUPING3: '辅助核算分组依据3(auxiliaryGrouping3)',
      AUXILIARY_GROUPING4: '辅助核算分组依据4(auxiliaryGrouping4)',
      AUXILIARY_GROUPING5: '辅助核算分组依据5(auxiliaryGrouping5)',
      AUXILIARY_GROUPING6: '辅助核算分组依据6(auxiliaryGrouping6)',
      NEED_EXPORT: '是否需要导出(needExport)',
      GROUPING_DIMENSION_VALUE1: '科目分组条件值1(groupingDimensionValue1)',
      GROUPING_DIMENSION_VALUE2: '科目分组条件值2(groupingDimensionValue2)',
      GROUPING_DIMENSION_VALUE3: '科目分组条件值3(groupingDimensionValue3)',
      GROUPING_DIMENSION_VALUE4: '科目分组条件值4(groupingDimensionValue4)',
      GROUPING_DIMENSION_VALUE5: '科目分组条件值5(groupingDimensionValue5)',
      GROUPING_DIMENSION_VALUE6: '科目分组条件值6(groupingDimensionValue6)',
      ACCOUNTING_CODE: '固定核算编码字段(accountingCode)',
      AccountingEntryRule: '分录分组规则(AccountingEntryRule)'
    },
    AccountingDocumentType: {
      CODE: '类型代码(code)',
      NAME: '类型名称(name)',
      PREFIX: '凭证字前缀(prefix)',
      REMARKS: '凭证类型说明(remarks)',
      RECEIVE_TYPE: '收款方式(receiveType)',
      AccountingDocumentType: '凭证类型(AccountingDocumentType)'
    },
    FinanceCodeMapping: {
      PRIORITY: '优先级(priority)',
      BASEDATA_TYPE: '基础数据类型(baseDataType)',
      CODE_MAPPING_TYPE: '编码类型(codeMappingType)',
      BASEDATA_VALUE: '基础数据值(baseDataValue)',
      FINANCE_CODE: '财务编码(financeCode)',
      VALUE_TYPE1: '值类型1(valueType1)',
      BUSINESS_DATA_TYPE: '凭证类型(businessDataType)',
      ENTRY_TYPE: '分录类型(entryType)',
      ACCOUNT_TITLE: '科目编码(accountTitle)',
      FinanceCodeMapping: '编码映射(FinanceCodeMapping)'
    },
    EntryAccountTitle: {
      ENTRY_TYPE: '分录类型(entryType)',
      BUSINESS_DATA_TYPE: '数据类型(businessDataType)',
      PRIORITY: '优先级(priority)',
      CODE: '编码(code)',
      NAME: '名称(name)',
      EntryAccountTitle: '分录科目(EntryAccountTitle)'
    },
    SubAccountItem: {
      GRADE: '等级(grade)',
      CODE: '编码(code)',
      NAME: '名称(name)',
      SubAccountItem: '子科目(SubAccountItem)'
    },
    EntryGroupingCriteria: {
      GROUPING_DIMENSION: '分组依据(groupingDimension)',
      OPERATOR: '操作符(operator)',
      GROUPIN_GVALUE: '分组值(groupingValue)',
      EntryGroupingCriteria: '分组条件(EntryGroupingCriteria)'
    },
    AccountingDocument: {
      BUSINESS_DATA_TYPE: '数据类型(businessDataType)',
      STATE: '凭证状态(state)',
      SOURCE_DOCUMENT: '附件(sourceDocument)',
      DOCUMENT_DATE: '凭证日期(documentDate)',
      PREFIX: '凭证字(prefix)',
      DOCUMENT_MAKER: '制单人(documentMaker)',
      DOCUMENT_NO: '凭证号(documentNo)',
      DEBIT_TOTAL: '借方金额合计(debitTotal)',
      CREDIT_TOTAL: '贷方金额合计(creditTotal)',
      VERIFIER: '审核人(verifier)',
      VERIFY_DATE: '审核日期(verifyDate)',
      TARGET_DOCUMENT_NO: '对方凭证号(targetDocumentNo)',
      YEAR: '年度(year)',
      MONTH: '月份(month)',
      PRE_PAYMENT: '是否预收(isPrePayment)',
      CLOSING: '是否结转凭证(closing)',
      AccountingDocument: '凭证(AccountingDocument)'
    },
    AccountingEntry: {
      ENTRY_TYPE: '分录类型(entryType)',
      SUMMARY: '摘要(summary)',
      ACCOUNT_TITLE: '科目(accountTitle)',
      ACCOUNT_TITLE_NAME: '科目名称(accountTitleName)',
      DEBIT_CREBIT: '借贷(debitCrebit)',
      AMOUNT: '金额(amount)',
      SOURCE_CURRENCY: '原币种(sourceCurrency)',
      SOURCE_AMOUNT: '原币金额(sourceAmount)',
      EXCHANGE_RATE: '汇率(exchangeRate)',
      DEPARTMENT: '部门(department)',
      SALES: '业务员(sales)',
      STAFF_ID: '职员(staffId)',
      ACCOUNT_CLIENT: '结算单位(accountClient)',
      PROJECT_NUMBER: '项目号(projectNumber)',
      PROJECT_NUMBER2: '项目号2(projectNumber2)',
      BUSINESS_DATE: '业务日期(businessDate)',
      BUSINESS_DATE2: '业务日期2(businessDate2)',
      LOB: '业务类型(lob)',
      TAX_AMOUNT: '税额(taxAmount)',
      INVOICE_TYPE: '发票类型(invoiceType)',
      UNIT: '计量单位(unit)',
      QUANTITY: '数量(quantity)',
      SERIAL_NUMBER: '序号(serialNumber)',
      PAID_OFF: '是否核销(paidOff)',
      PAID_OFF_TYPE: '核销类型(paidOffType)',
      PAID_OFF_SEQ_NUMBER: '核销批次号(paidOffSeqNumber)',
      AccountingEntry: '分录(AccountingEntry)'
    },
    EntrySummaryRule: {
      BUSINESS_DATA_TYPE: '数据类型(businessDataType)',
      ENTRY_TYPE: '分录类型(entryType)',
      DEFAULT_SUMMARY: '默认摘要(defaultSummary)',
      EntrySummaryRule: '分录摘要规则(EntrySummaryRule)'
    },
    EntrySummaryDimension: {
      DIMENSION: '摘要依据(dimension)',
      DISPLAY_FORMAT: '显示说明(displayFormat)',
      EntrySummaryDimension: '摘要依据(EntrySummaryDimension)'
    },
    AccountingDocumentBusiness: {
      BUSINESS_DATA_TYPE: '数据类型(businessDataType)',
      BUSINESS_DATA_ID: '业务数据Id(businessDataId)',
      AccountingDocumentBusiness: '凭证业务(AccountingDocumentBusiness)'
    },
    DocumentSequenceConfig: {
      SEQUENCE_TYPE: '类型代码(sequenceType)',
      PREFIX: '前缀(prefix)',
      SEQUENCE_LENGTH: '序号长度(sequenceLength)',
      DocumentSequenceConfig: '对方凭证序号配置(DocumentSequenceConfig)'
    },
    DocumentSequence: {
      SEQUENCE_DATE: '序号日期(sequenceDate)',
      CURRENT_NO: '当前序号(currentNo)',
      DocumentSequence: '对方凭证序号(DocumentSequence)'
    },
    AccountTitle: {
      YEAR: '年度(year)',
      ACCOUNT_TITLE_TYPE: '科目类型(accountTitleType)',
      SUB_TYPE: '科目子类(subType)',
      LEVEL: '科目级别(level)',
      DEBIT_CREBIT: '借贷(debitCrebit)',
      ACCOUNT_TITLE: '科目(accountTitle)',
      ACCOUNT_TITLE_NAME: '科目名称(accountTitleName)',
      ACCOUNT_ITEM1: '一级科目(accountItem1)',
      ACCOUNT_ITEM2: '二级科目(accountItem2)',
      ACCOUNT_ITEM3: '三级科目(accountItem3)',
      ACCOUNT_ITEM4: '四级科目(accountItem4)',
      ACCOUNT_ITEM5: '五级科目(accountItem5)',
      ACCOUNT_ITEM6: '六级科目(accountItem6)',
      AUXILIARY: '辅助核算(auxiliary)',
      AUXILIARY_CUSTOMER: '辅助核算客户(auxiliaryCustomer)',
      AUXILIARY_SUPPLIER: '辅助核算供应商(auxiliarySupplier)',
      AUXILIARY_SALES: '辅助核算销售(auxiliarySales)',
      AUXILIARY_DEPARTMENT: '辅助核算部门(auxiliaryDepartment)',
      AUXILIARY_PROJECT_NUMBER: '辅助核算项目号(auxiliaryProjectNumber)',
      ACCOUNTING_QUANTITY: '是否数量核算(accountingQuantity)',
      UNIT: '计量单位(unit)',
      ACCOUNTING_CURRENCY: '是否外币核算(accountingCurrency)',
      ADJUST_EXCHANGE_RATE: '是否期末调汇(adjustExchangeRate)',
      SOURCE_CURRENCY: '原币种(sourceCurrency)',
      CURRENT_ACCOUNT: '是否往来(currentAccount)',
      DEFAULT_DEPARTMENT: '指定部门(defaultDepartment)',
      AccountTitle: '财务科目(AccountTitle)'
    },
    StatementDescription: {
      YEAR: '年度(year)',
      STATEMENT_TYPE: '报表类型(statementType)',
      STATEMENT_NAME: '报表名称(statementName)',
      StatementDescription: '财务报表描述(StatementDescription)'
    },
    StatementColumnDescription: {
      GROUP_NO: '组号(groupNo)',
      COLUMN_NO: '列号(columnNo)',
      NAME: '名称(name)',
      StatementColumnDescription: '表头描述(StatementColumnDescription)'
    },
    StatementElementDescription: {
      GROUP_NO: '组号(groupNo)',
      LINE_NO: '行号(lineNo)',
      NAME: '项目名称(name)',
      ELEMENT_NO: '项号(elementNo)',
      AMOUNT_TYPE1: '财务金额类型1(amountType1)',
      AMOUNT_TYPE2: '财务金额类型2(amountType2)',
      AMOUNT_TYPE3: '财务金额类型3(amountType3)',
      CALCULATED_ITEM: '是否计算项(calculatedItem)',
      StatementElementDescription: '报表项目描述(StatementElementDescription)'
    },
    ElementFormula: {
      ACCOUNT_TITLE: '科目(accountTitle)',
      OPERATE_MODE: '运算方式(operateMode)',
      ElementFormula: '项目公式(ElementFormula)'
    },
    StatementElement: {
      YEAR: '年度(year)',
      MONTH: '月份(month)',
      FINANCIAL_AMOUNT1: '财务金额1(financialAmount1)',
      FINANCIAL_AMOUNT2: '财务金额2(financialAmount2)',
      FINANCIAL_AMOUNT3: '财务金额3(financialAmount3)',
      StatementElement: '报表项目(StatementElement)'
    },
    FiscalPeriod: {
      YEAR: '年度(year)',
      MONTH: '月份(month)',
      CLOSING: '是否结账(closing)',
      INITIAL_PERIOD: '是否初始期间(initialPeriod)',
      BEGIN_DATE: '开始日期(beginDate)',
      END_DATE: '结束日期(endDate)',
      EXCHANGE_DOCUMENT_NO: '调汇凭证号(exchangeDocumentNo)',
      CARRYOVER_DOCUMENT_NO: '损益结转凭证号(carryoverDocumentNo)',
      USE_GROUP_EXCHANGE_RATE: '是否使用集团汇率(useGroupExchangeRate)',
      FiscalPeriod: '会计期间(FiscalPeriod)'
    },
    AccountTitleBalance: {
      YEAR: '年度(year)',
      MONTH: '月份(month)',
      ACCOUNT_TITLE: '科目(accountTitle)',
      QUANTITY: '数量(quantity)',
      BEGINNING_BALANCE: '期初余额(beginningBalance)',
      BEGINNING_YEAR_DEBIT: '期初年累计借方发生额(beginningYearDebit)',
      BEGINNING_YEAR_CREDIT: '期初年累计贷方发生额(beginningYearCredit)',
      CURRENT_DEBIT_AMOUNT: '本期借方金额(currentDebitAmount)',
      CURRENT_CREDIT_AMOUNT: '本期贷方金额(currentCreditAmount)',
      BEGINNING_BALANCE_DEBIT: '期初借方期初余额(beginningBalanceDebit)',
      BEGINNING_BALANCE_CREDIT: '期初贷方期初余额(beginningBalanceCredit)',
      AccountTitleBalance: '科目余额表(AccountTitleBalance)'
    },
    AccountTitleBalanceCurrency: {
      SOURCE_CURRENCY: '原币种(sourceCurrency)',
      YEAR: '年度(year)',
      MONTH: '月份(month)',
      ACCOUNT_TITLE: '科目(accountTitle)',
      QUANTITY: '数量(quantity)',
      BEGINNING_BALANCE: '期初余额(beginningBalance)',
      BEGINNING_YEAR_DEBIT: '期初年累计借方发生额(beginningYearDebit)',
      BEGINNING_YEAR_CREDIT: '期初年累计贷方发生额(beginningYearCredit)',
      CURRENT_DEBIT_AMOUNT: '本期借方金额(currentDebitAmount)',
      CURRENT_CREDIT_AMOUNT: '本期贷方金额(currentCreditAmount)',
      SOURCE_BEGINNING_BALANCE: '原币期初余额(sourceBeginningBalance)',
      SOURCE_BEGINNING_YEAR_DEBIT: '原币期初年累计借方发生额(sourceBeginningYearDebit)',
      SOURCE_BEGINNING_YEAR_CREDIT: '原币期初年累计贷方发生额(sourceBeginningYearCredit)',
      SOURCE_CURRENT_DEBIT_AMOUNT: '原币本期借方金额(sourceCurrentDebitAmount)',
      SOURCE_CURRENT_CREDIT_AMOUNT: '原币本期贷方金额(sourceCurrentCreditAmount)',
      BEGINNING_BALANCE_DEBIT: '期初借方期初余额(beginningBalanceDebit)',
      BEGINNING_BALANCE_CREDIT: '期初贷方期初余额(beginningBalanceCredit)',
      EXCHANGE_RATE: '汇率(exchangeRate)',
      AccountTitleBalanceCurrency: '外币科目余额表(AccountTitleBalanceCurrency)'
    },
    FinancialExchangeRate: {
      ACCOUNT_SET_UUID: '账套uuid(accountSetUuid)',
      YEAR: '年度(year)',
      MONTH: '月份(month)',
      SOURCE_CURRENCY: '原币种(sourceCurrency)',
      TARGET_CURRENCY: '目标币种(targetCurrency)',
      RATE: '汇率(rate)',
      FinancialExchangeRate: '财务汇率(FinancialExchangeRate)'
    },
    AccountTitleAuxiliaryBalance: {
      ACCOUNT_CLIENT: '客户/供应商(accountClient)',
      STAFF_ID: '职员(staffId)',
      DEPARTMENT: '部门(department)',
      DEBIT_CREBIT: '借贷(debitCrebit)',
      BALANCE_CURRENCY_RMB: '余额人民币(balanceCurrencyRmb)',
      BALANCE_CURRENCY_USD: '余额美金(balanceCurrencyUsd)',
      YEAR: '年(year)',
      MONTH: '月份(month)',
      ACCOUNT_TITLE: '科目编码(accountTitle)',
      ACCOUNT_TITLE_NAME: '科目名称(accountTitleName)',
      CURRENT_CREDIT_AMOUNT: '本期发生贷方金额(currentCreditAmount)',
      CURRENT_DEBIT_AMOUNT: '本期发生借方金额(currentDebitAmount)',
      BEGINNING_YEAR_CREDIT: '本年合计贷方金额(beginningYearCredit)',
      BEGINNING_YEAR_DEBIT: '本年合计借方金额(beginningYearDebit)',
      SALES: '销售(sales)',
      PROJECT_NUMBER: '项目-1(projectNumber)',
      PROJECT_NUMBER2: '项目-2(projectNumber2)',
      BUSINESS_DATE: '业务日期(businessDate)',
      AccountTitleAuxiliaryBalance: '辅助期初余额(AccountTitleAuxiliaryBalance)'
    },
    AccountTitleAuxiliaryBalanceCurrency: {
      BEGINNING_BALANCE: '期初余额(beginningBalance)',
      CURRENT_CREDIT_AMOUNT: '本期贷方金额(currentCreditAmount)',
      CURRENT_DEBIT_AMOUNT: '本期借方金额(currentDebitAmount)',
      SOURCE_BEGINNING_BALANCE: '原币期初余额(sourceBeginningBalance)',
      SOURCE_BEGINNING_YEAR_CREDIT: '原币期初年累计贷方发生额(sourceBeginningYearCredit)',
      SOURCE_BEGINNING_YEAR_DEBIT: '原币期初年累计借方发生额(sourceBeginningYearDebit)',
      SOURCE_CURRENCY: '原币种(sourceCurrency)',
      SOURCE_CURRENT_CREDIT_AMOUNT: '原币本期贷方金额(sourceCurrentCreditAmount)',
      SOURCE_CURRENT_DEBIT_AMOUNT: '原币本期借方金额(sourceCurrentDebitAmount)',
      EXCHANGE_RATE: '汇率(exchangeRate)',
      BEGINNING_BALANCE_DEBIT: '期初借方期初余额(beginningBalanceDebit)',
      BEGINNING_BALANCE_CREDIT: '期初贷方期初余额(beginningBalanceCredit)',
      AccountTitleAuxiliaryBalanceCurrency: '往来辅助核算外币余额(AccountTitleAuxiliaryBalanceCurrency)'
    },
    ServiceProviderSelection: {
      NAME: '服务商名称(name)',
      SERVICE_NAME: '服务名称(serviceName)',
      SERVICE_INTRO: '服务简介(serviceIntro)',
      SERVICE_INTRO_URL: '服务介绍链接地址(serviceIntroUrl)',
      AUTHOR: '发布人(author)',
      CONTENT: '内容(content)',
      NEWS_DATE: '公告日期(newsDate)',
      NEWS_ID: '公告序号(newsId)',
      TITLE: '标题(title)',
      ServiceProviderSelection: '服务商优选(ServiceProviderSelection)'
    },
    Insure: {
      JOB_UUID: 'JOBUUID(jobUuid)',
      ORDER_GENERATE_STATUS: '出单成功状态<01成功02失败>(orderGenerateStatus)',
      ORDER_GENERATE_MESSAGE: '出单成功或失败的信息(orderGenerateMessage)',
      ORDER_GENERATE_DATE: '订单出单时间(orderGenerateDate)',
      ORDER_COMMIT_DATE: '订单提交时间(orderCommitDate)',
      ORDER_MODIFY_DATE: '订单修改时间(orderModifyDate)',
      POLICY_NO: '保单号(policyNo)',
      INSURE_NO: '投保单号(insureNo)',
      ORDER_STATUS: '投保状态(orderStatus)',
      PREMIUM: '保费(premium)',
      Insure: '投保记录(Insure)'
    },
    PortalShipmentOrder: {
      CUSTOMER: '委托人(customer)',
      JOB_NO: '工作号(jobNo)',
      MBL: 'MBL(mbl)',
      HBL: 'HBL(hbl)',
      VOYAGES_FLIGHTS: '航班航次(voyagesFlights)',
      PORT_OF_LOADING: '起运港(portOfLoading)',
      PORT_OF_DESTINATION: '目的港(portOfDestination)',
      SHIPPER_ID: '发货人Id(shipperId)',
      COSIGNEE_ID: '收货人Id(cosigneeId)',
      QUANTITY: '件数(quantity)',
      WEIGHT: '重量(weight)',
      CUBAGE: '体积(cubage)',
      GOOD_NAME: '品名(goodName)',
      SHIPPING_MARK: '唛头(shippingMark)',
      CARRIER: '承运人(carrier)',
      ETD: 'ETD(etd)',
      TRANSPORT_MODE: '运输方式(transportMode)',
      ETA: 'ETA(eta)',
      QUANTITY_ACTUAL: '实际件数(quantityActual)',
      WEIGHT_ACTUAL: '实际重量(weightActual)',
      CUBAGE_ACTUAL: '实际体积(cubageActual)',
      PO_NBR: '订单号(poNBR)',
      SHIPPER_NAME: '发货人名称(shipperName)',
      CONSIGNEE_NAME: '收货人名称(consigneeName)',
      PortalShipmentOrder: '货运订单(PortalShipmentOrder)'
    },
    PortalContainerQuantity: {
      EQ_SIZE: '箱型(eqSize)',
      EQ_TYPE: '箱种(eqType)',
      EQ_QUANTITY: '数量(eqQuantity)',
      PortalContainerQuantity: '箱量(PortalContainerQuantity)'
    },
    PortalContainer: {
      EQ_SIZE: '箱型(eqSize)',
      EQ_TYPE: '箱种(eqType)',
      CONTAINER_NO: '箱号(containerNo)',
      SEAL_NO: '封号(sealNo)',
      PortalContainer: '集装箱(PortalContainer)'
    },
    PortalShipmentNode: {
      NODE_TYPE: '节点类型(nodeType)',
      NODE_NAME: '节点名称(nodeName)',
      NODE_LOCAL_NAME: '节点本地名称(nodeLocalName)',
      LEVEL: '序号(level)',
      PortalShipmentNode: '货运节点(PortalShipmentNode)'
    },
    PortalNodeState: {
      STATE_NAME: '状态名称(stateName)',
      STATE_LOCAL_NAME: '状态本地名称(stateLocalName)',
      FINISHED_DATETIME: '完成时间(finishedDateTime)',
      STATE_TYPE: '状态类型(stateType)',
      REMARK: '状态说明(remark)',
      VERIFY_STATE: '审核状态(verifyState)',
      VERIFY_DATE: '审核日期(verifyDate)',
      LEVEL: '序号(level)',
      PortalNodeState: '节点状态(PortalNodeState)'
    },
    PortalRecipient: {
      RECIPIENT_NAME: '名称(recipientName)',
      RECIPIENT_LOCALNAME: '本地名称(recipientLocalName)',
      RECIPIENT_TYPE: '接收者类型(recipientType)',
      SYS_PARTNER_UUID: '合作伙伴Id(companyId)',
      PortalRecipient: '接收者(PortalRecipient)'
    },
    ApiPartner: {
      CODE: '代码(code)',
      NAME: '名称(name)',
      TOKEN_KEY: 'Token(TokenKey)',
      SECRET_KEY: 'Secret(SecretKey)',
      SERVER_PATH: 'Server(ServerPath)',
      REMARKS: '备注(remarks)',
      ApiPartner: 'API传递方信息(ApiPartner)'
    },
    ApiPartnerFunctions: {
      FUNCTION_TYPE: '函数调用类型(FunctionType)',
      FUNCTION_NAME: '函数名(FunctionName)',
      FUNCTION_DESC: '函数说明(FunctionDesc)',
      TOKEN_KEY: 'Token(TokenKey)',
      SECRET_KEY: 'Secret(SecretKey)',
      SERVER_PATH: 'Server(ServerPath)',
      REMARKS: '备注(remarks)',
      TO_TENANT: '消息接收方Tenant(toTenant)',
      PARTNER_FUNCTION_TYPE: '接收方API类型(partnerfunctionType)',
      ApiPartnerFunctions: 'API传递方函数信息(ApiPartnerFunctions)'
    },
    ServiceLog: {
      INVOCATION_ID: '调用标识(invocationId)',
      IP_ADDRESS: 'IP地址(ipAddress)',
      METHOD: '调用方法(method)',
      REQUEST_URL: '请求URL(requestUrl)',
      QUERY_PARAMETER: '查询参数(queryParameter)',
      START_TIME: '开始时间(startTime)',
      END_TIME: '结束时间(endTime)',
      AUTHORIZATION: '身份标识(authorization)',
      SUCCESS: '是否成功(success)',
      REQUEST_MSG: '请求信息(requestMsg)',
      RESPONSE_MSG: '响应信息(responseMsg)',
      COST: 'cost',
      SOURCE: 'source',
      ServiceLog: '系统数据传递日志'
    },
    CargoSystem: 'End'
  },

  ProperyLabelMap: {
    User: {
      userId: '用户序号(userId)',
      login: '登入名(login)',
      chineseName: '中文名 (chineseName)',
      englishName: '英文名(englishName)',
      password: '密码(password)',
      email: '电子邮箱(email)',
      phone: '电话(phone)',
      cell: '手机(cell)',
      fax: '传真(fax)',
      active: '激活(active)',
      expirationDate: '密码有效期(expirationDate)',
      defaultOfficeId: '默认分公司(defaultOfficeId)',
      defaultDepId: '默认部门(defaultDepId)',
      netCode: '网管代码(netCode)',
      manager: '上级主管(manager)',
      type: '用户类型(type)',
      portrait: '头像(portrait)',
      externalUser: '是否外部用户(externalUser)',
      partnerUUID: '外部用户所属合作伙伴UUID(partnerUUID)',
      userCode: '用户代码(userCode)',
      firstLoginDate: '首次登陆时间(firstLoginDate)',
      User: '用户(User)'
    },
    Privilege: {
      privilegeId: '权限序号(privilegeId)',
      name: '权限名(name)',
      category: '权限类(category)',
      shape: '权限型(shape)',
      point: '权限点(point)',
      description: '权限描述(description)',
      orderIndex: '顺序号(orderIndex)',
      Privilege: '权限(Privilege)'
    },
    Role: {
      roleId: '角色序号(roleId)',
      name: '角色名(name)',
      systemDefined: '固定角色(systemDefined)',
      description: '角色描述(description)',
      roleScope: '角色范围(roleScope)',
      Role: '角色(Role)'
    },
    Office: {
      officeId: '分公司序号(officeId)',
      code: '公司代码(code)',
      chineseName: '分公司中文名(chineseName)',
      englishName: '分公司英文名(englishName)',
      cityName: '城市名(cityName)',
      chineseAddress: '中文地址(chineseAddress)',
      seaAddressLine1: '海运提单地址(seaAddressLine1)',
      seaAddressLine2: '海运提单地址(seaAddressLine2)',
      seaAddressLine3: '海运提单地址(seaAddressLine3)',
      seaAddressLine4: '海运提单地址(seaAddressLine4)',
      seaAddressLine5: '海运提单地址(seaAddressLine5)',
      seaAddressLine6: '海运提单地址(seaAddressLine6)',
      airAddressLine1: '空运提单地址(airAddressLine1)',
      airAddressLine2: '空运提单地址(airAddressLine2)',
      airAddressLine3: '空运提单地址(airAddressLine3)',
      airAddressLine4: '空运提单地址(airAddressLine4)',
      airAddressLine5: '空运提单地址(airAddressLine5)',
      airAddressLine6: '空运提单地址(airAddressLine6)',
      zipCode: '邮政编码(zipCode)',
      phone: '电话(phone)',
      fax: '传真(fax)',
      email: '电子邮箱(email)',
      currency: '当地币种',
      airport: '默认空港(airport)',
      seaport: '默认海港(seaport)',
      rmbAccount: '人民币账号(rmbAccount)',
      usdAccount: '美元帐号(usdAccount)',
      taxAccount: '纳税人识别号(taxAccount)',
      overseaAddress: '海外帐单地址(overseaAddress)',
      localAddress: '国内帐单地址(localAddress)',
      EDICode: '海外EDI代码(EDICode)',
      taxRate: '税率(taxRate)',
      invoiceTaxRate: '开票税率(invoiceTaxRate)',
      clearEmail: '结算邮箱(clearEmail)',
      sajtInvoiceService: '税务系统接口服务地址(SajtInvoiceService)',
      invoiceTitle: '发票抬头(invoiceTitle)',
      invoiceAddress: '发票地址(invoiceAddress)',
      agreeTenantBooking: '同意接受外部委托(agreeTenantBooking)',
      userNameEi: '电子发票平台编码(userNameEi)',
      passWordEi: '电子发票密码(passWordEi)',
      taxPayerIdEi: '电子发票纳税人识别号(taxPayerIdEi)',
      authorizationCodeEi: '电子发票纳税人授权码(authorizationCodeEi)',
      invoiceServiceEi: '电子发票服务请求地址(invoiceServiceEi)',
      companyUuid: '关联合作伙伴(companyUuid)',
      Office: '公司/分公司(Office)'
    },
    BankAccount: {
      accoundId: '账号序号(accoundId)',
      description: '备注(description)',
      accountNo: '帐号(accountNo)',
      currency: '币种(currency)',
      bankChineseName: '银行中文名(bankChineseName)',
      bankEnglishName: '银行英文名(bankEnglishName)',
      bankEnglishAddress: '银行英文地址(bankEnglishAddress)',
      swiftCode: 'swiftCode',
      code: '账号代码(code)',
      shortName: '账号简称(shortName)',
      bankAddress: '银行中文地址(bankAddress)',
      BankAccount: '公司银行帐户(BankAccount)'
    },
    MailSubscribe: {
      subscriberId: '订阅人ID(subscriberId)',
      subscriberName: '订阅人名(subscriberName)',
      category: '订阅类(category)',
      shape: '订阅型(shape)',
      point: '订阅点(point)',
      remarks: '备注(remarks)',
      mail: '邮箱(mail)',
      name: '名称(name)',
      active: '是否有效(active)',
      MailSubscribe: '订阅(MailSubscribe)'
    },
    Department: {
      departmentId: '部门序号(departmentId)',
      code: '部门代码(code)',
      chineseName: '部门中文名称(chineseName)',
      englishName: '部门英文名称(englishName)',
      description: '备注(description)',
      jobNoPrefix: '工作号编码信息(JobNoPrefix)',
      clearing: '是否结算公司(clearing)',
      active: '是否有效',
      Department: '部门(Department)'
    },
    TenantInitState: {
      nodeCode: '节点代码(nodeCode)',
      state: '状态(state)',
      TenantInitState: 'Tenant初始化状态(TenantInitState)'
    },
    TenantInitScriptState: {
      scriptCode: '脚本代码(scriptCode)',
      executeState: '执行状态(executeState)',
      executeLog: '执行日志(executeLog)',
      TenantInitScriptState: 'Tenant初始化脚本状态(TenantInitScriptState)'
    },
    Delegation: {
      id: '序号(id)',
      delegator: '授权人(delegator)',
      delegatee: '被授权人(delegatee)',
      startTime: '起始日期(startTime)',
      endTime: '结束日期(endTime)',
      active: '是否有效(active)',
      remarks: '备注(remarks)',
      Delegation: '授权委托(Delegation)'
    },
    Menu: {
      menuId: '菜单Id(menuId)',
      code: '菜单代码(code)',
      chineseLabel: '中文名称(chineseLabel)',
      englishLabel: '英文名称(englishLabel)',
      icon: '(图标)icon',
      activeIcon: 'activeIcon',
      actions: 'actions',
      orderIndex: 'orderIndex',
      parentId: 'parentId',
      type: 'type',
      url: '(web地址)url',
      Menu: '系统菜单(Menu)'
    },
    InitalData: {
      seaPort: '海港(seaPort)',
      airPort: '空港(airPort)',
      chargeItem: '收费项目(chargeItem)',
      codeModule: '海关商品编码(codeModule)',
      country: '国家(Country)',
      region: '航线(region)',
      accessManagement: '权限管理(accessManagement)',
      config: '基本配置(config)',
      network: '网络(network)',
      currency: '币种(currency)',
      eQType: '箱种(eQType)',
      packing: '包装(packing)',
      platform: '提单类型(platForm)',
      cargotype: '货物类型(cargoType)',
      incoTerm: '贸易条款(incoTerm)',
      shippingTerm: '运输条款(shippingTerm)',
      priceAirService: '空运运费服务项目(priceAirService)',
      customerType: '客户类型(customerType)',
      blMode: '提单方式(blMode)',
      cutomJobType: '自定义业务类型(cutomJobType)',
      transmitFileType: '文件流转类型(transmitFileType)',
      tradeTerm: '贸易方式(tradeTerm)',
      portGroup: '关联港口(portGroup)',
      otherChargeItem: '空运运单杂费(otherChargeItem)',
      copyTenantId: '复制平台ID(copyTenantId)',
      documentCategory: '文件管理类型(documentCategory)',
      InitalData: '初始化数据(initalData)'
    },
    SubscribePortPush: {
      customerId: '客户Id(customerId)',
      SubscribePortPush: '客户订阅推送服务列表(SubscribePortPush)'
    },
    SubscribePortPushRule: {
      name: '名称(name)',
      property: '属性(property)',
      expression: '表达式(expression)',
      SubscribePortPushRule: '数据推送规则表(SubscribePortPushRule)'
    },
    Region: {
      code: '代码(code)',
      name: '区域名(name)',
      nameEnglish: '区域英文名(nameEnglish)',
      Region: '区域(Region)'
    },
    Country: {
      serialNumber: '序号(serialNumber)',
      interchangeCode: '交换码(interchangeCode)',
      isoCode: 'ISO代码(isoCode)',
      code: '代码(code)',
      name: '国名(name)',
      chineseName: '国家中文名(chineseName)',
      continent: '洲(continent)',
      Country: '国家(Country)'
    },
    AdministrativeDivision: {
      divisionType: '行政区划(divisionType)',
      parentId: '上级Id(parentId)',
      code: '代码(code)',
      name: '区划名(name)',
      englishName: '区划英文名(englishName)',
      AdministrativeDivision: '行政区划(AdministrativeDivision)'
    },
    Currency: {
      serialNumber: '序号(serialNumber)',
      interchangeCode: '交换码(interchangeCode)',
      isoCode: 'ISO代码(isoCode)',
      code: '货币代码(code)',
      name: '货币名称(name)',
      localName: '货币本地化名称(localName)',
      defaultFractionDigits: '默认小数位数(defaultFractionDigits)',
      symbol: '货币符号(symbol)',
      remarks: '备注(remarks)',
      Currency: '币种(Currency)'
    },
    AirPort: {
      serialNumber: '序号(serialNumber)',
      interchangeCode: '交换码(interchangeCode)',
      isoCode: 'ISO代码(isoCode)',
      code: '港口代码(code)',
      englishName: '港口英文名称(englishName)',
      chineseName: '港口中文名称(chineseName)',
      countryCode: '国家代码(countryCode)',
      region: '航线/区域(region)',
      AirPort: '空港(AirPort)'
    },
    SeaPort: {
      serialNumber: '序号(serialNumber)',
      interchangeCode: '交换码(interchangeCode)',
      isoCode: 'ISO代码(isoCode)',
      code: '港口代码(code)',
      englishName: '港口英文名称(englishName)',
      chineseName: '港口中文名称(chineseName)',
      countryCode: '国家代码(countryCode)',
      region: '航线/区域(region)',
      basePort: '基本港(basePort)',
      requirement: '目的港要求(requirement)',
      cityName: '城市名称(cityName)',
      cityCode: '城市代码(cityCode)',
      SeaPort: '海港(SeaPort)'
    },
    Packing: {
      serialNumber: '序号(serialNumber)',
      interchangeCode: '交换码(interchangeCode)',
      isoCode: 'ISO代码(isoCode)',
      code: '代码(code)',
      name: '名称(name)',
      chineseName: '中文名称(chineseName)',
      position: '位置(position)',
      ediCode: 'EDI代码(ediCode)',
      packType: '包装类型(packType)',
      Packing: '包装(Packing)'
    },
    Rate: {
      currency1: 'currency1',
      currency2: 'currency2',
      rate: 'rate',
      validdate1: 'validadate1',
      Rate: '汇率(Rate)'
    },
    EQType: {
      code: '代码(code)',
      name: '名称(name)',
      localName: '箱型本地化名称(localName)',
      remark: '备注(remark)',
      EQType: '箱型(EQType)'
    },
    ChargeItem: {
      serialNumber: '序号(serialNumber)',
      interchangeCode: '交换码(interchangeCode)',
      isoCode: 'ISO代码(isoCode)',
      branchId: '分公司(branchId)',
      itemId: '费用项目Id(itemId)',
      chargeCode: '费用代码(chargeCode)',
      enName: '费用英文名(enName)',
      zhName: '费用中文名(zhName)',
      measure: '费用计费方式(measure)',
      commission: '是否佣金(commission)',
      advance: '是否垫付(advance)',
      forOthers: '其它业务使用(forOthers)',
      forSeaExp: '海运出口使用(forSeaExp)',
      forSeaImp: '海运进口使用(forSeaImp)',
      forAirExp: '空运出口使用(forAirExp)',
      forAirImp: '空运进口使用(forAirImp)',
      defaultArCode: '默认应收对象(defaultArCode)',
      defaultArCurrency: '默认应收币种(defaultArCurrency)',
      defaultArPrice: '默认应收单价(defaultApPrice)',
      defaultApCode: '默认应付对象(defaultApCode)',
      defaultApCurrency: '默认应付币种(defaultApCurrency)',
      defaultApPrice: '默认应付单价(defaultApPrice)',
      remark: '费用项目备注(remark)',
      scaleCode: '交互代码(scaleCode)',
      surcharge: '附加费(surcharge)',
      localCharge: '本地费用(localCharge)',
      desCharge: '目的地费用(desCharge)',
      serviceType: '服务项目(serviceType)',
      defaultChargeItem: '是否默认费用(defaultChargeItem)',
      forRailwayExp: '铁路出口使用(forRailwayExp)',
      ChargeItem: '费用项(ChargeItem)'
    },
    Network: {
      code: '网络代码(code)',
      name: '网络名(name)',
      Network: '海外网络(Network)'
    },
    VesselCarrier: {
      carrierId: '船公司(carrierId)',
      EDICode: '船名EDI(EDICode)',
      remarks: '备注(remarks)',
      VesselCarrier: '关联共舱船公司(VesselCarrier)'
    },
    Vessel: {
      vesselId: '船名序号(vesselId)',
      englishName: '英文船名(englishName)',
      chineseName: '中文船名(chineseName)',
      imoCode: '劳氏代码(imoCode)',
      mmsiCode: '水上移动通讯标识号(mmsiCode)',
      callSign: '呼号(callSign)',
      carrierId: '船公司(carrierId)',
      importVoyage: '是否导入航次(importVoyage)',
      regCountry: '船名注册国(regCountry)',
      Vessel: '船名(Vessel)'
    },
    Voyage: {
      voyageId: '航次序号(voyageId)',
      vesselId: '船名序号(vesselId)',
      voyageNo: '航次代码(voyageNo)',
      voyageCode: 'EDI航次名称(ediVoyageCode)',
      ediVoyageNo: 'EDI航次代码(ediVoyageNo)',
      externalImport: '是否外部导入(externalImport)',
      Voyage: '航次(Voyage)'
    },
    VoyageSegment: {
      portOfCall: '停靠港(portOfCall)',
      berth: '港区(berth)',
      ETA: 'ETA',
      ETD: 'ETD',
      ediCode: 'EDI船舶呼号(ediCode)',
      externalImport: '是否外部导入(externalImport)',
      VoyageSegment: '航次明细(VoyageSegment)'
    },
    Business: {
      Id: '序号(Id)',
      companyEName: '公司英文名称(companyEName)',
      companyCode: '公司代码(companyCode)',
      inspectionCode: '商检编码(inspectionCode)',
      companyCName: '公司中文名(companyCName)',
      tenDigitCode: '海关十位码(tenDigitCode)',
      remarks: '备注(remarks)',
      Business: '海关十位码(Business)'
    },
    OrderFormType: {
      code: 'code',
      name: 'name',
      times: '提单允许打印次数(times)',
      OrderFormType: '提单种类(OrderFormType)'
    },
    ShippingTerm: {
      serialNumber: '序号(serialNumber)',
      interchangeCode: '交换码(interchangeCode)',
      isoCode: 'ISO代码(isoCode)',
      code: 'code',
      name: 'name',
      localName: '本地化名称(localName)',
      remark: '备注(remark)',
      ShippingTerm: '运输条款(ShippingTerm)'
    },
    ChargeItemGroup: {
      groupId: '费用组序号(groupId)',
      name: '费用组名称(name)',
      remark: '费用组备注(remark)',
      serviceType: '服务项目(serviceType)',
      ChargeItemGroup: '费用组(ChargeItemGroup)'
    },
    GroupDetail: {
      detailId: '明细序号(detailId)',
      chargeItemId: '费用项目Id(chargeItemId)',
      defaultChargeItem: '是否默认费用(defaultChargeItem)',
      GroupDetail: '费用组明细(GroupDetail)'
    },
    ChargeScheme: {
      schemeId: '费用方案序号(schemeId)',
      branchId: '分公司(branchId)',
      lob: '业务类型(lob)',
      name: '费用方案名称(name)',
      remark: '方案说明(remark)',
      inputBy: '方案创建人(inputBy)',
      inputDate: '方案创建日期(inputDate)',
      inputByDep: '创建人部门(inputByDep)',
      customerId: '委托单位编码(customerId)',
      bookingAgent: '订舱代理(bookingAgent)',
      carrierId: '承运人编号(carrierId)',
      cargoType: '货物种类(cargoType)',
      containerLoadType: '整拼类型(containerLoadType)',
      region: '航线/区域(region)',
      approvedState: '审核状态(approvedState)',
      approvedBy: '审核人(approvedBy)',
      dateApproved: '审核日期(dateApproved)',
      rejectReason: '拒绝原因(rejectReason)',
      effectiveDate: '生效日期(effectiveDate)',
      expiryDate: '失效日期(expiryDate)',
      destinationAgent: '目的港代理(destinationAgent)',
      ChargeScheme: '费用方案(ChargeScheme)'
    },
    SchemeDetail: {
      detailId: '明细序号(detailId)',
      receivable: '收付(receivable)',
      chargeItemId: '费用名称Id(chargeItemId)',
      accountId: '固定结算对象(accountId)',
      partnerType: '合作伙伴类型(partnerType)',
      measure: '收费种类(measure)',
      unitRate: '单价(unitRate)',
      currency: '币种(currency)',
      amount: '固定金额(amount)',
      remark: '备注(remark)',
      level: '序号(level)',
      unitStep: '收费单元(unitStep)',
      minimum: '最小收费金额(minimum)',
      rangeFrom: '收费区间开始(rangeFrom)',
      rangeTo: '收费区间结束(rangeTo)',
      eqType: '箱种(EQType)',
      eqSize: '箱型EQsize',
      quantity: '数量(quantity)',
      SchemeDetail: '费用方案明细(SchemeDetail)'
    },
    SchemeCriteria: {
      criteriaType: '条件类型(criteriaType)',
      criteriaValue: '条件值(criteriaValue)',
      SchemeCriteria: '费用方案条件(SchemeCriteria)'
    },
    CargoType: {
      code: '代码(code)',
      englishName: '英文名称(englishName)',
      chineseName: '中文名称(chineseName)',
      air: '是否空运(air)',
      sea: '是否海运(sea)',
      CargoType: '货物类型(CargoType)'
    },
    IncoTerm: {
      serialNumber: '序号(serialNumber)',
      interchangeCode: '交换码(interchangeCode)',
      isoCode: 'ISO代码(isoCode)',
      code: '代码(code)',
      name: '名称(name)',
      localName: '货币本地化名称(localName)',
      remark: '备注(remark)',
      IncoTerm: '贸易条款(IncoTerm)'
    },
    TradeTerm: {
      serialNumber: '序号(serialNumber)',
      interchangeCode: '交换码(interchangeCode)',
      isoCode: 'ISO代码(isoCode)',
      code: '代码(code)',
      name: '名称(name)',
      localName: '货币本地化名称(localName)',
      remark: '备注(remark)',
      TradeTerm: '贸易方式(TradeTerm)'
    },
    PaymentTerm: {
      serialNumber: '序号(serialNumber)',
      interchangeCode: '交换码(interchangeCode)',
      isoCode: 'ISO代码(isoCode)',
      code: '代码(code)',
      name: '名称(name)',
      localName: '本地化名称(localName)',
      remark: '备注(remark)',
      PaymentTerm: '运费条款(PaymentTerm)'
    },
    Continent: {
      code: '代码(code)',
      name: '洲名(name)',
      Continent: '洲(Continent)'
    },
    TemplateType: {
      templateType: '模板类(templateType)',
      templateTypeDesc: '模板类型说明(TemplateTypeDesc)',
      schemaType: '结构说明(SchemaType)',
      defaultEngine: '默认模板引擎(DefaultEngine)',
      remarks: '备注(remarks)',
      TemplateType: '打印模板类型(TemplateType)'
    },
    TemplateSchemaScript: {
      schemaType: '模板类(SchemaType)',
      schemaTable: '数据表(SchemaTable)',
      script: '脚本(Script)',
      TemplateSchemaScript: '打印模板查询脚本(TemplateSchemaScript)'
    },
    Template: {
      templateId: '模板序号(templateId)',
      name: '模板名称(name)',
      templateType: '模板类(templateType)',
      officeId: '分公司序号(officeId)',
      templateFile: '模板文件(templateFile)',
      filter: '过滤脚本(filter)',
      remarks: '备注(remarks)',
      engine: '模板引擎(Engine)',
      documentId: '模板文件云存储ID(DocumentId)',
      coverTemplateUUID: '附加输出关联模板(CoverTemplateUUID)',
      templateUsage: '模板用途(templateUsage)',
      Template: '打印模板(Template)'
    },
    TemplateAccess: {
      templateId: '模板序号(templateId)',
      name: '模板名称(name)',
      templateType: '模板类型(templateType)',
      officeId: '分公司序号(officeId)',
      templateFile: '模板文件(templateFile)',
      remarks: '备注(remarks)',
      docId: '业务关键字(DocId)',
      docType: '业务类型(DocType)',
      TemplateAccess: '模板访问日志(TemplateAccess)'
    },
    FeeFcl: {
      feeId: '附加费序号(feeId)',
      code: 'code',
      chineseName: 'chineseName',
      englishName: 'englishName',
      FeeFcl: '附加费(FeeFcl)'
    },
    PriceConfigFcl: {
      route: '航线(route)',
      category: '类(category)',
      value: '值(value)',
      PriceConfigFcl: '海运整箱报价配置(PriceConfigFcl)'
    },
    Config: {
      configId: '配置项(configId)',
      officeId: '分公司(officeId)',
      value: '值(value)',
      overrideable: '可否重设(overrideable)',
      Config: '系统配置(Config)'
    },
    ConfigDef: {
      configId: '配置项(configId)',
      name: '配置名(name)',
      officeOption: '分公司选项(officeOption)',
      client: '界面设置(client)',
      server: '服务设置(server)',
      dataType: '类型(dataType)',
      literals: '可选项(literals)',
      value: '缺省值(value)',
      remarks: '备注(remarks)',
      ConfigDef: '系统配置定义(ConfigDef)'
    },
    ConfigProfile: {
      profileId: '模板序号(profileId)',
      name: '模板名(name)',
      remarks: '备注(remarks)',
      ConfigProfile: '配置模板(ConfigProfile)'
    },
    ProfileDetail: {
      profileId: '模板序号(profileId)',
      configId: '配置项(configId)',
      value: '值(value)',
      overrideable: '可否重设(overrideable)',
      ProfileDetail: '配置模板细节(ProfileDetail)'
    },
    IataPrice: {
      carrier: '航空公司简称(carrier)',
      POL: '起运港(POL)',
      POD: '目的港(POD)',
      cargoType: '货物类型(cargoType)',
      levelM: '运价M(levelM)',
      levelN: '运价N(levelN)',
      level45: '运价45(level45)',
      level100: '运价100(level100)',
      level300: '运价300(level300)',
      level500: '运价500(level500)',
      level1000: '运价1000(level1000)',
      level2000: '运价2000(level2000)',
      remark: '备注(remark)',
      IataPrice: 'IATA运价(IataPrice)'
    },
    Berth: {
      port: '港口(port)',
      name: '港区名称(name)',
      Berth: '港区(Berth)'
    },
    OtherChargeItem: {
      chargeItemcode: '费用代码(chargeItemcode)',
      chineseName: '中文名(chineseName)',
      measure: '费用计费方式(measure)',
      defaultApPrice: '默认应收单价(defaultApPrice)',
      remark: '费用项目备注(remark)',
      OtherChargeItem: '空运运单杂费(OtherChargeItem)'
    },
    PriceServiceAir: {
      code: '代码(code)',
      chineseName: '中文名称(chineseName)',
      englishName: '英文名称(englishName)',
      PriceServiceAir: '空运运价服务项目(PriceServiceAir)'
    },
    AirRoute: {
      code: '代码(code)',
      name: '名称(name)',
      englishName: '英文名称(englishName)',
      originRegionCode: '起运区域代码(originRegionCode)',
      targetRegionCode: '目的区域代码(targetRegionCode)',
      AirRoute: '空运航线(AirRoute)'
    },
    AirRegion: {
      code: '代码(code)',
      name: '名称(name)',
      englishName: '英文名称(englishName)',
      AirRegion: '空运区域(AirRegion)'
    },
    AirPortRegion: {
      airPortId: '空港代码(airPortCode)',
      AirPortRegion: '空运区域港口(AirPortRegion)'
    },
    OperationResponsibility: {
      name: '名称(name)',
      englishName: '英文名称(englishName)',
      OperationResponsibility: '操作职责(OperationResponsibility)'
    },
    OperationResponsibilityCriteria: {
      criteriaType: '条件类型(criteriaType)',
      CriteriaValue: '条件值(CriteriaValue)',
      OperationResponsibilityCriteria: '操作职责条件(OperationResponsibilityCriteria)'
    },
    DocumentCategory: {
      lob: '业务类型(lob)',
      level: '序号(level)',
      code: '代码(code)',
      name: '名称(name)',
      localName: '本地名称(localName)',
      remarks: '备注(remarks)',
      DocumentCategory: '文件归类(DocumentCategory)'
    },
    DocumentType: {
      level: '序号(level)',
      code: '代码(code)',
      name: '名称(name)',
      localName: '本地名称(localName)',
      essentialScene: '必要场景(essentialScene)',
      originalScene: '正本场景(originalScene)',
      remarks: '备注(remarks)',
      sales: '销售(sales)',
      op: '操作(op)',
      other: '其他(other)',
      customer: '委托单位(customer)',
      consignee: '收货人(consignee)',
      shipper: '发货人(shipper)',
      destinationAgent: '海外代理(destinationAgent)',
      bookingAgent: '订舱代理(bookingAgent)',
      shared: '是否允许外部访问(shared)',
      templateRuleOne: '模板名称1(templateRuleOne)',
      templateRuleTwo: '模板名称2(templateRuleTwo)',
      templateRuleThree: '模板名称3(templateRuleThree)',
      templateRuleFour: '模板名称4(templateRuleFour)',
      separators: '分隔符(separators)',
      templateRuleName: '模板名称(templateRuleName)',
      DocumentType: ' 电子文件类型(DocumentType)'
    },
    ImageType: {
      code: '代码(code)',
      name: '名称(name)',
      width: '宽(width)',
      height: '高(height)',
      maxSize: '最大容量(maxSize)',
      format: '格式(format)',
      remarks: '备注(remarks)',
      ImageType: '图片类型(ImageType)'
    },
    SystemImage: {
      name: '图片名称(name)',
      officeId: '分公司(officeId)',
      imageFile: '图片文件(imageFile)',
      width: '宽(width)',
      height: '高(height)',
      SystemImage: '系统图片(SystemImage)'
    },
    OperationRequirementDescription: {
      descriptionId: '描述Id(descriptionId)',
      lob: '业务类型(lob)',
      operationRequirementType: '操作要求类型(operationRequirementType)',
      code: '代码(code)',
      contentDescription: '内容描述(contentDescription)',
      remarks: '备注(remarks)',
      OperationRequirementDescription: '操作要求描述(OperationRequirementDescription)'
    },
    ScacCodes: {
      scac: 'SCAC CODE(scac)',
      englishName: '英文名(englishName)',
      chineseName: '中文名(chineseName)',
      abbreviation: '简称(abbreviation)',
      ScacCodes: '船公司标准代码库(ScacCodes)'
    },
    HsCode: {
      countryCode: '国家代码(countryCode)',
      code: '商品编码(code)',
      commodityName: '品名(commodityName)',
      mfnRate: '最惠国税率(mfnRate)',
      generalRate: '普通税率(generalRate)',
      vat: '增值税(vat)',
      legalUnit: '法定单位(legalUnit)',
      secondUnit: '第二单位(secondUnit)',
      superviseMode: '监管方式(superviseMode)',
      mscCommodity: '英文品名(MSC)',
      HsCode: '海关商品编号(HsCode)'
    },
    EntityDefaultValue: {
      branchId: '分公司(branchId)',
      userId: '用户id(userId)',
      entityCode: '实体代码(entityCode)',
      entityName: '实体名称(entityName)',
      fieldCode: '字段代码(fieldCode)',
      fieldName: '字段名称(fieldName)',
      valueType: '值类型(valueType)',
      defaultValue: '默认值(defaultValue)',
      EntityDefaultValue: '实体默认值(EntityDefaultValue)'
    },
    CheckRule: {
      checkNode: '验证节点(checkNode)',
      checkCategory: '验证类型(checkCategory)',
      ruleName: '规则名称(ruleName)',
      checkMode: '验证模式(checkMode)',
      continueCheck: '是否继续验证(continueCheck)',
      remarks: '备注(remarks)',
      CheckRule: '验证规则(CheckRule)'
    },
    CheckCriteria: {
      relation: '关系(relation)',
      filterDimension: '过滤依据(filterDimension)',
      operator: '操作(operator)',
      filterValue: '过滤值(filterValue)',
      CheckCriteria: '验证条件(CheckCriteria)'
    },
    CheckExpression: {
      relation: '关系(relation)',
      checkItem: '验证项目(checkItem)',
      operator: '操作(operator)',
      checkValue: '验证值(checkValue)',
      CheckExpression: '验证表达式(CheckExpression)'
    },
    StatementConfig: {
      branchId: '分公司(branchId)',
      userId: '用户id(userId)',
      lob: '业务类型(lob)',
      name: '名称(name)',
      StatementConfig: '操作报表配置(StatementConfig)'
    },
    StatementColumn: {
      serialNumber: '顺序号(serialNumber)',
      name: '名称(name)',
      displayName: '显示名(displayName)',
      StatementColumn: '报表列(StatementColumn)'
    },
    MeasureCriteria: {
      filterDimension: '过滤依据(filterDimension)',
      operator: '操作(operator)',
      filterValue: '过滤值(filterValue)',
      MeasureCriteria: '度量计算条件(MeasureCriteria)'
    },
    BlMode: {
      serialNumber: '序号(serialNumber)',
      interchangeCode: '交换码(interchangeCode)',
      isoCode: 'ISO代码(isoCode)',
      code: 'code',
      name: 'name',
      localName: '本地化名称(localName)',
      remark: '备注(remark)',
      blType: '提单类型(blType)',
      BlMode: '提单方式(BlMode)'
    },
    JobNoRule: {
      ruleDesc: '编码规则说明(ruleDesc)',
      type: '业务类型(type)',
      regulation: '编码规则(regulation)',
      seqRegulation: '编码流水号规则(seqRegulation)',
      minSeq: '起始流水号(minSeq)',
      generateType: '生成时机',
      JobNoRule: '工作号生成规则(JobNoRule)'
    },
    CutomJobType: {
      serialNumber: '序号(serialNumber)',
      code: 'code',
      name: 'name',
      localName: '本地化名称(localName)',
      remarks: '备注(remarks)',
      type: '业务类型(type)',
      containerLoadType: '整拼类型(containerLoadType)',
      englishName: '英文名称(englishName)',
      CutomJobType: '工作号内部类型(customJobType)'
    },
    CustomerService: {
      partnerId: '合作伙伴ID(partnerId)',
      serviceName: '查询服务名(serviceName)',
      remarks: '备注(remarks)',
      serviceType: '类型(serviceType)',
      CustomerService: '合作伙伴信息查询(partnerWSInfo)'
    },
    DateAutoInitRule: {
      dateEntity: '待更新数据(dateEntity)',
      type: '业务类型(type)',
      baseDateField: '基数(baseDateField)',
      calcRule: '计算规则(calcRule)',
      remarks: '备注(remarks)',
      dataFilter: '过滤条件(dataFilter)',
      DateAutoInitRule: '业务日期默认计算规则(dateAutoInitRule)'
    },
    EntityTriggerType: {
      entityCode: '实体代码(entityCode)',
      entityName: '实体名称(entityName)',
      entityEname: '实体英文名称(entityEname)',
      fieldCode: '字段代码(fieldCode)',
      fieldName: '字段名称(fieldName)',
      fieldEname: '字段英文名称(fieldEname)',
      triggerType: '更新类型(triggerType)',
      fieldCheckType: '字段校验方式(fieldCheckType)',
      fieldCheckValue: '字段校验值(fieldCheckValue)',
      EntityTriggerType: '实体触发器类型(EntityTriggerType)'
    },
    MailServer: {
      smtpHost: 'SMTP邮件服务器(smtpHost)',
      smtpPort: 'SMTP端口(smtpPort)',
      smtpSsl: 'SMTP是否使用安全套接字层(smtpSsl)',
      smtpTimeOut: '发送服务器SMTP超时值(smtpTimeOut)',
      senderMail: '邮件发送方邮件(senderMail)',
      senderDisplayName: '邮件发送方名称(senderDisplayName)',
      authSender: 'STMP验证用户名(authSender)',
      authSenderPwd: 'SMTP验证密码(authSenderPwd)',
      returnPath: '默认回信地址(returnPath)',
      userEmail: '用户mail(userEmail)',
      remarks: '备注(remarks)',
      branchId: '分公司(branchId)',
      errorEmail: '异常接收邮箱(errorEmail)',
      ifAuto: '是否自动推送(ifAuto)',
      ifSop: '确认是否开启SOP推送(ifSop)',
      MailServer: '邮件发送服务器配置(MailServer)'
    },
    TransmitFileType: {
      lob: '业务类型(lob)',
      serialNumber: '序号(level)',
      code: '代码(code)',
      name: '名称(name)',
      localName: '本地名称(localName)',
      remarks: '备注(remarks)',
      interchangeCode: '交换代码(code)',
      englishName: '英文名称(englishName)',
      TransmitFileType: '文件流转文件类型(TransmitFileType)'
    },
    ProjectItem: {
      code: '项目代码(code)',
      name: '项目名(name)',
      ProjectItem: '项目(ProjectItem)'
    },
    RegionWarehouseMapping: {
      regionCode: '航线代码(regionCode)',
      warehouseId: '仓库(warehouseId)',
      remark: '备注(remark)',
      RegionWarehouseMapping: '区域与仓库映射(RegionWarehouseMapping)'
    },
    CommissionRule: {
      jobType: '业务类型(jobType)',
      accountPeriodBegin: '账期范围起始天数(accountPeriodBegin)',
      accountPeriodEnd: '账期范围结束天数(accountPeriodEnd)',
      percentage: '提成比例(percentage)',
      dateDatum: '日期基准(dateDatum)  0-ETD  1-其他日期',
      role: '岗位(role)',
      CommissionRule: '提成规则表(CommissionRule)'
    },
    IMDGCode: {
      unNo: '危险品联合国编号(unNo)',
      substance: 'substance(substance)',
      psn: '正确运输名称(psn)',
      classification: '危险品级别分类(classification)',
      subsidiaryRisks: 'subsidiaryRisks(subsidiaryRisks)',
      packingGroup: '包装类型代码(packingGroup)',
      specialProvisions: 'specialProvisions(specialProvisions)',
      limitedQuantities: 'limitedQuantities(limitedQuantities)',
      exceptedQuantities: 'exceptedQuantities(exceptedQuantities)',
      flashpoint: '危险品货物闪点(flashpoint)',
      emergencySchedule: '航运危险品应急措施(emergencySchedule)',
      packingInstruction: 'packingInstruction(packingInstruction)',
      packingProvisions: 'packingProvisions(packingProvisions)',
      ibcsInstruction: 'ibcsInstruction(ibcsInstruction)',
      ibcsProvisions: 'ibcsProvisions(ibcsProvisions)',
      tanksInstruction: 'tanksInstruction(tanksInstruction)',
      tanksProvisions: 'tanksProvisions(tanksProvisions)',
      stowageHandling: 'stowageHandling(stowageHandling)',
      segregation: 'segregation(segregation)',
      propertiesObservations: 'propertiesObservations(propertiesObservations)',
      psnCode: 'PSN CODE(psnCode)',
      techChemName: 'TECH.CHEM.NAME(techChemName)',
      imoSort: 'IMO SORT(imoSort)',
      segGroup: 'SEG GROUP(segGroup)',
      caa: 'CAA(caa)',
      pih: 'PIH(pih)',
      reportabelQty: 'EPORTABLE QTY(reportabelQty)',
      emerTemp: 'EMER TEMP(emerTemp)',
      mpCode: 'MP CODE(mpCode)',
      controlTemp: 'CONTROL TEMP(controlTemp)',
      density: 'DENSITY(density)',
      imdgFrom: 'IMDG FROM(imdgFrom)',
      imdgTo: 'IMDG TO(imdgTo)',
      mp: 'MP(mp)',
      IMDGCode: 'IMDG CODE(海运危险货物规则)'
    },
    SensitiveWord: {
      words: '敏感词(words)',
      wordField: '检测字段(wordField)',
      SensitiveWord: 'SensitiveWord(敏感词)'
    },
    MscServiceCode: {
      serviceCode: '代码(serviceCode)',
      serviceName: '名称(serviceName)',
      MscServiceCode: 'MscServiceCode(Msc服务代码)'
    },
    InnerPackage: {
      packageTypeCode: '类型代码(packageTypeCode)',
      packageTypeName: '类型名称(packageTypeName)',
      lcv: 'LCV(lcv)',
      InnerPackage: 'InnerPackage(Msc内包装类型)'
    },
    MscImoSort: {
      imoCode: 'imoCode(imoCode)',
      description: 'description(描述)',
      MscImoSort: 'MscImoSort(IMO SORT)'
    },
    MscSegGroup: {
      segGroupName: '名称(segGroupName)',
      MscSegGroup: 'MscSegGroup(SegGroup)'
    },
    Location: {
      chineseName: '中文名称(chineseName)',
      englishName: '英文名称(englishName)',
      locationCode: '五子码(locationCode)',
      code: '代码(code)',
      countryCode: '国家代码(countryCode)',
      Location: '地点(Location)'
    },
    LocationMapping: {
      mapType: '映射类型(mapType)',
      sourceCode: '源代码(sourceCode)',
      targetCode: '目标代码(targetCode)',
      targetName: '目标名称(targetName)',
      LocationMapping: '地点映射(LocationMapping)'
    },
    MsgNotify: {
      notifyDate: '通知内容的时间(notifyDate)',
      content: '内容/富文本(content)',
      type: '事件类型:0公告/1通知/2私信(type)',
      target: '事件源对象目标ID(target)',
      targetType: '事件源对象目标类型:财务/业务/合作伙伴ClassName(targetType)',
      actionCode: '动作编码(actionCode)',
      sender: '发送人(sender)',
      receiver: '接收人(receiver)',
      topic: '主题(topic)',
      readed: '是否已读(readed)',
      visible: '是否可见(visible)',
      confirmed: '是否确认(confirmed)',
      MsgNotify: '消息通知(MsgNotify)'
    },
    ContractConfig: {
      officeId: '分公司ID',
      warnDays: '天数',
      warnAdmin: '提醒:合同管理员',
      warnSale: '提醒:销售',
      forbidCreate: '不能再创建业务',
      ContractConfig: '合同到期提醒配置(ContractConfig)'
    },
    RailwayLine: {
      code: '代码(code)',
      name: '区域名(name)',
      nameEnglish: '区域英文名(nameEnglish)',
      RailwayLine: '铁路航线(RailwayLine)'
    },
    RailwayStation: {
      serialNumber: '序号(serialNumber)',
      code: '站点代码(code)',
      englishName: '英文名称(englishName)',
      chineseName: '中文名称(chineseName)',
      countryCode: '国家代码(countryCode)',
      region: '航线/区域(region)',
      cityCode: '城市代码(cityCode)',
      cityName: '城市名称(cityName)',
      interchangeCode: '交换码(interchangeCode)',
      isoCode: 'ISO代码(isoCode)',
      RailwayStation: '铁路站点(RailwayStation)'
    },
    InvoiceGoodsName: {
      officeId: '分公司ID',
      invoiceType: '发票类型',
      goodsNameRMB: 'RMB费用项目名称',
      goodsNameUSD: 'USD费用项目名称',
      goodsNameJPY: 'JPY费用项目名称',
      defaultGoodsName: '是否默认',
      taxRate: '税率',
      InvoiceGoodsName: '开票项目名称维护(InvoiceGoodsName)'
    },
    UserRersonalizeModule: {
      userId: '当前用户(userId)',
      modularCode: '模块标识(modularCode)',
      cacheType: '缓存类型(cacheType) 0.模块 1.桌面 2.表格颜色 3.合作伙伴显示',
      configContent: '配置内容(configContent)',
      UserRersonalizeModule: '模块(UserRersonalizeModule)'
    },
    SearchWrapFilter: {
      userId: '当前用户(userId)',
      moduleCode: '模块标识(moduleCode)',
      filterName: '过滤器名称(filterName)',
      level: '序号(level)',
      display: '是否展示(display)',
      searchCondition: '查询条件(searchCondition)',
      subOpen: '开启订阅(subOpen)',
      subTime: '订阅时间(subTime)',
      searchResult: '查询结果(searchResult)',
      SearchWrapFilter: '查询过滤器(SearchWrapFilter)'
    },
    Company: {
      branchId: '分公司(branchId)',
      cmpIdx: 'cmpIdx',
      englishName: '英文名称(englishName)',
      chineseName: '中文名称(chineseName)',
      shortName: '简称(shortName)',
      cnShortName: '客户中文名首字母(cnShortName)',
      address: '地址(address)',
      zipCode: '邮编(zipCode)',
      tel: '电话(tel)',
      fax: '传真(fax)',
      url: '网址(url)',
      region: '国家(region)',
      rmbAccount: '人民币开户行/帐号(rmbAccount)',
      usdAccount: '美圆开户行/帐号(usdAccount)',
      active: '是否有效(active)',
      global: '集团公司(global)',
      seaCmp: '船公司(seaCmp)',
      airCmp: '航空公司(airCmp)',
      seaCmpAgent: '船代(seaCmpAgent)',
      bookingAgent: '订舱代理(bookingAgent)',
      localAgent: '本地代理(localAgent)',
      overseaAgent: '海外代理(overseaAgent)',
      mustInputScn: '收发通是否选择录入(mustInputSCN)',
      designationAgent: '指定代理(designationAgent)',
      customer: '委托单位(customer)',
      truckCmp: '车队(truckCmp)',
      customsBroker: '报关公司(customsBroker)',
      warehouse: '仓库(warehouse)',
      settlementAgent: '结算代理(settlementAgent)',
      other: '其他(other)',
      seaExport: '海运出口(seaExport)',
      seaImport: '海运进口(seaImport)',
      airExport: '空运出口(airExport)',
      airImport: '空运进口(airImport)',
      remarks: '附加说明(remarks)',
      linkedBranchId: '连接分公司(linkedBranchId)',
      collection: '托收结算(collection)',
      shipper: '发货人(shipper)',
      consignee: '收货人(consignee)',
      notify: '通知人(notify)',
      taxRate: '税率(taxRate)',
      scac: '标准代码(scac)',
      province: '省(province)',
      city: '市(city)',
      districts: '区(districts)',
      detailedAddress: '详细地址(detailedAddress)',
      approvedState: '审核状态(approvedState)',
      approvedBy: '审核人(approvedBy)',
      dateApproved: '审核日期(dateApproved)',
      rejectReason: '拒绝原因(rejectReason)',
      parentBranchId: '上级分公司(parentBranchId)',
      relateTenantUuid: '关联TENANT的UUID(relateTenantUUID)',
      relateTenantId: '关联Tenant的ID(relateTenantId)',
      relateTenantOfficeId: '关联Tenant分公司ID(relateTenantOfficeId)',
      plateCode: '车队编码(plateCode)',
      freightVolume30: '30天内走货量(freightVolume30)',
      freightVolume60: '60天内走货量(freightVolume60)',
      freightVolume90: '90天内走货量(freightVolume90)',
      freightVolumeGt90: '大于90天走货量(freightVolumeGt90)',
      ifOpenSop: '是否开启SOP推送(ifOpenSop)',
      railwayExport: '铁路出口(railwayExport)',
      portAgent: '口岸代理(portAgent)',
      forwardingAgent: '发运代理(forwardingAgent)',
      loadingPlaceCompany: '装货地公司(loadingPlaceCompany)',
      signBillPlaceCompany: '签单地公司(signBillPlaceCompany)',
      dischargePortCompany: '卸货港公司(dischargePortCompany)',
      destinationPortCompany: '目的港公司(destinationPortCompany)',
      externalKeyCust: '外部客户主键(externalKeyCust)',
      externalKeyVend: '外部供应商主键(externalKeyVend)',
      Company: '合作伙伴(Company)'
    },
    CreditInfo: {
      creditDateType: '账款日期类型(creditDateType)',
      creditTerm: '账期(creditTerm)',
      termUnit: '账期单位(termUnit)',
      credit: '放帐额度(credit)',
      currency: '币种(currency)',
      blacklist: '是否黑名单(blacklist)',
      usedAmount: '已用额度(usedAmount)',
      amountExceeded: '是否超额度(amountExceeded)',
      dateExceeded: '是否超期(dateExceeded)',
      remarks: '备注(remarks)',
      receivableDeposit: '是否收款押金(receivableDeposit)',
      depositCurrency: '押金币种(depositCurrency)',
      depositAmount: '押金金额(depositAmount)',
      depositDate: '押金收付日期(depositDate)',
      depositType: '押金收付方式(depositType)',
      creditRmarks: '附加说明(creditRemarks)',
      CreditInfo: '放账信息(CreditInfo)'
    },
    Contact: {
      ContactPerson: '联系人(ContactPerson)',
      defaultContact: '是否默认联系人(defaultContact)',
      role: '职能(role)',
      telephone: 'telephone',
      fax: 'fax',
      mobile: 'mobile',
      email: 'email',
      remarks: 'remarks',
      relateUserId: 'relateUserId(关联账号id)',
      airline: '航线(airline)',
      pushNode: '推送节点(pushNode)',
      pushMode: '推送方式(pushMode)',
      Contact: '联系人(Contact)'
    },
    Site: {
      name: '门点名称(name)',
      contact: '门点联系人(contact)',
      phone: '联系人电话(phone)',
      address: '门点地址(address)',
      remarks: 'remarks',
      Site: '门点(Site)'
    },
    SpecialRequest: {
      requestId: 'requestId',
      request: '特殊要求(request)',
      lob: '业务类型(lob)',
      remarks: 'remarks',
      SpecialRequest: '特殊要求(SpecialRequest)'
    },
    Title: {
      title: '开票抬头(title)',
      taxAccount: '纳税人识别号(taxAccount)',
      address: '发票地址(address)',
      telephone: '电话(telephone)',
      defaultTitle: '是否默认抬头(defaultTitle)',
      email: '邮箱地址(email)',
      autoSend: '默认自动发送邮箱(autoSend)',
      Title: '开票抬头(Title)'
    },
    TitleBank: {
      currency: '币种(currency)',
      bank: '银行名称(bank)',
      bankAccount: '银行帐号(bankAccount)',
      defaultBank: '是否默认银行(defaultBank)',
      TitleBank: '开票抬头银行(TitleBank)'
    },
    OverseaAgent: {
      billAddress: '账单地址(billAddress)',
      forcastAddress: '预报地址(forcastAddress)',
      blAddress: '海运提单地址(blAddressLine1)',
      blAddressLine2: '海运提单地址(blAddressLine2)',
      blAddressLine3: '海运提单地址(blAddressLine3)',
      blAddressLine4: '海运提单地址(blAddressLine4)',
      blAddressLine5: '海运提单地址(blAddressLine5)',
      blAddressLine6: '海运提单地址(blAddressLine6)',
      airAddressLine1: '空运提单地址(airAddressLine1)',
      airAddressLine2: '空运提单地址(airAddressLine2)',
      airAddressLine3: '空运提单地址(airAddressLine3)',
      airAddressLine4: '空运提单地址(airAddressLine4)',
      airAddressLine5: '空运提单地址(airAddressLine5)',
      airAddressLine6: '空运提单地址(airAddressLine6)',
      network: '网络(network)',
      owner: '网络负责人(owner)',
      grade: '代理等级(grade)',
      blAddressLine7: '海运提单地址(blAddressLine7)',
      airAddressLine7: '空运提单地址(airAddressLine7)',
      OverseaAgent: '海外代理(OverseaAgent)'
    },
    Airline: {
      airlineCode: 'airlineCode',
      MAWBPrefix: 'MAWBPrefix',
      Airline: '航空公司(Airline)'
    },
    MAWBInfo: {
      branchId: '分公司(branchId)',
      schemeName: '方案名称(schemeName)',
      IATACode: 'IATACode',
      HandingInfo: 'HandingInfo',
      AccountInfo: 'AccountInfo',
      accountNo: 'accountNo',
      issuedBy: 'issuedBy',
      carrierAgentCity: 'carrierAgentCity',
      insuredAmount: 'insuredAmount',
      carriageDV: 'carriageDV',
      customsDV: 'customsDV',
      rateCharge: 'rateCharge',
      MAWBInfo: '航空公司主单默认信息(MAWBInfo)'
    },
    MAWBInfoOtherCharge: {
      chargeItem: '费用名称(chargeItem)',
      measure: '单位类型(measure)',
      unitRate: '单价(unitRate)',
      remark: '附加说明(remark)',
      minAmount: '最小收费金额(minAmount)',
      MAWBInfoOtherCharge: '航空公司主单默认其它费用 (MAWBInfoOtherCharge)'
    },
    Contract: {
      contractNo: 'contractNo',
      beginDate: 'beginDate',
      endDate: 'endDate',
      remarks: 'remarks',
      contractType: '合同类型',
      contractState: '合同状态: 4=已续签; 5=终止合同',
      contractAgreement: '合同协议',
      creditDateType: '结算方式',
      dateType: '日期类型',
      dateLimited: '账期',
      termUnit: '账期单位',
      credit: '信用额度',
      currency: '信用额度币种',
      postpone: '是否到期后顺延',
      postponeLimited: '顺延期限',
      postponeUnit: '顺延期限单位',
      postponeType: '顺延周期类型',
      isNeedSyshcronize: '是否需要同步',
      Contract: '合同(Contract)'
    },
    Customer: {
      customerTypeId: '客户类型Id(customerTypeId)',
      ownerType: '货主类型(ownerType)',
      ownerClass: '货主性质(ownerClass)',
      designated: '指定货客户(designated)',
      seftCanvass: '自揽货客户(seftCanvass)',
      peer: '是否同行(peer)',
      sales: '销售(sales)',
      ownerDepartment: '归属部门(ownerDepartment)',
      invoiceMode: '开票方式(invoiceMode)',
      overInvoicing: '可高开发票(overInvoicing)',
      invoiceRemarks: '开票备注(invoiceRemarks)',
      priceLevel: '运价级(priceLevel)',
      iTraceService: 'iTrace服务(iTraceService)',
      iTraceStartDate: 'iTrace服务启用日期(iTraceStartDate)',
      Customer: '委托单位(Customer)'
    },
    PortDestinationAgent: {
      destinationPort: 'destinationPort',
      destinationAgentId: 'destinationAgentId',
      defaultAgent: 'defaultAgent',
      remarks: 'remarks',
      loadingPort: '起运港(loadingPort)',
      PortDestinationAgent: '指定货客户目的港代理(PortDestinationAgent)'
    },
    Warehouse: {
      warehouseType: 'warehouseType',
      warehouseName: '仓库名称(warehouseName)',
      warehouseAddress: '仓库地址(warehouseAddress)',
      warehouseContact: '联系人(warehouseContact)',
      warehouseContactTel: '联系人电话(warehouseContactTel)',
      warehouseContactFax: '联系人传真(warehouseContactFax)',
      mapFileName: '地图(mapFileName)',
      mapFile: '地图图片(mapFile)',
      defaultWarehouse: '是否默认仓库(defaultWarehouse)',
      remarks: '备注(remarks)',
      Warehouse: '仓库(Warehouse)'
    },
    BillAddress: {
      partnerId: '合作伙伴编号(partnerId)',
      officeId: '分公司编号(officeId)',
      lob: '空运海运(lob)',
      lastUsed: '最近使用时间(lastUsed)',
      pod: '卸货港(pod)',
      shipperCode: '发货人代码(shipperCode)',
      shipperLine1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      shipperShortCode: '发货人代码缩写(shipperShortCode)',
      shipperEnterpriseCode: '发货人企业代码(shipperEnterpriseCode)',
      shipperEnterpriseName: '发货人企业名称(shipperEnterpriseName)',
      shipperAddress: '发货人详细地址(shipperAddress)',
      shipperContactsType: '发货人联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      shipperContacts: '发货人联系人(shipperContacts)',
      shipperCityName: '发货人城市名称(shipperCityName)',
      shipperProvinceCode: '发货人省份代码(shipperProvinceCode)',
      shipperProvinceName: '发货人省份名称(shipperProvinceName)',
      shipperZipCode: '发货人邮政编码(shipperZipCode)',
      shipperCountryCode: '发货人国家代码(shipperCountryCode)',
      shipperAeoEnterpriseCode: '发货人AEO企业编码(shipperAeoEnterpriseCode)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(consigneeLine1)',
      consigneeLine2: '收货人(consigneeLine2)',
      consigneeLine3: '收货人(consigneeLine3)',
      consigneeLine4: '收货人(consigneeLine4)',
      consigneeLine5: '收货人(consigneeLine5)',
      consigneeLine6: '收货人(consigneeLine6)',
      consigneeLine7: '收货人(consigneeLine7)',
      consigneeShortCode: '收货人代码缩写(consigneeShortCode)',
      consigneeEnterpriseCode: '收货人企业代码(consigneeEnterpriseCode)',
      consigneeEnterpriseName: '发货人企业名称(consigneeEnterpriseName)',
      consigneeAddress: '收货人详细地址(consigneeAddress)',
      consigneeContactsType: '收货人联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      consigneeContacts: '收货人联系人(consigneeContacts)',
      consigneeCityName: '收货人城市名称(consigneeCityName)',
      consigneeProvinceCode: '收货人省份代码(consigneeProvinceCode)',
      consigneeProvinceName: '收货人省份名称(consigneeProvinceName)',
      consigneeZipCode: '收货人邮政编码(consigneeZipCode)',
      consigneeCountryCode: '收货人国家代码(consigneeCountryCode)',
      consigneeAeoEnterpriseCode: '收货人AEO企业编码(consigneeAeoEnterpriseCode)',
      consigneeSpecificContactsName: '收货人具体联系人名称(consigneeSpecificContactsName)',
      consigneeSpecificContactsType: '收货人具体联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      consigneeSpecificContacts: '收货人具体联系人(consigneeSpecificContacts)',
      notifyCode: '通知人代码(notifyCode)',
      notifyLine1: '通知人(notifyLine1)',
      notifyLine2: '通知人(notifyLine2)',
      notifyLine3: '通知人(notifyLine3)',
      notifyLine4: '通知人(notifyLine4)',
      notifyLine5: '通知人(notifyLine5)',
      notifyLine6: '通知人(notifyLine6)',
      notifyLine7: '通知人(notifyLine7)',
      notifyShortCode: '通知人代码缩写(notifyShortCode)',
      notifyEnterpriseCode: '通知人企业代码(notifyEnterpriseCode)',
      notifyEnterpriseName: '通知人企业名称(notifyEnterpriseName)',
      notifyAddress: '通知人详细地址(notifyAddress)',
      notifyContactsType: '通知人联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      notifyContacts: '通知人联系人(notifyContacts)',
      notifyCityName: '通知人城市名称(notifyCityName)',
      notifyProvinceCode: '通知人省份代码(notifyProvinceCode)',
      notifyProvinceName: '通知人省份名称(notifyProvinceName)',
      notifyZipCode: '通知人邮政编码(notifyZipCode)',
      notifyCountryCode: '通知人国家代码(notifyCountryCode)',
      notifyAeoEnterpriseCode: '通知人AEO企业编码(notifyAeoEnterpriseCode)',
      instructBill: '指示提单instructBill(instructBill)',
      billHistoryType: '提单历史类型(billHistoryType)',
      BillAddress: '收发通(BillAddress)'
    },
    Shipping: {
      branchId: '分公司(branchId)',
      sendCode: '发送方代码(sendCode)',
      receiveCode: '接收方代码(receiveCode)',
      EDI: '是否导EDI(EDI)',
      CNCode: 'CN代码(CNCode)',
      bookingAgentId: '订舱代理(bookingAgentId)',
      bookingPartyCode: '订舱人代码(BookingPartyCode)',
      Shipping: '船公司信息(Shipping)'
    },
    CreditHistory: {
      action: 'action',
      companyUuid: 'companyUuid',
      jobUuid: 'jobUuid',
      reason: 'reason',
      jobNo: 'jobNo',
      CreditHistory: '信誉历史(CreditHistory)'
    },
    ChargePardon: {
      chargeUuid: 'chargeUuid',
      remarks: 'remarks',
      ChargePardon: 'ChargePardon'
    },
    OverseaAgentPort: {
      lob: '空运海运(lob)',
      port: '港口(port)',
      OverseaAgentPort: '海外代理港口(OverseaAgentPort)'
    },
    CustomerType: {
      typeId: '类型Id(typeId)',
      englishName: '英文名称(englishName)',
      chineseName: '中文名称(chineseName)',
      CustomerType: '客户类型(CustomerType)'
    },
    BookingAgentCarrier: {
      branchId: '分公司(branchId)',
      carrierType: '承运人类型(carrierType)',
      bookingMode: '订舱方式(bookingMode)',
      BookingAgentCarrier: '订舱代理承运人(BookingAgentCarrier)'
    },
    CompanyUser: {
      lob: '业务类型(lob)',
      roleType: '用户岗位类型(roleType)',
      userId: '用户(userId)',
      defaultUser: '是否默认(defaultUser)',
      remarks: '备注(remarks)',
      CompanyUser: '合作伙伴对应的用户(CompanyUser)'
    },
    PartnerAuthorization: {
      authorizationType: '授权类型(authorizationType)',
      authorizationValue: '授权内容(authorizationValue)',
      PartnerAuthorization: '合作伙伴授权(PartnerAuthorization)'
    },
    ManifestAddress: {
      shortCode: '代码缩写(shortCode)',
      enterpriseCode: '企业代码(enterpriseCode)',
      enterpriseName: '名称(enterpriseName)',
      address: '详细地址(address)',
      contactsType: '联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      contacts: '联系人(contacts)',
      cityName: '城市名称(cityName)',
      provinceCode: '省份代码(provinceCode)',
      provinceName: '省份名称(provinceName)',
      zipCode: '邮政编码(zipCode)',
      countryCode: '国家代码(countryCode)',
      aeoEnterpriseCode: 'AEO企业编码(aeoEnterpriseCode)',
      specificContactsName: '具体联系人名称(specificContactsName)',
      specificContactsType: '具体联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      specificContacts: '具体联系人(specificContacts)',
      addressLine1: '地址一(addressLine1)',
      addressLine2: '地址二(addressLine2)',
      addressLine3: '地址三(addressLine3)',
      addressLine4: '地址四(addressLine4)',
      addressLine5: '地址五(addressLine5)',
      addressLine6: '地址六(addressLine6)',
      addressLine7: '地址七(addressLine7)',
      ManifestAddress: '舱单地址信息(ManifestAddress)'
    },
    OverseaAgentUser: {
      lob: '业务类型(lob)',
      roleType: '用户岗位类型(roleType)',
      userId: '用户(userId)',
      defaultUser: '是否默认(defaultUser)',
      remarks: '备注(remarks)',
      OverseaAgentUser: '目的港对应的海外客服(OverseaAgentUser)'
    },
    SopPushConfig: {
      officeId: '分公司(officeId)',
      ifAuto: '是否自动推送(ifAuto)',
      ifApplied: '应用总公司(ifApplied)',
      ifEmail: '是否开启邮件推送(ifEmail)',
      ifNote: '是否开启短信推送(ifNote)',
      ifSop: '是否校验推送接收人(ifSop)',
      noteChinese: '短信中文(noteChinese)',
      noteEnglish: '短信英文(noteEnglish)',
      SopPushConfig: 'SOP推送配置(SopPushConfig)'
    },
    Order: {
      orderId: '订单号(orderId)',
      orderDate: '订单日期(orderDate)',
      salesOffice: '销售公司(salesOffice)',
      salesDep: '业务员部门(salesDep)',
      sales: '业务员(sales)',
      cancelled: '是否取消(cancelled)',
      customer: '委托单位(customer)',
      customerContact: '联系人(customerContact)',
      contactTelephone: '联系电话(contactTelephone)',
      contactFax: '联系电传(contactFax)',
      designationAgent: '指定代理(designationAgent)',
      destinationAgent: '目的港代理(destinationAgent)',
      dispatchPort: '起运地(dispatchingPort)',
      loadingPortCode: '装货港代码(loadingPortCode)',
      dischargingPortCode: '卸货港代码(dischargingPortCode)',
      destinationPort: '目的地(destinationPort)',
      freightType: '业务类型(freightType)',
      quantity: '货物件数(quantity)',
      weight: '货物重量(weight)',
      cubage: '货物体积(cubage)',
      packing: '包装类型(packing)',
      description: '中文品名(description)',
      remarks: '备注(remarks)',
      inputBy: '创建人(inputBy)',
      inputDate: '创建日期(inputDate)',
      checkBy: '审核人(checkBy)',
      checkDate: '审核日期(checkDate)',
      inputByDep: '创建人部门(inputByDep)',
      inputByOffice: '创建人分公司(inputByOffice)',
      checkRemark: '审批备注(checkRemark)',
      op: '指派操作(op)',
      orderNo: '订单编号(orderNo)',
      Order: '订单(Order)'
    },
    OrderSeaEQ: {
      EQid: '序号(EQid)',
      EQsize: '箱型EQsize',
      EQtype: '箱种(EQtype)',
      quantity: '数量(quantity)',
      OrderSeaEQ: '预录箱型箱量(OrderSeaEQ)'
    },
    OrderCharge: {
      chargeId: '预录费用序号(chargeId)',
      local: '是否国内(isLocal)',
      ar: '是否应收(isAr)',
      accountId: '结算对象(accountId)',
      chargeCode: '费用名称(chargeCode)',
      currency: '币种(currency)',
      amount: '金额(amount)',
      inputBy: '创建人(inputBy)',
      inputByDep: '创建人部门(inputByDep)',
      inputByOffice: '创建人公司(inputByOffice)',
      OrderCharge: '预录费用(OrderCharge)'
    },
    Job: {
      jobNo: '工作号(jobNo)',
      warehouseNo: '进仓编号(warehouseNo)',
      customerRefNo: '客户参考号(customerRefNo)',
      agentRefNo: '代理业务编号(agentRefNo)',
      mbl: 'MBL(mbl)',
      mblNo5: 'MBL_NO5(mblNo5)',
      relatedJob: '公司往来关联号(relatedJob)',
      relatedJob2: '联运编号(relatedJob2)',
      mblOnly: '是否直发(mblOnly)',
      joinFlagMBL: 'MBL并单标志(joinFlagMBL)',
      joinFlagHBL: 'HBL并单标志(joinFlagHBL)',
      masterFlag: '拼箱主号标志(masterFlag)',
      cancelled: '是否取消(cancelled)',
      salesOffice: '销售公司(salesOffice)',
      salesDepartment: '销售部门(salesDepartment)',
      sales: '业务员(sales)',
      csrOffice: '客服公司(csrOffice)',
      csrDepartment: '客服部门(csrDepartment)',
      csr: '客服(csr)',
      opOffice: '操作公司(opOffice)',
      opDepartment: '操作部门(opDepartment)',
      op: '操作(op)',
      customerId: '委托单位编码(customerId)',
      customerContact: '联系人(customerContact)',
      contactTelephone: '联系电话(contactTelephone)',
      contactFax: '联系电传(contactFax)',
      designationAgent: '指定代理(designationAgent)',
      destinationAgent: '目的港代理(destinationAgent)',
      localAgent: '本地代理(localAgent)',
      masterAgent: '是否主代理(masterAgent)',
      bookingAgent: '订舱代理(bookingAgent)',
      customsBroker: '报关行(customsBroker)',
      dispatchingPlace: '发货地(dispatchingPlace)',
      destinationPlace: '最终目的地(destinationPlace)',
      destinationPlaceCode: '最终目的地代码(destinationPlaceCode)',
      loadingPortCode: '装货港代码(loadingPortCode)',
      dischargingPortCode: '卸货港代码(dischargingPortCode)',
      destinationPortCode: '目的港代码(destinationPortCode)',
      quantityContract: '委托货物件数(quantityContract)',
      weightContract: '委托货物重量(weightContract)',
      cubageContract: '委托货物体积(cubageContract)',
      quantityActual: '实际货物件数(quantityActual)',
      weightActual: '实际货物重量(weightActual)',
      cubageActual: '实际货物体积(cubageActual)',
      chargeWeight: '计费重量(chargeWeight)',
      chargeCubage: '计费体积(chargeCubage)',
      measurements: '货物尺寸(measurements)',
      cargoType: '货物种类(cargoType)',
      packing: '包装(packing)',
      paymentTermMBL: '主单运费方式(paymentTermMBL)',
      paymentTermHBL: '分单运费方式(paymentTermHBL)',
      cargoChineseName: '中文品名(cargoChineseName)',
      cargoEnglishName: '英文品名(cargoEnglishName)',
      mark: '唛头(mark)',
      carrierId: '承运人编号(carrierId)',
      carrierAgentId: '船代(carrierAgentId)',
      vessel: '船名(vessel)',
      voyageFlight: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      jobState: '业务状态(jobState)',
      comission: '业务提成金额(commission)',
      remarks: '备注(remarks)',
      businessDate: '业务日期(businessDate)',
      lob: '业务类型(lob)',
      shutOut: '是否退关(shutOut)',
      satisfiedRequests: ' 满足的特殊要求(satisfiedRequests)',
      dcOffice: '单证公司(dcOffice)',
      dcDepartment: '单证部门(dcDepartment)',
      dc: '单证(dc)',
      PONO: '项目编号(PONO)',
      agentLevel: '代理等级(agentLevel)',
      cargoSource: '货物来源(cargoSource)',
      containerDesc: '货量描述(containerDesc)',
      teu: 'teu',
      profit: 'profit',
      warehousing: '是否仓储(warehousing)',
      landTransportation: '是否路运(landTransportation)',
      international: '是否国际运输(international)',
      multiplePickups: '是否多次派车(multiplePickups)',
      advance: '是否垫付(advance)',
      blocked: '是否等待特批(blocked)',
      express: '是否是快递(express)',
      declareCustomsState: '报关状态(declareCustomsState)',
      warehouseNoFormat: '进仓编号格式化(warehouseNoFormat)',
      shipperId: '发货人Id(shipperId)',
      consigneeId: '收货人Id(consigneeId)',
      notifyId: '通知人Id(notifyId)',
      preverifyState: '预审核状态(preverifyState)',
      trustFromJob: '委托来源关联号(trustFromJob)',
      signMBL: '是否签发主单(signMBL)',
      signHBL: '是否签发分单(signHBL)',
      EstimateAccountsReceivable: '预估收入(EstimateAccountsReceivable)',
      EstimateAccountsPayable: '预估成本(EstimateAccountsPayable)',
      EstimateGrossProfit: '预估利润(EstimateGrossProfit)',
      shipperCode: '发货人代码(shipperCode)',
      shipperLine1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(consigneeLine1)',
      consigneeLine2: '收货人(consigneeLine2)',
      consigneeLine3: '收货人(consigneeLine3)',
      consigneeLine4: '收货人(consigneeLine4)',
      consigneeLine5: '收货人(consigneeLine5)',
      consigneeLine6: '收货人(consigneeLine6)',
      consigneeLine7: '收货人(consigneeLine7)',
      notifyCode: '通知人代码(notifyCode)',
      notifyLine1: '通知人(notifyLine1)',
      notifyLine2: '通知人(notifyLine2)',
      notifyLine3: '通知人(notifyLine3)',
      notifyLine4: '通知人(notifyLine4)',
      notifyLine5: '通知人(notifyLine5)',
      notifyLine6: '通知人(notifyLine6)',
      notifyLine7: '通知人(notifyLine7)',
      alsoNotify: '第二通知人(alsoNotify)',
      bookingRefuseNote: '拒绝订舱理由(bookingRefuseNote)',
      customsDate: '报关日期(customsDate)',
      customsRemarks: '报关备注(customsRemarks)',
      HSCODE: 'HS Code(HSCODE)',
      operationContent: '操作要求说明(operationContent)',
      situation: '情况说明(situation)',
      ATD: 'ATD',
      checkData: '已核对数据(checkData)',
      virtualHBL: '是否形式分单(virtualHBL)',
      receivableState: '应收状态(receivableState)',
      payablesState: '应付状态(payablesState)',
      priceNo: '运价No(priceNo)',
      booking: '是否订舱(booking)',
      priceTier: '运价等级(priceTier)',
      selfDeliver: '是否自拉自送(selfDeliver)',
      bookingState: '订舱状态(bookingState)',
      itmService: '是否有外贸(ITMService)',
      customsJobNo: '报关关联号(customsJobNo)',
      customJobType: '客户自定义业务种类(customJobType)',
      preverifier: '预审审核人(preverifier)',
      preverifyDate: '预审审核时间(preverifyDate)',
      salePrice: '是否特价(salePrice)',
      salePriceRemarks: '特价备注(salePriceRemarks)',
      salesChannel: '订舱渠道(salesChannel)',
      depositReceived: '预付款(depositReceived)',
      contactEmail: '联系邮件(contactEmail)',
      provisioned: '已计提(provisioned)',
      provisionedDate: '计提时间(provisionedDate)',
      provisionedBy: '计提人(provisionedBy)',
      planner: '航线(planner)',
      plannerDepartment: '航线部门(plannerDepartment)',
      riverCarrierId: '江船公司(riverCarrierId)',
      tradeTerm: '贸易方式(tradeTerm)',
      overseaOpDepartment: '外海操作部门(overseaOpDepartment)',
      overseaOp: '海外操作(overseaOp)',
      userDefinedField1: '自定义字段1(userDefinedField1)',
      userDefinedField2: '自定义字段2(userDefinedField2)',
      userDefinedField3: '自定义字段3(userDefinedField3)',
      manageAuditRemark: '审核备注(manageAuditRemark)',
      manageAuditRejectRemark: '审核拒绝备注(manageAuditRejectRemark)',
      manageAuditStatus: '主管审核状态(manageAuditStatus)',
      submitterUser: '提交人(submitterUser)',
      auditCheckNode: '提交审核节点(auditCheckNode)',
      typeHBL: '分单类型(typeHBL)',
      typeMBL: '主单类型(typeMBL)',
      ifPushSopM: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      ifPushSopZ: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      ifPushSopQ: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      ifPushSop: '是否确认推送SOP信息(ifPushSop)',
      changeState: '改单状态(changeState)',
      cargoSalesId: '揽货销售(cargoSalesId)',
      changeBy: '改单人(changeBy)',
      changeDate: '改单时间(changeDate)',
      closingAccountStatus: '结转状态(closingAccountStatus)',
      firstProvisionedDate: '首次计提时间(firstProvisionedDate)',
      firstProvisionedProfit: '首次提成利润(firstProvisionedProfit)',
      provisionedProfit: '累计提成利润(provisionedProfit)',
      provisionedStatus: '计提状态(provisionedStatus)',
      salesRequire: '销售要求(salesRequire)',
      userDefinedField4: '自定义字段4(userDefinedField4)',
      vesselPortArea: '港区船名(vesselPortArea)',
      voyageFlightPortArea: '港区航次(voyageFlightPortArea)',
      customerTenantId: '委托单位所属tenantId(customerTenantId)',
      customerTenantName: '委托单位所属tenantName(customerTenantName)',
      Job: '工作单(Job)'
    },
    SeaExportJob: {
      containerLoadType: '整拼类型(containerLoadType)',
      selfConsolidation: '是否自拼箱(selfConsolidation)',
      loadingTerm: '装箱方式(loadingTerm)',
      bookingTerm: '订舱性质(bookingTerm)',
      customClaim: '报关方式(customClaim)',
      incoTerm: '贸易条款(incoTerm)',
      dangerousGoods: '是否危险品(dangerousGoods)',
      sailingDay: '航期(sailingDay)',
      freightTerm: '运输条款(freightTerm)',
      freightTermHBL: '分单运输条款(freightTermHBL)',
      remarksBooking: '配舱通知书备注(remarksBooking)',
      remarksShipping: 'SHIPPING ADVICE备注(remarksShipping)',
      insideQuantity: '小件数(insideQuantity)',
      insidePacking: '小件数包装类型(insidePacking)',
      secondVesselETD: '二程开航日期(secondVesselETD)',
      secondVesselVoyage: '二程船名(secondVesselVoyage)',
      secondVoyage: '二程航次(secondVoyage)',
      thirdVesselETD: '三程开航日期(thirdVesselETD',
      thirdVesselVoyage: '三程船名航次(thirdVesselVoyage)',
      portDistrict: '港区(portDistrict)',
      portCode: '港口代码(portCode)',
      addressEIR: '交接单地址(addressEIR)',
      contactEIR: '交接单地址联系人(contactEIR)',
      phoneEIR: '交接单地址联系方式(phoneEIR)',
      terminalOpendate: '开港日期(terminalOpendate)',
      terminalCutoff: '截港日期(terminalCutoff)',
      customCutoff: '截关日期(customCutoff)',
      fileCutoff: '截单日期(fileCutoff)',
      comercialInspectation: '是否商检(comercialInspectation)',
      transfering: '是否转运(transfering)',
      customs: '是否报关(customs)',
      heating: '是否薰蒸(heating)',
      batch: '是否分批(batch)',
      AMS: '是否AMS(AMS)',
      barge: '是否驳船(barge)',
      vgm: '是否VGM(vgm)',
      bargeVessel: '驳船船名(bargeVessel)',
      bargeVoyage: '驳船航次(bargeVoyage)',
      bargeETD: '驳船ETD(bargeETD)',
      bargeETA: '驳船ETA(bargeETA)',
      bargePOL: '驳船POL(bargePOL)',
      bargePOD: '驳船POD(bargePOD)',
      soNo: '配舱编号(soNo)',
      currency: '货值币种(currency)',
      amount: '货值金额(amount)',
      quotationNo: '运费协议号(quotationNo)',
      bookingEDI: '是否导订舱EDI(bookingEDI)',
      BLEDI: '是否导提单EDI(BLEDI)',
      agentEDI: '是否导海外代理EDI(agentEDI)',
      SOC: '是否货主箱(SOC)',
      agentPrice: '是否代理约价(agentPrice)',
      transferPortCode: '中转港代码(transferPortCode)',
      warehousePrinted: '是否打印进仓通知(warehousePrinted)',
      priceOwner: '约主(priceOwner)',
      yardCode: '堆场代码(yardCode)',
      vesselCode: '船舶呼号(vesselCode)',
      apCode: 'apCode',
      apName: 'apName',
      bookingNo: '订舱编号(bookingNo)',
      hds: 'HDS(hds)',
      scNo: '约号(scNo)',
      customerCutoff: '客户截关日期(customerCutoff)',
      customerShutout: '客户退关日期(CustomerShutOut)',
      bargeCustomCutoff: '驳船截关日期(bargeCustomCutoff)',
      vesselLineCode: '船舶航线代码(vesselLineCode)',
      freeTime: '集装箱免租期(freeTime)',
      returnPeriodBegin: '预计还柜期间开始(returnPeriodBegin)',
      returnPeriodEnd: '预计还柜期间结束(returnPeriodEnd)',
      amsCutoff: '截AMS/ENS时间(amsCutoff)',
      operationTips: '操作提示(operationTips)',
      laneCode: '航线代码(laneCode)',
      subContractNo: '子合同号(subContractNo)',
      na: 'N/A(na)',
      naCode: 'N/A CODE(naCode)',
      realArrivalsDate: '实际进港时间(realArrivalsDate)',
      berthPlanDate: '计划靠泊时间(berthPlanDate)',
      unBerthPlanDate: '计划离泊时间(unBerthPlanDate)',
      actualBerthPlanDate: '实际靠泊时间(actualBerthPlanDate)',
      actualUnBerthPlanDate: '实际离泊时间(actualUnBerthPlanDate)',
      berthPlanPlace: '计划靠泊泊位(berthPlanPlace)',
      actualBerthPlanPlace: '实际靠泊泊位(actualBerthPlanPlace)',
      fnlTm: 'FNL TM(fnlTm 名称/代码：Truck/TRK，Barge/BRG，Rail/RAL)',
      insideQuantitySize: '小件数尺寸(insideQuantitySize)',
      spelling: '舱单是否加拼业务(Spelling)',
      vesselIMO: '船名IMO(vesselIMO)',
      actualArrivalTime: '实际到港时间(actualArrivalTime)',
      destPortCustomsClearanceTime: '目的港放关时间(destPortCustomsClearanceTime)',
      destPortDeliveryTime: '目的港送货时间(destPortDeliveryTime)',
      destPortReturnTime: '目的港还箱时间(destPortReturnTime)',
      subTenantId: '客户编号(subTenantId)',
      jobNo: '工作号(jobNo)',
      warehouseNo: '进仓编号(warehouseNo)',
      customerRefNo: '客户参考号(customerRefNo)',
      agentRefNo: '代理业务编号(agentRefNo)',
      mbl: 'MBL(mbl)',
      mblNo5: 'MBL_NO5(mblNo5)',
      relatedJob: '公司往来关联号(relatedJob)',
      relatedJob2: '联运编号(relatedJob2)',
      mblOnly: '是否直发(mblOnly)',
      joinFlagMBL: 'MBL并单标志(joinFlagMBL)',
      joinFlagHBL: 'HBL并单标志(joinFlagHBL)',
      masterFlag: '拼箱主号标志(masterFlag)',
      cancelled: '是否取消(cancelled)',
      salesOffice: '销售公司(salesOffice)',
      salesDepartment: '销售部门(salesDepartment)',
      sales: '业务员(sales)',
      csrOffice: '客服公司(csrOffice)',
      csrDepartment: '客服部门(csrDepartment)',
      csr: '客服(csr)',
      opOffice: '操作公司(opOffice)',
      opDepartment: '操作部门(opDepartment)',
      op: '操作(op)',
      customerId: '委托单位编码(customerId)',
      customerContact: '联系人(customerContact)',
      contactTelephone: '联系电话(contactTelephone)',
      contactFax: '联系电传(contactFax)',
      designationAgent: '指定代理(designationAgent)',
      destinationAgent: '目的港代理(destinationAgent)',
      localAgent: '本地代理(localAgent)',
      masterAgent: '是否主代理(masterAgent)',
      bookingAgent: '订舱代理(bookingAgent)',
      customsBroker: '报关行(customsBroker)',
      dispatchingPlace: '发货地(dispatchingPlace)',
      destinationPlace: '最终目的地(destinationPlace)',
      destinationPlaceCode: '最终目的地代码(destinationPlaceCode)',
      loadingPortCode: '装货港代码(loadingPortCode)',
      dischargingPortCode: '卸货港代码(dischargingPortCode)',
      destinationPortCode: '目的港代码(destinationPortCode)',
      quantityContract: '委托货物件数(quantityContract)',
      weightContract: '委托货物重量(weightContract)',
      cubageContract: '委托货物体积(cubageContract)',
      quantityActual: '实际货物件数(quantityActual)',
      weightActual: '实际货物重量(weightActual)',
      cubageActual: '实际货物体积(cubageActual)',
      chargeWeight: '计费重量(chargeWeight)',
      chargeCubage: '计费体积(chargeCubage)',
      measurements: '货物尺寸(measurements)',
      cargoType: '货物种类(cargoType)',
      packing: '包装(packing)',
      paymentTermMBL: '主单运费方式(paymentTermMBL)',
      paymentTermHBL: '分单运费方式(paymentTermHBL)',
      cargoChineseName: '中文品名(cargoChineseName)',
      cargoEnglishName: '英文品名(cargoEnglishName)',
      mark: '唛头(mark)',
      carrierId: '承运人编号(carrierId)',
      carrierAgentId: '船代(carrierAgentId)',
      vessel: '船名(vessel)',
      voyageFlight: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      jobState: '业务状态(jobState)',
      comission: '业务提成金额(commission)',
      remarks: '备注(remarks)',
      businessDate: '业务日期(businessDate)',
      lob: '业务类型(lob)',
      shutOut: '是否退关(shutOut)',
      satisfiedRequests: ' 满足的特殊要求(satisfiedRequests)',
      dcOffice: '单证公司(dcOffice)',
      dcDepartment: '单证部门(dcDepartment)',
      dc: '单证(dc)',
      PONO: '项目编号(PONO)',
      agentLevel: '代理等级(agentLevel)',
      cargoSource: '货物来源(cargoSource)',
      containerDesc: '货量描述(containerDesc)',
      teu: 'teu',
      profit: 'profit',
      warehousing: '是否仓储(warehousing)',
      landTransportation: '是否路运(landTransportation)',
      international: '是否国际运输(international)',
      multiplePickups: '是否多次派车(multiplePickups)',
      advance: '是否垫付(advance)',
      blocked: '是否等待特批(blocked)',
      express: '是否是快递(express)',
      declareCustomsState: '报关状态(declareCustomsState)',
      warehouseNoFormat: '进仓编号格式化(warehouseNoFormat)',
      shipperId: '发货人Id(shipperId)',
      consigneeId: '收货人Id(consigneeId)',
      notifyId: '通知人Id(notifyId)',
      preverifyState: '预审核状态(preverifyState)',
      trustFromJob: '委托来源关联号(trustFromJob)',
      signMBL: '是否签发主单(signMBL)',
      signHBL: '是否签发分单(signHBL)',
      EstimateAccountsReceivable: '预估收入(EstimateAccountsReceivable)',
      EstimateAccountsPayable: '预估成本(EstimateAccountsPayable)',
      EstimateGrossProfit: '预估利润(EstimateGrossProfit)',
      shipperCode: '发货人代码(shipperCode)',
      shipperLine1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(consigneeLine1)',
      consigneeLine2: '收货人(consigneeLine2)',
      consigneeLine3: '收货人(consigneeLine3)',
      consigneeLine4: '收货人(consigneeLine4)',
      consigneeLine5: '收货人(consigneeLine5)',
      consigneeLine6: '收货人(consigneeLine6)',
      consigneeLine7: '收货人(consigneeLine7)',
      notifyCode: '通知人代码(notifyCode)',
      notifyLine1: '通知人(notifyLine1)',
      notifyLine2: '通知人(notifyLine2)',
      notifyLine3: '通知人(notifyLine3)',
      notifyLine4: '通知人(notifyLine4)',
      notifyLine5: '通知人(notifyLine5)',
      notifyLine6: '通知人(notifyLine6)',
      notifyLine7: '通知人(notifyLine7)',
      alsoNotify: '第二通知人(alsoNotify)',
      bookingRefuseNote: '拒绝订舱理由(bookingRefuseNote)',
      customsDate: '报关日期(customsDate)',
      customsRemarks: '报关备注(customsRemarks)',
      HSCODE: 'HS Code(HSCODE)',
      operationContent: '操作要求说明(operationContent)',
      situation: '情况说明(situation)',
      ATD: 'ATD',
      checkData: '已核对数据(checkData)',
      virtualHBL: '是否形式分单(virtualHBL)',
      receivableState: '应收状态(receivableState)',
      payablesState: '应付状态(payablesState)',
      priceNo: '运价No(priceNo)',
      booking: '是否订舱(booking)',
      priceTier: '运价等级(priceTier)',
      selfDeliver: '是否自拉自送(selfDeliver)',
      bookingState: '订舱状态(bookingState)',
      itmService: '是否有外贸(ITMService)',
      customsJobNo: '报关关联号(customsJobNo)',
      customJobType: '客户自定义业务种类(customJobType)',
      preverifier: '预审审核人(preverifier)',
      preverifyDate: '预审审核时间(preverifyDate)',
      salePrice: '是否特价(salePrice)',
      salePriceRemarks: '特价备注(salePriceRemarks)',
      salesChannel: '订舱渠道(salesChannel)',
      depositReceived: '预付款(depositReceived)',
      contactEmail: '联系邮件(contactEmail)',
      provisioned: '已计提(provisioned)',
      provisionedDate: '计提时间(provisionedDate)',
      provisionedBy: '计提人(provisionedBy)',
      planner: '航线(planner)',
      plannerDepartment: '航线部门(plannerDepartment)',
      riverCarrierId: '江船公司(riverCarrierId)',
      tradeTerm: '贸易方式(tradeTerm)',
      overseaOpDepartment: '外海操作部门(overseaOpDepartment)',
      overseaOp: '海外操作(overseaOp)',
      userDefinedField1: '自定义字段1(userDefinedField1)',
      userDefinedField2: '自定义字段2(userDefinedField2)',
      userDefinedField3: '自定义字段3(userDefinedField3)',
      manageAuditRemark: '审核备注(manageAuditRemark)',
      manageAuditRejectRemark: '审核拒绝备注(manageAuditRejectRemark)',
      manageAuditStatus: '主管审核状态(manageAuditStatus)',
      submitterUser: '提交人(submitterUser)',
      auditCheckNode: '提交审核节点(auditCheckNode)',
      typeHBL: '分单类型(typeHBL)',
      typeMBL: '主单类型(typeMBL)',
      ifPushSopM: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      ifPushSopZ: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      ifPushSopQ: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      ifPushSop: '是否确认推送SOP信息(ifPushSop)',
      changeState: '改单状态(changeState)',
      cargoSalesId: '揽货销售(cargoSalesId)',
      changeBy: '改单人(changeBy)',
      changeDate: '改单时间(changeDate)',
      closingAccountStatus: '结转状态(closingAccountStatus)',
      firstProvisionedDate: '首次计提时间(firstProvisionedDate)',
      firstProvisionedProfit: '首次提成利润(firstProvisionedProfit)',
      provisionedProfit: '累计提成利润(provisionedProfit)',
      provisionedStatus: '计提状态(provisionedStatus)',
      salesRequire: '销售要求(salesRequire)',
      userDefinedField4: '自定义字段4(userDefinedField4)',
      vesselPortArea: '港区船名(vesselPortArea)',
      voyageFlightPortArea: '港区航次(voyageFlightPortArea)',
      customerTenantId: '委托单位所属tenantId(customerTenantId)',
      customerTenantName: '委托单位所属tenantName(customerTenantName)',
      SeaExportJob: '海运出口工作单(SeaExportJob)'
    },
    SeaImportJob: {
      containerLoadType: '整拼类型(containerLoadType)',
      HBL: '分单号(HBL)',
      incoTerm: '贸易条款(incoTerm)',
      portDistrict: '港区(portDistrict)',
      freightTermMBL: '主单运输条款(freightTermMBL)',
      freightTermHBL: '客户运输条款(freightTermHBL)',
      releaseType: '放货方式(releaseType)',
      paymentPlace: '付款地点(paymentPlace)',
      transDate: '换单日期(transDate)',
      releaseDate: '放货日期(releaseDate)',
      deliverDate: '送货日期(deliverDate)',
      ESD: '预计提箱日期(ESD)',
      returnDate: '还箱日期(returnDate)',
      releaseTypeMBL: '主单放单方式(releaseTypeMBL)',
      releaseTypeHBL: '分单放单方式(releaseTypeHBL)',
      secondVessel: '二程船名(secondVessel)',
      secondVoyage: '二程航次(secondVoyage)',
      trans: '是否换单(trans)',
      customs: '是否报关(customs)',
      customDate: '报关日期(customDate)',
      parts: '是否拆箱(parts)',
      quarantine: '是否动卫检(quarantine)',
      arriveStorageDate: '到库日期(arriveStorageDate)',
      customsHBL: '海关分单号(customsHBL)',
      vesselUnCode: '船舶代码(vesselUnCode)',
      deliverRemarks: '提货备注(deliverRemarks)',
      arriveStorageRemarks: '到库备注(arriveStorageRemarks)',
      customerRemarks: '委托单位备注(customerRemarks)',
      customsNo: '海关编号(customsNo)',
      vesselChineseName: '中文船名(vesselChineseName)',
      loadingPortOp: '起运港操作(loadingPortOp)',
      destinationPortOp: '目的地操作(destinationPortOp)',
      bookingTerm: '约价性质(bookingTerm)',
      scNo: '船公司约号(scNo)',
      insideQuantity: '小件数(insideQuantity)',
      insidePacking: '小件数包装类型(insidePacking)',
      vesselCode: '船舶呼号(vesselCode)',
      barge: '是否驳船(barge)',
      bargeVessel: '驳船船名(bargeVessel)',
      bargeVoyage: '驳船航次(bargeVoyage)',
      subTenantId: '客户编号(subTenantId)',
      jobNo: '工作号(jobNo)',
      warehouseNo: '进仓编号(warehouseNo)',
      customerRefNo: '客户参考号(customerRefNo)',
      agentRefNo: '代理业务编号(agentRefNo)',
      mbl: 'MBL(mbl)',
      mblNo5: 'MBL_NO5(mblNo5)',
      relatedJob: '公司往来关联号(relatedJob)',
      relatedJob2: '联运编号(relatedJob2)',
      mblOnly: '是否直发(mblOnly)',
      joinFlagMBL: 'MBL并单标志(joinFlagMBL)',
      joinFlagHBL: 'HBL并单标志(joinFlagHBL)',
      masterFlag: '拼箱主号标志(masterFlag)',
      cancelled: '是否取消(cancelled)',
      salesOffice: '销售公司(salesOffice)',
      salesDepartment: '销售部门(salesDepartment)',
      sales: '业务员(sales)',
      csrOffice: '客服公司(csrOffice)',
      csrDepartment: '客服部门(csrDepartment)',
      csr: '客服(csr)',
      opOffice: '操作公司(opOffice)',
      opDepartment: '操作部门(opDepartment)',
      op: '操作(op)',
      customerId: '委托单位编码(customerId)',
      customerContact: '联系人(customerContact)',
      contactTelephone: '联系电话(contactTelephone)',
      contactFax: '联系电传(contactFax)',
      designationAgent: '指定代理(designationAgent)',
      destinationAgent: '目的港代理(destinationAgent)',
      localAgent: '本地代理(localAgent)',
      masterAgent: '是否主代理(masterAgent)',
      bookingAgent: '订舱代理(bookingAgent)',
      customsBroker: '报关行(customsBroker)',
      dispatchingPlace: '发货地(dispatchingPlace)',
      destinationPlace: '最终目的地(destinationPlace)',
      destinationPlaceCode: '最终目的地代码(destinationPlaceCode)',
      loadingPortCode: '装货港代码(loadingPortCode)',
      dischargingPortCode: '卸货港代码(dischargingPortCode)',
      destinationPortCode: '目的港代码(destinationPortCode)',
      quantityContract: '委托货物件数(quantityContract)',
      weightContract: '委托货物重量(weightContract)',
      cubageContract: '委托货物体积(cubageContract)',
      quantityActual: '实际货物件数(quantityActual)',
      weightActual: '实际货物重量(weightActual)',
      cubageActual: '实际货物体积(cubageActual)',
      chargeWeight: '计费重量(chargeWeight)',
      chargeCubage: '计费体积(chargeCubage)',
      measurements: '货物尺寸(measurements)',
      cargoType: '货物种类(cargoType)',
      packing: '包装(packing)',
      paymentTermMBL: '主单运费方式(paymentTermMBL)',
      paymentTermHBL: '分单运费方式(paymentTermHBL)',
      cargoChineseName: '中文品名(cargoChineseName)',
      cargoEnglishName: '英文品名(cargoEnglishName)',
      mark: '唛头(mark)',
      carrierId: '承运人编号(carrierId)',
      carrierAgentId: '船代(carrierAgentId)',
      vessel: '船名(vessel)',
      voyageFlight: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      jobState: '业务状态(jobState)',
      comission: '业务提成金额(commission)',
      remarks: '备注(remarks)',
      businessDate: '业务日期(businessDate)',
      lob: '业务类型(lob)',
      shutOut: '是否退关(shutOut)',
      satisfiedRequests: ' 满足的特殊要求(satisfiedRequests)',
      dcOffice: '单证公司(dcOffice)',
      dcDepartment: '单证部门(dcDepartment)',
      dc: '单证(dc)',
      PONO: '项目编号(PONO)',
      agentLevel: '代理等级(agentLevel)',
      cargoSource: '货物来源(cargoSource)',
      containerDesc: '货量描述(containerDesc)',
      teu: 'teu',
      profit: 'profit',
      warehousing: '是否仓储(warehousing)',
      landTransportation: '是否路运(landTransportation)',
      international: '是否国际运输(international)',
      multiplePickups: '是否多次派车(multiplePickups)',
      advance: '是否垫付(advance)',
      blocked: '是否等待特批(blocked)',
      express: '是否是快递(express)',
      declareCustomsState: '报关状态(declareCustomsState)',
      warehouseNoFormat: '进仓编号格式化(warehouseNoFormat)',
      shipperId: '发货人Id(shipperId)',
      consigneeId: '收货人Id(consigneeId)',
      notifyId: '通知人Id(notifyId)',
      preverifyState: '预审核状态(preverifyState)',
      trustFromJob: '委托来源关联号(trustFromJob)',
      signMBL: '是否签发主单(signMBL)',
      signHBL: '是否签发分单(signHBL)',
      EstimateAccountsReceivable: '预估收入(EstimateAccountsReceivable)',
      EstimateAccountsPayable: '预估成本(EstimateAccountsPayable)',
      EstimateGrossProfit: '预估利润(EstimateGrossProfit)',
      shipperCode: '发货人代码(shipperCode)',
      shipperLine1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(consigneeLine1)',
      consigneeLine2: '收货人(consigneeLine2)',
      consigneeLine3: '收货人(consigneeLine3)',
      consigneeLine4: '收货人(consigneeLine4)',
      consigneeLine5: '收货人(consigneeLine5)',
      consigneeLine6: '收货人(consigneeLine6)',
      consigneeLine7: '收货人(consigneeLine7)',
      notifyCode: '通知人代码(notifyCode)',
      notifyLine1: '通知人(notifyLine1)',
      notifyLine2: '通知人(notifyLine2)',
      notifyLine3: '通知人(notifyLine3)',
      notifyLine4: '通知人(notifyLine4)',
      notifyLine5: '通知人(notifyLine5)',
      notifyLine6: '通知人(notifyLine6)',
      notifyLine7: '通知人(notifyLine7)',
      alsoNotify: '第二通知人(alsoNotify)',
      bookingRefuseNote: '拒绝订舱理由(bookingRefuseNote)',
      customsDate: '报关日期(customsDate)',
      customsRemarks: '报关备注(customsRemarks)',
      HSCODE: 'HS Code(HSCODE)',
      operationContent: '操作要求说明(operationContent)',
      situation: '情况说明(situation)',
      ATD: 'ATD',
      checkData: '已核对数据(checkData)',
      virtualHBL: '是否形式分单(virtualHBL)',
      receivableState: '应收状态(receivableState)',
      payablesState: '应付状态(payablesState)',
      priceNo: '运价No(priceNo)',
      booking: '是否订舱(booking)',
      priceTier: '运价等级(priceTier)',
      selfDeliver: '是否自拉自送(selfDeliver)',
      bookingState: '订舱状态(bookingState)',
      itmService: '是否有外贸(ITMService)',
      customsJobNo: '报关关联号(customsJobNo)',
      customJobType: '客户自定义业务种类(customJobType)',
      preverifier: '预审审核人(preverifier)',
      preverifyDate: '预审审核时间(preverifyDate)',
      salePrice: '是否特价(salePrice)',
      salePriceRemarks: '特价备注(salePriceRemarks)',
      salesChannel: '订舱渠道(salesChannel)',
      depositReceived: '预付款(depositReceived)',
      contactEmail: '联系邮件(contactEmail)',
      provisioned: '已计提(provisioned)',
      provisionedDate: '计提时间(provisionedDate)',
      provisionedBy: '计提人(provisionedBy)',
      planner: '航线(planner)',
      plannerDepartment: '航线部门(plannerDepartment)',
      riverCarrierId: '江船公司(riverCarrierId)',
      tradeTerm: '贸易方式(tradeTerm)',
      overseaOpDepartment: '外海操作部门(overseaOpDepartment)',
      overseaOp: '海外操作(overseaOp)',
      userDefinedField1: '自定义字段1(userDefinedField1)',
      userDefinedField2: '自定义字段2(userDefinedField2)',
      userDefinedField3: '自定义字段3(userDefinedField3)',
      manageAuditRemark: '审核备注(manageAuditRemark)',
      manageAuditRejectRemark: '审核拒绝备注(manageAuditRejectRemark)',
      manageAuditStatus: '主管审核状态(manageAuditStatus)',
      submitterUser: '提交人(submitterUser)',
      auditCheckNode: '提交审核节点(auditCheckNode)',
      typeHBL: '分单类型(typeHBL)',
      typeMBL: '主单类型(typeMBL)',
      ifPushSopM: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      ifPushSopZ: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      ifPushSopQ: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      ifPushSop: '是否确认推送SOP信息(ifPushSop)',
      changeState: '改单状态(changeState)',
      cargoSalesId: '揽货销售(cargoSalesId)',
      changeBy: '改单人(changeBy)',
      changeDate: '改单时间(changeDate)',
      closingAccountStatus: '结转状态(closingAccountStatus)',
      firstProvisionedDate: '首次计提时间(firstProvisionedDate)',
      firstProvisionedProfit: '首次提成利润(firstProvisionedProfit)',
      provisionedProfit: '累计提成利润(provisionedProfit)',
      provisionedStatus: '计提状态(provisionedStatus)',
      salesRequire: '销售要求(salesRequire)',
      userDefinedField4: '自定义字段4(userDefinedField4)',
      vesselPortArea: '港区船名(vesselPortArea)',
      voyageFlightPortArea: '港区航次(voyageFlightPortArea)',
      customerTenantId: '委托单位所属tenantId(customerTenantId)',
      customerTenantName: '委托单位所属tenantName(customerTenantName)',
      SeaImportJob: '海运进口工作单(SeaImportJob)'
    },
    AirExportJob: {
      operateType: '操作模式(operateType)',
      HAWB: '分单号(HAWB)',
      bookingTerm: '订舱性质(bookingTerm)',
      customClaim: '报关方式(customClaim)',
      incoTerm: '贸易条款(incoTerm)',
      typeHAWB: '分单类型(typeHAWB)',
      secondPortCode: '二程港口(secondPortCode)',
      secondBookingAgentId: '二程订舱代理(secondBookingAgentId)',
      secondCarrierId: '二程航空公司(secondCarrierId)',
      secondETD: '二程开航日期(secondETD)',
      secondFlight: '二程航班(secondFlight)',
      secondMAWB: '二程运单号(secondMAWB)',
      thirdCarrierId: '三程航空公司(thirdCarrierId)',
      thirdETD: '三程开航日期(thirdETD)',
      thirdFlight: '三程航班(thirdFlight)',
      thirdMAWB: '三程运单号(thirdMAWB)',
      thirdPortCode: '三程港口(thirdPortCode)',
      comercialInspectation: '是否商检(comercialInspectation)',
      documentAll: '是否单齐(documentAll)',
      cargoArrive: '是否货到(cargoArrive)',
      comercialInspectCheck: '是否商检查验(comercialInspectCheck)',
      InspectCheck: '是否海关查验(InspectCheck)',
      currency: '币种(currency)',
      KCNo: 'KCNo',
      cabinReq: '舱位要求(cabinReq)',
      loadReq: '装板要求(loadReq)',
      docReq: '制单要求(docReq)',
      remarksShipping: 'SHIPPING ADVICE备注(remarksShipping)',
      insideQuantity: '小件数(insideQuantity)',
      insidePacking: '小件数包装类型(insidePacking)',
      loadingAgentId: '起运港代理(loadingAgentId)',
      cargoProp: '二级货物类型(cargoProp)',
      cWeight: '实际计费重量(cWeight)',
      transfering: '是否转运(transfering)',
      loadingTerm: '本地服务(loadingTerm)',
      customsClaim2: '委托报关类别(customsClaim2)',
      quantityBooking: '订舱件数(quantityBooking)',
      weightBooking: '订舱重量(weightBooking)',
      cubageBooking: '订舱体积(cubageBooking)',
      chargeWeightBooking: '订舱计费重量(chargeWeightBooking)',
      csTotal: '报关票数(csTotal)',
      csCounts: '已报关票数(csCounts)',
      checkCounts: '查验票数(checkCounts)',
      ciCounts: '商检票数(ciCounts)',
      shipment: '是否已出货(shipment)',
      handOff: '是否已交接(handOff)',
      pbProportion: '客户分泡比例(pbProportion)',
      pbProportion2: '供应商分泡比例(pbProportion2)',
      siteRemark: '现场备注(siteRemark)',
      selling: '卖价(selling)',
      buying: '买价(buying)',
      siteOpDepartment: '现场操作部门(siteOpDepartment)',
      siteOP: '现场操作(siteOP)',
      sealCounts: '关封票数(sealCounts)',
      authorizeCounts: '授权票数(authorizeCounts)',
      patchUpCounts: '联单票数(patchUpCounts)',
      ownWarehouse: '货进本仓(ownWarehouse)',
      takePhotos: '拍照(takePhotos)',
      documentsAttached: '附随机文件(documentsAttached)',
      estimatedDateOfWarehousinge: '预计进仓时间(estimatedDateOfWarehousinge)',
      otherWarehouseNotes: '其它进仓说明(otherWarehouseNotes)',
      deliveryAgent: '交货代理(deliveryAgent)',
      deliveryRemark: '交货备注(deliveryRemark)',
      otherCharges: '杂费(otherCharges)',
      predictionOperation: '预报操作(predictionOperation)',
      printedLabel: '已打印标签(printedLabel)',
      actualFlight: '实际航班(actualFlight)',
      onwardJourney: '续程信息(onwardJourney)',
      protocolType: '协议类型(protocolType)',
      fileCutoff: '截单日期(fileCutoff)',
      subTenantId: '客户编号(subTenantId)',
      jobNo: '工作号(jobNo)',
      warehouseNo: '进仓编号(warehouseNo)',
      customerRefNo: '客户参考号(customerRefNo)',
      agentRefNo: '代理业务编号(agentRefNo)',
      mbl: 'MBL(mbl)',
      mblNo5: 'MBL_NO5(mblNo5)',
      relatedJob: '公司往来关联号(relatedJob)',
      relatedJob2: '联运编号(relatedJob2)',
      mblOnly: '是否直发(mblOnly)',
      joinFlagMBL: 'MBL并单标志(joinFlagMBL)',
      joinFlagHBL: 'HBL并单标志(joinFlagHBL)',
      masterFlag: '拼箱主号标志(masterFlag)',
      cancelled: '是否取消(cancelled)',
      salesOffice: '销售公司(salesOffice)',
      salesDepartment: '销售部门(salesDepartment)',
      sales: '业务员(sales)',
      csrOffice: '客服公司(csrOffice)',
      csrDepartment: '客服部门(csrDepartment)',
      csr: '客服(csr)',
      opOffice: '操作公司(opOffice)',
      opDepartment: '操作部门(opDepartment)',
      op: '操作(op)',
      customerId: '委托单位编码(customerId)',
      customerContact: '联系人(customerContact)',
      contactTelephone: '联系电话(contactTelephone)',
      contactFax: '联系电传(contactFax)',
      designationAgent: '指定代理(designationAgent)',
      destinationAgent: '目的港代理(destinationAgent)',
      localAgent: '本地代理(localAgent)',
      masterAgent: '是否主代理(masterAgent)',
      bookingAgent: '订舱代理(bookingAgent)',
      customsBroker: '报关行(customsBroker)',
      dispatchingPlace: '发货地(dispatchingPlace)',
      destinationPlace: '最终目的地(destinationPlace)',
      destinationPlaceCode: '最终目的地代码(destinationPlaceCode)',
      loadingPortCode: '装货港代码(loadingPortCode)',
      dischargingPortCode: '卸货港代码(dischargingPortCode)',
      destinationPortCode: '目的港代码(destinationPortCode)',
      quantityContract: '委托货物件数(quantityContract)',
      weightContract: '委托货物重量(weightContract)',
      cubageContract: '委托货物体积(cubageContract)',
      quantityActual: '实际货物件数(quantityActual)',
      weightActual: '实际货物重量(weightActual)',
      cubageActual: '实际货物体积(cubageActual)',
      chargeWeight: '计费重量(chargeWeight)',
      chargeCubage: '计费体积(chargeCubage)',
      measurements: '货物尺寸(measurements)',
      cargoType: '货物种类(cargoType)',
      packing: '包装(packing)',
      paymentTermMBL: '主单运费方式(paymentTermMBL)',
      paymentTermHBL: '分单运费方式(paymentTermHBL)',
      cargoChineseName: '中文品名(cargoChineseName)',
      cargoEnglishName: '英文品名(cargoEnglishName)',
      mark: '唛头(mark)',
      carrierId: '承运人编号(carrierId)',
      carrierAgentId: '船代(carrierAgentId)',
      vessel: '船名(vessel)',
      voyageFlight: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      jobState: '业务状态(jobState)',
      comission: '业务提成金额(commission)',
      remarks: '备注(remarks)',
      businessDate: '业务日期(businessDate)',
      lob: '业务类型(lob)',
      shutOut: '是否退关(shutOut)',
      satisfiedRequests: ' 满足的特殊要求(satisfiedRequests)',
      dcOffice: '单证公司(dcOffice)',
      dcDepartment: '单证部门(dcDepartment)',
      dc: '单证(dc)',
      PONO: '项目编号(PONO)',
      agentLevel: '代理等级(agentLevel)',
      cargoSource: '货物来源(cargoSource)',
      containerDesc: '货量描述(containerDesc)',
      teu: 'teu',
      profit: 'profit',
      warehousing: '是否仓储(warehousing)',
      landTransportation: '是否路运(landTransportation)',
      international: '是否国际运输(international)',
      multiplePickups: '是否多次派车(multiplePickups)',
      advance: '是否垫付(advance)',
      blocked: '是否等待特批(blocked)',
      express: '是否是快递(express)',
      declareCustomsState: '报关状态(declareCustomsState)',
      warehouseNoFormat: '进仓编号格式化(warehouseNoFormat)',
      shipperId: '发货人Id(shipperId)',
      consigneeId: '收货人Id(consigneeId)',
      notifyId: '通知人Id(notifyId)',
      preverifyState: '预审核状态(preverifyState)',
      trustFromJob: '委托来源关联号(trustFromJob)',
      signMBL: '是否签发主单(signMBL)',
      signHBL: '是否签发分单(signHBL)',
      EstimateAccountsReceivable: '预估收入(EstimateAccountsReceivable)',
      EstimateAccountsPayable: '预估成本(EstimateAccountsPayable)',
      EstimateGrossProfit: '预估利润(EstimateGrossProfit)',
      shipperCode: '发货人代码(shipperCode)',
      shipperLine1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(consigneeLine1)',
      consigneeLine2: '收货人(consigneeLine2)',
      consigneeLine3: '收货人(consigneeLine3)',
      consigneeLine4: '收货人(consigneeLine4)',
      consigneeLine5: '收货人(consigneeLine5)',
      consigneeLine6: '收货人(consigneeLine6)',
      consigneeLine7: '收货人(consigneeLine7)',
      notifyCode: '通知人代码(notifyCode)',
      notifyLine1: '通知人(notifyLine1)',
      notifyLine2: '通知人(notifyLine2)',
      notifyLine3: '通知人(notifyLine3)',
      notifyLine4: '通知人(notifyLine4)',
      notifyLine5: '通知人(notifyLine5)',
      notifyLine6: '通知人(notifyLine6)',
      notifyLine7: '通知人(notifyLine7)',
      alsoNotify: '第二通知人(alsoNotify)',
      bookingRefuseNote: '拒绝订舱理由(bookingRefuseNote)',
      customsDate: '报关日期(customsDate)',
      customsRemarks: '报关备注(customsRemarks)',
      HSCODE: 'HS Code(HSCODE)',
      operationContent: '操作要求说明(operationContent)',
      situation: '情况说明(situation)',
      ATD: 'ATD',
      checkData: '已核对数据(checkData)',
      virtualHBL: '是否形式分单(virtualHBL)',
      receivableState: '应收状态(receivableState)',
      payablesState: '应付状态(payablesState)',
      priceNo: '运价No(priceNo)',
      booking: '是否订舱(booking)',
      priceTier: '运价等级(priceTier)',
      selfDeliver: '是否自拉自送(selfDeliver)',
      bookingState: '订舱状态(bookingState)',
      itmService: '是否有外贸(ITMService)',
      customsJobNo: '报关关联号(customsJobNo)',
      customJobType: '客户自定义业务种类(customJobType)',
      preverifier: '预审审核人(preverifier)',
      preverifyDate: '预审审核时间(preverifyDate)',
      salePrice: '是否特价(salePrice)',
      salePriceRemarks: '特价备注(salePriceRemarks)',
      salesChannel: '订舱渠道(salesChannel)',
      depositReceived: '预付款(depositReceived)',
      contactEmail: '联系邮件(contactEmail)',
      provisioned: '已计提(provisioned)',
      provisionedDate: '计提时间(provisionedDate)',
      provisionedBy: '计提人(provisionedBy)',
      planner: '航线(planner)',
      plannerDepartment: '航线部门(plannerDepartment)',
      riverCarrierId: '江船公司(riverCarrierId)',
      tradeTerm: '贸易方式(tradeTerm)',
      overseaOpDepartment: '外海操作部门(overseaOpDepartment)',
      overseaOp: '海外操作(overseaOp)',
      userDefinedField1: '自定义字段1(userDefinedField1)',
      userDefinedField2: '自定义字段2(userDefinedField2)',
      userDefinedField3: '自定义字段3(userDefinedField3)',
      manageAuditRemark: '审核备注(manageAuditRemark)',
      manageAuditRejectRemark: '审核拒绝备注(manageAuditRejectRemark)',
      manageAuditStatus: '主管审核状态(manageAuditStatus)',
      submitterUser: '提交人(submitterUser)',
      auditCheckNode: '提交审核节点(auditCheckNode)',
      typeHBL: '分单类型(typeHBL)',
      typeMBL: '主单类型(typeMBL)',
      ifPushSopM: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      ifPushSopZ: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      ifPushSopQ: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      ifPushSop: '是否确认推送SOP信息(ifPushSop)',
      changeState: '改单状态(changeState)',
      cargoSalesId: '揽货销售(cargoSalesId)',
      changeBy: '改单人(changeBy)',
      changeDate: '改单时间(changeDate)',
      closingAccountStatus: '结转状态(closingAccountStatus)',
      firstProvisionedDate: '首次计提时间(firstProvisionedDate)',
      firstProvisionedProfit: '首次提成利润(firstProvisionedProfit)',
      provisionedProfit: '累计提成利润(provisionedProfit)',
      provisionedStatus: '计提状态(provisionedStatus)',
      salesRequire: '销售要求(salesRequire)',
      userDefinedField4: '自定义字段4(userDefinedField4)',
      vesselPortArea: '港区船名(vesselPortArea)',
      voyageFlightPortArea: '港区航次(voyageFlightPortArea)',
      customerTenantId: '委托单位所属tenantId(customerTenantId)',
      customerTenantName: '委托单位所属tenantName(customerTenantName)',
      AirExportJob: '空运出口工作单(AirExportJob)'
    },
    AirImportJob: {
      HBL: '分单号(HBL)',
      operateType: '操作模式(operateType)',
      freightTerm: '运输条款(freightTerm)',
      releaseTypeMbl: '主单放货方式(releaseTypeMbl)',
      releaseTypeHbl: '分单放货方式(releaseTypeHbl)',
      loadingAgentId: '起运港代理(loadingAgentId)',
      groundAgentId: '地面代理(groundAgentId)',
      customs: '是否报关(customs)',
      transDate: '换单日期(transDate)',
      releaseDate: '放货日期(releaseDate)',
      deliverDate: '送货日期(deliverDate)',
      arriveStorageDate: '到库日期(arriveStorageDate)',
      customsHBL: '海关分单号(customsHBL)',
      deliverRemarks: '提货备注(deliverRemarks)',
      arriveStorageRemarks: '到库备注(arriveStorageRemarks)',
      loadingPortOp: '起运港操作(loadingPortOp)',
      destinationPortOp: '目的地操作(destinationPortOp)',
      incoTerm: '贸易条款(incoTerm)',
      subTenantId: '客户编号(subTenantId)',
      jobNo: '工作号(jobNo)',
      warehouseNo: '进仓编号(warehouseNo)',
      customerRefNo: '客户参考号(customerRefNo)',
      agentRefNo: '代理业务编号(agentRefNo)',
      mbl: 'MBL(mbl)',
      mblNo5: 'MBL_NO5(mblNo5)',
      relatedJob: '公司往来关联号(relatedJob)',
      relatedJob2: '联运编号(relatedJob2)',
      mblOnly: '是否直发(mblOnly)',
      joinFlagMBL: 'MBL并单标志(joinFlagMBL)',
      joinFlagHBL: 'HBL并单标志(joinFlagHBL)',
      masterFlag: '拼箱主号标志(masterFlag)',
      cancelled: '是否取消(cancelled)',
      salesOffice: '销售公司(salesOffice)',
      salesDepartment: '销售部门(salesDepartment)',
      sales: '业务员(sales)',
      csrOffice: '客服公司(csrOffice)',
      csrDepartment: '客服部门(csrDepartment)',
      csr: '客服(csr)',
      opOffice: '操作公司(opOffice)',
      opDepartment: '操作部门(opDepartment)',
      op: '操作(op)',
      customerId: '委托单位编码(customerId)',
      customerContact: '联系人(customerContact)',
      contactTelephone: '联系电话(contactTelephone)',
      contactFax: '联系电传(contactFax)',
      designationAgent: '指定代理(designationAgent)',
      destinationAgent: '目的港代理(destinationAgent)',
      localAgent: '本地代理(localAgent)',
      masterAgent: '是否主代理(masterAgent)',
      bookingAgent: '订舱代理(bookingAgent)',
      customsBroker: '报关行(customsBroker)',
      dispatchingPlace: '发货地(dispatchingPlace)',
      destinationPlace: '最终目的地(destinationPlace)',
      destinationPlaceCode: '最终目的地代码(destinationPlaceCode)',
      loadingPortCode: '装货港代码(loadingPortCode)',
      dischargingPortCode: '卸货港代码(dischargingPortCode)',
      destinationPortCode: '目的港代码(destinationPortCode)',
      quantityContract: '委托货物件数(quantityContract)',
      weightContract: '委托货物重量(weightContract)',
      cubageContract: '委托货物体积(cubageContract)',
      quantityActual: '实际货物件数(quantityActual)',
      weightActual: '实际货物重量(weightActual)',
      cubageActual: '实际货物体积(cubageActual)',
      chargeWeight: '计费重量(chargeWeight)',
      chargeCubage: '计费体积(chargeCubage)',
      measurements: '货物尺寸(measurements)',
      cargoType: '货物种类(cargoType)',
      packing: '包装(packing)',
      paymentTermMBL: '主单运费方式(paymentTermMBL)',
      paymentTermHBL: '分单运费方式(paymentTermHBL)',
      cargoChineseName: '中文品名(cargoChineseName)',
      cargoEnglishName: '英文品名(cargoEnglishName)',
      mark: '唛头(mark)',
      carrierId: '承运人编号(carrierId)',
      carrierAgentId: '船代(carrierAgentId)',
      vessel: '船名(vessel)',
      voyageFlight: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      jobState: '业务状态(jobState)',
      comission: '业务提成金额(commission)',
      remarks: '备注(remarks)',
      businessDate: '业务日期(businessDate)',
      lob: '业务类型(lob)',
      shutOut: '是否退关(shutOut)',
      satisfiedRequests: ' 满足的特殊要求(satisfiedRequests)',
      dcOffice: '单证公司(dcOffice)',
      dcDepartment: '单证部门(dcDepartment)',
      dc: '单证(dc)',
      PONO: '项目编号(PONO)',
      agentLevel: '代理等级(agentLevel)',
      cargoSource: '货物来源(cargoSource)',
      containerDesc: '货量描述(containerDesc)',
      teu: 'teu',
      profit: 'profit',
      warehousing: '是否仓储(warehousing)',
      landTransportation: '是否路运(landTransportation)',
      international: '是否国际运输(international)',
      multiplePickups: '是否多次派车(multiplePickups)',
      advance: '是否垫付(advance)',
      blocked: '是否等待特批(blocked)',
      express: '是否是快递(express)',
      declareCustomsState: '报关状态(declareCustomsState)',
      warehouseNoFormat: '进仓编号格式化(warehouseNoFormat)',
      shipperId: '发货人Id(shipperId)',
      consigneeId: '收货人Id(consigneeId)',
      notifyId: '通知人Id(notifyId)',
      preverifyState: '预审核状态(preverifyState)',
      trustFromJob: '委托来源关联号(trustFromJob)',
      signMBL: '是否签发主单(signMBL)',
      signHBL: '是否签发分单(signHBL)',
      EstimateAccountsReceivable: '预估收入(EstimateAccountsReceivable)',
      EstimateAccountsPayable: '预估成本(EstimateAccountsPayable)',
      EstimateGrossProfit: '预估利润(EstimateGrossProfit)',
      shipperCode: '发货人代码(shipperCode)',
      shipperLine1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(consigneeLine1)',
      consigneeLine2: '收货人(consigneeLine2)',
      consigneeLine3: '收货人(consigneeLine3)',
      consigneeLine4: '收货人(consigneeLine4)',
      consigneeLine5: '收货人(consigneeLine5)',
      consigneeLine6: '收货人(consigneeLine6)',
      consigneeLine7: '收货人(consigneeLine7)',
      notifyCode: '通知人代码(notifyCode)',
      notifyLine1: '通知人(notifyLine1)',
      notifyLine2: '通知人(notifyLine2)',
      notifyLine3: '通知人(notifyLine3)',
      notifyLine4: '通知人(notifyLine4)',
      notifyLine5: '通知人(notifyLine5)',
      notifyLine6: '通知人(notifyLine6)',
      notifyLine7: '通知人(notifyLine7)',
      alsoNotify: '第二通知人(alsoNotify)',
      bookingRefuseNote: '拒绝订舱理由(bookingRefuseNote)',
      customsDate: '报关日期(customsDate)',
      customsRemarks: '报关备注(customsRemarks)',
      HSCODE: 'HS Code(HSCODE)',
      operationContent: '操作要求说明(operationContent)',
      situation: '情况说明(situation)',
      ATD: 'ATD',
      checkData: '已核对数据(checkData)',
      virtualHBL: '是否形式分单(virtualHBL)',
      receivableState: '应收状态(receivableState)',
      payablesState: '应付状态(payablesState)',
      priceNo: '运价No(priceNo)',
      booking: '是否订舱(booking)',
      priceTier: '运价等级(priceTier)',
      selfDeliver: '是否自拉自送(selfDeliver)',
      bookingState: '订舱状态(bookingState)',
      itmService: '是否有外贸(ITMService)',
      customsJobNo: '报关关联号(customsJobNo)',
      customJobType: '客户自定义业务种类(customJobType)',
      preverifier: '预审审核人(preverifier)',
      preverifyDate: '预审审核时间(preverifyDate)',
      salePrice: '是否特价(salePrice)',
      salePriceRemarks: '特价备注(salePriceRemarks)',
      salesChannel: '订舱渠道(salesChannel)',
      depositReceived: '预付款(depositReceived)',
      contactEmail: '联系邮件(contactEmail)',
      provisioned: '已计提(provisioned)',
      provisionedDate: '计提时间(provisionedDate)',
      provisionedBy: '计提人(provisionedBy)',
      planner: '航线(planner)',
      plannerDepartment: '航线部门(plannerDepartment)',
      riverCarrierId: '江船公司(riverCarrierId)',
      tradeTerm: '贸易方式(tradeTerm)',
      overseaOpDepartment: '外海操作部门(overseaOpDepartment)',
      overseaOp: '海外操作(overseaOp)',
      userDefinedField1: '自定义字段1(userDefinedField1)',
      userDefinedField2: '自定义字段2(userDefinedField2)',
      userDefinedField3: '自定义字段3(userDefinedField3)',
      manageAuditRemark: '审核备注(manageAuditRemark)',
      manageAuditRejectRemark: '审核拒绝备注(manageAuditRejectRemark)',
      manageAuditStatus: '主管审核状态(manageAuditStatus)',
      submitterUser: '提交人(submitterUser)',
      auditCheckNode: '提交审核节点(auditCheckNode)',
      typeHBL: '分单类型(typeHBL)',
      typeMBL: '主单类型(typeMBL)',
      ifPushSopM: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      ifPushSopZ: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      ifPushSopQ: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      ifPushSop: '是否确认推送SOP信息(ifPushSop)',
      changeState: '改单状态(changeState)',
      cargoSalesId: '揽货销售(cargoSalesId)',
      changeBy: '改单人(changeBy)',
      changeDate: '改单时间(changeDate)',
      closingAccountStatus: '结转状态(closingAccountStatus)',
      firstProvisionedDate: '首次计提时间(firstProvisionedDate)',
      firstProvisionedProfit: '首次提成利润(firstProvisionedProfit)',
      provisionedProfit: '累计提成利润(provisionedProfit)',
      provisionedStatus: '计提状态(provisionedStatus)',
      salesRequire: '销售要求(salesRequire)',
      userDefinedField4: '自定义字段4(userDefinedField4)',
      vesselPortArea: '港区船名(vesselPortArea)',
      voyageFlightPortArea: '港区航次(voyageFlightPortArea)',
      customerTenantId: '委托单位所属tenantId(customerTenantId)',
      customerTenantName: '委托单位所属tenantName(customerTenantName)',
      AirImportJob: '空运进口工作单(AirImportJob)'
    },
    CustomsJob: {
      incoTerm: '贸易条款(incoTerm)',
      dangerousGoods: '是否危险品(dangerousGoods)',
      freightTerm: '运输条款(freightTerm)',
      comercialInspectation: '是否商检(comercialInspectation)',
      heating: '是否薰蒸(heating)',
      currency: '货值币种(currency)',
      amount: '货值金额(amount)',
      cargoJobNo: '货代业务关联号(cargoJobNo)',
      jobNo: '工作号(jobNo)',
      warehouseNo: '进仓编号(warehouseNo)',
      customerRefNo: '客户参考号(customerRefNo)',
      agentRefNo: '代理业务编号(agentRefNo)',
      mbl: 'MBL(mbl)',
      mblNo5: 'MBL_NO5(mblNo5)',
      relatedJob: '公司往来关联号(relatedJob)',
      relatedJob2: '联运编号(relatedJob2)',
      mblOnly: '是否直发(mblOnly)',
      joinFlagMBL: 'MBL并单标志(joinFlagMBL)',
      joinFlagHBL: 'HBL并单标志(joinFlagHBL)',
      masterFlag: '拼箱主号标志(masterFlag)',
      cancelled: '是否取消(cancelled)',
      salesOffice: '销售公司(salesOffice)',
      salesDepartment: '销售部门(salesDepartment)',
      sales: '业务员(sales)',
      csrOffice: '客服公司(csrOffice)',
      csrDepartment: '客服部门(csrDepartment)',
      csr: '客服(csr)',
      opOffice: '操作公司(opOffice)',
      opDepartment: '操作部门(opDepartment)',
      op: '操作(op)',
      customerId: '委托单位编码(customerId)',
      customerContact: '联系人(customerContact)',
      contactTelephone: '联系电话(contactTelephone)',
      contactFax: '联系电传(contactFax)',
      designationAgent: '指定代理(designationAgent)',
      destinationAgent: '目的港代理(destinationAgent)',
      localAgent: '本地代理(localAgent)',
      masterAgent: '是否主代理(masterAgent)',
      bookingAgent: '订舱代理(bookingAgent)',
      customsBroker: '报关行(customsBroker)',
      dispatchingPlace: '发货地(dispatchingPlace)',
      destinationPlace: '最终目的地(destinationPlace)',
      destinationPlaceCode: '最终目的地代码(destinationPlaceCode)',
      loadingPortCode: '装货港代码(loadingPortCode)',
      dischargingPortCode: '卸货港代码(dischargingPortCode)',
      destinationPortCode: '目的港代码(destinationPortCode)',
      quantityContract: '委托货物件数(quantityContract)',
      weightContract: '委托货物重量(weightContract)',
      cubageContract: '委托货物体积(cubageContract)',
      quantityActual: '实际货物件数(quantityActual)',
      weightActual: '实际货物重量(weightActual)',
      cubageActual: '实际货物体积(cubageActual)',
      chargeWeight: '计费重量(chargeWeight)',
      chargeCubage: '计费体积(chargeCubage)',
      measurements: '货物尺寸(measurements)',
      cargoType: '货物种类(cargoType)',
      packing: '包装(packing)',
      paymentTermMBL: '主单运费方式(paymentTermMBL)',
      paymentTermHBL: '分单运费方式(paymentTermHBL)',
      cargoChineseName: '中文品名(cargoChineseName)',
      cargoEnglishName: '英文品名(cargoEnglishName)',
      mark: '唛头(mark)',
      carrierId: '承运人编号(carrierId)',
      carrierAgentId: '船代(carrierAgentId)',
      vessel: '船名(vessel)',
      voyageFlight: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      jobState: '业务状态(jobState)',
      comission: '业务提成金额(commission)',
      remarks: '备注(remarks)',
      businessDate: '业务日期(businessDate)',
      lob: '业务类型(lob)',
      shutOut: '是否退关(shutOut)',
      satisfiedRequests: ' 满足的特殊要求(satisfiedRequests)',
      dcOffice: '单证公司(dcOffice)',
      dcDepartment: '单证部门(dcDepartment)',
      dc: '单证(dc)',
      PONO: '项目编号(PONO)',
      agentLevel: '代理等级(agentLevel)',
      cargoSource: '货物来源(cargoSource)',
      containerDesc: '货量描述(containerDesc)',
      teu: 'teu',
      profit: 'profit',
      warehousing: '是否仓储(warehousing)',
      landTransportation: '是否路运(landTransportation)',
      international: '是否国际运输(international)',
      multiplePickups: '是否多次派车(multiplePickups)',
      advance: '是否垫付(advance)',
      blocked: '是否等待特批(blocked)',
      express: '是否是快递(express)',
      declareCustomsState: '报关状态(declareCustomsState)',
      warehouseNoFormat: '进仓编号格式化(warehouseNoFormat)',
      shipperId: '发货人Id(shipperId)',
      consigneeId: '收货人Id(consigneeId)',
      notifyId: '通知人Id(notifyId)',
      preverifyState: '预审核状态(preverifyState)',
      trustFromJob: '委托来源关联号(trustFromJob)',
      signMBL: '是否签发主单(signMBL)',
      signHBL: '是否签发分单(signHBL)',
      EstimateAccountsReceivable: '预估收入(EstimateAccountsReceivable)',
      EstimateAccountsPayable: '预估成本(EstimateAccountsPayable)',
      EstimateGrossProfit: '预估利润(EstimateGrossProfit)',
      shipperCode: '发货人代码(shipperCode)',
      shipperLine1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(consigneeLine1)',
      consigneeLine2: '收货人(consigneeLine2)',
      consigneeLine3: '收货人(consigneeLine3)',
      consigneeLine4: '收货人(consigneeLine4)',
      consigneeLine5: '收货人(consigneeLine5)',
      consigneeLine6: '收货人(consigneeLine6)',
      consigneeLine7: '收货人(consigneeLine7)',
      notifyCode: '通知人代码(notifyCode)',
      notifyLine1: '通知人(notifyLine1)',
      notifyLine2: '通知人(notifyLine2)',
      notifyLine3: '通知人(notifyLine3)',
      notifyLine4: '通知人(notifyLine4)',
      notifyLine5: '通知人(notifyLine5)',
      notifyLine6: '通知人(notifyLine6)',
      notifyLine7: '通知人(notifyLine7)',
      alsoNotify: '第二通知人(alsoNotify)',
      bookingRefuseNote: '拒绝订舱理由(bookingRefuseNote)',
      customsDate: '报关日期(customsDate)',
      customsRemarks: '报关备注(customsRemarks)',
      HSCODE: 'HS Code(HSCODE)',
      operationContent: '操作要求说明(operationContent)',
      situation: '情况说明(situation)',
      ATD: 'ATD',
      checkData: '已核对数据(checkData)',
      virtualHBL: '是否形式分单(virtualHBL)',
      receivableState: '应收状态(receivableState)',
      payablesState: '应付状态(payablesState)',
      priceNo: '运价No(priceNo)',
      booking: '是否订舱(booking)',
      priceTier: '运价等级(priceTier)',
      selfDeliver: '是否自拉自送(selfDeliver)',
      bookingState: '订舱状态(bookingState)',
      itmService: '是否有外贸(ITMService)',
      customsJobNo: '报关关联号(customsJobNo)',
      customJobType: '客户自定义业务种类(customJobType)',
      preverifier: '预审审核人(preverifier)',
      preverifyDate: '预审审核时间(preverifyDate)',
      salePrice: '是否特价(salePrice)',
      salePriceRemarks: '特价备注(salePriceRemarks)',
      salesChannel: '订舱渠道(salesChannel)',
      depositReceived: '预付款(depositReceived)',
      contactEmail: '联系邮件(contactEmail)',
      provisioned: '已计提(provisioned)',
      provisionedDate: '计提时间(provisionedDate)',
      provisionedBy: '计提人(provisionedBy)',
      planner: '航线(planner)',
      plannerDepartment: '航线部门(plannerDepartment)',
      riverCarrierId: '江船公司(riverCarrierId)',
      tradeTerm: '贸易方式(tradeTerm)',
      overseaOpDepartment: '外海操作部门(overseaOpDepartment)',
      overseaOp: '海外操作(overseaOp)',
      userDefinedField1: '自定义字段1(userDefinedField1)',
      userDefinedField2: '自定义字段2(userDefinedField2)',
      userDefinedField3: '自定义字段3(userDefinedField3)',
      manageAuditRemark: '审核备注(manageAuditRemark)',
      manageAuditRejectRemark: '审核拒绝备注(manageAuditRejectRemark)',
      manageAuditStatus: '主管审核状态(manageAuditStatus)',
      submitterUser: '提交人(submitterUser)',
      auditCheckNode: '提交审核节点(auditCheckNode)',
      typeHBL: '分单类型(typeHBL)',
      typeMBL: '主单类型(typeMBL)',
      ifPushSopM: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      ifPushSopZ: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      ifPushSopQ: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      ifPushSop: '是否确认推送SOP信息(ifPushSop)',
      changeState: '改单状态(changeState)',
      cargoSalesId: '揽货销售(cargoSalesId)',
      changeBy: '改单人(changeBy)',
      changeDate: '改单时间(changeDate)',
      closingAccountStatus: '结转状态(closingAccountStatus)',
      firstProvisionedDate: '首次计提时间(firstProvisionedDate)',
      firstProvisionedProfit: '首次提成利润(firstProvisionedProfit)',
      provisionedProfit: '累计提成利润(provisionedProfit)',
      provisionedStatus: '计提状态(provisionedStatus)',
      salesRequire: '销售要求(salesRequire)',
      userDefinedField4: '自定义字段4(userDefinedField4)',
      vesselPortArea: '港区船名(vesselPortArea)',
      voyageFlightPortArea: '港区航次(voyageFlightPortArea)',
      customerTenantId: '委托单位所属tenantId(customerTenantId)',
      customerTenantName: '委托单位所属tenantName(customerTenantName)',
      CustomsJob: '报关工作单(CustomsJob)'
    },
    SpecialGoods: {
      danClassNo: '危险货物类别(danClassNo)',
      danUNNo: '联合国编号(danUNNo)',
      danPacking: '货物包装类别(danPacking)',
      danLable: '危险品标签(danLable)',
      danEMS: 'Emergency Schedule(航运危险品应急措施号 danEMS)',
      danPoint: 'Flashpoint(危险货物闪点 danPoint)',
      danMfagNo: '医疗救急指南号(danMfagNo)',
      dan24man: '24小时紧急联系人(dan24man)',
      dan24tel: '24小时紧急联系人(dan24tel)',
      responsibleParty: '责任方(responsibleParty)',
      danPickTime: '提箱时间(danPickTime)',
      danSeaPullution: '海洋污染(danSeaPullution)',
      gohTier: '挂衣箱层(gohTier)',
      gohHanger: '挂衣箱每层根数(gohHanger)',
      gohRopes: '每管几跟绳(gohRopes)',
      gohKnots: '每根绳几各节(gohKnots)',
      gohReformCost: '改制费用(gohReformCost)',
      reefVentilation: '通风量(reefVentilation)',
      reefHumidity: '冷藏箱湿度(reefHumidity)',
      reefPTI: '预冷提前天数(reefPTI)',
      reefMeasure: '湿度计量单位(reefMeasure)',
      reefTemperature: '设置温度(reefTemperature)',
      reefHighestTemp: '最高温度(reefHighestTemp)',
      reefLowestTemp: '最低温度(reefLowestTemp)',
      reefContainerYard: '进箱点(reefContainerYard)',
      reefDeliverTime: '送箱港区(reefDeliverTime)',
      overFront: '前超(overFront)',
      overBack: '后超(overBack)',
      overLeft: '左超(overLeft)',
      overRight: '右超(overRight)',
      overHeight: '超高(overHeight)',
      danNo: '特殊货物编号(danNo)',
      chineseCommodity: '中文品名(chineseCommodity)',
      englishCommodity: '英文品名(englishCommodity)',
      soNo: 'soNo(soNo)',
      correctTransportName: '正确运输名称(correctTransportName)',
      secondarySpecialGoods: '副危险品(secondarySpecialGoods)',
      grossWeight: '危险品毛重(grossWeight)',
      neatWeight: '危险品净重(neatWeight)',
      outerPackagingType: '外包装类型(outerPackagingType)',
      outerPackagingQuantity: '外包装件数(outerPackagingQuantity)',
      innerPackagingType: '内包装类型(innerPackagingType)',
      innerPackagingQuantity: '内包装件数(innerPackagingQuantity)',
      remark: '备注(remark)',
      packingCode: '包装代码(packingCode)',
      hsCode: 'HS Code(hsCode)',
      SpecialGoods: '特殊物品(SpecialGoods)'
    },
    File: {
      fileId: '流水号(fileId)',
      fileNo: '文件编号(fileNo)',
      jobNo: '业务编号(jobNo)',
      fileType: '文件类型(fileType)',
      tax: '是否退税(tax)',
      tenDigitCode: '海关十位码(tenDigitCode)',
      companyCName: '经营单位(companyCName)',
      customsBroker: '报关行(customsBroker)',
      state: '文件状态(state)',
      expressAddress: '快递地址(expressAddress)',
      receiveCompany: '收件单位(receiveCompany)',
      receivePerson: '收件人(receivePerson)',
      receiveTel: '收件人电话(receiveTel)',
      returnExpressNo: '退还快递号(returnExpressNo)',
      sendDate: '送出日期(sendDate)',
      backDate: '取回日期(backDate)',
      backUser: '取回人(backUser)',
      returnDate: '退还日期(returnDate)',
      returnPerson: '退单经手人(returnPerson)',
      remark: '备注(remark)',
      second: '是否二次送出(isSecond)',
      secondSendDate: '二次送出日期(secondSendDate)',
      secondSendBy: '二次送出人(secondSendBy)',
      inputBy: '创建人(inputBy)',
      inputDate: '创建日期(inputDate)',
      inputByDep: '创建人部门(inputByDep)',
      branchId: '分公司(branchId)',
      receiveDate: '收到日期(receiveDate)',
      sendExpressAddress: '送出快递地址(sendExpressAddress)',
      sendReceiveCompany: '送出收件单位(sendReceiveCompany)',
      sendReceivePerson: '送出收件人(sendReceivePerson)',
      sendReceiveTel: '送出收件人电话(sendReceiveTel)',
      sendExpressNo: '送出快递号(sendExpressNo)',
      SendBy: '送出人(SendBy)',
      customsNo: '海关编号(customsNo)',
      originFileId: '源文件Id(originFileId)',
      currentHolder: '当前持有人(currentHolder)',
      prerecordingNo: '预录入单号(prerecordingNo)',
      declareDate: '申报日期(declareDate)',
      customsPageNumber: '报关单页数(customsPageNumber)',
      customsTransfer: '是否转关(customsTransfer)',
      tradeMode: '贸易方式(tradeMode)',
      filedUser: '归档人(filedUser)',
      filedDate: '归档日期(filedDate)',
      rebatedUser: '退税人(rebatedUser)',
      rebatedDate: '退税日期(rebatedDate)',
      returnedUser: '退回人(returnedUser)',
      returnedDate: '退回日期(returnedDate)',
      acceptedUser: '接单人(acceptedUser)',
      acceptedDate: '接单日期(acceptedDate)',
      File: '文件(File)'
    },
    CargoDoc: {
      state: '状态(state)',
      docType: '提单种类(docType)',
      hblNbr2: '二级编号(hblNbr2)',
      shipperId: '发货人编号(shipperId)',
      shipperCode: '发货人代码(shipperCode)',
      shipperLine1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      consigneeId: '收货人编号(consigneeId)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(consigneeLine1)',
      consigneeLine2: '收货人(consigneeLine2)',
      consigneeLine3: '收货人(consigneeLine3)',
      consigneeLine4: '收货人(consigneeLine4)',
      consigneeLine5: '收货人(consigneeLine5)',
      consigneeLine6: '收货人(consigneeLine6)',
      consigneeLine7: '收货人(consigneeLine7)',
      notifyId: '通知人编号(notifyId)',
      notifyCode: '通知人代码(notifyCode)',
      notifyLine1: '通知人(notifyLine1)',
      notifyLine2: '通知人(notifyLine2)',
      notifyLine3: '通知人(notifyLine3)',
      notifyLine4: '通知人(notifyLine4)',
      notifyLine5: '通知人(notifyLine5)',
      notifyLine6: '通知人(notifyLine6)',
      notifyLine7: '通知人(notifyLine7)',
      agentCode: '代理代码(agentCode)',
      agentPartyLine1: '代理地址(agentPartyLine1)',
      agentPartyLine2: '代理地址(agentPartyLine2)',
      agentPartyLine3: '代理地址(agentPartyLine3)',
      agentPartyLine4: '代理地址(agentPartyLine4)',
      agentPartyLine5: '代理地址(agentPartyLine5)',
      agentPartyLine6: '代理地址(agentPartyLine6)',
      agentPartyLine7: '代理地址(agentPartyLine7)',
      quantity: '提单件数(quantity)',
      weight: '提单重量(weight)',
      cubage: '提单体积(cubage)',
      chargeWeight: '计费重量(chargeWeight)',
      packing: '包装(packing)',
      cargoEnglishName: '英文品名(cargoEnglishName)',
      mark: '唛头(mark)',
      BLNumber: '提单份数(BLNumber)',
      signDateBL: '签单日期(signDateBL)',
      signPlaceBL: '签单地点(signPlaceBL)',
      signDateBy: '签单人(signDateBy)',
      releaseType: '放单方式(releaseType)',
      issuerBL: '分单种类(issuerBL)',
      oversea: '是否异地放单(oversea)',
      insideQuantity: '小件数(insideQuantity)',
      insidePacking: '小件数包装类型(insidePacking)',
      paymentTerm: '运费方式(paymentTerm)',
      cfmState: '对单状态(CfmState)',
      freightChargeTotal: '提单运费USD合计(freightChargeTotal)',
      freightChargeEnUpper: 'USD费用合计英文大写(freightChargeEnUpper)',
      CargoDoc: '提单(CargoDoc)'
    },
    SeaCargoDoc: {
      mblNbr2: '二级主单编号(mblNbr2)',
      quantitySum: '提单货量英文合计(quantitySum)',
      containerSum: '提单箱量英文合计(containerSum)',
      loadingPort: '装货港(loadingPort)',
      dischargingPort: '中转港(dischargingPort)',
      destinationPort: '目的港(destinationPort)',
      dispatchingPlace: '发货地(dispatchingPlace)',
      destinationPlace: '最终目的地(destinationPlace)',
      paymentPlaceBL: '付款地点(paymentPlaceBL)',
      EDI: '是否导提单EDI(EDI)',
      manifestEDI: '是否导舱单EDI(manifestEDI)',
      remarks: '备注(remarks)',
      printParam1: '打印参数1(printParam1)',
      printParam2: '打印参数2(printParam2)',
      printParam3: '打印参数3(printParam3)',
      printParam4: '打印参数4(printParam4)',
      printParam5: '打印参数5(printParam5)',
      printParam6: '打印参数6(printParam6)',
      serialNo: '提单流水号(serialNo)',
      seaeq: '分票箱型箱量(seaeq)',
      container: '分票箱封(container)',
      alsoNotify: '第二通知人(alsoNotify)',
      costcoNo: '电子装箱单编号(costcoNo)',
      cargoManifestName: '舱单品名(cargoManifestName)',
      mblId: '分单对应主单Id(MblId)',
      shipperTel: '发货人联系电话(ShipperTel)',
      consigneeTel: '收货人联系电话(ConsigneeTel)',
      notifyTel: '通知人联系电话(NotifyTel)',
      releaseReview: '放单审核(releaseReview)',
      reviewDate: '放单审核时间(reviewDate)',
      releaseState: '放单状态(releaseState)',
      releaseDate: '放单时间(releaseDate)',
      payable: '是否可付款(payable)',
      agreePayDate: '同意付款时间(agreePayDate)',
      withhold: '是否扣货(withhold)',
      withholdDate: '扣货时间(withholdDate)',
      withholdReason: '扣货原因(withholdReason)',
      secondReleaseDate: '目的港放货时间(secondReleaseDate)  二次放货时间',
      surrenderedApplicant: '电放申请人(surrenderedApplicant)',
      surrenderedApplicationDate: '电放申请时间(surrenderedApplicationDate)',
      surrenderedNo: '电放号(surrenderedNo)',
      customerCfmException: '客户对单异常信息(customerCfmException)',
      originalBLWay: '正本提单寄送方式(originalBLWay)',
      warehouseNo: '进仓编号(warehouseNo)',
      freightTermHBL: '运输条款(freightTermHBL)',
      shipperContact: '发货人联系人(shipperContact)',
      shipperMobile: '发货人联系电话(shipperMobile)',
      shipperFax: '发货人传真(shipperFax)',
      shipperEmail: '发货人邮箱(shipperEmail)',
      shipperZipCode: '发货人邮编(shipperZipCode)',
      shipperCity: '发货人城市(shipperCity)',
      consigneeContact: '收货人联系人(consigneeContact)',
      consigneeMobile: '收货人联系电话(consigneeMobile)',
      consigneeFax: '收货人传真(consigneeFax)',
      consigneeEmail: '收货人邮箱(consigneeEmail)',
      consigneeZipCode: '收货人邮编(consigneeZipCode)',
      consigneeCity: '收货人城市(consigneeCity)',
      notifyContact: '通知人联系人(notifyContact)',
      notifyMobile: '通知人联系电话(notifyMobile)',
      notifyFax: '通知人传真(notifyFax)',
      notifyEmail: '通知人邮箱(notifyEmail)',
      notifyZipCode: '通知人邮编(notifyZipCode)',
      notifyCity: '通知人城市(notifyCity)',
      alsoNotifyCode: '第二通知人代码(alsoNotifyCode)',
      alsoNotifyLine1: '第二通知人(alsoNotifyLine1)',
      alsoNotifyLine2: '第二通知人(alsoNotifyLine2)',
      alsoNotifyLine3: '第二通知人(alsoNotifyLine3)',
      alsoNotifyLine4: '第二通知人(alsoNotifyLine4)',
      alsoNotifyLine5: '第二通知人(alsoNotifyLine5)',
      alsoNotifyLine6: '第二通知人(alsoNotifyLine6)',
      alsoNotifyLine7: '第二通知人(alsoNotifyLine7)',
      alsoNotifyContact: '第二通知人联系人(alsoNotifyContact)',
      alsoNotifyMobile: '第二通知人联系电话(alsoNotifyMobile)',
      alsoNotifyFax: '第二通知人传真(alsoNotifyFax)',
      alsoNotifyEmail: '第二通知人邮箱(alsoNotifyEmail)',
      alsoNotifyZipCode: '第二通知人邮编(alsoNotifyZipCode)',
      alsoNotifyCity: '第二通知人城市(alsoNotifyCity)',
      dgconsignCode: 'dgconsignCode(dgconsignCode)',
      dgconsignLine1: 'dgconsign(dgconsignLine1)',
      dgconsignLine2: 'dgconsign(dgconsignLine2)',
      dgconsignLine3: 'dgconsign(dgconsignLine3)',
      dgconsignLine4: 'dgconsign(dgconsignLine4)',
      dgconsignLine5: 'dgconsign(dgconsignLine5)',
      dgconsignLine6: 'dgconsign(dgconsignLine6)',
      dgconsignLine7: 'dgconsign(dgconsignLine7)',
      dgconsignContact: 'dgconsign联系人(dgconsignContact)',
      dgconsignMobile: 'dgconsign联系电话(dgconsignMobile)',
      dgconsignFax: 'dgconsign传真(dgconsignFax)',
      dgconsignEmail: 'dgconsign邮箱(dgconsignEmail)',
      dgconsignZipCode: 'dgconsign邮编(dgconsignZipCode)',
      dgconsignCity: 'dgconsign城市(dgconsignCity)',
      elseInvoiceCode: 'elseInvoiceCode(elseInvoiceCode)',
      elseInvoiceLine1: 'elseInvoice(elseInvoiceLine1)',
      elseInvoiceLine2: 'elseInvoice(elseInvoiceLine2)',
      elseInvoiceLine3: 'elseInvoice(elseInvoiceLine3)',
      elseInvoiceLine4: 'elseInvoice(elseInvoiceLine4)',
      elseInvoiceLine5: 'elseInvoice(elseInvoiceLine5)',
      elseInvoiceLine6: 'elseInvoice(elseInvoiceLine6)',
      elseInvoiceLine7: 'elseInvoice(elseInvoiceLine7)',
      elseInvoiceContact: 'elseInvoice联系人(elseInvoiceContact)',
      elseInvoiceMobile: 'elseInvoice联系电话(elseInvoiceMobile)',
      elseInvoiceFax: 'elseInvoice传真(elseInvoiceFax)',
      elseInvoiceEmail: 'elseInvoice邮箱(elseInvoiceEmail)',
      elseInvoiceZipCode: 'elseInvoice邮编(elseInvoiceZipCode)',
      elseInvoiceCity: 'elseInvoice城市(elseInvoiceCity)',
      showPODAgency: 'showPODAgency(showPODAgency)',
      receivedDate: '接收时间(receivedDate)',
      getBackDate: '取回时间(getBackDate)',
      claimDate: '认领时间(claimDate)',
      customerSelfRelease: '自出单类型(customerSelfRelease)',
      state: '状态(state)',
      docType: '提单种类(docType)',
      hblNbr2: '二级编号(hblNbr2)',
      shipperId: '发货人编号(shipperId)',
      shipperCode: '发货人代码(shipperCode)',
      shipperLine1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      consigneeId: '收货人编号(consigneeId)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(consigneeLine1)',
      consigneeLine2: '收货人(consigneeLine2)',
      consigneeLine3: '收货人(consigneeLine3)',
      consigneeLine4: '收货人(consigneeLine4)',
      consigneeLine5: '收货人(consigneeLine5)',
      consigneeLine6: '收货人(consigneeLine6)',
      consigneeLine7: '收货人(consigneeLine7)',
      notifyId: '通知人编号(notifyId)',
      notifyCode: '通知人代码(notifyCode)',
      notifyLine1: '通知人(notifyLine1)',
      notifyLine2: '通知人(notifyLine2)',
      notifyLine3: '通知人(notifyLine3)',
      notifyLine4: '通知人(notifyLine4)',
      notifyLine5: '通知人(notifyLine5)',
      notifyLine6: '通知人(notifyLine6)',
      notifyLine7: '通知人(notifyLine7)',
      agentCode: '代理代码(agentCode)',
      agentPartyLine1: '代理地址(agentPartyLine1)',
      agentPartyLine2: '代理地址(agentPartyLine2)',
      agentPartyLine3: '代理地址(agentPartyLine3)',
      agentPartyLine4: '代理地址(agentPartyLine4)',
      agentPartyLine5: '代理地址(agentPartyLine5)',
      agentPartyLine6: '代理地址(agentPartyLine6)',
      agentPartyLine7: '代理地址(agentPartyLine7)',
      quantity: '提单件数(quantity)',
      weight: '提单重量(weight)',
      cubage: '提单体积(cubage)',
      chargeWeight: '计费重量(chargeWeight)',
      packing: '包装(packing)',
      cargoEnglishName: '英文品名(cargoEnglishName)',
      mark: '唛头(mark)',
      BLNumber: '提单份数(BLNumber)',
      signDateBL: '签单日期(signDateBL)',
      signPlaceBL: '签单地点(signPlaceBL)',
      signDateBy: '签单人(signDateBy)',
      releaseType: '放单方式(releaseType)',
      issuerBL: '分单种类(issuerBL)',
      oversea: '是否异地放单(oversea)',
      insideQuantity: '小件数(insideQuantity)',
      insidePacking: '小件数包装类型(insidePacking)',
      paymentTerm: '运费方式(paymentTerm)',
      cfmState: '对单状态(CfmState)',
      freightChargeTotal: '提单运费USD合计(freightChargeTotal)',
      freightChargeEnUpper: 'USD费用合计英文大写(freightChargeEnUpper)',
      SeaCargoDoc: '海运提单(SeaCargoDoc)'
    },
    SeaImCargoDoc: {
      mblNbr2: '二级主单编号(mblNbr2)',
      quantitySum: '提单货量英文合计(quantitySum)',
      containerSum: '提单箱量英文合计(containerSum)',
      loadingPort: '装货港(loadingPort)',
      dischargingPort: '中转港(dischargingPort)',
      destinationPort: '目的港(destinationPort)',
      dispatchingPlace: '发货地(dispatchingPlace)',
      destinationPlace: '最终目的地(destinationPlace)',
      paymentPlaceBL: '付款地点(paymentPlaceBL)',
      EDI: '是否导提单EDI(EDI)',
      manifestEDI: '是否导舱单EDI(manifestEDI)',
      remarks: '备注(remarks)',
      printParam1: '打印参数1(printParam1)',
      printParam2: '打印参数2(printParam2)',
      printParam3: '打印参数3(printParam3)',
      printParam4: '打印参数4(printParam4)',
      printParam5: '打印参数5(printParam5)',
      printParam6: '打印参数6(printParam6)',
      serialNo: '提单流水号(serialNo)',
      seaeq: '分票箱型箱量(seaeq)',
      container: '分票箱封(container)',
      alsoNotify: '第二通知人(alsoNotify)',
      costcoNo: '电子装箱单编号(costcoNo)',
      cargoManifestName: '舱单品名(cargoManifestName)',
      mblId: '分单对应主单Id(mblId)',
      shipperTel: '发货人联系电话(shipperTel)',
      consigneeTel: '收货人联系电话(consigneeTel)',
      notifyTel: '通知人联系电话(notifyTel)',
      releaseReview: '放单审核(releaseReview)',
      reviewDate: '放单审核时间(reviewDate)',
      releaseState: '放单状态(releaseState)',
      releaseDate: '放单时间(releaseDate)',
      payable: '是否可付款(payable)',
      agreePayDate: '同意付款时间(agreePayDate)',
      withhold: '是否扣货(withhold)',
      withholdDate: '扣货时间(withholdDate)',
      withholdReason: '扣货原因(withholdReason)',
      secondReleaseDate: '目的港放货时间(secondReleaseDate)  二次放货时间',
      surrenderedApplicant: '电放申请人(surrenderedApplicant)',
      surrenderedApplicationDate: '电放申请时间(surrenderedApplicationDate)',
      surrenderedNo: '电放号(surrenderedNo)',
      customerCfmException: '客户对单异常信息(customerCfmException)',
      originalBLWay: '正本提单寄送方式(originalBLWay)',
      warehouseNo: '进仓编号(warehouseNo)',
      freightTermHBL: '运输条款(freightTermHBL)',
      shipperContact: '发货人联系人(shipperContact)',
      shipperMobile: '发货人联系电话(shipperMobile)',
      shipperFax: '发货人传真(shipperFax)',
      shipperEmail: '发货人邮箱(shipperEmail)',
      shipperZipCode: '发货人邮编(shipperZipCode)',
      shipperCity: '发货人城市(shipperCity)',
      consigneeContact: '收货人联系人(consigneeContact)',
      consigneeMobile: '收货人联系电话(consigneeMobile)',
      consigneeFax: '收货人传真(consigneeFax)',
      consigneeEmail: '收货人邮箱(consigneeEmail)',
      consigneeZipCode: '收货人邮编(consigneeZipCode)',
      consigneeCity: '收货人城市(consigneeCity)',
      notifyContact: '通知人联系人(notifyContact)',
      notifyMobile: '通知人联系电话(notifyMobile)',
      notifyFax: '通知人传真(notifyFax)',
      notifyEmail: '通知人邮箱(notifyEmail)',
      notifyZipCode: '通知人邮编(notifyZipCode)',
      notifyCity: '通知人城市(notifyCity)',
      alsoNotifyCode: '第二通知人代码(alsoNotifyCode)',
      alsoNotifyLine1: '第二通知人(alsoNotifyLine1)',
      alsoNotifyLine2: '第二通知人(alsoNotifyLine2)',
      alsoNotifyLine3: '第二通知人(alsoNotifyLine3)',
      alsoNotifyLine4: '第二通知人(alsoNotifyLine4)',
      alsoNotifyLine5: '第二通知人(alsoNotifyLine5)',
      alsoNotifyLine6: '第二通知人(alsoNotifyLine6)',
      alsoNotifyLine7: '第二通知人(alsoNotifyLine7)',
      alsoNotifyContact: '第二通知人联系人(alsoNotifyContact)',
      alsoNotifyMobile: '第二通知人联系电话(alsoNotifyMobile)',
      alsoNotifyFax: '第二通知人传真(alsoNotifyFax)',
      alsoNotifyEmail: '第二通知人邮箱(alsoNotifyEmail)',
      alsoNotifyZipCode: '第二通知人邮编(alsoNotifyZipCode)',
      alsoNotifyCity: '第二通知人城市(alsoNotifyCity)',
      dgconsignCode: 'dgconsignCode(dgconsignCode)',
      dgconsignLine1: 'dgconsign(dgconsignLine1)',
      dgconsignLine2: 'dgconsign(dgconsignLine2)',
      dgconsignLine3: 'dgconsign(dgconsignLine3)',
      dgconsignLine4: 'dgconsign(dgconsignLine4)',
      dgconsignLine5: 'dgconsign(dgconsignLine5)',
      dgconsignLine6: 'dgconsign(dgconsignLine6)',
      dgconsignLine7: 'dgconsign(dgconsignLine7)',
      dgconsignContact: 'dgconsign联系人(dgconsignContact)',
      dgconsignMobile: 'dgconsign联系电话(dgconsignMobile)',
      dgconsignFax: 'dgconsign传真(dgconsignFax)',
      dgconsignEmail: 'dgconsign邮箱(dgconsignEmail)',
      dgconsignZipCode: 'dgconsign邮编(dgconsignZipCode)',
      dgconsignCity: 'dgconsign城市(dgconsignCity)',
      elseInvoiceCode: 'elseInvoiceCode(elseInvoiceCode)',
      elseInvoiceLine1: 'elseInvoice(elseInvoiceLine1)',
      elseInvoiceLine2: 'elseInvoice(elseInvoiceLine2)',
      elseInvoiceLine3: 'elseInvoice(elseInvoiceLine3)',
      elseInvoiceLine4: 'elseInvoice(elseInvoiceLine4)',
      elseInvoiceLine5: 'elseInvoice(elseInvoiceLine5)',
      elseInvoiceLine6: 'elseInvoice(elseInvoiceLine6)',
      elseInvoiceLine7: 'elseInvoice(elseInvoiceLine7)',
      elseInvoiceContact: 'elseInvoice联系人(elseInvoiceContact)',
      elseInvoiceMobile: 'elseInvoice联系电话(elseInvoiceMobile)',
      elseInvoiceFax: 'elseInvoice传真(elseInvoiceFax)',
      elseInvoiceEmail: 'elseInvoice邮箱(elseInvoiceEmail)',
      elseInvoiceZipCode: 'elseInvoice邮编(elseInvoiceZipCode)',
      elseInvoiceCity: 'elseInvoice城市(elseInvoiceCity)',
      showPODAgency: 'showPODAgency(showPODAgency)',
      receivedDate: '接收时间(receivedDate)',
      getBackDate: '取回时间(getBackDate)',
      claimDate: '认领时间(claimDate)',
      customerSelfRelease: '自出单类型(customerSelfRelease)',
      state: '状态(state)',
      docType: '提单种类(docType)',
      hblNbr2: '二级编号(hblNbr2)',
      shipperId: '发货人编号(shipperId)',
      shipperCode: '发货人代码(shipperCode)',
      shipperLine1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      consigneeId: '收货人编号(consigneeId)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(consigneeLine1)',
      consigneeLine2: '收货人(consigneeLine2)',
      consigneeLine3: '收货人(consigneeLine3)',
      consigneeLine4: '收货人(consigneeLine4)',
      consigneeLine5: '收货人(consigneeLine5)',
      consigneeLine6: '收货人(consigneeLine6)',
      consigneeLine7: '收货人(consigneeLine7)',
      notifyId: '通知人编号(notifyId)',
      notifyCode: '通知人代码(notifyCode)',
      notifyLine1: '通知人(notifyLine1)',
      notifyLine2: '通知人(notifyLine2)',
      notifyLine3: '通知人(notifyLine3)',
      notifyLine4: '通知人(notifyLine4)',
      notifyLine5: '通知人(notifyLine5)',
      notifyLine6: '通知人(notifyLine6)',
      notifyLine7: '通知人(notifyLine7)',
      agentCode: '代理代码(agentCode)',
      agentPartyLine1: '代理地址(agentPartyLine1)',
      agentPartyLine2: '代理地址(agentPartyLine2)',
      agentPartyLine3: '代理地址(agentPartyLine3)',
      agentPartyLine4: '代理地址(agentPartyLine4)',
      agentPartyLine5: '代理地址(agentPartyLine5)',
      agentPartyLine6: '代理地址(agentPartyLine6)',
      agentPartyLine7: '代理地址(agentPartyLine7)',
      quantity: '提单件数(quantity)',
      weight: '提单重量(weight)',
      cubage: '提单体积(cubage)',
      chargeWeight: '计费重量(chargeWeight)',
      packing: '包装(packing)',
      cargoEnglishName: '英文品名(cargoEnglishName)',
      mark: '唛头(mark)',
      BLNumber: '提单份数(BLNumber)',
      signDateBL: '签单日期(signDateBL)',
      signPlaceBL: '签单地点(signPlaceBL)',
      signDateBy: '签单人(signDateBy)',
      releaseType: '放单方式(releaseType)',
      issuerBL: '分单种类(issuerBL)',
      oversea: '是否异地放单(oversea)',
      insideQuantity: '小件数(insideQuantity)',
      insidePacking: '小件数包装类型(insidePacking)',
      paymentTerm: '运费方式(paymentTerm)',
      cfmState: '对单状态(CfmState)',
      freightChargeTotal: '提单运费USD合计(freightChargeTotal)',
      freightChargeEnUpper: 'USD费用合计英文大写(freightChargeEnUpper)',
      SeaImCargoDoc: '海运进口提单(SeaImCargoDoc)'
    },
    AfrAddress: {
      state: '状态(state)',
      docType: '提单种类(docType)',
      consolidationClosed: '拼箱最后提单(ConsolidationClosed)',
      shipperCode: '发货人代码(ShipperCode)',
      shipperLine1: '发货人(ShipperLine1)',
      shipperLine2: '发货人(ShipperLine2)',
      shipperLine3: '发货人(ShipperLine3)',
      shipperLine4: '发货人(ShipperLine4)',
      shipperLine5: '发货人(ShipperLine5)',
      shipperLine6: '发货人(ShipperLine6)',
      shipperTel: '发货人联系电话(ShipperTel)',
      shipperFax: '发货人联系传真(ShipperFax)',
      shipperCity: '发货人城市(ShipperCity)',
      shipperProvince: '发货人省份(ShipperProvince)',
      shipperCountry: '发货人国家代码(ShipperCountry)',
      shipperPostalcode: '发货人邮编(ShipperPostalcode)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(ConsigneeLine1)',
      consigneeLine2: '收货人(ConsigneeLine2)',
      consigneeLine3: '收货人(ConsigneeLine3)',
      consigneeLine4: '收货人(ConsigneeLine4)',
      consigneeLine5: '收货人(ConsigneeLine5)',
      consigneeLine6: '收货人(ConsigneeLine6)',
      consigneeTel: '收货人联系电话(ConsigneeTel)',
      consigneeFax: '收货人联系传真(ConsigneeFax)',
      consigneeCity: '收货人城市(ConsigneeCity)',
      consigneeProvince: '收货人省份(ConsigneeProvince)',
      consigneeCountry: '收货人国家代码(ConsigneeCountry)',
      consigneePostalcode: '收货人邮编(ConsigneePostalcode)',
      notifyCode: '通知人代码(NotifyCode)',
      notifyLine1: '通知人(NotifyLine1)',
      notifyLine2: '通知人(NotifyLine2)',
      notifyLine3: '通知人(NotifyLine3)',
      notifyLine4: '通知人(NotifyLine4)',
      notifyLine5: '通知人(NotifyLine5)',
      notifyLine6: '通知人(NotifyLine6)',
      notifyTel: '通知人联系电话(NotifyTel)',
      notifyFax: '通知人联系传真(NotifyFax)',
      notifyCity: '通知人城市(NotifyCity)',
      notifyProvince: '通知人省份(NotifyProvince)',
      notifyCountry: '通知人国家代码(NotifyCountry)',
      notifyPostalcode: '通知人邮编(NotifyPostalcode)',
      alsonotifyCode: '第二通知人代码(AlsonotifyCode)',
      alsonotifyLine1: '第二通知人(AlsonotifyLine1)',
      alsonotifyLine2: '第二通知人(AlsonotifyLine2)',
      alsonotifyLine3: '第二通知人(AlsonotifyLine3)',
      alsonotifyLine4: '第二通知人(AlsonotifyLine4)',
      alsonotifyLine5: '第二通知人(AlsonotifyLine5)',
      alsonotifyLine6: '第二通知人(AlsonotifyLine6)',
      alsonotifyTel: '第二通知人联系电话(AlsonotifyTel)',
      alsonotifyFax: '第二通知人联系传真(AlsonotifyFax)',
      alsonotifyCity: '第二通知人城市(AlsonotifyCity)',
      alsonotifyProvince: '第二通知人省份(AlsonotifyProvince)',
      alsonotifyCountry: '第二通知人国家代码(AlsonotifyCountry)',
      alsonotifyPostalcode: '第二通知人邮编(AlsonotifyPostalcode)',
      AfrAddress: 'JP24反恐舱单地址(AfrAddress)'
    },
    AirCargoDoc: {
      cWeight: '提单计费重量(cWeight)',
      IATACode: 'IATACode',
      accountCode: 'accountCode',
      handingInfo: 'handingInfo',
      accountingInfo: 'accountingInfo',
      TSRemarks: 'TSRemarks',
      airportOfDeparture: 'airportOfDeparture',
      airportOfDestination: 'airportOfDestination',
      PODTo: 'PODTo',
      carrierBy: 'carrierBy',
      PODTo1: 'PODTo1',
      carrierBy1: 'carrierBy1',
      PODTo2: 'PODTo2',
      carrierBy2: 'carrierBy2',
      currency: 'currency',
      WtVal: 'WtVal',
      other: 'other',
      carriageDV: 'carriageDV',
      DVforCustoms: 'customsDV',
      insuredAmount: 'insuredAmount',
      PP1: 'PP1',
      PP2: 'PP2',
      PP3: 'PP3',
      PP4: 'PP4',
      PP5: 'PP5',
      PP6: 'PP6',
      CC1: 'CC1',
      CC2: 'CC2',
      CC3: 'CC3',
      CC4: 'CC4',
      CC5: 'CC5',
      CC6: 'CC6',
      rateClass: 'rateClass',
      rate: 'rate',
      rateCharge: 'rateCharge',
      dimension: 'dimension',
      remark1: 'remark1',
      remark2: 'remark2',
      signByShipper: '货主签单人(signByShipper)',
      signByCarrier: '承运人签单人(signByCarrier)',
      issuedBy: 'issuedBy',
      kglb: 'kglb',
      cTotal: '(提单总金额)cTotal',
      state: '状态(state)',
      docType: '提单种类(docType)',
      hblNbr2: '二级编号(hblNbr2)',
      shipperId: '发货人编号(shipperId)',
      shipperCode: '发货人代码(shipperCode)',
      shipperLine1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      consigneeId: '收货人编号(consigneeId)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(consigneeLine1)',
      consigneeLine2: '收货人(consigneeLine2)',
      consigneeLine3: '收货人(consigneeLine3)',
      consigneeLine4: '收货人(consigneeLine4)',
      consigneeLine5: '收货人(consigneeLine5)',
      consigneeLine6: '收货人(consigneeLine6)',
      consigneeLine7: '收货人(consigneeLine7)',
      notifyId: '通知人编号(notifyId)',
      notifyCode: '通知人代码(notifyCode)',
      notifyLine1: '通知人(notifyLine1)',
      notifyLine2: '通知人(notifyLine2)',
      notifyLine3: '通知人(notifyLine3)',
      notifyLine4: '通知人(notifyLine4)',
      notifyLine5: '通知人(notifyLine5)',
      notifyLine6: '通知人(notifyLine6)',
      notifyLine7: '通知人(notifyLine7)',
      agentCode: '代理代码(agentCode)',
      agentPartyLine1: '代理地址(agentPartyLine1)',
      agentPartyLine2: '代理地址(agentPartyLine2)',
      agentPartyLine3: '代理地址(agentPartyLine3)',
      agentPartyLine4: '代理地址(agentPartyLine4)',
      agentPartyLine5: '代理地址(agentPartyLine5)',
      agentPartyLine6: '代理地址(agentPartyLine6)',
      agentPartyLine7: '代理地址(agentPartyLine7)',
      quantity: '提单件数(quantity)',
      weight: '提单重量(weight)',
      cubage: '提单体积(cubage)',
      chargeWeight: '计费重量(chargeWeight)',
      packing: '包装(packing)',
      cargoEnglishName: '英文品名(cargoEnglishName)',
      mark: '唛头(mark)',
      BLNumber: '提单份数(BLNumber)',
      signDateBL: '签单日期(signDateBL)',
      signPlaceBL: '签单地点(signPlaceBL)',
      signDateBy: '签单人(signDateBy)',
      releaseType: '放单方式(releaseType)',
      issuerBL: '分单种类(issuerBL)',
      oversea: '是否异地放单(oversea)',
      insideQuantity: '小件数(insideQuantity)',
      insidePacking: '小件数包装类型(insidePacking)',
      paymentTerm: '运费方式(paymentTerm)',
      cfmState: '对单状态(CfmState)',
      freightChargeTotal: '提单运费USD合计(freightChargeTotal)',
      freightChargeEnUpper: 'USD费用合计英文大写(freightChargeEnUpper)',
      AirCargoDoc: '空运主分单(AirCargoDoc)'
    },
    OtherCharge: {
      chargeItem: '费用名称(chargeItem)',
      measure: '单位类型(measure)',
      unitRate: '单价(unitRate)',
      amount: '金额(amount)',
      remark: '附加说明(remark)',
      minAmount: '最小收费金额(minAmount)',
      chargeId: '费用序号(chargeId)',
      OtherCharge: '空运提单其它费用 (OtherCharge)'
    },
    TruckingInfo: {
      truckingId: '陆运序号(truckingId)',
      carryingCmp: '运输公司(carryingCmp)',
      loadingDate: '预计装货日期(loadingDate)',
      driver: '司机(driver)',
      driverTel: '司机电话(driverTel)',
      doorName: '门点(doorName)',
      doorMan: '门点联系人(doorMan)',
      doorManTel: '门点联系人电话(doorManTel)',
      doorAddr: '门点地址(doorAddr)',
      remarks: '备注(remarks)',
      quantity: '件数(quantity)',
      weight: '重量(weight)',
      cubage: '体积(cubage)',
      soNo: 'soNo(soNo)',
      truckOrderNo: '派车单号(TruckOrderNo)',
      printState: '派车单打印状态(PrintState)',
      printDate: '派车单打印日期(PrintDate)',
      printBy: '派车单打印人(PrintBy)',
      plateNumber: '车牌号(plateNumber)',
      truckingFee: '拖车费(truckingFee)',
      sendState: '派车状态(sendState)',
      interactiveNo: '交互单号(InteractiveNo)',
      travelHour: '在途时间-小时(TravelHour)',
      travelMinute: '在途时间-分钟(TravelMinute)',
      TruckingInfo: '本地运输(TruckingInfo)'
    },
    WarehouseInfo: {
      warehouseId: '仓储序号(warehouseId)',
      warehouseCmp: '仓储公司(warehouseCmp)',
      arriveDate: '预计送货日期(arriveDate)',
      warehouseContact: '联系人(warehouseContact)',
      warehouseContactTel: '联系人电话(warehouseContactTel)',
      warehouseContactFax: '联系人传真(warehouseContactFax)',
      warehouseAddress: '仓库地址(warehouseAddress)',
      remarks: '备注(remarks)',
      quantity: '破损受潮件数(quantity)',
      warehouseName: '仓库名称(warehouseName)',
      mapFile: '地图图片(mapFile)',
      WarehouseInfo: '仓储(WarehouseInfo)'
    },
    CustomsInfo: {
      customsId: '报关序号(customsId)',
      customsBroker: '报关行(customsBroker)',
      companyCName: '经营单位(companyCName)',
      tenDigitCode: '报关十位码(tenDigitCode)',
      inspectionCode: '报检十位码(inspectionCode)',
      hsCode: 'hsCode',
      remarks: '备注(remarks)',
      customsDate: '报关日期(customsDate)',
      level: '序号(level)',
      declareCustomsState: '报关状态(declareCustomsState)',
      commodityInspection: '是否商检(commodityInspection )',
      spotInspection: '是否查验(spotInspection)',
      quantityActual: '实际货物件数(quantityActual)',
      weightActual: '实际货物重量(weightActual)',
      cubageActual: '实际货物体积(cubageActual)',
      soNo: '关单号(soNo)',
      customsNo: '海关编号(customsNo)',
      declareCustomsType: '报关类别(declareCustomsType)',
      preNumber: '预录入编号(preNumber)',
      plateNumber: '车牌号(plateNumber)',
      containerNo: '柜型柜号(containerNo)',
      CustomsInfo: '报关信息(CustomsInfo)'
    },
    SeaEQ: {
      EQid: '流水号(EQid)',
      EQsize: '箱型EQsize',
      EQtype: '箱种EQtype',
      EQquantity: '数量EQquantity',
      containerNo: '箱号containerNo',
      sealNo: '封号sealNo',
      SOC: '是否货主箱(SOC)',
      sizeLength: '长(sizeLength)',
      sizeWidth: '宽(sizeWidth)',
      sizeHeight: '高(sizeHeight)',
      SeaEQ: '箱型箱量(SeaEQ)'
    },
    Container: {
      containerId: 'containerId',
      containerNo: '箱号containerNo',
      sealNo: '封号sealNo',
      reSealed: '是否更改封号reSealed',
      EQtype: '箱种EQtype',
      EQsize: '箱型EQsize',
      remark: '备注remark',
      containerWeight: '皮重containerWeight',
      cargoName: '品名(cargoName)',
      mark: '唛头(mark)',
      VGMWeight: 'VGM重量(VGMWeight)',
      WGMWeightingMeothd: 'VGM称重方法(VGMWeightingMethod)',
      VGMWeightingTime: 'VGM称重时间(VGMWeightingTime)',
      VGMWeightingPlace: 'VGMWeightingPlace',
      quantity: '件数quantity',
      weight: '重量weight',
      cubage: '体积cubage',
      approachDate: '进场时间(approachDate)',
      playDate: '出场时间(playDate)',
      dischargingPort: '卸货港(dischargingPort)',
      destinationPort: '目的港(destinationPort)',
      transportMessageDate: '运抵报文发送时间(transportMessageDate)',
      wharfReleaseDate: '码头放行时间(wharfReleaseDate)',
      customReleaseDate: '海关放行时间(customReleaseDate)',
      containerAscription: '箱属（备选COC/SOC）(containerAscription)',
      boxAscription: '箱属(箱管)(boxAscription)',
      plateNumber: '车牌号(plateNumber)',
      plateApproachDate: '集卡进场时间(plateApproachDate)',
      platePlayDate: '集卡出场时间(platePlayDate)',
      loadingPort: '装货港(loadingPort)',
      inSpected: '是否查验(inSpected)',
      boxOwner: '箱主',
      returnBoxTime: '箱管-还箱时间(returnBoxTime)',
      Container: '集装箱(Container)',
      SIZE_LENGTH: '长(sizeLength)',
      SIZE_WIDTH: '宽(sizeWidth)',
      SIZE_HEIGHT: '高(sizeHeight)'
    },
    ContainerUsage: {
      quantity: '件数quantity',
      weight: '重量weight',
      cubage: '体积cubage',
      masterJoin: '并单主单关联号(masterJoin)',
      serialNo: '拼箱装箱序号(serialNo)',
      HSCODE: 'HSCODE',
      SOC: '是否货主箱(SOC)',
      truckingInfoUuid: '本地运输UUID(truckingInfoUuid)',
      type: '互联派车订单状态变更类型(type)',
      code: '互联派车验证结果代码(code)',
      description: '互联派车状态描述(description)',
      truckingFee: '拖车费(truckingFee)',
      truckStatus: '互联派车状态(truckStatus)',
      driverNameHL: '司机姓名(driverNameHL)',
      driverPhoneHL: '司机手机号(driverPhoneHL)',
      truckNoHL: '互联车牌号码(truckNoHL)',
      tmsNoHL: '互联派车单号(tmsNoHL)',
      containerNoDiff: '互联箱封号提醒(containerNoDiff)',
      dcTicketNo: '互联DC票号',
      dcSequence: '互联DC柜序号',
      auditId: '互联费用确认编号',
      auditUrl: '互联费用确认URL',
      auditMoney: '互联费用确认金额',
      auditState: '互联费用确认状态(1:确认 2:退回)',
      truckingPlaceOfDep: '提柜堆场(TRUCKING_PLACE_OF_DEP)',
      truckingPlaceOfDest: '还柜堆场(TRUCKING_PLACE_OF_DEST)',
      tosCarNum: 'G7车牌号',
      tosDriverName: 'G7司机名称',
      tosDriverPhone: 'G7司机联系电话',
      tosTaskId: 'G7任务id',
      tosStartTime: 'G7计划发车时间',
      tosEndTime: 'G7计划到达时间',
      tosGstartTime: 'G7实际发车时间',
      tosGarriveTime: 'G7实际到达时间',
      tosInTime: 'G7计划到达工厂时间',
      tosGinTime: 'G7实际到达工厂时间',
      tosOutTime: 'G7计划离开工厂时间',
      tosGoutTime: 'G7实际离开工厂时间',
      tosNodeDate: '节点变更时间',
      tosLocation: 'G7定位信息',
      tosErrorType: 'G7运输异常标识',
      tosErrorMessage: 'G7异常信息',
      cargoName: '品名(cargoName)',
      mark: '唛头(mark)',
      ContainerUsage: '装箱明细(ContainerUsage)'
    },
    ContainerUsageTrucking: {
      containerUuid: '集装箱(containerUuid)',
      jobUuid: '业务(jobUuid)',
      truckingUuid: '业务(truckingUuid)',
      sequence: '序号(sequence)',
      status: '互联派车状态(status)',
      goodsDescription: '品名(goodsDescription)',
      feeferTemperaTrue: '温度要求(feeferTemperaTrue)',
      ventilaction: '通风要求(ventilaction)',
      containerSizeType: '箱型(containerSizeType)',
      shipCompany: '船公司(shipCompany)',
      containerOwner: '箱属(containerOwner)',
      containerNo: '箱号containerNo',
      sealNo: '封号sealNo',
      packages: '单箱件数(packages)',
      weight: '单箱重量(weight)',
      mearsurement: '单箱体积(mearsurement)',
      truckingDate: '装/送货时间(truckingDate)',
      truckingPalceOfDep: '起点(truckingPalceOfDep)',
      truckingPalceOfDest: '终点(truckingPalceOfDest)',
      truckingPalce: '装/卸货点(truckingPalce)',
      truckingData: '装/卸货点(truckingData)',
      shipper: '发货人(shipper)',
      shipperContact: '发货人联系人(shipperContact)',
      shipperContactPhone: '发货人联系电话(shipperContactPhone)',
      receiver: '收货人(receiver)',
      receiverContact: '收货人联系人(receiverContact)',
      receiverContactPhone: '收货人联系电话(receiverContactPhone)',
      shipCompanyRequirement: '船公司备注(shipCompanyRequirement)',
      truckFee: '拖车费(truckFee)',
      feeRemark: '费用备注(feeRemark)',
      attachments: '数组: 客户上传的附件标识，为返回的FILEUNIQUEKEY(attachments)',
      accepting: '审核通过操作时间(accepting)',
      refuseReason: '拒绝订单原因(refuseReason)',
      refusing: '拒绝订单操作时间(refusing)',
      assigning: '分配车辆操作时间(assigning)',
      assingReason: '分配车辆异常原因(assingReason)',
      assingRemark: '分配车辆异常备注(assingRemark)',
      loading: '服务商(车队)派车时，提供的车辆到厂时间(loading)',
      loadingTime: '提供到厂时间的录入时间(loadingTime)',
      truckNo: '车牌号码(truckNo)',
      driverName: '司机姓名(driverName)',
      driverPhone: '司机手机号(driverPhone)',
      newLoading: '(提柜后更新的)预计车辆到厂时间(newLoading)',
      containerWeigth: '空柜重量(containerWeigth)',
      pickupTime: '提空时间(pickupTime)',
      offerInfo: '报柜时间(offerInfo)',
      pickupReason: '提柜异常原因(pickupReason)',
      pickupRemark: '提柜异常备注(pickupRemark)',
      updateTime: '更新司机资料或箱信息操作时间(updateTime)',
      grossWeight: '过磅重量(grossWeight)',
      weighReason: '修改信息异常原因(weighReason)',
      weighRemark: '修改信息异常备注(weighRemark)',
      revokeTime: '撤销订单操作时间(revokeTime)',
      returnTime: '还柜进港操作时间(returnTime)',
      returnReason: '还柜进港异常原因(returnReason)',
      returnRemark: '还柜进港异常备注(returnRemark)',
      truckAttachments: '数组: 车队提供的附件地址(truckAttachments)',
      active: '有效,0=历史(active)',
      ContainerUsageTrucking: '装箱明细派车信息(ContainerUsageTrucking)'
    },
    MAWB: {
      sequence: '序号(sequence)',
      carrierId: '航空公司(carrierId)',
      bookingAgentId: '订舱代理(bookingAgentId)',
      startNo: '主单起始号(startNo)',
      number: '主单份数(number)',
      remark: '附加说明(remark)',
      inputBy: '领用人(inputBy)',
      dep: '领用部门(dep)',
      inputDate: '领用日期(inputDate)',
      effectDate: '失效日期(effectDate)',
      branchId: '分公司(branchId)',
      MAWB: '主单 (MAWB)'
    },
    MAWBDetail: {
      jobNo: '业务编号(jobNo)',
      state: '状态(state)',
      MAWBNo: '主单号(MAWBNo)',
      agentId: '过单代理(agentId)',
      borrowDate: '过单日期(borrowDate)',
      returnDate: '预计返回日期(returnDate)',
      actualReturnDate: '实际返回日期(actualReturnDate)',
      remark: '附加说明(remark)',
      MAWBDetail: '主单明细 (MAWBDetail)'
    },
    JobProfit: {
      jobNo: ' 工作号(jobNo)',
      rate: '汇率(rate)',
      profitUSD: '美元利润(profitUSD)',
      profitRMB: '人民币利润(profitRMB)',
      profit: '利润(profit)',
      JobProfit: '利润分析(JobProfit)'
    },
    EDIContainer: {
      containerNo: '箱号(containerNo)',
      sealNo: '封号(sealNo)',
      eqType: '箱种(eqType)',
      eqSize: '箱型(eqSize)',
      quantity: '件数(quantity)',
      weight: '重量(weight)',
      cubage: '体积(cubage)',
      remarks: '备注(remarks)',
      hv: 'hv(hv)',
      refNo: '客户参考号(refNo)',
      payLoad: '收货载重(payLoad)',
      nr: '非操作冷柜(nr)',
      temperature: '温度(temperature)',
      ventilated: '开通风盘(ventilated)',
      openning: '通风比例(openning)',
      fumPol: '起运港熏蒸证(fumPol)',
      fumDate: '熏蒸日期(fumDate)',
      venPolDate: '开通风盘日期(venPolDate)',
      fumUnNo: '熏蒸货物Un no(fumUnNo)',
      fumImoClass: '熏蒸货物imo class(fumImoClass)',
      deFumPod: '卸货港免熏蒸证(deFumPod)',
      dcCerReceived: 'dcCerReceived(dcCerReceived)',
      oldContainer: 'oldContainer(oldContainer)',
      EDIContainer: '提单EDI箱封信息(EDIContainer)'
    },
    AirFlight: {
      airFlightId: '序号(airFlightId)',
      carrierId: '航空公司(carrierId)',
      flight: '航班(flight)',
      ETD: '开航日期(ETD)',
      locked: '是否锁定(locked)',
      remark: '附加说明(remark)',
      inputBy: '创建人(inputBy)',
      dept: '创建部门(dept)',
      branchId: '分公司(branchId)',
      AirFlight: '空运航班表(AirFlight)'
    },
    WarehouseIn: {
      warehouseId: '入库流水号(warehouseId)',
      warehouse: '仓库名称(warehouse)',
      branchId: '分公司(branchId)',
      warehouseNo: '进仓编号(warehouseNo)',
      receiptNo: '回执单号(receiptNo)',
      warehouseInDate: '入库日期(warehouseInDate)',
      warehouseOP: '仓库员(warehouseOP)',
      location: '库位(location)',
      palletSum: '托盘数量(palletSum)',
      quantitySum: '入库件数合计(quantitySum)',
      weightSum: '入库重量合计(weightSum)',
      cubageSum: '入库体积合计(cubageSum)',
      deliveryCMP: '送货公司(deliveryCMP)',
      truckNo: '车牌(truckNo)',
      driver: '司机(driver)',
      driverTel: '司机联系电话(driverTel)',
      remarks: '备注(remarks)',
      broken: '是否破损受潮(broken)',
      brokenQuantity: '破损受潮件数(brokenQuantity)',
      brokenDes: '货损描述(brokenDes)',
      comments: '处理意见(comments)',
      receiveDC: '是否收到文件(receiveDC)',
      warehouseOutDate: '出库日期(warehouseOutDate)',
      outType: '出库方式(outType)',
      label: '分标签(label)',
      warehouseNoFormat: '进仓编号格式化(warehouseNoFormat)',
      sealCargo: '是否关封货(sealCargo)',
      sealWeight: '关封重量(sealWeight)',
      lob: '业务类型(lob)',
      referenceNo: '参考号(ReferenceNo)',
      instoreFrom: '入库操作类型(InstoreFrom)',
      outstoreTo: '出库操作类型(OutstoreTo)',
      marks: '唛头(Marks)',
      WarehouseIn: '仓储入库(WarehouseIn)'
    },
    WarehouseInDetail: {
      packing: '包装类型(packing)',
      quantity: '件数(quantity)',
      weight: '重量(weight)',
      cubage: '体积(cubage)',
      dimension: '尺寸(dimension)',
      remarks: '备注(remarks)',
      warehouseInDate: '入库日期(warehouseInDate)',
      WarehouseInDetail: '仓储入库明细(WarehouseInDetail)'
    },
    TrackingInfo: {
      code: '主状态代码(code)',
      codeCname: '主状态中文名(codeCname)',
      codeEname: '主状态英文名(codeEname)',
      subCode: '子状态代码(subCode)',
      subCodeCname: '子状态中文名(subCodeCname)',
      subCodeEname: '子状态英文名(subCodeEname)',
      modifyDate: '状态更新时间(modifyDate)',
      modifyBy: '状态更新人(modifyBy)',
      remark: '状态说明(remark)',
      roleType: '用户类型(ROLE_TYPE)',
      TrackingInfo: '业务状态跟踪(TrackingInfo)'
    },
    AirFlightDetail: {
      boardNo: '板号(boardNo)',
      boardType: '板型(boardType)',
      weight: '板重(weight)',
      wholeBoard: '是否包板(wholeBoard)',
      remark: '附加说明(remark)',
      transBy: '交接人(transBy)',
      transDate: '交接日期(transDate)',
      AirFlightDetail: '空运航班明细表(AirFlightDetail)'
    },
    TrackingInfoHistory: {
      code: '主状态代码(code)',
      codeCname: '主状态中文名(codeCname)',
      codeEname: '主状态英文名(codeEname)',
      subCode: '子状态代码(subCode)',
      subCodeCname: '子状态中文名(subCodeCname)',
      subCodeEname: '子状态英文名(subCodeEname)',
      modifyDate: '状态更新时间(modifyDate)',
      modifyBy: '状态更新人(modifyBy)',
      TrackingInfoHistory: '业务状态跟踪历史(TrackingInfoHistory)'
    },
    Flight: {
      ETD: '开航日期(ETD)',
      ATD: '实际起飞时间(ATD)',
      ATA: '实际到达时间(ATA)',
      handOffDateTime: '交货时间(handOffDateTime)',
      branchId: '分公司(branchId)',
      departureTime: '起飞时间(departureTime)',
      settleState: '结算状态(settleState)',
      Flight: '航班(Flight)'
    },
    AirExportBooking: {
      bookingNo: '订舱号(bookingNo)',
      bookingDate: '订舱日期(bookingDate)',
      bookingState: '订舱状态(bookingState)',
      bookingNotes: '订舱备注(bookingNotes)',
      bookingResultNotes: '订舱结果说明(bookingResultNotes)',
      inputBy: '创建人(inputBy)',
      inputDate: '创建日期(inputDate)',
      inputByDep: '创建人部门(inputByDep)',
      inputByOffice: '创建人分公司(inputByOffice)',
      AirExportBooking: '空运出口订舱(AirExportBooking)'
    },
    AirExportBookingItem: {
      success: '是否成功(isSuccess)',
      AirExportBookingItem: '空运出口订舱项(AirExportBookingItem)'
    },
    AirExportLoadingNotes: {
      notes: '说明(notes)',
      takePhotos: '拍照(takePhotos)',
      AirExportLoadingNotes: '空运出口装板说明(AirExportLoadingNotes)'
    },
    Business_Document: {
      documentId: '文档ID(documentId)',
      documentCategory: '文档类型(documentCategory)',
      fileName: '文件名(fileName)',
      fileCategory: '文件归类(fileCategory)',
      fileType: '文件类型(fileType)',
      fileSize: '文件大小(fileSize)',
      businessId: '业务ID(businessId)',
      sourceType: '文件来源(sourceType)',
      remarks: '备注(remarks)',
      Business_Document: '业务文档(Business_Document)'
    },
    AirExportTransitRoutingAdjustment: {
      adjuster: '调整人(adjuster)',
      adjustedTime: '调整时间(adjustedTime)',
      verifier: '审核人(verifier)',
      verifiedTime: '审核时间(verifiedTime)',
      originAirTransitRoutingDescriptionUUID: '源线路描述Id(originAirTransitRoutingDescriptionUUID)',
      targetAirTransitRoutingDescriptionUUID: '目标线路描述Id(targetAirTransitRoutingDescriptionUUID)',
      originFlightId: '源航班Id(originFlightId)',
      targetFlightId: '目标航班Id(targetFlightId)',
      AirExportTransitRoutingAdjustment: '空运线路调整(AirExportTransitRoutingAdjustment)'
    },
    ExceptionHandling: {
      operateType: '操作类型(OPERATE_TYPE)',
      operator: '操作人(operator)',
      operateTime: '操作时间(operateTime)',
      operationRequirement: '操作要求(operationRequirement)',
      executor: '执行人(executor)',
      executeTime: '执行时间(executeTime)',
      ExceptionHandling: '异常处理(ExceptionHandling)'
    },
    LayAside: {
      operator: '操作人(operator)',
      operateTime: '操作时间(operateTime)',
      layAsideNode: '拉货环节(layAsideNode)',
      layAsideReason: '拉货原因(layAsideReason)',
      LayAside: '拉货(LayAside)'
    },
    TrackingNode: {
      jobuuid: 'jobuuid(jobuuid)',
      active: '有效(active)',
      TrackingNode: '业务节点(TrackingNode)'
    },
    AirExportFlightCustomer: {
      flightNo: '航班号(flightNo)',
      ETD: 'ETD',
      customerId: '委托单位编码(customerId)',
      AirExportFlightCustomer: '空运出口航班客户(AirExportFlightCustomer)'
    },
    FileHandover: {
      handoverStatus: '交接状态(handoverStatus)',
      sender: '发送人(sender)',
      sendedDate: '发送时间(sendedDate)',
      recipient: '接收人(recipient)',
      receivedDate: '接收时间(receivedDate)',
      remarks: '备注(remarks)',
      returnedReason: '退回原因(returnedReason)',
      FileHandover: '文件交接(FileHandover)'
    },
    FileHandoverDetail: {
      fileType: '文件类型(fileType)',
      handoverStatus: '交接状态(handoverStatus)',
      FileHandoverDetail: '文件交接明细(FileHandoverDetail)'
    },
    AirTransitRoutingDescription: {
      firstTransshipmentPortCode: '一程中转港代码(firstTransshipmentPortCode)',
      secondTransshipmentPortCode: '二程中转港代码(secondTransshipmentPortCode)',
      beginValidDate: '生效时间(beginValidDate)',
      endValidDate: '失效时间(endValidDate)',
      createDepartment: '创建部门(createDepartment)',
      branchId: '分公司(branchId)',
      AirTransitRoutingDescription: '空运线路描述(AirTransitRoutingDescription)'
    },
    AirInteriorPoints: {
      interiorPointPortId: '转运港代码(interiorPointPortId)',
      AirInteriorPoints: '空运内陆转运点(AirInteriorPoints)'
    },
    FlightDescription: {
      flightNo: '航班号(flightNo)',
      carrierId: '航空公司(carrierId)',
      loadingPortCode: '起运港代码(loadingPortCode)',
      destinationPortCode: '目的港代码(destinationPortCode)',
      beginValidDate: '生效时间(beginValidDate)',
      endValidDate: '失效时间(endValidDate)',
      createDepartment: '创建部门(createDepartment)',
      branchId: '分公司(branchId)',
      cargoTerminals: '货站(cargoTerminals)',
      FlightDescription: '航班描述(FlightDescription)'
    },
    FlightScheduleItem: {
      itemName: '项名称(itemName)',
      departureTime: '起飞时间(departureTime)',
      flyingDays: '飞行天数(flyingDays)',
      arrivalTime: '到达时间(arrivalTime)',
      FlightScheduleItem: '航班时刻表计划项(FlightScheduleItem)'
    },
    Tracking: {
      lob: '业务类型(lob)',
      level: '主状态序号(level)',
      code: '主状态代码(code)',
      codeCname: '主状态中文名(codeCname)',
      codeEname: '主状态英文名(codeEname)',
      remark: '备注(remark)',
      nodeType: '节点类型(nodeType)',
      published: '是否公开(published)',
      defaultTracking: '默认跟踪(defaultTracking)',
      keyNode: '关键节点(keyNode)',
      offsetDay: '预计执行时间-天(offsetDay)',
      offsetHour: '预计执行时间-小时(offsetHour)',
      sopTypeUuid: 'SOP类型UUID(sopTypeUuid)',
      Tracking: '业务跟踪状态配置(Tracking)'
    },
    TrackingDetail: {
      defaultNode: '默认节点(defaultNode)',
      level: '子状态序号(level)',
      code: '子状态代码(code)',
      codeCname: '子状态中文名(codeCname)',
      codeEname: '子状态英文名(codeEname)',
      type: '状态触发类型(type)',
      event: '状态触发事件(event)',
      remark: '备注(remark)',
      stateType: '状态类型(stateType)',
      published: '是否公开(published)',
      templateUuid: '输出报表模板(templateUuid)',
      documentTypeUuid: '触发文件类型(documentTypeUuid)',
      externalCode: '外部代码(externalCode)',
      applyType: '应用类型(applyType 0.全部 1.内部 2.外部)',
      sendInnerNotify: '是否发送内部通知(sendInnerNotify)',
      innerConfig: '内部配置(innerConfig)',
      TrackingDetail: '业务跟踪状态配置明细(TrackingDetail)'
    },
    SOPExternalCodeConfig: {
      serviceName: '对接服务名称(serviceName)',
      code: '代码(code)',
      description: '描述(description)',
      SOPExternalCodeConfig: 'SOP外部映射(SOPExternalMapping)'
    },
    TrackingDetailNotifyExt: {
      trackingDetailUuid: '跟踪状态明细UUID(trackingDetailUuid)',
      messageCode: '输出标识(messageCode)',
      messageDesc: '输出说明(messageDesc)',
      entityName: '数据来源(entityName)',
      fieldName: '数据字段(fieldName)',
      remarks: '备注(remarks)',
      TrackingDetailNotifyExt: '业务跟踪状态明细消息附加信息(TrackingDetailNotifyExt)'
    },
    OperationRequirement: {
      descriptionId: '描述Id(descriptionId)',
      finished: '是否完成(finished)',
      finishedDate: '完成时间(finishedDate)',
      remarks: '备注(remarks)',
      OperationRequirement: '操作要求(OperationRequirement)'
    },
    SurchargeTerms: {
      chargeItemId: '费用项id(chargeItemId)',
      terms: '条款(terms)',
      SurchargeTerms: '附加费条款(SurchargeTerms)'
    },
    Memo: {
      jobUuid: '业务UUID(jobUuid)',
      talk: '说说(talk)',
      jobNo: '工作号(jobNo)',
      listener: '消息接收人(Listener)',
      Memo: '备忘录(Memo)'
    },
    MailHistory: {
      jobUuid: '业务UUID(JobUuid)',
      jobNos: '业务号码(JobNos)',
      mailSubject: '主题(MailSubject)',
      mailTo: 'TO(MailTo)',
      mailCc: 'CC(MailCc)',
      mailBcc: 'BCC(MailBcc)',
      mailContent: '邮件内容(MailContent)',
      returnTo: '回复接受人(ReturnTo)',
      attachmentPath: '附件保存位置(AttachmentPath)',
      docIdList: '附件云存储位置(docIdList)',
      MailHistory: '业务邮件历史(MailHistory)'
    },
    DataTransfer: {
      transferType: '传输类型(TransferType)',
      dataType: '数据类型(DataType)',
      dataKey: '业务数据关联键(DataKey)',
      referenceNo: '传输参考号(ReferenceNo)',
      refContent: '传输参考信息(RefContent)',
      dateUploaded: '数据导出时间(DateUploaded)',
      DataTransfer: '工作单数据传递信息(DataTransfer)'
    },
    JobPriceHistory: {
      jobUuid: '工作单uuid(jobUuid)',
      oldPriceNo: '原运价编号(oldPriceNo)',
      newPriceNo: '新运价编号(newPriceNo)',
      batchNumber: '批次号(batchNumber)',
      notifyState: '通知状态(notifyState)',
      JobPriceHistory: '业务运价更新历史(JobPriceHistory)'
    },
    PoItems: {
      orderNo: '订单号(OrderNo)',
      module_code: '型号(ModuleCode)',
      caseNo: 'CaseNo(CaseNo)',
      itemNo: 'ItemNo(ItemNo)',
      subItemNo: 'SubItemNo(SubItemNo)',
      supplyPartNo: 'SupplyPartNo(SupplyPartNo)',
      orderPartNo: 'OrderPartNo(OrderPartNo)',
      hsCode: '海关编码(HsCode)',
      chineseCommodity: '中文品名(ChineseCommodity)',
      englishCommodity: '英文品名(EnglishCommodity)',
      customsCommodity: '海关品名(CustomsCommodity)',
      quantity: '货物件数(quantity)',
      grossWeight: '货物毛重(GrossWeight)',
      orgRegion: '产地(OrgRegion)',
      cubage: '货物体积(cubage)',
      purchasePrice: '买价(PurchasePrice)',
      purchaseAmount: '买入货款(PurchaseAmount)',
      purchaseTariffRate: '买入关税税率(PurchaseTariffRate)',
      purchaseTariffAmount: '买入关税(PurchaseTariffAmount)',
      purchaseValRate: '买入增值税税率(PurchaseValRate)',
      purchaseValAmount: '买入增值税(PurchaseValAmount)',
      purchaseExciseRate: '买入消费税税率(PurchaseExciseRate)',
      purchaseExciseAmount: '买入消费税(PurchaseExciseAmount)',
      purchaseCurrency: '买入币种(PurchaseCurrency)',
      pruchaseExchangeRate: '买入汇率(PurchaseExchangeRate)',
      sellPrice: '卖价(SellPrice)',
      sellAmount: '卖出货款(SellAmount)',
      sellValRate: '卖出增值税税率(SellValRate)',
      sellValAmount: '卖出增值税(SellValAmount)',
      customsBillSeq: '报关归类序号(CustomsBillSeq)',
      remarks: '备注(remarks)',
      netWeight: '货物净重(netWeight)',
      itemSpec: '货物规格(itemSpec)',
      measure: '费用计费方式(measure)',
      related: '是否关联(related)',
      containerNo: '箱号(containerNo)',
      EQtype: '箱种(EQtype)',
      EQsize: '箱型(EQsize)',
      sealNo: '封号(sealNo)',
      containerUsageKey: '装箱信息(containerUsageKey)',
      psdCode: 'psdCode(psdCode)',
      techChemName: 'techChemName(techChemName)',
      imoSort: 'imoSort(imoSort)',
      segGroup: 'segGroup(segGroup)',
      caa: 'caa(caa)',
      pih: 'pih(pih)',
      reportableQty: 'reportableQty(reportableQty)',
      emerTemp: 'emerTemp(emerTemp)',
      mpCode: 'mpCode(mpCode)',
      controlTemp: 'controlTemp(controlTemp)',
      density: 'density(density)',
      imdgFrom: 'imdgFrom(imdgFrom)',
      imdgTo: 'imdgTo(imdgTo)',
      marPollutant: 'MAR POLLUTANT(marPollutant)',
      flashPoint: 'FLASH POINT(flashPoint)',
      dcPackage: 'DC PACKAGE(dcPackage)',
      dcPackaging: 'DC PACKING(dcPackaging)',
      dcWeight: 'DC WEIGHT(dcWeight)',
      quterQty: 'QUTER QTY(quterQty)',
      innerPackage: 'INNER PACKAGE(innerPackage)',
      innerQty: 'INNER QTY(innerQty)',
      emerProvider: 'EMER PROVIDER(emerProvider)',
      contactName: 'CONTACT NAME(contactName)',
      emerPhone: 'EMER PHONE(emerPhone)',
      PoItems: 'PO货物明细(PoItems)'
    },
    PoList: {
      poNo: '订单号(PONo)',
      customerId: '委托单位(CustomerId)',
      poState: 'PO状态（PoState)',
      salesOffice: '销售公司(salesOffice)',
      salesDepartment: '销售部门(salesDepartment)',
      sales: '业务员(sales)',
      supportor: '销售支持(supportor)',
      firstPo: '是否首单(FirstPo)',
      valPath: '退税路径(VALPath)',
      poAmount: '订单金额(POAmount)',
      poDeclareAmount: '订单核销金额(PODeclareAmount)',
      poCurrency: '订单币种(PoCurrency)',
      poExchangeRate: '订单汇率(PoExchangeRate)',
      faContract: '服务框架合同号(FAContract)',
      commisionDiscount: '服务费折扣率(CommisionDiscount)',
      opRemarks: '操作说明(OPRemarks)',
      remarks: '备注(remarks)',
      PoList: 'PO信息(PoList)'
    },
    ForexPayment: {
      paymentNo: '结汇编号(PaymentNo)',
      paymentDate: '外汇进账日期(PaymentDate)',
      forexType: '结汇方式(ForexType)',
      referenceNo: '参考编号(RerfrenceNo)',
      forexAmount: '结汇金额(ForexAmount)',
      forexCurrency: '结汇币种(ForexCurrency)',
      forexExchangeRate: '汇率(ForexExchangeRate)',
      paymentPreLocalAmount: '付汇预款项(PaymentPreLocalAmount)',
      commission: '手续费(Commission)',
      postalCommission: '邮电费(PostalCommission)',
      acceptCommission: '承兑手续费(AcceptCommission)',
      diffAmount: '调整差额(DiffAmount)',
      remarks: '备注(remarks)',
      ForexPayment: '付汇信息(ForexPayment)'
    },
    BatchDataGroup: {
      groupCode: '分组号码(groupCode)',
      dataType: '数据类型(dataType)',
      groupType: '用途(groupType)',
      dataKey: '业务ID(dataKey)',
      BatchDataGroup: '批量处理分组定义(batchDataGroup)'
    },
    CheckCargoDocHistory: {
      timestamp: '批次时间戳(timestamp)',
      fieldName: '字段名(fieldName)',
      fieldValue: '字段值(fieldValue)',
      fieldType: '字段类型(fieldType)',
      CheckCargoDocHistory: '对单修改历史记录(CheckCargoDocHistory)'
    },
    ContainerUsageHistory: {
      timestamp: '批次时间戳(timestamp)',
      fieldName: '字段名(fieldName)',
      fieldValue: '字段值(fieldValue)',
      fieldType: '字段类型(fieldType)',
      ContainerUsageHistory: '装箱明细修改历史记录(ContainerUsageHistory)'
    },
    VGM: {
      shipperLin1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      shipperContact: 'VGM联系人(shipperContact)',
      shipperContactEmail: 'VGM联系人邮箱(shipperContactEmail)',
      shipperContactWay: 'VGM联系方式(shipperContactWay)',
      shipperPerson: 'VGM负责人(shipperPerson)',
      companyContact: '公司联系人(companyContact)',
      companyContactEmail: '公司联系人邮箱(companyContactEmail)',
      companyContactWay: '公司联系方式(companyContactWay)',
      companyPrincipal: '公司负责人(companyPrincipal)',
      companyName: '公司名称(companyName)',
      companyAddress: '公司地址(companyAddress)',
      VGM: 'VGM'
    },
    CrossTenantHistory: {
      sendTenantId: '发送方TenantId(sendTenantId)',
      sendJobNo: '发送方业务编号(sendJobNo)',
      receiveTenantId: '接受方tenantId(receiveTenantId)',
      receiveJobNo: '接受方jobNo(receiveJobNo)',
      state: '状态(state)',
      operateDate: '操作日期(operateDate)',
      operatorId: '操作人Id(operatorId)',
      remark: '附加信息(remark)',
      operatorName: '操作人姓名(operatorName)',
      loadingPortCode: '起运港(loadingPortCode)',
      destinationPortCode: '目的港(destinationPortCode)',
      carrierId: '承运人编号(carrierId)',
      carrierName: '承运人姓名(carrierName)',
      ETD: 'ETD',
      containerInfo: '箱型箱量(containerInfo)',
      CrossTenantHistory: '跨Tenant委托日志(CrossTenantHistory)'
    },
    FreightCharges: {
      chargeItemId: '费用名称代码(chargeItemId)',
      amount: '金额(amount)',
      paymentTermHBL: '分单运费方式(paymentTermHBL)',
      unitRate: '单价(unitRate)',
      currency: '币种(currency)',
      quantity: '数量(quantity)',
      EQsize: '箱型EQsize',
      EQtype: '箱种EQtype',
      FreightCharges: 'HBL提单运费(freightCharges)'
    },
    SubscribePortPushHistory: {
      timestamp: '批次时间戳(timestamp)',
      jobUuid: '业务ID(jobUuid)',
      mbl: '提单号(mbl)',
      fieldName: '字段名称(fieldName)',
      sourceValue: '原值(sourceValue)',
      targetValue: '新值(targetValue)',
      recordId: '修改的实体记录UUID(recordId)',
      sourceType: '数据源类型(sourceType)',
      SubscribePortPushHistory: '推送历史表(SubscribePortPushHistory)'
    },
    SubscribePortPushStatistics: {
      jobUUID: '业务编号(jobUUID)',
      mbl: '提单号(mbl)',
      year: '年份(year)',
      month: '月份(month)',
      officeId: '操作分公司(officeId)',
      SubscribePortPushStatistics: '推送统计表(SubscribePortPushStatistics)'
    },
    ThirdPartyUser: {
      unionid: 'unionid(unionid)',
      openid: 'openid(openid)',
      nickname: 'nickname(nickname)',
      avatarUrl: '头像url(avatarUrl)',
      country: '国家(country)',
      province: '省份(province)',
      city: '城市(city)',
      gender: '性别(gender  0:未知 1:男 2:女)',
      phone: '联系电话(phone)',
      status: 'status(status)',
      userId: 'userId(userId)',
      ThirdPartyUser: '第三方用户登录(ThirdPartyUser)'
    },
    MscCargoDoc: {
      soNo: 'soNo(soNo)',
      customerRefNo: '参考号(customerRefNo)',
      mstBooking: '主单号(mstBooking)',
      splitType: '拆分类型(splitType)',
      relatedOrderNo: '相关订单号(relatedOrderNo)',
      contractType: '签约类型(contractType)',
      serviceCode: '服务代码(serviceCode)',
      remarks: '备注(remarks)',
      producionAssemblyStation: '产装地场站(producionAssemblyStation)',
      productionFreightType: '产装运输方式(productionFreightType)',
      loadingPort: '起运港(loadingPort)',
      loadingPortWharf: '起运港码头(loadingPortWharf)',
      dischargingPort: '卸货港(dischargingPort)',
      dischargingPortWharf: '卸港码头(dischargingPortWharf)',
      destinationPort: '目的地(destinationPort)',
      zipCode: '邮编(zipCode)',
      destinationPortStation: '目的地场站(destinationPortStation)',
      destinationTransferType: '目的地转运方式(destinationTransferType)',
      transitCountry: '中转国(transitCountry)',
      billType: '提单类型(billType)',
      sighDateBl: '签发日期(sighDateBl)',
      freightBl: 'Freight BL(freightBl)',
      podAgency: 'POD Agency(podAgency)',
      lastDescription: '最后一个箱子品名(lastDescription)',
      toOrderType: 'To Order Type(toOrderType)',
      mbl: '主单号(mbl)',
      billLoadingPort: '提单起运港(billLoadingPort)',
      billDischargingPort: '提单卸货港(billDischargingPort)',
      billDestinationPort: '提单交货地(billDestinationPort)',
      MscCargoDoc: 'MSC提单(MscCargoDoc)'
    },
    MscCompanyTypeAddress: {
      companyType: '公司类型(companyType)',
      mscUUID: 'Msc提单UUID(mscUUID)',
      MscCompanyTypeAddress: 'MSC提单类型地址(MscCompanyTypeAddress)'
    },
    SubLocation: {
      subLocationCode: '代码(subLocationCode)',
      sublocation: '名称(sublocation)',
      SubLocation: '产装地场站(SubLocation)'
    },
    Wharf: {
      portCode: '港口代码(portCode)',
      terminal: '码头名称(terminal)',
      terminalCode: '代码(terminalCode)',
      Wharf: '港口码头(Wharf)'
    },
    ContainerUsageDgStuffing: {
      ediContainerUUID: 'EDI装箱信息UUID(ediContainerUUID)',
      ContainerUsageDgStuffing: '装箱信息关联危险品装箱地址(ContainerUsageDgStuffing)'
    },
    MscBillAddress: {
      companyName: '公司名称(companyName)',
      companyAddress: '公司地址(companyAddress)',
      city: '城市(city)',
      cityName: '城市名称(cityName)',
      zipCode: '邮政编码(zipCode)',
      phone: '电话(phone)',
      fax: '传真(fax)',
      contact: '联系人(contact)',
      email: '电子邮件(email)',
      vipCode: 'VIP代码(vipCode)',
      inttraCode: 'Inttra代码(inttraCode)',
      mscCode: 'MSC代码(mscCode)',
      groupCode: '公司代码(groupCode)',
      otherInformation: '其他信息(otherInformation)',
      blTitle: '提单抬头(blTitle)',
      blAddress: '提单地址(blAddress)',
      blContact: '提单联系信息(blContact)',
      joinedUUID: '关联的UUID(joinedUUID)',
      MscBillAddress: 'MSC提单地址信息表(MscBillAddress)'
    },
    MscHistoryBillAddress: {
      companyName: '公司名称(companyName)',
      companyAddress: '公司地址(companyAddress)',
      city: '城市(city)',
      cityName: '城市名称(cityName)',
      zipCode: '邮政编码(zipCode)',
      phone: '电话(phone)',
      fax: '传真(fax)',
      contact: '联系人(contact)',
      email: '电子邮件(email)',
      vipCode: 'VIP代码(vipCode)',
      inttraCode: 'Inttra代码(inttraCode)',
      mscCode: 'MSC代码(mscCode)',
      groupCode: '公司代码(groupCode)',
      otherInformation: '其他信息(otherInformation)',
      blTitle: '提单抬头(blTitle)',
      blAddress: '提单地址(blAddress)',
      blContact: '提单联系信息(blContact)',
      MscHistoryBillAddress: 'MSC提单地址历史信息表(MscHistoryBillAddress)'
    },
    IntelligentDocument: {
      fileName: '文件名(fileName)',
      fileType: '文件类型(fileType)',
      fileSize: '文件大小(fileSize)',
      status: '处理状态(status)',
      fileId: '云存储ID(fileId)',
      resultJson: '解析结果(resultJson)',
      remark: '备注(remark)',
      clientRefId: '客户端唯一标识(clientRefId)',
      fileNo: '文件单号(fileNo)',
      jobUuid: '业务UUID(jobUuid)',
      jobNo: '业务编号(jobNo)',
      analysisCompleteDate: '解析完成时间(analysisCompleteDate)',
      IntelligentDocument: 'IntelligentDocument(IntelligentDocument)'
    },
    StatusChangeHistory: {
      statusType: '状态类型(statusType)',
      statusValue: '状态值(statusValue)',
      businessDataId: '业务ID(businessDataId)',
      remarks: '备注(remarks)',
      StatusChangeHistory: '状态修改记录(StatusChangeHistory)'
    },
    CargoBulkDetail: {
      insideQuantity: '小件数(insideQuantity)',
      weight: '重量(weight)',
      cubage: '体积(cubage)',
      sizeLength: '长(sizeLength)',
      sizeWidth: '宽(sizeWidth)',
      sizeHeight: '高(sizeHeight)',
      CargoBulkDetail: '散杂货明细'
    },
    SpecialSeaEQ: {
      EQsize: '箱型(EQsize)',
      EQquantity: '数量(EQquantity)',
      sizeLength: '长(sizeLength)',
      sizeWidth: '宽(sizeWidth)',
      sizeHeight: '高(sizeHeight)',
      SpecialSeaEQ: '特种箱箱型箱量(SpecialSeaEQ)'
    },
    TenantMessage: {
      messageId: '消息唯一ID号(messageId)',
      sender: '发送方ID(sender)',
      receiver: '接收方ID(receiver)',
      senderOffice: '发送方分公司(senderOffice)',
      receiveOffice: '接收方分公司(receiveOffice)',
      sendJobNo: '发送方业务编号(sendJobNo)',
      receiveJobNo: '接收方业务编号(receiveJobNo)',
      type: '消息类型(type)',
      state: '消息状态(state)',
      summary: '摘要(summary)',
      sendDate: '发送时间(sendDate)',
      receiveDate: '接收时间(receiveDate)',
      timeoutDate: '超时时间(timeoutDate)',
      payload: '消息内容(payload)',
      sendUser: '发送人ID(sendUser)',
      receiveUser: '接收人ID(receiveUser)',
      TenantMessage: '跨tenant传递消息(tenantMessage)'
    },
    TenantMessageEvent: {
      triggerTime: '触发时间(triggerTime)',
      name: '事件名(name)',
      state: '事件类型(state)',
      TenantMessageEvent: '跨tenant传递消息事件(tenantMessageEvent)'
    },
    SopType: {
      code: '类型代码(code)',
      codeCname: '类型中文名(codeCname)',
      codeEname: '类型英文名(codeEname)',
      lob: '业务类型(lob)',
      level: '类型序号(level)',
      remark: '备注(remark)',
      notify: '是否通知(isNotify)',
      notifyEmail: '邮件通知(isNotifyEmail)',
      notifySms: '短信通知(isNotifySms)',
      baseLineType: '基准时间类型(baseLineType)',
      offset: '偏移时间(offset)',
      SopType: 'SOP类型配置(SopType)'
    },
    ManifestInfo: {
      shipperShortCode: '发货人代码缩写(shipperShortCode)',
      shipperEnterpriseCode: '发货人企业代码(shipperEnterpriseCode)',
      shipperEnterpriseName: '发货人企业名称(shipperEnterpriseName)',
      shipperAddress: '发货人详细地址(shipperAddress)',
      shipperContactsType: '发货人联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      shipperContacts: '发货人联系人(shipperContacts)',
      shipperCityName: '发货人城市名称(shipperCityName)',
      shipperProvinceCode: '发货人省份代码(shipperProvinceCode)',
      shipperProvinceName: '发货人省份名称(shipperProvinceName)',
      shipperZipCode: '发货人邮政编码(shipperZipCode)',
      shipperCountryCode: '发货人国家代码(shipperCountryCode)',
      shipperAeoEnterpriseCode: '发货人AEO企业编码(shipperAeoEnterpriseCode)',
      consigneeShortCode: '收货人代码缩写(consigneeShortCode)',
      consigneeEnterpriseCode: '收货人企业代码(consigneeEnterpriseCode)',
      consigneeEnterpriseName: '发货人企业名称(consigneeEnterpriseName)',
      consigneeAddress: '收货人详细地址(consigneeAddress)',
      consigneeContactsType: '收货人联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      consigneeContacts: '收货人联系人(consigneeContacts)',
      consigneeCityName: '收货人城市名称(consigneeCityName)',
      consigneeProvinceCode: '收货人省份代码(consigneeProvinceCode)',
      consigneeProvinceName: '收货人省份名称(consigneeProvinceName)',
      consigneeZipCode: '收货人邮政编码(consigneeZipCode)',
      consigneeCountryCode: '收货人国家代码(consigneeCountryCode)',
      consigneeAeoEnterpriseCode: '收货人AEO企业编码(consigneeAeoEnterpriseCode)',
      consigneeSpecificContactsName: '收货人具体联系人名称(consigneeSpecificContactsName)',
      consigneeSpecificContactsType: '收货人具体联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      consigneeSpecificContacts: '收货人具体联系人(consigneeSpecificContacts)',
      notifyShortCode: '通知人代码缩写(notifyShortCode)',
      notifyEnterpriseCode: '通知人企业代码(notifyEnterpriseCode)',
      notifyEnterpriseName: '通知人企业名称(notifyEnterpriseName)',
      notifyAddress: '通知人详细地址(notifyAddress)',
      notifyContactsType: '通知人联系人类型(0.电话号码 1.Email地址 2.电传号码)',
      notifyContacts: '通知人联系人(notifyContacts)',
      notifyCityName: '通知人城市名称(notifyCityName)',
      notifyProvinceCode: '通知人省份代码(notifyProvinceCode)',
      notifyProvinceName: '通知人省份名称(notifyProvinceName)',
      notifyZipCode: '通知人邮政编码(notifyZipCode)',
      notifyCountryCode: '通知人国家代码(notifyCountryCode)',
      notifyAeoEnterpriseCode: '通知人AEO企业编码(notifyAeoEnterpriseCode)',
      instructBill: '指示提单instructBill(instructBill)',
      cfmState: '舱单状态(cfmState)',
      soNo: '关单号(soNo)',
      shipperId: '发货人Id(shipperId)',
      consigneeId: '收货人Id(consigneeId)',
      notifyId: '通知人Id(notifyId)',
      ManifestInfo: '舱单数据格式化(ManifestInfo)'
    },
    ManifestGoodsInfo: {
      soNo: '关单号(soNo)',
      EQsize: '箱型EQsize',
      containerNo: '箱号containerNo',
      sealNo: '封号sealNo',
      cargoEnglishName: '英文品名(cargoEnglishName)',
      hsCode: 'HS Code(HSCODE)',
      quantity: '件数(quantity)',
      weight: '重量(weight)',
      cubage: '体积(cubage)',
      packing: '包装(packing)',
      mark: '唛头(mark)',
      danClassNo: '危险货物类别(danClassNo)',
      danUNNo: '联合国编号(danUNNo)',
      ediStatus: 'EDI发送以及处理状态,0:未发送,1:已发送,2:已成功,3:已失败,3:未发送,4:修复成功',
      ManifestGoodsInfo: '舱单格式化货物信息'
    },
    ManifestVGMInfo: {
      soNo: '关单号(soNo)',
      EQsize: '箱型EQsize',
      containerNo: '箱号containerNo',
      sealNo: '封号sealNo',
      VGMWeight: '总量(VGMWeight)',
      VGMWeightingMeothd: '称重方式(VGMWeightingMeothd)',
      VGMLiabilityCompany: 'VGM责任公司(VGMLiabilityCompany)',
      VGMAutoGraph: 'VGM签名(VGMAutoGraph)',
      contactEmail: 'VGM邮箱(contactEmail)',
      grossWeight: '箱皮重(grossWeight)',
      telephone: '电话(telephone)',
      weighingAddress: '称重地址(weighingAddress)',
      ManifestVGMInfo: '舱单格式化VGM信息'
    },
    ContainerUsageTostaskstatus: {
      ids: '任务方的唯一id',
      orgRoot: '所属机构号',
      orgCode: '顶级机构号',
      actions: '数据动作，每次推送必有，action的值必须为，add（添加）、update（更新）、del（删除）',
      remark: '备注',
      orderNo: '业务编号',
      taskCode: '任务号',
      postLineName: '任务线路',
      postLineCode: '线路编码',
      startTime: '计划发车时间',
      gStartTime: '实际开始时间',
      startDelay: '发车延误 秒',
      endTime: '计划到达时间',
      gArriveTime: '实际到达时间',
      arriveDelay: '到达延误 秒',
      planDistance: '计划总里程',
      totalDistance: '实际总里程',
      runTime: '运行时间 秒',
      gRunTime: '实际运行时间 秒',
      runDelay: '运行延误 秒',
      events: '异常事件数目',
      responsibility: '延误有责: 0无；1有',
      responsibleTime: '有责时长 秒',
      auditor: '审核人',
      isAudited: '是否审核：0、否，1、是，2申诉状态',
      auditTime: '审核时间',
      custome: '客户名称',
      inHavenTime: '进始发站时间',
      startPoint: '始发地',
      startPointCode: '始发地编码',
      endPoint: '到达地',
      endPointCode: '到达地编码',
      carNum: '车牌号',
      truckId: '车辆id',
      gpsNo: '设备号',
      driverName: '任务司机',
      driverPhone: '司机电话',
      carriageType: '运费类型',
      postlineType: '线路类型',
      isException: '完成异常',
      fineAmount: '罚款金额',
      jsonLog: 'json报文记录',
      ContainerUsageTostaskstatus: 'tos任务状态'
    },
    ContainerUsageToslocation: {
      code: '编号',
      message: '消息',
      event: '事件类型',
      pushTime: '推送时间',
      receiveOrgCode: '接收数据的机构号',
      plateNum: '车牌号',
      course: '方向角',
      imei: '设备终端号',
      lat: '纬度',
      lng: '经度',
      speed: '速度',
      time: '定位时间',
      jsonLog: 'json报文记录',
      ContainerUsageToslocation: 'tos定位数据'
    },
    ContainerUsageTostasktime: {
      ids: '任务方的唯一id',
      orgRoot: '顶级机构号',
      orgCode: '所属机构号',
      actions: '数据动作，每次推送必有，action的值必须为，add（添加）、update（更新）、del（删除）',
      taskId: '任务id',
      taskCode: '任务编码',
      orderNo: '站点顺序',
      siteId: '站点id',
      siteName: '站点名',
      inTime: '计划进场时间',
      gInTime: '实际进场时间',
      outTime: '计划出发时间',
      gOutTime: '实际出发时间',
      runTime: '计划运行时长 秒',
      gRunTime: '实际运行时长 秒',
      planDistance: '计划里程,单位米',
      totalDistance: '实际里程,单位米',
      jsonLog: 'json报文记录',
      ContainerUsageTostasktime: 'tos任务时效数据'
    },
    ContainerUsageTosevents: {
      ids: '事件id',
      orgRoot: '顶级机构号',
      orgCode: '所属机构号',
      actions: '数据动作，每次推送必有，action的值必须为，add（添加）、update（更新）、del（删除）',
      taskId: '这个事件绑定的任务id，创建任务的时候tos 会返回',
      taskCode: '这个事件绑定的任务编码',
      lat: '事件开始的纬度',
      lng: '事件开始的经度',
      status: '时间状态，0事件开始，1事件结束，2单次事件（无开始和结束）',
      elat: '事件结束的纬度,当status不为1的时候此字段无效',
      elng: '事件结束的经度,当status不为1的时候此字段无效',
      eventType: '事件类型，offline：离线，problem：异常停车，slow：缓行，late_leave：晚发预警，late_arrive：晚到预警，path_offset：线路偏移，late_out：晚发报警',
      gpsNo: '设备号',
      carNum: '车牌号',
      driverName: '司机姓名',
      driverPhone: '司机手机号',
      eventAddr: '事件发生地址',
      sTime: '事件开始时间戳',
      eventTime: '事件发生事件戳',
      eTime: '事件结束时间戳，当status不为1的时候此字段无效',
      cTime: '事件创建时间戳',
      uTime: '事件修改事件戳',
      isHandle: '事件是否处理了，1：是，0否',
      pathId: '线路偏移的id',
      isCheck: '事件是否审核了，1：是，0否',
      isAppeal: '事件是否申诉了，1：是，0否',
      mile: '事件持续里程,单位米，当status不为1的时候此字段无效',
      photo: '如果存在此字段则是增量的照片列表:[{id:唯一id（用于修改、删除）,url:照片地址，ctime:创建时间戳},............]',
      detail: '增量推送,处理过程[{id:唯一id（用于更新）,etype:类型，ctime:创建时间戳,min:免责时长，-1 未知，0全责,大于0为免责时间，单位分,resp:是否有责，1无，2 部分有责，3全责},............]',
      mins: '免责时长，-1 未知，0全责,大于0为免责时间，单位分，仅当事件problem：异常停车，slow：缓行,path_offset：线路偏移,traffic:拥堵事件有效',
      json_log: 'json报文记录',
      ContainerUsageTosevents: 'tos事件推送'
    },
    SopEmailReceiver: {
      pushObject: '推送对象(pushObject)',
      receivingMode: '接收方式(receivingMode)',
      name: '姓名(name)',
      pushNode: '推送节点(pushNode)',
      email: '邮箱(email)',
      phone: '电话(phone)',
      cmpId: '合作伙伴标识(cmpId)',
      relationId: '关联业务(relationId)',
      SopEmailReceiver: 'sop邮件接收人(SopEmailReceiver)'
    },
    SopEmailRecord: {
      orderNo: '流水号(orderNo)',
      type: '类型(type)',
      pushNode: '推送节点(pushNode)',
      pushObject: '推送对象(pushObject)',
      pushingChannel: '推送渠道(pushingChannel)',
      pushingResult: '推送结果(pushingResult)',
      receivingUser: '接收人(receivingUser)',
      receivingTxt: '内容描述(receivingTxt)',
      fileId: '附件编号(fileId)',
      relationId: '关联业务(relationId)',
      modifyDate: '节点推送时间',
      SopEmailRecord: 'sop邮件推送记录(SopEmailRecord)'
    },
    TrackingTemplateConfig: {
      pushObject: '推送对象(pushObject)',
      pushChannel: '推送渠道(pushChannel)',
      templateTitle: '模板主题(templateTitle)',
      pushNode: '推送节点(pushNode)',
      templateText: '模板正文(templateText)',
      fileId: '附件(fileId)',
      lob: '业务类型(lob)',
      trackingDetailUuid: '关联状态详情(trackingDetailUuid)',
      TrackingTemplateConfig: '业务消息推送模板配置(TrackingTemplateConfig)'
    },
    RailwayExportJob: {
      headwayTail: '是否头程尾程',
      containerLoadType: '委托类型',
      transportType: '运输类型',
      fullHalf: '全程/半程',
      transportLine: '航线',
      departureStation: '始发站',
      transferStation: '中转站',
      transitStation: '过境站',
      destinationStation: '目的站',
      destinationCountry: '目的国',
      portAgent: '口岸代理',
      forwardingAgent: '发运代理',
      paymentMethod: '付款方式',
      diffPlacesCollaborate: '是否异地协同',
      loadingPlaceCompany: '装货地公司',
      signBillPlaceCompany: '签单地公司',
      fullShipment: '是否全程出运',
      dischargePortCompany: '卸货港公司',
      destinationPortCompany: '目的港公司',
      transfer: '是否中转',
      operationTips: '操作提示',
      loadingTerm: '装箱方式',
      sailingDay: '航期/班期',
      customs: '是否报关',
      comercialInspectation: '是否商检',
      heating: '是否薰蒸',
      subTenantId: '客户编号(subTenantId)',
      jobNo: '工作号(jobNo)',
      warehouseNo: '进仓编号(warehouseNo)',
      customerRefNo: '客户参考号(customerRefNo)',
      agentRefNo: '代理业务编号(agentRefNo)',
      mbl: 'MBL(mbl)',
      mblNo5: 'MBL_NO5(mblNo5)',
      relatedJob: '公司往来关联号(relatedJob)',
      relatedJob2: '联运编号(relatedJob2)',
      mblOnly: '是否直发(mblOnly)',
      joinFlagMBL: 'MBL并单标志(joinFlagMBL)',
      joinFlagHBL: 'HBL并单标志(joinFlagHBL)',
      masterFlag: '拼箱主号标志(masterFlag)',
      cancelled: '是否取消(cancelled)',
      salesOffice: '销售公司(salesOffice)',
      salesDepartment: '销售部门(salesDepartment)',
      sales: '业务员(sales)',
      csrOffice: '客服公司(csrOffice)',
      csrDepartment: '客服部门(csrDepartment)',
      csr: '客服(csr)',
      opOffice: '操作公司(opOffice)',
      opDepartment: '操作部门(opDepartment)',
      op: '操作(op)',
      customerId: '委托单位编码(customerId)',
      customerContact: '联系人(customerContact)',
      contactTelephone: '联系电话(contactTelephone)',
      contactFax: '联系电传(contactFax)',
      designationAgent: '指定代理(designationAgent)',
      destinationAgent: '目的港代理(destinationAgent)',
      localAgent: '本地代理(localAgent)',
      masterAgent: '是否主代理(masterAgent)',
      bookingAgent: '订舱代理(bookingAgent)',
      customsBroker: '报关行(customsBroker)',
      dispatchingPlace: '发货地(dispatchingPlace)',
      destinationPlace: '最终目的地(destinationPlace)',
      destinationPlaceCode: '最终目的地代码(destinationPlaceCode)',
      loadingPortCode: '装货港代码(loadingPortCode)',
      dischargingPortCode: '卸货港代码(dischargingPortCode)',
      destinationPortCode: '目的港代码(destinationPortCode)',
      quantityContract: '委托货物件数(quantityContract)',
      weightContract: '委托货物重量(weightContract)',
      cubageContract: '委托货物体积(cubageContract)',
      quantityActual: '实际货物件数(quantityActual)',
      weightActual: '实际货物重量(weightActual)',
      cubageActual: '实际货物体积(cubageActual)',
      chargeWeight: '计费重量(chargeWeight)',
      chargeCubage: '计费体积(chargeCubage)',
      measurements: '货物尺寸(measurements)',
      cargoType: '货物种类(cargoType)',
      packing: '包装(packing)',
      paymentTermMBL: '主单运费方式(paymentTermMBL)',
      paymentTermHBL: '分单运费方式(paymentTermHBL)',
      cargoChineseName: '中文品名(cargoChineseName)',
      cargoEnglishName: '英文品名(cargoEnglishName)',
      mark: '唛头(mark)',
      carrierId: '承运人编号(carrierId)',
      carrierAgentId: '船代(carrierAgentId)',
      vessel: '船名(vessel)',
      voyageFlight: '航次(voyage/fleight)',
      ETD: 'ETD',
      ETA: 'ETA',
      ATA: 'ATA',
      jobState: '业务状态(jobState)',
      comission: '业务提成金额(commission)',
      remarks: '备注(remarks)',
      businessDate: '业务日期(businessDate)',
      lob: '业务类型(lob)',
      shutOut: '是否退关(shutOut)',
      satisfiedRequests: ' 满足的特殊要求(satisfiedRequests)',
      dcOffice: '单证公司(dcOffice)',
      dcDepartment: '单证部门(dcDepartment)',
      dc: '单证(dc)',
      PONO: '项目编号(PONO)',
      agentLevel: '代理等级(agentLevel)',
      cargoSource: '货物来源(cargoSource)',
      containerDesc: '货量描述(containerDesc)',
      teu: 'teu',
      profit: 'profit',
      warehousing: '是否仓储(warehousing)',
      landTransportation: '是否路运(landTransportation)',
      international: '是否国际运输(international)',
      multiplePickups: '是否多次派车(multiplePickups)',
      advance: '是否垫付(advance)',
      blocked: '是否等待特批(blocked)',
      express: '是否是快递(express)',
      declareCustomsState: '报关状态(declareCustomsState)',
      warehouseNoFormat: '进仓编号格式化(warehouseNoFormat)',
      shipperId: '发货人Id(shipperId)',
      consigneeId: '收货人Id(consigneeId)',
      notifyId: '通知人Id(notifyId)',
      preverifyState: '预审核状态(preverifyState)',
      trustFromJob: '委托来源关联号(trustFromJob)',
      signMBL: '是否签发主单(signMBL)',
      signHBL: '是否签发分单(signHBL)',
      EstimateAccountsReceivable: '预估收入(EstimateAccountsReceivable)',
      EstimateAccountsPayable: '预估成本(EstimateAccountsPayable)',
      EstimateGrossProfit: '预估利润(EstimateGrossProfit)',
      shipperCode: '发货人代码(shipperCode)',
      shipperLine1: '发货人(shipperLine1)',
      shipperLine2: '发货人(shipperLine2)',
      shipperLine3: '发货人(shipperLine3)',
      shipperLine4: '发货人(shipperLine4)',
      shipperLine5: '发货人(shipperLine5)',
      shipperLine6: '发货人(shipperLine6)',
      shipperLine7: '发货人(shipperLine7)',
      consigneeCode: '收货人代码(consigneeCode)',
      consigneeLine1: '收货人(consigneeLine1)',
      consigneeLine2: '收货人(consigneeLine2)',
      consigneeLine3: '收货人(consigneeLine3)',
      consigneeLine4: '收货人(consigneeLine4)',
      consigneeLine5: '收货人(consigneeLine5)',
      consigneeLine6: '收货人(consigneeLine6)',
      consigneeLine7: '收货人(consigneeLine7)',
      notifyCode: '通知人代码(notifyCode)',
      notifyLine1: '通知人(notifyLine1)',
      notifyLine2: '通知人(notifyLine2)',
      notifyLine3: '通知人(notifyLine3)',
      notifyLine4: '通知人(notifyLine4)',
      notifyLine5: '通知人(notifyLine5)',
      notifyLine6: '通知人(notifyLine6)',
      notifyLine7: '通知人(notifyLine7)',
      alsoNotify: '第二通知人(alsoNotify)',
      bookingRefuseNote: '拒绝订舱理由(bookingRefuseNote)',
      customsDate: '报关日期(customsDate)',
      customsRemarks: '报关备注(customsRemarks)',
      HSCODE: 'HS Code(HSCODE)',
      operationContent: '操作要求说明(operationContent)',
      situation: '情况说明(situation)',
      ATD: 'ATD',
      checkData: '已核对数据(checkData)',
      virtualHBL: '是否形式分单(virtualHBL)',
      receivableState: '应收状态(receivableState)',
      payablesState: '应付状态(payablesState)',
      priceNo: '运价No(priceNo)',
      booking: '是否订舱(booking)',
      priceTier: '运价等级(priceTier)',
      selfDeliver: '是否自拉自送(selfDeliver)',
      bookingState: '订舱状态(bookingState)',
      itmService: '是否有外贸(ITMService)',
      customsJobNo: '报关关联号(customsJobNo)',
      customJobType: '客户自定义业务种类(customJobType)',
      preverifier: '预审审核人(preverifier)',
      preverifyDate: '预审审核时间(preverifyDate)',
      salePrice: '是否特价(salePrice)',
      salePriceRemarks: '特价备注(salePriceRemarks)',
      salesChannel: '订舱渠道(salesChannel)',
      depositReceived: '预付款(depositReceived)',
      contactEmail: '联系邮件(contactEmail)',
      provisioned: '已计提(provisioned)',
      provisionedDate: '计提时间(provisionedDate)',
      provisionedBy: '计提人(provisionedBy)',
      planner: '航线(planner)',
      plannerDepartment: '航线部门(plannerDepartment)',
      riverCarrierId: '江船公司(riverCarrierId)',
      tradeTerm: '贸易方式(tradeTerm)',
      overseaOpDepartment: '外海操作部门(overseaOpDepartment)',
      overseaOp: '海外操作(overseaOp)',
      userDefinedField1: '自定义字段1(userDefinedField1)',
      userDefinedField2: '自定义字段2(userDefinedField2)',
      userDefinedField3: '自定义字段3(userDefinedField3)',
      manageAuditRemark: '审核备注(manageAuditRemark)',
      manageAuditRejectRemark: '审核拒绝备注(manageAuditRejectRemark)',
      manageAuditStatus: '主管审核状态(manageAuditStatus)',
      submitterUser: '提交人(submitterUser)',
      auditCheckNode: '提交审核节点(auditCheckNode)',
      typeHBL: '分单类型(typeHBL)',
      typeMBL: '主单类型(typeMBL)',
      ifPushSopM: '是否确认目的港代理推送SOP信息(ifPushSopM)',
      ifPushSopZ: '是否确认指定货代理推送SOP信息(ifPushSopZ)',
      ifPushSopQ: '是否确认起运港代理推送SOP信息(ifPushSopQ)',
      ifPushSop: '是否确认推送SOP信息(ifPushSop)',
      changeState: '改单状态(changeState)',
      cargoSalesId: '揽货销售(cargoSalesId)',
      changeBy: '改单人(changeBy)',
      changeDate: '改单时间(changeDate)',
      closingAccountStatus: '结转状态(closingAccountStatus)',
      firstProvisionedDate: '首次计提时间(firstProvisionedDate)',
      firstProvisionedProfit: '首次提成利润(firstProvisionedProfit)',
      provisionedProfit: '累计提成利润(provisionedProfit)',
      provisionedStatus: '计提状态(provisionedStatus)',
      salesRequire: '销售要求(salesRequire)',
      userDefinedField4: '自定义字段4(userDefinedField4)',
      vesselPortArea: '港区船名(vesselPortArea)',
      voyageFlightPortArea: '港区航次(voyageFlightPortArea)',
      customerTenantId: '委托单位所属tenantId(customerTenantId)',
      customerTenantName: '委托单位所属tenantName(customerTenantName)',
      RailwayExportJob: '铁路出口工作单(RailwayExportJob)'
    },
    RailwayHeadwayTail: {
      headwayTail: '头程/尾程',
      transportMethod: '运输方式',
      transportCompany: '运输公司',
      region: '国家',
      province: '省',
      city: '市',
      districts: '区',
      address: '详细信息',
      contact: '门点联系人',
      telephone: '电话',
      remarks: '备注',
      RailwayHeadwayTail: '铁路出口头程尾程(RailwayHeadwayTail)'
    },
    RailwayContainer: {
      eqsize: '箱型',
      eqtype: '箱种',
      containerno: '箱号',
      unitPrice: '单价',
      containerStatus: '箱子状态',
      containerAscription: '箱属',
      jobNo: '关联业务编号',
      jobUuid: '关联业务',
      containerUuid: '关联箱',
      currencyCode: '币种',
      orderUuid: '关联订单',
      RailwayContainer: '箱管-明细(RailwayContainer)'
    },
    RailwayContainerOrder: {
      orderNo: '流水号',
      sellerId: '箱主/卖家编号',
      sellerName: '箱主/卖家中文',
      buyerId: '箱主/买家编号',
      buyerName: '箱主/买家中文',
      currencyCode: '币种',
      orderType: '订单类型',
      amount: '订单金额',
      ifSettlement: '是否结算',
      settlementDate: '结算时间',
      buyerDate: '买箱时间',
      sellerDate: '卖箱时间',
      rentDate: '起租时间',
      returnDate: '退还时间',
      RailwayContainerOrder: '箱管-订单(RailwayContainerOrder)'
    },
    RailwayReturnBox: {
      containerno: '箱号',
      jobNo: '关联业务编号',
      jobUuid: '箱主/买家中文',
      containerUuid: '关联箱',
      returnBoxUser: '还箱人',
      returnBoxOperationTime: '还箱操作时间',
      returnBoxTime: '还箱时间',
      RailwayReturnBox: '箱管-还箱(RailwayReturnBox)'
    },
    Charge: {
      chargeId: '费用ID(chargeId)',
      chargeItemId: '费用名称代码(chargeItemId)',
      receivable: '收支类型(receivable)',
      oversea: '国内国外(oversea)',
      adjustment: '是否调整费用(adjustment)',
      shared: '是否分摊费用(shared)',
      shareScheme: '分摊类型(shareScheme)',
      shareRefNo: '分摊关联编号(shareRefNo)',
      commission: '是否佣金(commission)',
      advance: '是否垫付(advance)',
      prepaid: '是否托收拆分(prepaid)',
      paidOff: '已付清(paidOff)',
      collection: '已转入托收(collection)',
      relatedId: '内结费用编号(relatedId)',
      accountId: '结算单位代码(accountId)',
      invoiceTitle: '发票抬头(invoiceTitle)',
      currency: '币种(currency)',
      measure: '单位类型(measure)',
      quantity: '数量(quantity)',
      unitRate: '单价(unitRate)',
      amount: '金额(amount)',
      verifiedAmount: '已核销金额(verfiedAmount)',
      exchangeRate: '汇率(exchangeRate)',
      billNo: '帐单号(billNo)',
      counterPartyBillingNo: '对方账单号(counterPartyBillingNo)',
      paymentNo: '付款审批号(paymentNo)',
      invoiceNo: '发票号/税金号(invoiceNo)',
      voucherNo: '财务接口编号(voucherNo)',
      containerNo: '箱号(containerNo)',
      inputBy: '录入人(inputBy)',
      inputDate: '录入日期(inputDate)',
      auditor: '审核人(auditor)',
      auditDate: '审核日期(auditDate)',
      accountingDate: '财务日期(accountingDate)',
      clearingDate: '销账日期(clearingDate)',
      payReceiveDate: '最后收付日期(payReceiveDate)',
      remarks: '备注(remarks)',
      inputByDep: '录入人部门(inputByDep)',
      branchId: '费用分公司(branchId)',
      taxRate: '税率(taxRate)',
      taxAmount: '税额(taxAmount)',
      excludingTaxAmount: '不含税额(excludingTaxAmount)',
      controlled: '是否受控(controlled)',
      chargeSource: '费用来源(chargeSource)',
      chargeState: '费用状态(chargeState)',
      confirmState: '确认状态(confirmState)',
      confirmDate: '确认日期(confirmDate)',
      confirmUser: '费用确认人(confirmUser)',
      billingAmount: '对帐金额(billingAmount)',
      confirmRemarks: '确认备注(confirmRemarks)',
      differentState: '差异调整状态(differentState)',
      invoiceAmount: '开票金额(invoiceAmount)',
      invoiceExcludingTax: '开票不含税额(invoiceExcludingTax)',
      invoiceTax: '开票税额(invoiceTax)',
      offsetState: '红冲状态(offsetState)',
      serviceType: '服务项目(serviceType)',
      contactPerson: '联系人(ContactPerson)',
      payable: '是否可付款(payable)',
      ppcc: '预付到付(ppcc)',
      relatedMbl: '关联提单号(relatedMbl)',
      needInvoice: '是否需要开票(needInvoice)',
      paymentCompany: '来款单位(paymentCompany)',
      serialNumber: '序号(serialNumber)',
      billingDate: '账单日期(billingDate)',
      invoiceDate: '开票日期(invoiceDate)',
      businessDate: '业务日期(businessDate)',
      voucherJob: '是否按业务生成凭证(voucherJob)',
      voucherBilling: '是否按账单生成凭证(voucherBilling)',
      voucherInvoice: '是否按发票生成凭证(voucherInvoice)',
      provisionedDate: '计提时间(provisionedDate)',
      closingAccountExcludingTax: '结转不含税额(closingAccountExcludingTax)',
      closingAccountTax: '结转税额(closingAccountTax)',
      splitRelationKey: '拆分关系(splitRelationKey)',
      special: '是否特殊费用(special)',
      voucherDate: '凭证日期(voucherDate)',
      truckOrderNo: '派车单号(TruckOrderNo)',
      targetVoucherNo: '对方凭证号(targetVoucherNo)',
      Charge: '费用(Charge)'
    },
    Billing: {
      bankAccount: '银行帐号(bankAccount)',
      swiftCode: 'swiftCode(swiftCode)',
      clearingState: '核销状态(clearingState)',
      agentRefNo: '代理编号(agentRefNo)',
      billingId: '账单序号(billingId)',
      billingNo: '账单号(billingNo)',
      counterPartyBillingNo: '对方账单号(counterPartyBillingNo)',
      billingType: '账单类型(billingType)',
      ar: '账单收支(isAr)',
      state: '账单状态(state)',
      accountId: '结算对象(accountId)',
      contact: '结算对象联系人(contact)',
      currency: '币种(currency)',
      rate: '汇率(rate)',
      chargeCurrency1: '费用币种1(chargeCurrency1)',
      chargeRate1: '费用汇率1(chargeRate1)',
      chargeCurrency2: '费用币种2(chargeCurrency2)',
      chargeRate2: '费用汇率2(chargeRate2)',
      amount: '金额(amount)',
      taxAmount: '税额(taxAmount)',
      currencyAmount: '分币种合计(currencyAmount)',
      bankAccountId: '银行帐号Id(bankAccountId)',
      invoiceDemand: '开票要求(invoiceDemand)',
      title: '开票抬头(title)',
      percentage: '分成比例(percentage)',
      jobNo: '工作号(jobNo)1',
      mbl: '主单号(mbl)',
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      pod2: '目的港(pod2)',
      ETD: '开航日期(ETD)',
      ETA: '到港日期(ETA)',
      voyageFlight: '船名航次(voyageFlight)',
      containerSeal: '箱封号(containerSeal)',
      titleBranchId: '账单抬头分公司(titleBranchId)',
      billingAddress: '账单地址(billingAddress)',
      remark: '账单备注(remark)',
      inputBy: '创建人(inputBy)',
      inputByDep: '创建人部门(inputByDep)',
      inputDate: '创建日期(inputDate)',
      printDate: '打印日期(printDate)',
      invalidBy: '作废人(invalidBy)',
      invalidDate: '作废日期(invalidDate)',
      cancellationDetails: '作废细节(cancellationDetails)',
      branchId: '分公司(branchId)',
      sales: '销售(sales)',
      sourceCurrency1: '原币种1(sourceCurrency1)',
      sourceCurrency2: '原币种2(sourceCurrency2)',
      sourceCurrency3: '原币种3(sourceCurrency3)',
      sourceRate1: '原币对目标币种汇率1(sourceRate1)',
      sourceRate2: '原币对目标币种汇率2(sourceRate2)',
      sourceRate3: '原币对目标币种汇率3(sourceRate3)',
      amount1: '原币转换的金额(amount1)',
      amount2: '原币转换的金额(amount2)',
      amount3: '原币转换的金额(amount3)',
      buyerTaxAccount: '纳税人识别号(buyerTaxAccount)',
      buyerBank: '开户银行(buyerBank)',
      buyerBankAccount: '银行帐号(buyerBankAccount)',
      buyerAddress: '纳税人地址(buyerAddress)',
      buyerTelephone: '电话(buyerTelephone)',
      markUser: '标记人(markUser)',
      markDate: '标记时间(markDate)',
      mark: '已标记(isMark)',
      settlementAgent: '结算代理(settlementAgent)',
      settlementAgentId: '结算代理ID(settlementAgentId)',
      Billing: '账单(Billing)'
    },
    BillingGroup: {
      billingId: '账单序号(billingId)',
      billingNo: '账单号(billingNo)',
      counterPartyBillingNo: '对方账单号(counterPartyBillingNo)',
      billingType: '账单类型(billingType)',
      ar: '账单收支(isAr)',
      state: '账单状态(state)',
      accountId: '结算对象(accountId)',
      currency: '币种(currency)',
      rate: '汇率(rate)',
      amount: '金额(amount)',
      currencyAmount: '分币种合计(currencyAmount)',
      bankAccountId: '银行帐号Id(bankAccountId)',
      invoiceDemand: '开票要求(invoiceDemand)',
      title: '开票抬头(title)',
      titleBranchId: '账单抬头分公司(titleBranchId)',
      billingAddress: '账单地址(billingAddress)',
      remark: '账单备注(remark)',
      inputBy: '创建人(inputBy)',
      inputByDep: '创建人部门(inputByDep)',
      inputDate: '创建日期(inputDate)',
      branchId: '分公司(branchId)',
      sales: '销售(sales)',
      buyerTaxAccount: '纳税人识别号(buyerTaxAccount)',
      buyerBank: '开户银行(buyerBank)',
      buyerBankAccount: '银行帐号(buyerBankAccount)',
      buyerAddress: '纳税人地址(buyerAddress)',
      buyerTelephone: '电话(buyerTelephone)',
      BillingGroup: '对账单(BillingGroup)'
    },
    Invoice: {
      batchNo: '发票批次号(batchNo)',
      VAT: '是否专用发票(VAT)',
      active: '是否有效发票(active)',
      TAX: '是否已报税(TAX)',
      merged: '是否合并开票(merged)',
      mergeNo: '合并开票编号(mergeNo)',
      invoiceId: '发票序号(invoiceId)',
      invoiceType: '发票类型(invoiceType)',
      clearingState: '核销状态(clearingState)',
      ar: '发票收支(isAr)',
      invoiceNo: '发票号(invoiceNo)',
      invoiceDate: '开票日期(invoiceDate)',
      accountId: '结算对象(accountId)',
      title: '发票抬头(title)',
      currency: '币种(currency)',
      amount: '发票金额(amount)',
      chineseAmount: '金额中文合计(chineseAmount)',
      rate: '发票汇率(rate)',
      chargeCurrency1: '费用币种1(chargeCurrency1)1',
      chargeExchangeRate1: '费用汇率1(chargeExchangeRate1)',
      chargeCurrency2: '费用币种2(chargeCurrency2)',
      chargeExchangeRate2: '费用汇率2(chargeExchangeRate2)',
      invoiceDemand: '开票要求(invoiceDemand)',
      remark: '发票备注(remark)',
      printed: '是否打印(printed)',
      revoked: '是否作废(revoked)',
      revokedBy: '发票作废人(revokedBy)',
      revokedDate: '发票作废日期(revokedDate)',
      inputBy: '发票创建人(inputBy)',
      inputDate: '发票创建日期(inputDate)',
      inputByDep: '发票创建人部门(inputByDep)',
      branchId: '分公司(branchId)',
      taxAccount: '纳税人识别号(taxAccount)',
      bank: '银行名称(bank)',
      bankAccount: '银行帐号(bankAccount)',
      address: '发票地址(address)',
      telephone: '电话(telephone)',
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      pod2: '目的港(pod2)',
      jobNo: '工作号(jobNo)',
      mbl: '主单号(mbl)',
      customerRefNo: '客户编号(customerRefNo)',
      ETD: '开航日期(ETD)',
      ETA: '到港日期(ETA)',
      vesselVoyage: '船名航次(vesselVoyage)',
      partCargo: '货物拼接(partCargo)',
      partChargeName: '费用名称拼接(partChargeName)',
      partQuantity: '拼接数量(partQuantity)',
      partUnitPrice: '拼接单价(partUnitPrice)',
      partCurrency: '原币种拼接(partCurrency)',
      partAmount: '原金额拼接(partAmount)',
      partAmount2: '折算金额拼接(partAmount2)',
      excludingTaxAmount: '不含税额(excludingTaxAmount)1',
      taxRate: '税率(taxRate)',
      taxAmount: '税额(taxAmount)',
      buyerTaxAccount: '纳税人识别号(buyerTaxAccount)',
      buyerBank: '银行名称(buyerBank)',
      buyerBankAccount: '银行帐号(buyerBankAccount)',
      buyerAddress: '发票地址(buyerAddress)',
      buyerTelephone: '电话(buyerTelephone)',
      payee: '收款人(payee)',
      auditor: '审核人(auditor)',
      exportToInterface: '已导出(exportToInterface)',
      mergeType: '拼票类型(mergeType)',
      invoiceState: '发票状态(invoiceState)',
      remark2: '发票备注2(remark2)',
      sellTitle: '销货单位发票抬头(sellTitle)',
      valInvoiceCode: '发票代码(valInvoiceCode)',
      makeType: '开票种类(0.纸质发票 1.电子发票)',
      sendStatus: '电子发票发送状态(1.已发送 0.未发送)',
      downloads: '客户下载次数(downloads)',
      webPdfUrl: '金税PDF路径(webPdfUrl)',
      webPdfFile: '金税PDF文件(webPdfFile)',
      returnTaxCode: '金税结果代码(0000:下发成功,9999:下发失败)',
      returnTaxMsg: '金税结果描述(错误原因)',
      review: '是否复核(review)',
      reviewDate: '复核日期(reviewDate)',
      exportToGoldenTax: '金税是否已导出(exportToGoldenTax)',
      actualReceiptDate: '实际收票日期(actualReceiptDate)',
      beredInvoiceUuid: '被红冲发票UUID(beredInvoiceUuid)',
      cnnoticeNo: '专票红字通知单号(cnnoticeNo)',
      Invoice: '发票(Invoice)'
    },
    InvoiceItem: {
      level: '序号(level)',
      goodsName: '货物名称(goodsName)',
      dimension: '规格型号(dimension)',
      unit: '单位(unit)',
      quantity: '数量(quantity)',
      unitRate: '单价(unitRate)',
      amount: '金额(amount)',
      taxRate: '税率(taxRate)',
      taxAmount: '税额(taxAmount)',
      InvoiceItem: '发票项目(InvoiceItem)'
    },
    ConfirmBill: {
      confirmBillId: '费用确认单序号(confirmBillId)',
      accountId: '结算对象(accountId)',
      contact: '结算对象联系人(contact)',
      currency: '币种(currency)',
      amount: '金额(amount)',
      rate: '汇率(rate)',
      remark: '备注(remark)',
      invoiceDemand: '开票要求(invoiceDemand)',
      title: '开票抬头(title)',
      bank: '银行名称(bank)',
      bankAccount: '银行帐号(bankAccount)',
      inputByDep: '创建人部门(inputByDep)',
      inputBy: '创建人(inputBy)',
      inputDate: '创建日期(inputDate)',
      branchId: '分公司(branchId)',
      state: '费用确认单状态(state)',
      commitDate: '提交开票申请日期(commitDate)',
      invoiceType: '发票类型(invoiceType)',
      excludingTaxAmount: '不含税额(excludingTaxAmount)',
      ConfirmBill: '费用确认单(ConfirmBill)'
    },
    BillPayment: {
      billPaymentId: '付款审批单序号(billPaymentId)',
      billPaymentNo: '付款审批单号(billPaymentNo)',
      jobNo: '业务编号(jobNo)',
      ywType: '业务类型(ywType)',
      SE: '包括海运出口(SE)',
      SI: '包括海运进口(SI)',
      AE: '包括空运出口(AE)',
      AI: '包括空运进口(AI)',
      payType: '支付类型(payType)',
      accountId: '支付对象(accountId)',
      settlementAgentId: '结算代理(settlementAgentId)',
      currency: '币种(currency)',
      amount: '金额(amount)',
      rate: '汇率(rate)',
      state: '状态(state)',
      deadline: '付款期限(deadline)',
      remark: '备注(remark)',
      inputBy: '创建人(inputBy)',
      inputByDep: '创建人部门(inputByDep)',
      inputDate: '创建日期(inputDate)',
      branchId: '分公司(branchId)',
      clearingState: '核销状态(clearingState)',
      costInvoiceNo: '供应商发票号(costInvoiceNo)',
      chineseAmount: '金额中文合计(chineseAmount)',
      advance: '是否垫付(advance)',
      customerId: '客户ID(customerId)',
      businessVerifier: '业务审核人(businessVerifier)',
      businessVerifyDate: '业务审核日期(businessVerifyDate)',
      financeVerifier: '财务审核人(financeVerifier)',
      financeVerifyDate: '财务审核日期(financeVerifyDate)',
      currencyAmount: '分币种合计(currencyAmount)',
      buyerBank: '开户银行(buyerBank)',
      buyerBankAccount: '银行帐号(buyerBankAccount)',
      BillPayment: '付款审批(BillPayment)'
    },
    ClearHistory: {
      accountId: '结算对象(accountId)',
      ar: '是否应收(isAr)',
      jobNo: '费用业务编号(jobNo)',
      invoiceNo: '费用发票号(invoiceNo)',
      billingNo: '海外账单号(billingNo)',
      paymentNo: '付款审批单号(paymentNo)',
      chargeCurrency: '原始费用币种(chargeCurrency)',
      actualCurrency: '核销币种(actualCurrency)',
      confirmState: '结款确认状态(confirmState)',
      notifier: '通知人(notifier)',
      notifyDate: '通知日期(notifyDate)',
      confirmer: '确认人(confirmer)',
      confirmDate: '确认日期(confirmDate)',
      rate: '费用汇率(rate)',
      chargeAmt: '本次核销原始金额(amount)',
      clearRate: '核销汇率(clearRate)',
      actualAmt: '本次核销实收金额(actualAmount)',
      clearRemark: '备注(clearRemark)',
      branchId: '分公司(branchId)',
      verificationBy: '核销人(verificationBy)',
      verificationByDep: '核销人部门(verificationByDep)',
      verificationDate: '核销日期(verificationDate)',
      clearId: '核销序号(clearId)',
      paymentAmount: '收付金额(paymentAmount)',
      diffChange: '汇兑损益(diffChange)',
      financialCost: '财务费用(financialCost)',
      clearOdd: '零头短账(clearOdd)',
      writeoffSeqNo: '核销批次号(writeoffSeqNo)',
      voucher: '是否生成凭证(isVoucher)',
      voucherDate: '凭证日期(voucherDate)',
      targetVoucherNo: '对方凭证号(targetVoucherNo)',
      ClearHistory: '核销历史(ClearHistory)'
    },
    ActualAmount: {
      remainAmount: '余额(remainAmount)',
      arIncluded: '是否含应收费用(isArIncluded)',
      apIncluded: '是否含应付费用(isApIncluded)',
      voucher: '是否导财务(isVoucher)',
      voucherNo: '财务凭证号(voucherNo)',
      voucherDate: '导财务日期(voucherDate)',
      Reconciliation: '是否船公司托收(Reconciliation)',
      advance: '是否垫付(advance)',
      oversea: '国内国外(oversea)',
      verificationBy: '核销人(verificationBy)',
      verificationByDep: '核销人部门(verificationByDep)',
      verificationDate: '核销日期(verificationDate)',
      actualAmountId: '实际收付序号(actualAmountId)',
      actualAmountNo: '实际收付编号(actualAmountNo)',
      state: '实际收付状态(state)',
      ar: '是否实收(isAr)',
      accountId: '结算对象(accountId)',
      settlementAgentId: '结算代理(settlementAgentId)',
      paymentCompany: '付款单位(paymentCompany)',
      currency: '币种(currency)',
      rate: '汇率(rate)',
      amount: '收付金额(amount)',
      diffChange: '汇兑损益(diffChange)',
      financialCost: '财务费用(financialCost)',
      clearOdd: '零头短账(clearOdd)',
      verfiedAmount: '已核销金额(verfiedAmount)',
      type: '收付方式(type)',
      bankWaterNo: '银行水单号(bankWaterNo)',
      companyBank: '对方银行(companyBank)',
      companyBankAccount: '对方银行帐号(companyBankAccount)',
      ourBank: '我方银行(ourBank)',
      ourBankAccount: '我方银行帐号(ourBankAccount)',
      payReceiveDate: '收付日期(payReceiveDate)',
      chargeCurrency1: '费用币种1(chargeCurrency1)2',
      chargeExchangeRate1: '费用汇率1(chargeExchangeRate1)',
      chargeCurrency2: '费用币种2(chargeCurrency2)',
      chargeExchangeRate2: '费用汇率2(chargeExchangeRate2)',
      remark: '备注(remark)',
      branchId: '分公司(branchId)',
      prepay: '预收预付(prepay)',
      approvedState: '审核状态(approvedState)',
      approvedBy: '审核人(approvedBy)',
      dateApproved: '审核日期(dateApproved)',
      cashTransferState: '水单状态(cashTransferState)',
      writeoffSeqNo: '核销批次号(writeoffSeqNo)',
      bankSlip: '是否水单(isBankSlip)',
      releaseState: '发布状态(releaseState)',
      bankSlipState: '认领状态(bankSlipState)',
      preAmount: '预收款金额(preAmount)',
      preBankSlipState: '预收款状态(preBankSlipState)',
      prePayment: '是否预收(isPrePayment)',
      returnAmount: '退回金额(returnAmount)',
      bankSlipReceiveBy: '认领人(bankSlipReceiveBy)',
      redPunchActualAmountUuid: '红冲费用记录UUID(redPunchActualAmountUuid)',
      ActualAmount: '实际收付(ActualAmount)'
    },
    DismatchedAmount: {
      Id: '序号(Id)',
      state: '未核销预收款状态(state)',
      paymentCompany: '付款单位(paymentCompany)',
      currency: '币种(currency)',
      amount: '未核销预收款金额(amount)',
      rate: '汇率(rate)',
      type: '收款方式(type)',
      bankWaterNo: '银行水单号(bankWaterNo)',
      companyBank: '对方银行(companyBank)',
      companyBankAccount: '对方银行帐号(companyBankAccount)',
      ourBank: '我方银行(ourBank)',
      ourBankAccount: '我方银行帐号(ourBankAccount)',
      remark: '备注(remark)',
      payReceiveDate: '收付日期(payReceiveDate)',
      verificationBy: '核销人(verificationBy)',
      verificationDate: '核销日期(verificationDate)',
      inputBy: '创建人(inputBy)',
      inputByDep: '创建人部门(inputByDep)',
      inputDate: '创建日期(inputDate)',
      branchId: '分公司(branchId)',
      DismatchedAmount: '未核销预收款(DismatchedAmount)'
    },
    BankActualAmount: {
      bankactualAmountId: '银行记账序号(bankactualAmountId)',
      waterNo: '银行水单号(waterNo)',
      paymentCompany: '收付款单位(paymentCompany)',
      currency: '币种(currency)',
      amount: '银行记账金额(amount)',
      ar: '是否应收(isAr)',
      type: '收付方式(type)',
      companyBank: '对方银行(companyBank)',
      companyBankAccount: '对方银行帐号(companyBankAccount)',
      ourBank: '我方银行(ourBank)',
      ourBankAccount: '我方银行帐号(ourBankAccount)',
      remark: '记账备注(remark)',
      payReceiveDate: '收付日期(payReceiveDate)',
      inputBy: '记账人(inputBy)',
      verificationDate: '记账日期(verificationDate)',
      branchId: '分公司(branchId)',
      BankActualAmount: '银行记账(BankActualAmount)'
    },
    ClosingAccount: {
      branchId: '关帐分公司(branchId)',
      inputBy: '关帐人(inputBy)',
      closingDate: '关帐日期(closingDate)',
      verifiedBy: '审核人(verifiedBy)',
      verifyDate: '审核日期(verifyDate)',
      ClosingAccount: '关帐(ClosingAccount)'
    },
    ActualMailHistory: {
      branchId: '分公司(branchId)',
      accountId: '结算单位代码(accountId)',
      currency: '币种(currency)',
      amount: '金额(amount)',
      remittance: '汇费(remittance)',
      exchangeDiff: '汇差(exchangeDiff )',
      state: '邮件发送状态(state)',
      senddate: '发送日期(senddate)',
      sendNo: '发送编号(sendNo)',
      ActualMailHistory: '海外结算邮件历史(ActualMailHistory)'
    },
    PurchaseInvoiceRecords: {
      invoiceType: '发票类型(invoiceType)',
      startInvoiceNo: '开始号码(startInvoiceNo)',
      endInvoiceNo: '结束号码(endInvoiceNo)',
      quantity: '购买份数(quantity)',
      purchaser: '购买人(purchaser)',
      purchasingDate: '购买时间(purchasingDate)',
      branchId: '分公司(branchId)',
      PurchaseInvoiceRecords: '购买发票记录(PurchaseInvoiceRecords)'
    },
    InvoiceNo: {
      invoiceType: '发票类型(invoiceType)',
      invoiceNo: '发票号(invoiceNo)',
      invoiceState: '发票状态(invoiceState)',
      abandoner: '作废人(abandoner)',
      abandoningDate: '作废时间(abandoningDate)',
      user: '使用人(user)',
      usingDate: '使用时间(usingDate)',
      branchId: '分公司(branchId)',
      InvoiceNo: '发票号(InvoiceNo)'
    },
    RecipientsInvoiceRecords: {
      invoiceType: '发票类型(invoiceType)',
      quantity: '领用份数(quantity)',
      recipienter: '领用人(recipienter)',
      recipientingDate: '领用时间(recipientingDate)',
      branchId: '分公司(branchId)',
      RecipientsInvoiceRecords: '领用发票记录(RecipientsInvoiceRecords)'
    },
    AgentCharge: {
      agentChargeId: '分成费用ID(agentChargeId)',
      ar: '费用收支(isAr)',
      percentage: '是否参与分成(isPercentage)',
      chargeItemId: '费用代码(chargeItemId)',
      currency: '币种(currency)',
      rate: '汇率(rate)',
      amount: '金额(amount)',
      type: '计费单位(type)',
      quantity: '数量(quantity)',
      unitPrice: '单价(unitPrice)',
      remark: '备注(remark)',
      inputBy: '录入人(inputBy)',
      inputDate: '录入日期(inputDate)',
      serialNumber: '序号(serialNumber)',
      paymentType: '支付类型(paymentType)',
      AgentCharge: '代理分成费用(AgentCharge)'
    },
    NullifyCharge: {
      chargeId: '费用序号(chargeId)',
      chargeItemId: '费用名称代码(chargeItemId)',
      receivable: '收支类型(receivable)',
      oversea: '国内国外(oversea)',
      adjustment: '是否调整费用(adjustment)',
      shared: '是否分摊费用(shared)',
      shareScheme: '分摊类型(shareScheme)',
      shareRefNo: '分摊关联编号(shareRefNo)',
      commission: '是否佣金(commission)',
      advance: '是否垫付(advance)',
      prepaid: '是否托收拆分(prepaid)',
      paidOff: '已付清(paidOff)',
      collection: '已转入托收(collection)',
      relatedId: '内结费用编号(relatedId)',
      accountId: '结算单位代码(accountId)',
      invoiceTitle: '发票抬头(invoiceTitle)',
      currency: '币种(currency)',
      measure: '单位类型(measure)',
      quantity: '数量(quantity)',
      unitRate: '单价(unitRate)',
      amount: '金额(amount)',
      verifiedAmount: '已核销金额(verfiedAmount)',
      exchangeRate: '汇率(exchangeRate)',
      billNo: '帐单号(billNo)',
      counterPartyBillingNo: '对方账单号(counterPartyBillingNo)',
      paymentNo: '付款审批号(paymentNo)',
      invoiceNo: '发票号/税金号(invoiceNo)',
      voucherNo: '财务接口编号(voucherNo)',
      containerNo: '箱号(containerNo)',
      inputBy: '录入人(inputBy)',
      inputDate: '录入日期(inputDate)',
      auditor: '审核人(auditor)',
      auditDate: '审核日期(auditDate)',
      accountingDate: '财务日期(accountingDate)',
      clearingDate: '销账日期(clearingDate)',
      remarks: '备注(remarks)',
      inputByDep: '录入人部门(inputByDep)',
      branchId: '费用分公司(branchId)',
      taxRate: '税率(taxRate)',
      taxAmount: '税额(taxAmount)',
      excludingTaxAmount: '不含税额(excludingTaxAmount)',
      controlled: '是否受控(controlled)',
      chargeSource: '费用来源(chargeSource)',
      chargeState: '费用状态(chargeState)',
      confirmState: '确认状态(confirmState)',
      billingAmount: '对帐金额(billingAmount)',
      confirmRemarks: '确认备注(confirmRemarks)',
      differentState: '差异调整状态(differentState)',
      invoiceAmount: '开票金额(invoiceAmount)',
      invoiceExcludingTax: '开票不含税额(invoiceExcludingTax)',
      invoiceTax: '开票税额(invoiceTax)',
      offsetState: '红冲状态(offsetState)',
      originalChargeUuid: '原始费用UUID(originalChargeUuid)',
      jobUuid: '业务UUID(jobUuid)',
      billingUuid: '账单UUID(billingUuid)',
      billPaymentUuid: '付款申请UUID(billPaymentUuid)',
      NullifyCharge: '作废费用(NullifyCharge)'
    },
    EDI: {
      EDIId: 'EDI序号(EDIId)',
      type: 'EDI类型(type)',
      jobNo: '业务编号(jobNo)',
      supplyId: '船公司或代理编号(supplyId)',
      outputDate: '导出日期(outputDate)',
      status: '状态(status)',
      content: 'EDI报文(content)',
      returnMessage: '返回信息(returnMessage)',
      fileId: '报文标识(fileId)',
      officeId: '分公司(officeId)',
      jobUuid: 'JobUUID(jobUuid)',
      sendType: '发送地址类型(sendType)',
      EDI: '电子文件数据(EDI)'
    },
    EDIMapping: {
      mapId: '转换序号(mapId)',
      officeId: '分公司(officeId)',
      type: '转换类型(type)',
      subType: '子类型(subType)',
      condition1: '转换条件(condition1)',
      condition2: '转换条件(condition2)',
      condition3: '转换条件(condition3)',
      sourceValue: '原值(sourceValue)',
      targetValue: '新值(targetValue)',
      remarks: '备注(remarks)',
      EDIMapping: '电子文件数据转换(EDIMapping)'
    },
    EDIPartnerTemplate: {
      parnterId: '合作伙伴代码(ParnterId)',
      templateDescribe: '模板说明(TemplateDescribe)',
      serviceType: '服务类型(ServiceType)',
      templateType: '模板类型(TemplateType)',
      templatePath: '模板访问路径(TemplatePath)',
      remarks: '备注(remarks)',
      fileCombineType: 'EDI文件合并方式(FileCombineType)',
      defaultFileType: 'EDI文件默认类型(DefaultFileType)',
      encodingType: 'EDI文件编码类型(EncodingType)',
      email: '邮箱(email)',
      sendType: '发送FTP地址类型(sendType)',
      sendFilePrefix: '发送FTP地址类型(sendFilePrefix)',
      EDIPartnerTemplate: '合作伙伴EDI模板(EDIpartnerTemplate)'
    },
    EDIMappingType: {
      typeCode: '映射代码(TypeCode)',
      typeDesc: '映射说明(TypeDesc)',
      EDIMappingType: 'EDI映射类型(EDIMappingType)'
    },
    EContainerHistory: {
      containerUUID: '集装箱uuid(containerUUID)',
      jobUUID: '工作单UUID(jobUUID)',
      printBoxID: '箱单唯一标识(printBoxID)',
      printBoxOnlyID: '箱单打印唯一标识(printBoxOnlyID)',
      parameter: '参数(parameter)',
      success: '是否成功(success)',
      errorMsg: '失败信息(errorMsg)',
      jobNo: '工作单号(jobNo)',
      printDate: '打印时间(printDate)',
      printCount: '打印次数(printCount)',
      EContainerHistory: 'UBI与99路电子箱单接口数据传递记录表'
    },
    PriceFcl: {
      state: '状态(state)',
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      direct: '直达(direct)',
      via: '中转(via)',
      term: '付款方式(term)',
      eqType: '箱种(eqType)',
      carrier: '船公司(carrier)',
      shippingLine: '船公司航线代码(shippingLine)',
      contractNo: '约号(contractNo)',
      days: 'days',
      serviceMode: 'serviceMode',
      serviceCode: 'serviceCode',
      commodity: 'commodity',
      currency: '币种(currency)',
      beginDate: 'beginDate',
      endDate: 'endDate',
      remarks: '备注(remarks)',
      dateApproved: 'dateApproved',
      approvedBy: 'approvedBy',
      branchId: '分公司(branchId)',
      lane: '航线代码(lane)',
      priceNo: '运价No(priceNo)',
      priceNo7: '运价No7(priceNo7)',
      bookingAgent: '订舱代理(bookingAgent)',
      vat: '税率(vat)',
      dock: '挂靠码头(dock)',
      destinationDock: '目的港码头(destinationDock)',
      frequency1: '周一船期(frequency1)',
      frequency2: '周二船期(frequency2)',
      frequency3: '周三船期(frequency3)',
      frequency4: '周四船期(frequency4)',
      frequency5: '周五船期(frequency5)',
      frequency6: '周六船期(frequency6)',
      frequency7: '周日船期(frequency7)',
      frequency8: '一程船期总数frequency8',
      cost20: '成本20(cost20)',
      cost40: '成本40(cost40)',
      costHC: '成本HC(costHC)',
      cost45: '成本45(cost45)',
      one20: '一级20(one20)',
      one40: '一级40(one40)',
      oneHC: '一级HC(oneHC)',
      one45: '一级45(one45)',
      two20: '二级20(two20)',
      two40: '二级40(two40)',
      twoHC: '二级HC(twoHC)',
      two45: '二级45(two45)',
      three20: '三级20(three20)',
      three40: '三级40(three40)',
      threeHC: '三级HC(threeHC)',
      three45: '三级45(three45)',
      dateEffective: '生效日期(dateEffective)',
      dateExpiration: '失效日期(dateExpiration)',
      active: '是否有效(active)',
      share: '仓位性质(share)',
      trend: '价格走势(trend)',
      costVat: '成本税率(costVat)',
      sellVat: '卖价税率(sellVat)',
      priceState: '运价状态(priceState)',
      reject20: '拒接箱型20(reject20)',
      reject40: '拒接箱型40(reject40)',
      rejectHC: '拒接箱型HC(rejectHC)',
      reject45: '拒接箱型45(reject45)',
      saleState: '特价状态(saleState)',
      freeTime: '集装箱免租期(freeTime)',
      dateTypeEffective: '生效日期类型(dateTypeEffective)',
      dateTypeExpiration: '失效日期类型(dateTypeExpiration)',
      receivingType: '接货特殊说明类型(receivingType)',
      receivingInstructions: '接货特殊说明(receivingInstructions)',
      secondFrequency1: '二程周一(secondFrequency1)',
      secondFrequency2: '二程周二(secondFrequency2)',
      secondFrequency3: '二程周三(secondFrequency3)',
      secondFrequency4: '二程周四(secondFrequency4)',
      secondFrequency5: '二程周五(secondFrequency5)',
      secondFrequency6: '二程周六(secondFrequency6)',
      secondFrequency7: '二程周日(secondFrequency7)',
      via2: '中转2(via2)',
      sourceId: '源运价ID(sourceId)',
      sourceTenantId: '运价来源(sourceTenantId)',
      subContractNo: '子合同号(subContractNo)',
      na: 'N/A(na)',
      naCode: 'N/A Code(naCode)',
      transportMode: '运输方式(transportMode)',
      closingDay: '截关日(closingDay)',
      amsEns: 'amsEns(AMS/ENS)',
      overloadRemarks: '超重说明(overloadRemarks)',
      templateFileId: '模块文件ID(templateFileId)',
      sourcePriceUuid: '原运价UUID(sourcePriceUuid)',
      customSpecs: '自定义规格(customSpecs)',
      PriceFcl: '整箱运价(PriceFcl)'
    },
    Price: {
      state: '状态(state)',
      approvedBy: '审核人(approvedBy)',
      dateApproved: '审核日期(dateApproved)',
      beginDate: '有效开始日期(beginDate)',
      endDate: '有效截至日期(endDate)',
      currency: '币种(currency)',
      branchId: '分公司(branchId)',
      Price: '价格(Price)'
    },
    PriceWeightLimit: {
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      carrier: '船公司(carrier)',
      frequency1: '周一船期(frequency1)',
      frequency2: '周二船期(frequency2)',
      frequency3: '周三船期(frequency3)',
      frequency4: '周四船期(frequency4)',
      frequency5: '周五船期(frequency5)',
      frequency6: '周六船期(frequency6)',
      frequency7: '周日船期(frequency7)',
      eqType: '箱种(eqType)',
      eqSize: '箱型(eqSize)',
      amount: '最大重量(amount)',
      remarks: '备注(remarks)',
      gradeMin: '运价等级下限(大于等于)(gradeMin)',
      gradeMax: '运价等级上限(小于)(gradeMax)',
      via: '中转(via)',
      state: '状态(state)',
      approvedBy: '审核人(approvedBy)',
      dateApproved: '审核日期(dateApproved)',
      beginDate: '有效开始日期(beginDate)',
      endDate: '有效截至日期(endDate)',
      currency: '币种(currency)',
      branchId: '分公司(branchId)',
      PriceWeightLimit: '整箱限重信息(PriceWeightLimit)'
    },
    SurchargeFCL: {
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      region: '航线(region)',
      carrier: '船公司(carrier)',
      bookingAgent: '订舱代理(bookingAgent)',
      chargeScaleCode: '费用名称(chargeScaleCode)',
      unit: '单位(unit)',
      eqType: '箱型(eqType)',
      sum20: '20(sum20)',
      sum40: '40(sum40)',
      sumHC: '40HC(sumHC)',
      sum45: '45(sum45)',
      casePrice: '单价(casePrice)',
      payment: '付款方式(payment)',
      vat: '是否含税(vat)',
      remarks: '备注(remarks)',
      chargeType: '费用类别(chargeType)',
      cost20: '成本20(cost20)',
      cost40: '成本40(cost40)',
      costHC: '成本HC(costHC)',
      cost45: '成本45(cost45)',
      costCasePrice: '单价成本(costCasePrice)',
      costVat: '成本税率(costVat)',
      sellVat: '卖价税率(sellVat)',
      generateCharge: '订舱时生成费用(generateCharge)',
      sourceId: '源运价ID(sourceId)',
      sourceTenantId: '运价来源(sourceTenantId)',
      dangerous: '是否危险品(dangerous)',
      dangerousClass: '危险品等级(dangerousClass)',
      state: '状态(state)',
      approvedBy: '审核人(approvedBy)',
      dateApproved: '审核日期(dateApproved)',
      beginDate: '有效开始日期(beginDate)',
      endDate: '有效截至日期(endDate)',
      currency: '币种(currency)',
      branchId: '分公司(branchId)',
      SurchargeFCL: '整箱附加费(SurchargeFCL)'
    },
    PriceFclExtra: {
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      carrier: '船公司(carrier)',
      frequency1: '周一船期(frequency1)',
      frequency2: '周二船期(frequency2)',
      frequency3: '周三船期frequency3)',
      frequency4: '周四船期(frequency4)',
      frequency5: '周五船期(frequency5)',
      frequency6: '周六船期(frequency6)',
      frequency7: '周日船期(frequency7)',
      dockland: '港区(dockland)',
      shareCarrier: '共舱船公司(shareCarrier)',
      billType: '提单类型(billType)',
      shippingTerm: '运输条款(shippingTerm)',
      seawayBill: '是否SEAWAY BILL(seawayBill)',
      lane: '航线代码(lane)',
      otherInfo: '其它信息(otherInfo)',
      state: '状态(state)',
      approvedBy: '审核人(approvedBy)',
      dateApproved: '审核日期(dateApproved)',
      beginDate: '有效开始日期(beginDate)',
      endDate: '有效截至日期(endDate)',
      currency: '币种(currency)',
      branchId: '分公司(branchId)',
      PriceFclExtra: '整箱运价附加信息(PriceFclExtra)'
    },
    PriceFclAddon: {
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      eqType: '箱种(eqType)',
      carrier: '船公司(carrier)',
      shippingLine: '船公司航线代码(shippingLine)',
      days: 'days',
      priceDateType: '运价日期种类(priceDateType)',
      remarks: '备注(remarks)',
      sum20: "20'费用(sum20)",
      sum40: "40'费用(sum40)",
      sumHC: "HC'费用(sumHC)",
      sum45: "45'费用(sum45)",
      state: '状态(state)',
      approvedBy: '审核人(approvedBy)',
      dateApproved: '审核日期(dateApproved)',
      beginDate: '有效开始日期(beginDate)',
      endDate: '有效截至日期(endDate)',
      currency: '币种(currency)',
      branchId: '分公司(branchId)',
      PriceFclAddon: 'PriceFclAddon'
    },
    PriceAir: {
      state: '状态(state)',
      level: '运价级(level)',
      flight: '航班号(flight)',
      aircraft: '机型(aircraft)',
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      via: '中转(via)',
      minCharge: 'minCharge',
      step: 'step',
      fsc: 'fsc',
      ssc: 'ssc',
      p45: 'p45',
      p100: 'p100',
      p300: 'p300',
      p500: 'p500',
      p1000: 'p1000',
      carrier: '航空公司(carrier)',
      agent: '代理(agent)',
      frequency1: '周一(frequency1)',
      frequency2: '周二(frequency2)',
      frequency3: '周三(frequency3)',
      frequency4: '周四(frequency4)',
      frequency5: '周五(frequency5)',
      frequency6: '周六(frequency6)',
      frequency7: '周日(frequency7)',
      days: 'days',
      currency: '币种(currency)',
      beginDate: 'beginDate',
      endDate: 'endDate',
      remarks: '备注(remarks)',
      dateApproved: 'dateApproved',
      approvedBy: 'approvedBy',
      branchId: '分公司(branchId)',
      priceNo: '运价No(priceNo)',
      priceNo7: '运价No7(priceNo7)',
      groupNo: '组号(groupNo)',
      tc: 'tc',
      t1Min: 't1Min',
      t1Step: 't1Step',
      t1P45: 't1P45',
      t1P100: 't1P100',
      t1P300: 't1P300',
      t1P500: 't1P500',
      t1P1000: 't1P1000',
      t2Min: 't2Min',
      t2Step: 't2Step',
      t2P45: 't2P45',
      t2P100: 't2P100',
      t2P300: 't2P300',
      t2P500: 't2P500',
      t2P1000: 't2P1000',
      t3Min: 't3Min',
      t3Step: 't3Step',
      t3P45: 't3P45',
      t3P100: 't3P100',
      t3P300: 't3P300',
      t3P500: 't3P500',
      t3P1000: 't3P1000',
      salesAllowance: '销售补贴(salesAllowance)',
      secondAircraft: '二程机型(secondAircraft)',
      secondFrequency1: '二程周一(secondFrequency1)',
      secondFrequency2: '二程周二(secondFrequency2)',
      secondFrequency3: '二程周三(secondFrequency3)',
      secondFrequency4: '二程周四(secondFrequency4)',
      secondFrequency5: '二程周五(secondFrequency5)',
      secondFrequency6: '二程周六(secondFrequency6)',
      secondFrequency7: '二程周日(secondFrequency7)',
      via2: '中转2(via2)',
      bookingAgent: '订舱代理(bookingAgent)',
      templateFileId: '模块文件ID(templateFileId)',
      sourcePriceUuid: '原运价UUID(sourcePriceUuid)',
      PriceAir: 'PriceAir'
    },
    PortGroup: {
      groupCode: 'groupCode',
      portCode: 'portCode',
      PortGroup: 'PortGroup'
    },
    PriceLcl: {
      state: '状态(state)',
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      via: '中转(via)',
      bookingAgent: '订舱代理(bookingAgent)',
      term: '付款方式(term)',
      carrier: '船公司(carrier)',
      closingDay: '截关日(closingDay)',
      days: 'days(航程)',
      currency: '币种(currency)',
      beginDate: '有效期开始时间(beginDate)',
      endDate: '有效期结束时间(endDate)',
      remarks: '备注(remarks)',
      dateApproved: 'dateApproved',
      approvedBy: 'approvedBy',
      branchId: '分公司(branchId)',
      priceNo: '运价No(priceNo)',
      priceNo7: '运价No7(priceNo7)',
      costWeightPrice: '重量价(成本)(costWeightPrice)',
      oneWeightPrice: '重量价(T1)(oneWeightPrice)',
      twoWeightPrice: '重量价(T2)(twoWeightPrice)',
      threeWeightPrice: '重量价(T3)(threeWeightPrice)',
      costVolumePrice: '体积价(成本)(costVolumePrice)',
      oneVolumePrice: '体积价(T1)(oneVolumePrice)',
      twoVolumePrice: '体积价(T2)(twoVolumePrice)',
      threeVolumePrice: '体积价(T3)(threeVolumePrice)',
      active: '是否有效(active)',
      trend: '价格走势(trend)',
      direct: '直达(direct)',
      frequency1: '周一船期(frequency1)',
      frequency2: '周二船期(frequency2)',
      frequency3: '周三船期(frequency3)',
      frequency4: '周四船期(frequency4)',
      frequency5: '周五船期(frequency5)',
      frequency6: '周六船期(frequency6)',
      frequency7: '周日船期(frequency7)',
      dateEffective: '生效日期(dateEffective)',
      dateExpiration: '失效日期(dateExpiration)',
      share: '仓位性质(share)',
      costVat: '成本税率(costVat)',
      sellVat: '卖价税率(sellVat)',
      shareCarrier: '共舱船公司(shareCarrier)',
      shippingLine: '船公司航线代码(shippingLine)',
      priceState: '运价状态(priceState)',
      gradeMin: '运价等级下限(大于等于)(gradeMin)',
      gradeMax: '运价等级上限(小于)(gradeMax)',
      gradeUnit: '运价等级单位(gradeUnit)',
      saleState: '特价状态(saleState)',
      minimumTon: '最小计费吨(minimumTon)',
      minimumTonCost: '最小计费吨成本(minimumTonCost)',
      minimumTonPrice1: '最小计费吨价格1(minimumTonPrice1)',
      minimumTonPrice2: '最小计费吨价格2(minimumTonPrice2)',
      minimumTonPrice3: '最小计费吨价格3(minimumTonPrice3)',
      sourceId: '源运价ID(sourceId)',
      sourceTenantId: '运价来源(sourceTenantId)',
      dock: '挂靠码头(dock)',
      destinationDock: '目的港挂靠码头(destinationDock)',
      subContractNo: '子合同号(subContractNo)',
      na: 'N/A(na)',
      naCode: 'N/A Code(naCode)',
      transportMode: '运输方式(transportMode)',
      templateFileId: '模块文件ID(templateFileId)',
      sourcePriceUuid: '原运价UUID(sourcePriceUuid)',
      customSpecs: '自定义规格(customSpecs)',
      PriceLcl: 'PriceLcl'
    },
    PodCharge: {
      bookingAgent: '订舱代理(bookingAgent)',
      tradeLane: '航线(tradeLane)',
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      chargeScaleCode: '费用名称(chargeScaleCode)',
      unit: '计费单位(unit)',
      costMin: '最低费用(成本)(costMin)',
      costRate: '费用(成本)(costRate)',
      coloaderRate: '费用(同行)(coloaderRate)',
      coloaderMin: '最低费用(同行)(coloaderMin)',
      customerRate: '费用(直客)(customerRate)',
      customerMin: '最低费用(直客)(customerMin)',
      feeIndex: '费用序号(feeIndex)',
      chargeType: '费用类别(chargeType)',
      payment: '付款方式(payment)',
      vat: '是否含税(vat)',
      costVat: '成本税率(costVat)',
      sellVat: '卖价税率(sellVat)',
      remarks: '备注(remarks)',
      state: '状态(state)',
      approvedBy: '审核人(approvedBy)',
      dateApproved: '审核日期(dateApproved)',
      beginDate: '有效开始日期(beginDate)',
      endDate: '有效截至日期(endDate)',
      currency: '币种(currency)',
      branchId: '分公司(branchId)',
      PodCharge: 'PodCharge'
    },
    PriceKPI: {
      name: '运价类型名称(name)',
      category: 'KPI类(category)',
      shape: 'KPI型(shape)',
      point: 'KPI点(point)',
      remarks: '备注(remarks)',
      PriceKPI: '运价KPI(PriceKPI)'
    },
    Quotation: {
      branchId: '分公司(branchId)',
      type: '业务类型(type)',
      quotationNo: '报价单号(quotationNo)',
      beginDate: '有效期开始时间(beginDate)',
      endDate: '有效期结束时间(endDate)',
      clientId: '客户(clientId)',
      receiptPlace: '收货地(receiptPlace)',
      deliveryPlace: '交货地(deliveryPlace)',
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      goodsName: '品名(goodsName)',
      HSCode: 'HS Code(HSCode)',
      quantity: '件数(quantity)',
      grossWeight: '毛重(grossWeight)',
      cubage: '体积(cubage)',
      size: '尺寸(size)',
      chargeWeight: '计费重量(chargeWeight)',
      freightTerm: '运输条款(freightTerm)',
      dangerousGoods: '是否危险品(dangerousGoods)',
      UNNo: '危险品编码(UNNo)',
      hazardClass: '危险品等级(hazardClass)',
      email: '电子邮箱(email)',
      phone: '联系电话(phone)',
      fax: '传真(fax)',
      remarks: '备注(remarks)',
      receiptRemark: '收货地费用备注(receiptRemark)',
      deliveryRemark: '交货地费用备注(deliveryRemark)',
      contact: '联系人(contact)',
      num20: '20尺箱数量(num20)',
      num40: '40尺箱数量(num40)',
      numHC: '40HC箱数量(numHC)',
      num45: '45尺箱数量(num45)',
      bookingAgent: '订舱代理(bookingAgent)',
      jobType: '业务类型(jobType) 0.出口 1.进口',
      jobNo: '业务编号(jobNo)',
      clientTenantId: '客户所属tenantId(clientTenantId)',
      clientTenantName: '客户所属tenantName(clientTenantName)',
      status: '状态：0待确认，1已接受，2已拒绝(status)',
      ETD: '预计开航日期(ETD)',
      ETA: '预计到港日期(ETA)',
      Quotation: '报价单(Quotation)'
    },
    QuotationFCLDetail: {
      level: '运价级(level)',
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      via: '中转(via)',
      carrier: '船公司(carrier)',
      eqType: '箱种(eqType)',
      eq20: '20价格(eq20)',
      eq40: '40价格(eq40)',
      eqHC: '40HC价格(eqHC)',
      eq45: '45价格(eq45)',
      term: '付款方式(term)',
      lane: '航线代码(lane)',
      departureDay: '开航日(departureDay)',
      closingDay: '截关日(closingDay)',
      days: '航程(days)',
      beginDate: '有效期开始时间(beginDate)',
      endDate: '有效期结束时间(endDate)',
      serviceMode: 'serviceMode',
      currency: '币种(currency)',
      remarks: '备注(remarks)',
      commodity: 'commodity',
      cost20: '20成本(cost20)',
      cost40: '40成本(cost40)',
      costHC: 'HC成本(costHC)',
      cost45: '45成本(cost45)',
      amount: '金额(amount)',
      priceKey: '整箱运价UUID(priceUUID)',
      direct: '直达(direct)',
      priceNo: '运价No(priceNo)',
      vat: '税率(vat)',
      dock: '挂靠码头(dock)',
      share: '仓位性质(share)',
      saleState: '特价状态(saleState)',
      sourceTenantId: '运价来源(sourceTenantId)',
      QuotationFCLDetail: '整箱报价价格明细(QuotationFCLDetail)'
    },
    QuotationLCLDetail: {
      level: '运价级(level)',
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      via: '中转(via)',
      source: '运价来源(source)',
      term: '付款方式(term)',
      carrier: '船公司(carrier)',
      shippingLine: '船公司航线代码(shippingLine)',
      departureDay: '开航日(departureDay)',
      closingDay: '截关日(closingDay)',
      days: '航程(days)',
      currency: '币种(currency)',
      weightPrice: '重量价格(weightPrice)',
      volumePrice: '体积价格(volumePrice)',
      beginDate: '有效期开始时间(beginDate)',
      endDate: '有效期结束时间(endDate)',
      remarks: '备注(remarks)',
      weightCost: '重量成本(weightCost)',
      volumeCost: '体积成本(volumeCost)',
      QuotationLCLDetail: '拼箱报价价格明细(QuotationLCLDetail)'
    },
    QuotationAirDetail: {
      level: '运价级(level)',
      flight: '航班号(flight)',
      aircraft: '机型(aircraft)',
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      via: '中转(via)',
      minCharge: 'minCharge',
      step: 'step',
      fsc: 'fsc',
      ssc: 'ssc',
      p45: 'p45',
      p100: 'p100',
      p300: 'p300',
      p500: 'p500',
      p1000: 'p1000',
      carrier: '航空公司(carrier)',
      agent: '代理(agent)',
      frequency1: '周一(frequency1)',
      frequency2: '周二(frequency2)',
      frequency3: '周三(frequency3)',
      frequency4: '周四(frequency4)',
      frequency5: '周五(frequency5)',
      frequency6: '周六(frequency6)',
      frequency7: '周日(frequency7)',
      days: 'days',
      currency: '币种(currency)',
      beginDate: 'beginDate',
      endDate: 'endDate',
      remarks: '备注(remarks)',
      bookingAgent: '订舱代理(bookingAgent)',
      QuotationAirDetail: '空运报价价格明细(QuotationAirDetail)'
    },
    QuotationClient: {
      clientId: '客户ID(clientId)',
      branchId: '分公司(branchId)',
      owerId: '所属销售ID(owerId)',
      preOwerId: '上次销售ID(preOwerId)',
      name: '客户名称(name)',
      contact: '联系人(contact)',
      phone: '电话(phone)',
      fax: '传真(fax)',
      email: '电子邮箱(email)',
      address: '地址(address)',
      remarks: '备注(remarks)',
      englishName: '英文名(englishName)',
      companySize: '公司规模人员(companySize)',
      registeredCapital: '公司注册资金(registeredCapital)',
      department: '所属部门(department)',
      groupLeader: '所属组长(groupLeader)',
      assignDate: '分配日期(assignDate)',
      companyTypeCode: '公司类型(companyTypeCode)',
      customerStatusCode: '客户状态(customerStatusCode)',
      customerLevelCode: '客户评定等级(customerLevelCode)',
      overcomeLevelCode: '客户攻克难度指数(overcomeLevelCode)',
      firstMeetDate: '初次接触日期(firstMeetDate)',
      sleepDays: '沉睡天数(sleepDays)',
      signed: '是否签单(signed)',
      signedDays: '签单天数(signedDays)',
      dueTime: '即将到期天数(dueTime)',
      competitorCompany: '竞争公司(competitorCompany)',
      country: '国(country)',
      province: '省(province)',
      city: '市(city)',
      disricts: '区(disricts)',
      companyKey: '正式客户(companyKey)',
      active: '是否有效(active)',
      approvedState: '审核状态0.未审核 1.已审核 2.已拒绝(approvedState)',
      sourceType: '客户来源,0销售自拓,1客户公海,2组长分配,5无(sourceType)',
      QuotationClient: '询价客户(QuotationClient)'
    },
    QuotationClientContact: {
      name: '联系人(name)',
      phone: '电话(phone)',
      cellphone: '手机(cellphone)',
      qqAccout: 'QQ(qqAccout)',
      wechatAccout: '微信号(wechatAccout)',
      skypeAccout: 'skype(skypeAccout)',
      email: '电子邮箱(email)',
      remarks: '备注(remarks)',
      type: '类型(type)',
      QuotationClientContact: '联系人(QuotationClientContact)'
    },
    QuotationClientBusiness: {
      name: '货物名称(name)',
      special: '有无特殊性(special)',
      dangerousChemicals: '是否含危化品(dangerousChemicals)',
      seaShipmentMonthlyFCL: '月均出货量_海运_FCL(seaShipmentMonthlyFCL)',
      seaShipmentMonthlyLCL: '月均出货量_海运_LCL(seaShipmentMonthlyLCL)',
      airlineShipmentMonthlyMT: '月均出货量_空运_MT(airlineShipmentMonthlyMT)',
      customsBrokerType: '偏好报关服务类型(customsBrokerType)',
      customsBrokerId: '偏好报关行(customsBrokerId)',
      truckingType: '偏好拖车服务类型(truckingType)',
      truckingInfoId: '偏好拖车服务公司(truckingInfoId)',
      signedHBL: '是否签HB/L(signedHBL)',
      payed: '是否付款买单(payed)',
      remarks: '备注(remarks)',
      overSeaAgentId: '偏好目的港代理(overSeaAgentId)',
      QuotationClientBusiness: '业务(QuotationClientBusiness)'
    },
    QuotationClientBusinessMultipleDetail: {
      bType: '类型(bType)',
      bValue: '值(bValue)',
      QuotationClientBusinessMultipleDetail: '详细(QuotationClientBusinessMultipleDetail)'
    },
    QuotationClientEvent: {
      titleName: '主题(titleName)',
      taskTime: '任务时间(taskTime)',
      recorderID: '记录人(recorderID)',
      recordTime: '记录时间(recordTime)',
      status: '事件状态(status)',
      address: '地点(address)',
      participants: '参与人(participants)',
      content: '内容(content)',
      achievement: '成果(achievement)',
      nextTask: '下一步任务(nextTask)',
      reportTarget: '汇报对象(reportTarget)',
      remarks: '备注(remarks)',
      QuotationClientEvent: '事件记录(QuotationClientEvent)'
    },
    QuotationChargeDetail: {
      chargeId: '费用ID(chargeId)',
      chargeName: '费用名称(chargeName)',
      type: '类别(type)',
      currency: '币种(currency)',
      rate: '费率(rate)',
      unit: '计费单位(unit)',
      remarks: '备注(remarks)',
      num: '数量(num)',
      amount: '金额(amount)',
      QuotationChargeDetail: '本地费用(QuotationChargeDetail)'
    },
    ShippingSchedule: {
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      carrier: '船公司(carrier)',
      lane: '航线代码(lane)',
      departureDay: '开航日(departureDay)',
      closingDay: 'closingDay',
      days: 'days',
      beginDate: 'beginDate',
      endDate: 'endDate',
      branchId: '分公司(branchId)',
      dockland: '港区(dockland)',
      transferPort: '中转港(transferPort)',
      remarks: '备注(remarks)',
      ShippingSchedule: 'ShippingSchedule(船期表)'
    },
    TenantSharing: {
      inviteTenant: '邀请方(inviteTenant)',
      inviteTenantName: '邀请方名称(inviteTenantName)',
      acceptTenant: '接受方(acceptTenant)',
      acceptTenantName: '接受方名称(acceptTenantName)',
      inviteTime: '邀请日期(inviteTime)',
      acceptTime: '接受日期(acceptTime)',
      inviteUser: '邀请方用户(inviteUser)',
      inviteUserName: '邀请方用户名(inviteUserName)',
      acceptUser: '接受方用户(acceptUser)',
      acceptUserName: '接受方用户名(acceptUserName)',
      active: '是否有效(active)',
      name: '分享标题(name)',
      category: '分享类(category)',
      shape: '分享型(shape)',
      point: '分享点(point)',
      remarks: '备注(remarks)',
      applyFor: '是否申请分享(applyFor)',
      checkState: '同意/拒绝(checkState)',
      TenantSharing: '租户分享(TenantSharing)'
    },
    SurchargeAir: {
      pol: '起运港(pol)',
      pod: '卸货港(pod)',
      region: '航线(region)',
      carrier: '航空公司(carrier)',
      bookingAgent: '订舱代理(bookingAgent)',
      supplier: '供应商(supplier)',
      generateCharge: '订舱时生成费用(generateCharge)',
      chargeType: '费用类别(chargeType)',
      chargeScaleCode: '费用名称(chargeScaleCode)',
      payment: '付款方式(payment)',
      unit: '单位(unit)',
      costMin: '成本最小收费(costMin)',
      costPrice: '成本(costPrice)',
      sellingMin: '卖价最小收费(sellingMin)',
      sellingPrice: '卖价(sellingPrice)',
      frequency1: '周一(frequency1)',
      frequency2: '周二(frequency2)',
      frequency3: '周三(frequency3)',
      frequency4: '周四(frequency4)',
      frequency5: '周五(frequency5)',
      frequency6: '周六(frequency6)',
      frequency7: '周日(frequency7)',
      remarks: '备注(remarks)',
      state: '状态(state)',
      approvedBy: '审核人(approvedBy)',
      dateApproved: '审核日期(dateApproved)',
      beginDate: '有效开始日期(beginDate)',
      endDate: '有效截至日期(endDate)',
      currency: '币种(currency)',
      branchId: '分公司(branchId)',
      SurchargeAir: '空运附加费(SurchargeAir)'
    },
    PriceSharingRule: {
      name: '名称(name)',
      property: '字段属性(property)',
      expression: '表达式(expression)',
      tenantId: 'TenantId(tenantId)',
      PriceSharingRule: '运价分享规则(PriceSharingRule)'
    },
    PriceSharingProfile: {
      name: '机制名称(name)',
      matchType: '匹配方式(matchType)',
      application: '数据类型(application)',
      toTenant: '接收方(toTenant)',
      toTenantName: '接收方企业名称(toTenantName)',
      fromTenant: '分享方(fromTenant)',
      fromTenantName: '分享方企业名(fromTenantName)',
      callbackClass: '数据格式(callbackClass)',
      tenantId: 'TenantId(tenantId)',
      PriceSharingProfile: '运价分享机制(PriceSharingProfile)'
    },
    PriceApproveHistory: {
      pirceId: 'pirceId(pirceId)',
      pricType: '运价类型(pricType)',
      markupTypes: '加价类型(markupTypes)',
      markupsTier1: '加价等级T1(markupsTier1)',
      markupsTier2: '加价等级T2(markupsTier2)',
      markupsTier3: '加价等级T3(markupsTier3)',
      PriceApproveHistory: '运价审批历史表(PriceApproveHistory)'
    },
    Announcement: {
      newsId: '公告序号(newsId)',
      newsDate: '公告日期(newsDate)',
      title: '标题(title)',
      content: '内容(content)',
      author: '发布人(author)',
      releaseVersion: '版本号(releaseVersion)',
      invalid: '是否失效(invalid)',
      Announcement: '公告(Announcement)'
    },
    Task: {
      id: '序号(id)',
      priority: '优先级(priority)',
      category: '任务类(category)',
      parameters: '任务参数(parameters)',
      active: '是否有效(active)',
      title: '标题(title)',
      user: '用户(user)',
      role: '角色(role)',
      deadline: '期限(deadline)',
      dateEscalated: 'dateEscalated',
      managerEscalated: 'managerEscalated',
      status: '状态(status)',
      url: 'url',
      department: '部门(department)',
      Task: '任务(Task)'
    },
    FaxHistory: {
      id: '序号(id)',
      state: '状态(state)',
      clientReferenceCode: '客户参考号(clientReferenceCode)',
      faxJobNo: '服务号(faxJobNo)',
      faxNo: '传真号(faxNo)',
      userId: '用户(userId)',
      faxParameter1: 'faxParameter1',
      faxParameter2: 'faxParameter2',
      faxParameter3: 'faxParameter3',
      faxParameter4: 'faxParameter4',
      serverState: 'serverState',
      serverTime: 'serverTime',
      serverTry: 'serverTry',
      serverCost: 'serverCost',
      sendDate: '发送时间(sendDate)',
      documentId: '文档ID(documentId)',
      FaxHistory: 'FaxHistory'
    },
    AccountSet: {
      branchId: '分公司(branchId)',
      code: '帐套编码(code)',
      name: '账套名称(name)',
      accountTitleGradeRule: '科目分级规则(accountTitleGradeRule)',
      softwareVersions: '软件版本(softwareVersions)',
      interfaceScheme: '接口方案(interfaceScheme)',
      periodBeginDay: '财务期间起始日期(periodBeginDay) 含本天',
      accountingOrganization: '核算组织(accountingOrganization)',
      AccountSet: '账套(AccountSet)'
    },
    AccountingDocumentsRule: {
      businessDataType: '数据类型(businessDataType)',
      groupingDimension1: '分组依据1(groupingDimension1)',
      groupingDimension2: '分组依据2(groupingDimension2)',
      groupingDimension3: '分组依据3(groupingDimension3)',
      groupingDimension4: '分组依据4(groupingDimension4)',
      groupingDimension5: '分组依据5(groupingDimension5)',
      groupingDimension6: '分组依据6(groupingDimension6)',
      accountingMode: '记帐方式(accountingMode)',
      AccountingDocumentsRule: '凭证分组规则(AccountingDocumentsRule)'
    },
    AccountingEntryRule: {
      entryType: '分录类型(entryType)',
      entrySeries: '科目级数(entrySeries)',
      groupingDimension1: '分组依据1(groupingDimension1)',
      groupingDimension2: '分组依据2(groupingDimension2)',
      groupingDimension3: '分组依据3(groupingDimension3)',
      groupingDimension4: '分组依据4(groupingDimension4)',
      groupingDimension5: '分组依据5(groupingDimension5)',
      groupingDimension6: '分组依据6(groupingDimension6)',
      auxiliaryGrouping1: '辅助核算分组依据1(auxiliaryGrouping1)',
      auxiliaryGrouping2: '辅助核算分组依据2(auxiliaryGrouping2)',
      auxiliaryGrouping3: '辅助核算分组依据3(auxiliaryGrouping3)',
      auxiliaryGrouping4: '辅助核算分组依据4(auxiliaryGrouping4)',
      auxiliaryGrouping5: '辅助核算分组依据5(auxiliaryGrouping5)',
      auxiliaryGrouping6: '辅助核算分组依据6(auxiliaryGrouping6)',
      needExport: '是否需要导出(needExport)',
      groupingDimensionValue1: '科目分组条件值1(groupingDimensionValue1)',
      groupingDimensionValue2: '科目分组条件值2(groupingDimensionValue2)',
      groupingDimensionValue3: '科目分组条件值3(groupingDimensionValue3)',
      groupingDimensionValue4: '科目分组条件值4(groupingDimensionValue4)',
      groupingDimensionValue5: '科目分组条件值5(groupingDimensionValue5)',
      groupingDimensionValue6: '科目分组条件值6(groupingDimensionValue6)',
      accountingCode: '固定核算编码字段(accountingCode)',
      AccountingEntryRule: '分录分组规则(AccountingEntryRule)'
    },
    AccountingDocumentType: {
      code: '类型代码(code)',
      name: '类型名称(name)',
      prefix: '凭证字前缀(prefix)',
      remarks: '凭证类型说明(remarks)',
      receiveType: '收款方式(receiveType)',
      AccountingDocumentType: '凭证类型(AccountingDocumentType)'
    },
    FinanceCodeMapping: {
      priority: '优先级(priority)',
      baseDataType: '基础数据类型(baseDataType)',
      codeMappingType: '编码类型(codeMappingType)',
      baseDataValue: '基础数据值(baseDataValue)',
      financeCode: '财务编码(financeCode)',
      valueType1: '值类型1(valueType1)',
      businessDataType: '凭证类型(businessDataType)',
      entryType: '分录类型(entryType)',
      accountTitle: '科目编码(accountTitle)',
      FinanceCodeMapping: '编码映射(FinanceCodeMapping)'
    },
    EntryAccountTitle: {
      entryType: '分录类型(entryType)',
      businessDataType: '数据类型(businessDataType)',
      priority: '优先级(priority)',
      code: '编码(code)',
      name: '名称(name)',
      EntryAccountTitle: '分录科目(EntryAccountTitle)'
    },
    SubAccountItem: {
      grade: '等级(grade)',
      code: '编码(code)',
      name: '名称(name)',
      SubAccountItem: '子科目(SubAccountItem)'
    },
    EntryGroupingCriteria: {
      groupingDimension: '分组依据(groupingDimension)',
      operator: '操作符(operator)',
      groupingValue: '分组值(groupingValue)',
      EntryGroupingCriteria: '分组条件(EntryGroupingCriteria)'
    },
    AccountingDocument: {
      businessDataType: '数据类型(businessDataType)',
      state: '凭证状态(state)',
      sourceDocument: '附件(sourceDocument)',
      documentDate: '凭证日期(documentDate)',
      prefix: '凭证字(prefix)',
      documentMaker: '制单人(documentMaker)',
      documentNo: '凭证号(documentNo)',
      debitTotal: '借方金额合计(debitTotal)',
      creditTotal: '贷方金额合计(creditTotal)',
      verifier: '审核人(verifier)',
      verifyDate: '审核日期(verifyDate)',
      targetDocumentNo: '对方凭证号(targetDocumentNo)',
      year: '年度(year)',
      month: '月份(month)',
      prePayment: '是否预收(isPrePayment)',
      closing: '是否结转凭证(closing)',
      AccountingDocument: '凭证(AccountingDocument)'
    },
    AccountingEntry: {
      entryType: '分录类型(entryType)',
      summary: '摘要(summary)',
      accountTitle: '科目(accountTitle)',
      accountTitleName: '科目名称(accountTitleName)',
      debitCrebit: '借贷(debitCrebit)',
      amount: '金额(amount)',
      sourceCurrency: '原币种(sourceCurrency)',
      sourceAmount: '原币金额(sourceAmount)',
      exchangeRate: '汇率(exchangeRate)',
      department: '部门(department)',
      sales: '业务员(sales)',
      staffId: '职员(staffId)',
      accountClient: '结算单位(accountClient)',
      projectNumber: '项目号(projectNumber)',
      projectNumber2: '项目号2(projectNumber2)',
      businessDate: '业务日期(businessDate)',
      businessDate2: '业务日期2(businessDate2)',
      lob: '业务类型(lob)',
      taxAmount: '税额(taxAmount)',
      invoiceType: '发票类型(invoiceType)',
      unit: '计量单位(unit)',
      quantity: '数量(quantity)',
      serialNumber: '序号(serialNumber)',
      paidOff: '是否核销(paidOff)',
      paidOffType: '核销类型(paidOffType)',
      paidOffSeqNumber: '核销批次号(paidOffSeqNumber)',
      AccountingEntry: '分录(AccountingEntry)'
    },
    EntrySummaryRule: {
      businessDataType: '数据类型(businessDataType)',
      entryType: '分录类型(entryType)',
      defaultSummary: '默认摘要(defaultSummary)',
      EntrySummaryRule: '分录摘要规则(EntrySummaryRule)'
    },
    EntrySummaryDimension: {
      dimension: '摘要依据(dimension)',
      displayFormat: '显示说明(displayFormat)',
      EntrySummaryDimension: '摘要依据(EntrySummaryDimension)'
    },
    AccountingDocumentBusiness: {
      businessDataType: '数据类型(businessDataType)',
      businessDataId: '业务数据Id(businessDataId)',
      AccountingDocumentBusiness: '凭证业务(AccountingDocumentBusiness)'
    },
    DocumentSequenceConfig: {
      sequenceType: '类型代码(sequenceType)',
      prefix: '前缀(prefix)',
      sequenceLength: '序号长度(sequenceLength)',
      DocumentSequenceConfig: '对方凭证序号配置(DocumentSequenceConfig)'
    },
    DocumentSequence: {
      sequenceDate: '序号日期(sequenceDate)',
      currentNo: '当前序号(currentNo)',
      DocumentSequence: '对方凭证序号(DocumentSequence)'
    },
    AccountTitle: {
      year: '年度(year)',
      accountTitleType: '科目类型(accountTitleType)',
      subType: '科目子类(subType)',
      level: '科目级别(level)',
      debitCrebit: '借贷(debitCrebit)',
      accountTitle: '科目(accountTitle)',
      accountTitleName: '科目名称(accountTitleName)',
      accountItem1: '一级科目(accountItem1)',
      accountItem2: '二级科目(accountItem2)',
      accountItem3: '三级科目(accountItem3)',
      accountItem4: '四级科目(accountItem4)',
      accountItem5: '五级科目(accountItem5)',
      accountItem6: '六级科目(accountItem6)',
      auxiliary: '辅助核算(auxiliary)',
      auxiliaryCustomer: '辅助核算客户(auxiliaryCustomer)',
      auxiliarySupplier: '辅助核算供应商(auxiliarySupplier)',
      auxiliarySales: '辅助核算销售(auxiliarySales)',
      auxiliaryDepartment: '辅助核算部门(auxiliaryDepartment)',
      auxiliaryProjectNumber: '辅助核算项目号(auxiliaryProjectNumber)',
      accountingQuantity: '是否数量核算(accountingQuantity)',
      unit: '计量单位(unit)',
      accountingCurrency: '是否外币核算(accountingCurrency)',
      adjustExchangeRate: '是否期末调汇(adjustExchangeRate)',
      sourceCurrency: '原币种(sourceCurrency)',
      currentAccount: '是否往来(currentAccount)',
      defaultDepartment: '指定部门(defaultDepartment)',
      AccountTitle: '财务科目(AccountTitle)'
    },
    StatementDescription: {
      year: '年度(year)',
      statementType: '报表类型(statementType)',
      statementName: '报表名称(statementName)',
      StatementDescription: '财务报表描述(StatementDescription)'
    },
    StatementColumnDescription: {
      groupNo: '组号(groupNo)',
      columnNo: '列号(columnNo)',
      name: '名称(name)',
      StatementColumnDescription: '表头描述(StatementColumnDescription)'
    },
    StatementElementDescription: {
      groupNo: '组号(groupNo)',
      lineNo: '行号(lineNo)',
      name: '项目名称(name)',
      elementNo: '项号(elementNo)',
      amountType1: '财务金额类型1(amountType1)',
      amountType2: '财务金额类型2(amountType2)',
      amountType3: '财务金额类型3(amountType3)',
      calculatedItem: '是否计算项(calculatedItem)',
      StatementElementDescription: '报表项目描述(StatementElementDescription)'
    },
    ElementFormula: {
      accountTitle: '科目(accountTitle)',
      operateMode: '运算方式(operateMode)',
      ElementFormula: '项目公式(ElementFormula)'
    },
    StatementElement: {
      year: '年度(year)',
      month: '月份(month)',
      financialAmount1: '财务金额1(financialAmount1)',
      financialAmount2: '财务金额2(financialAmount2)',
      financialAmount3: '财务金额3(financialAmount3)',
      StatementElement: '报表项目(StatementElement)'
    },
    FiscalPeriod: {
      year: '年度(year)',
      month: '月份(month)',
      closing: '是否结账(closing)',
      initialPeriod: '是否初始期间(initialPeriod)',
      beginDate: '开始日期(beginDate)',
      endDate: '结束日期(endDate)',
      exchangeDocumentNo: '调汇凭证号(exchangeDocumentNo)',
      carryoverDocumentNo: '损益结转凭证号(carryoverDocumentNo)',
      useGroupExchangeRate: '是否使用集团汇率(useGroupExchangeRate)',
      FiscalPeriod: '会计期间(FiscalPeriod)'
    },
    AccountTitleBalance: {
      year: '年度(year)',
      month: '月份(month)',
      accountTitle: '科目(accountTitle)',
      quantity: '数量(quantity)',
      beginningBalance: '期初余额(beginningBalance)',
      beginningYearDebit: '期初年累计借方发生额(beginningYearDebit)',
      beginningYearCredit: '期初年累计贷方发生额(beginningYearCredit)',
      currentDebitAmount: '本期借方金额(currentDebitAmount)',
      currentCreditAmount: '本期贷方金额(currentCreditAmount)',
      beginningBalanceDebit: '期初借方期初余额(beginningBalanceDebit)',
      beginningBalanceCredit: '期初贷方期初余额(beginningBalanceCredit)',
      AccountTitleBalance: '科目余额表(AccountTitleBalance)'
    },
    AccountTitleBalanceCurrency: {
      sourceCurrency: '原币种(sourceCurrency)',
      year: '年度(year)',
      month: '月份(month)',
      accountTitle: '科目(accountTitle)',
      quantity: '数量(quantity)',
      beginningBalance: '期初余额(beginningBalance)',
      beginningYearDebit: '期初年累计借方发生额(beginningYearDebit)',
      beginningYearCredit: '期初年累计贷方发生额(beginningYearCredit)',
      currentDebitAmount: '本期借方金额(currentDebitAmount)',
      currentCreditAmount: '本期贷方金额(currentCreditAmount)',
      sourceBeginningBalance: '原币期初余额(sourceBeginningBalance)',
      sourceBeginningYearDebit: '原币期初年累计借方发生额(sourceBeginningYearDebit)',
      sourceBeginningYearCredit: '原币期初年累计贷方发生额(sourceBeginningYearCredit)',
      sourceCurrentDebitAmount: '原币本期借方金额(sourceCurrentDebitAmount)',
      sourceCurrentCreditAmount: '原币本期贷方金额(sourceCurrentCreditAmount)',
      beginningBalanceDebit: '期初借方期初余额(beginningBalanceDebit)',
      beginningBalanceCredit: '期初贷方期初余额(beginningBalanceCredit)',
      exchangeRate: '汇率(exchangeRate)',
      AccountTitleBalanceCurrency: '外币科目余额表(AccountTitleBalanceCurrency)'
    },
    FinancialExchangeRate: {
      accountSetUuid: '账套uuid(accountSetUuid)',
      year: '年度(year)',
      month: '月份(month)',
      sourceCurrency: '原币种(sourceCurrency)',
      targetCurrency: '目标币种(targetCurrency)',
      rate: '汇率(rate)',
      FinancialExchangeRate: '财务汇率(FinancialExchangeRate)'
    },
    AccountTitleAuxiliaryBalance: {
      accountClient: '客户/供应商(accountClient)',
      staffId: '职员(staffId)',
      department: '部门(department)',
      debitCrebit: '借贷(debitCrebit)',
      balanceCurrencyRmb: '余额人民币(balanceCurrencyRmb)',
      balanceCurrencyUsd: '余额美金(balanceCurrencyUsd)',
      year: '年(year)',
      month: '月份(month)',
      accountTitle: '科目编码(accountTitle)',
      accountTitleName: '科目名称(accountTitleName)',
      currentCreditAmount: '本期发生贷方金额(currentCreditAmount)',
      currentDebitAmount: '本期发生借方金额(currentDebitAmount)',
      beginningYearCredit: '本年合计贷方金额(beginningYearCredit)',
      beginningYearDebit: '本年合计借方金额(beginningYearDebit)',
      sales: '销售(sales)',
      projectNumber: '项目-1(projectNumber)',
      projectNumber2: '项目-2(projectNumber2)',
      businessDate: '业务日期(businessDate)',
      AccountTitleAuxiliaryBalance: '辅助期初余额(AccountTitleAuxiliaryBalance)'
    },
    AccountTitleAuxiliaryBalanceCurrency: {
      beginningBalance: '期初余额(beginningBalance)',
      currentCreditAmount: '本期贷方金额(currentCreditAmount)',
      currentDebitAmount: '本期借方金额(currentDebitAmount)',
      sourceBeginningBalance: '原币期初余额(sourceBeginningBalance)',
      sourceBeginningYearCredit: '原币期初年累计贷方发生额(sourceBeginningYearCredit)',
      sourceBeginningYearDebit: '原币期初年累计借方发生额(sourceBeginningYearDebit)',
      sourceCurrency: '原币种(sourceCurrency)',
      sourceCurrentCreditAmount: '原币本期贷方金额(sourceCurrentCreditAmount)',
      sourceCurrentDebitAmount: '原币本期借方金额(sourceCurrentDebitAmount)',
      exchangeRate: '汇率(exchangeRate)',
      beginningBalanceDebit: '期初借方期初余额(beginningBalanceDebit)',
      beginningBalanceCredit: '期初贷方期初余额(beginningBalanceCredit)',
      AccountTitleAuxiliaryBalanceCurrency: '往来辅助核算外币余额(AccountTitleAuxiliaryBalanceCurrency)'
    },
    ServiceProviderSelection: {
      name: '服务商名称(name)',
      serviceName: '服务名称(serviceName)',
      serviceIntro: '服务简介(serviceIntro)',
      serviceIntroUrl: '服务介绍链接地址(serviceIntroUrl)',
      author: '发布人(author)',
      content: '内容(content)',
      newsDate: '公告日期(newsDate)',
      newsId: '公告序号(newsId)',
      title: '标题(title)',
      ServiceProviderSelection: '服务商优选(ServiceProviderSelection)'
    },
    Insure: {
      jobUuid: 'JOBUUID(jobUuid)',
      orderGenerateStatus: '出单成功状态<01成功02失败>(orderGenerateStatus)',
      orderGenerateMessage: '出单成功或失败的信息(orderGenerateMessage)',
      orderGenerateDate: '订单出单时间(orderGenerateDate)',
      orderCommitDate: '订单提交时间(orderCommitDate)',
      orderModifyDate: '订单修改时间(orderModifyDate)',
      policyNo: '保单号(policyNo)',
      insureNo: '投保单号(insureNo)',
      orderStatus: '投保状态(orderStatus)',
      premium: '保费(premium)',
      Insure: '投保记录(Insure)'
    },
    PortalShipmentOrder: {
      customer: '委托人(customer)',
      jobNo: '工作号(jobNo)',
      mbl: 'MBL(mbl)',
      hbl: 'HBL(hbl)',
      voyagesFlights: '航班航次(voyagesFlights)',
      portOfLoading: '起运港(portOfLoading)',
      portOfDestination: '目的港(portOfDestination)',
      shipperId: '发货人Id(shipperId)',
      cosigneeId: '收货人Id(cosigneeId)',
      quantity: '件数(quantity)',
      weight: '重量(weight)',
      cubage: '体积(cubage)',
      goodName: '品名(goodName)',
      shippingMark: '唛头(shippingMark)',
      carrier: '承运人(carrier)',
      etd: 'ETD(etd)',
      transportMode: '运输方式(transportMode)',
      eta: 'ETA(eta)',
      quantityActual: '实际件数(quantityActual)',
      weightActual: '实际重量(weightActual)',
      cubageActual: '实际体积(cubageActual)',
      poNBR: '订单号(poNBR)',
      shipperName: '发货人名称(shipperName)',
      consigneeName: '收货人名称(consigneeName)',
      PortalShipmentOrder: '货运订单(PortalShipmentOrder)'
    },
    PortalContainerQuantity: {
      eqSize: '箱型(eqSize)',
      eqType: '箱种(eqType)',
      eqQuantity: '数量(eqQuantity)',
      PortalContainerQuantity: '箱量(PortalContainerQuantity)'
    },
    PortalContainer: {
      eqSize: '箱型(eqSize)',
      eqType: '箱种(eqType)',
      containerNo: '箱号(containerNo)',
      sealNo: '封号(sealNo)',
      PortalContainer: '集装箱(PortalContainer)'
    },
    PortalShipmentNode: {
      nodeType: '节点类型(nodeType)',
      nodeName: '节点名称(nodeName)',
      nodeLocalName: '节点本地名称(nodeLocalName)',
      level: '序号(level)',
      PortalShipmentNode: '货运节点(PortalShipmentNode)'
    },
    PortalNodeState: {
      stateName: '状态名称(stateName)',
      stateLocalName: '状态本地名称(stateLocalName)',
      finishedDateTime: '完成时间(finishedDateTime)',
      stateType: '状态类型(stateType)',
      remark: '状态说明(remark)',
      verifyState: '审核状态(verifyState)',
      verifyDate: '审核日期(verifyDate)',
      level: '序号(level)',
      PortalNodeState: '节点状态(PortalNodeState)'
    },
    PortalRecipient: {
      recipientName: '名称(recipientName)',
      recipientLocalName: '本地名称(recipientLocalName)',
      recipientType: '接收者类型(recipientType)',
      companyId: '合作伙伴Id(companyId)',
      PortalRecipient: '接收者(PortalRecipient)'
    },
    ApiPartner: {
      code: '代码(code)',
      name: '名称(name)',
      tokenKey: 'Token(TokenKey)',
      secretKey: 'Secret(SecretKey)',
      serverPath: 'Server(ServerPath)',
      remarks: '备注(remarks)',
      ApiPartner: 'API传递方信息(ApiPartner)'
    },
    ApiPartnerFunctions: {
      functionType: '函数调用类型(FunctionType)',
      functionName: '函数名(FunctionName)',
      functionDesc: '函数说明(FunctionDesc)',
      tokenKey: 'Token(TokenKey)',
      secretKey: 'Secret(SecretKey)',
      serverPath: 'Server(ServerPath)',
      remarks: '备注(remarks)',
      toTenant: '消息接收方Tenant(toTenant)',
      partnerfunctionType: '接收方API类型(partnerfunctionType)',
      ApiPartnerFunctions: 'API传递方函数信息(ApiPartnerFunctions)'
    },
    ServiceLog: {
      invocationId: '调用标识(invocationId)',
      ipAddress: 'IP地址(ipAddress)',
      method: '调用方法(method)',
      requestUrl: '请求URL(requestUrl)',
      queryParameter: '查询参数(queryParameter)',
      startTime: '开始时间(startTime)',
      endTime: '结束时间(endTime)',
      authorization: '身份标识(authorization)',
      success: '是否成功(success)',
      requestMsg: '请求信息(requestMsg)',
      responseMsg: '响应信息(responseMsg)',
      cost: 'cost',
      source: 'source',
      ServiceLog: '系统数据传递日志'
    },
    CargoSystem: 'End'
  }
}
